import { DocumentNode } from 'graphql'
import * as Urql from 'urql'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  BigFloat: number
  Cursor: string
  Date: Date
  Datetime: Date
  JSON: string
  UUID: string
}

export type Address = Node & {
  __typename: 'Address'
  budovaregestaid?: Maybe<Scalars['UUID']>
  castobce?: Maybe<Scalars['String']>
  cislodomovni?: Maybe<Scalars['Int']>
  cisloorientacni?: Maybe<Scalars['Int']>
  cisloorientacnipismeno?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['Datetime']>
  id: Scalars['UUID']
  kod?: Maybe<Scalars['String']>
  kraj?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  obec?: Maybe<Scalars['String']>
  okres?: Maybe<Scalars['String']>
  psc?: Maybe<Scalars['String']>
  radnice?: Maybe<Scalars['String']>
  /** Reads and enables pagination through a set of `Recipient`. */
  recipientsByAdresnimistokod: RecipientsConnection
  typbudovy?: Maybe<Scalars['String']>
  ulice?: Maybe<Scalars['String']>
}

export type AddressRecipientsByAdresnimistokodArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<RecipientCondition>
  filter?: InputMaybe<RecipientFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<RecipientsOrderBy>>
}

/** A condition to be used against `Address` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AddressCondition = {
  /** Checks for equality with the object’s `budovaregestaid` field. */
  budovaregestaid?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `castobce` field. */
  castobce?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `cislodomovni` field. */
  cislodomovni?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `cisloorientacni` field. */
  cisloorientacni?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `cisloorientacnipismeno` field. */
  cisloorientacnipismeno?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `kod` field. */
  kod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `kraj` field. */
  kraj?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `obec` field. */
  obec?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `okres` field. */
  okres?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `psc` field. */
  psc?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `radnice` field. */
  radnice?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `typbudovy` field. */
  typbudovy?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ulice` field. */
  ulice?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `Address` object types. All fields are combined with a logical ‘and.’ */
export type AddressFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AddressFilter>>
  /** Filter by the object’s `budovaregestaid` field. */
  budovaregestaid?: InputMaybe<UuidFilter>
  /** Filter by the object’s `castobce` field. */
  castobce?: InputMaybe<StringFilter>
  /** Filter by the object’s `cislodomovni` field. */
  cislodomovni?: InputMaybe<IntFilter>
  /** Filter by the object’s `cisloorientacni` field. */
  cisloorientacni?: InputMaybe<IntFilter>
  /** Filter by the object’s `cisloorientacnipismeno` field. */
  cisloorientacnipismeno?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `kod` field. */
  kod?: InputMaybe<StringFilter>
  /** Filter by the object’s `kraj` field. */
  kraj?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<AddressFilter>
  /** Filter by the object’s `obec` field. */
  obec?: InputMaybe<StringFilter>
  /** Filter by the object’s `okres` field. */
  okres?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AddressFilter>>
  /** Filter by the object’s `psc` field. */
  psc?: InputMaybe<StringFilter>
  /** Filter by the object’s `radnice` field. */
  radnice?: InputMaybe<StringFilter>
  /** Filter by the object’s `typbudovy` field. */
  typbudovy?: InputMaybe<StringFilter>
  /** Filter by the object’s `ulice` field. */
  ulice?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `Address` */
export type AddressInput = {
  budovaregestaid?: InputMaybe<Scalars['UUID']>
  castobce?: InputMaybe<Scalars['String']>
  cislodomovni?: InputMaybe<Scalars['Int']>
  cisloorientacni?: InputMaybe<Scalars['Int']>
  cisloorientacnipismeno?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  kod?: InputMaybe<Scalars['String']>
  kraj?: InputMaybe<Scalars['String']>
  obec?: InputMaybe<Scalars['String']>
  okres?: InputMaybe<Scalars['String']>
  psc?: InputMaybe<Scalars['String']>
  radnice?: InputMaybe<Scalars['String']>
  typbudovy?: InputMaybe<Scalars['String']>
  ulice?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `Address`. Fields that are set will be updated. */
export type AddressPatch = {
  budovaregestaid?: InputMaybe<Scalars['UUID']>
  castobce?: InputMaybe<Scalars['String']>
  cislodomovni?: InputMaybe<Scalars['Int']>
  cisloorientacni?: InputMaybe<Scalars['Int']>
  cisloorientacnipismeno?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  kod?: InputMaybe<Scalars['String']>
  kraj?: InputMaybe<Scalars['String']>
  obec?: InputMaybe<Scalars['String']>
  okres?: InputMaybe<Scalars['String']>
  psc?: InputMaybe<Scalars['String']>
  radnice?: InputMaybe<Scalars['String']>
  typbudovy?: InputMaybe<Scalars['String']>
  ulice?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `Address` values. */
export type AddressesConnection = {
  __typename: 'AddressesConnection'
  /** A list of edges which contains the `Address` and cursor to aid in pagination. */
  edges: Array<AddressesEdge>
  /** A list of `Address` objects. */
  nodes: Array<Maybe<Address>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Address` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `Address` edge in the connection. */
export type AddressesEdge = {
  __typename: 'AddressesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `Address` at the end of the edge. */
  node?: Maybe<Address>
}

/** Methods to use when ordering `Address`. */
export enum AddressesOrderBy {
  BudovaregestaidAsc = 'BUDOVAREGESTAID_ASC',
  BudovaregestaidDesc = 'BUDOVAREGESTAID_DESC',
  CastobceAsc = 'CASTOBCE_ASC',
  CastobceDesc = 'CASTOBCE_DESC',
  CislodomovniAsc = 'CISLODOMOVNI_ASC',
  CislodomovniDesc = 'CISLODOMOVNI_DESC',
  CisloorientacnipismenoAsc = 'CISLOORIENTACNIPISMENO_ASC',
  CisloorientacnipismenoDesc = 'CISLOORIENTACNIPISMENO_DESC',
  CisloorientacniAsc = 'CISLOORIENTACNI_ASC',
  CisloorientacniDesc = 'CISLOORIENTACNI_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KodAsc = 'KOD_ASC',
  KodDesc = 'KOD_DESC',
  KrajAsc = 'KRAJ_ASC',
  KrajDesc = 'KRAJ_DESC',
  Natural = 'NATURAL',
  ObecAsc = 'OBEC_ASC',
  ObecDesc = 'OBEC_DESC',
  OkresAsc = 'OKRES_ASC',
  OkresDesc = 'OKRES_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PscAsc = 'PSC_ASC',
  PscDesc = 'PSC_DESC',
  RadniceAsc = 'RADNICE_ASC',
  RadniceDesc = 'RADNICE_DESC',
  TypbudovyAsc = 'TYPBUDOVY_ASC',
  TypbudovyDesc = 'TYPBUDOVY_DESC',
  UliceAsc = 'ULICE_ASC',
  UliceDesc = 'ULICE_DESC',
}

export type AuctionListing = Node & {
  __typename: 'AuctionListing'
  auctionDecreeText?: Maybe<Scalars['String']>
  auctionDecreeUrl?: Maybe<Scalars['String']>
  auctionNumber?: Maybe<Scalars['String']>
  /** Reads and enables pagination through a set of `AuctionProperty`. */
  auctionPropertiesByAuctionId: AuctionPropertiesConnection
  auctionedOn?: Maybe<Scalars['String']>
  createdAt: Scalars['Datetime']
  description: Scalars['String']
  detailUrl: Scalars['String']
  endDate?: Maybe<Scalars['Datetime']>
  id: Scalars['UUID']
  ku?: Maybe<Scalars['Int']>
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByAuctionListingId: LabelConnectionsConnection
  lat?: Maybe<Scalars['BigFloat']>
  long?: Maybe<Scalars['BigFloat']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  obec?: Maybe<Scalars['Int']>
  photoUrl?: Maybe<Scalars['String']>
  price: Scalars['BigFloat']
  ruianId?: Maybe<Scalars['String']>
  slug: Scalars['String']
  sourceHostname: Scalars['String']
  startDate?: Maybe<Scalars['Datetime']>
  state: Scalars['String']
  title: Scalars['String']
  type: Scalars['String']
  updatedAt?: Maybe<Scalars['Datetime']>
  /** Reads and enables pagination through a set of `UserActivityLog`. */
  userActivityLogsByAuctionListingId: UserActivityLogsConnection
}

export type AuctionListingAuctionPropertiesByAuctionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<AuctionPropertyCondition>
  filter?: InputMaybe<AuctionPropertyFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<AuctionPropertiesOrderBy>>
}

export type AuctionListingLabelConnectionsByAuctionListingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

export type AuctionListingUserActivityLogsByAuctionListingIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<UserActivityLogCondition>
  filter?: InputMaybe<UserActivityLogFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<UserActivityLogsOrderBy>>
}

/**
 * A condition to be used against `AuctionListing` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuctionListingCondition = {
  /** Checks for equality with the object’s `auctionDecreeText` field. */
  auctionDecreeText?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `auctionDecreeUrl` field. */
  auctionDecreeUrl?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `auctionNumber` field. */
  auctionNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `auctionedOn` field. */
  auctionedOn?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `detailUrl` field. */
  detailUrl?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `endDate` field. */
  endDate?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `ku` field. */
  ku?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `lat` field. */
  lat?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `long` field. */
  long?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `obec` field. */
  obec?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `photoUrl` field. */
  photoUrl?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `ruianId` field. */
  ruianId?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `sourceHostname` field. */
  sourceHostname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `startDate` field. */
  startDate?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** A filter to be used against `AuctionListing` object types. All fields are combined with a logical ‘and.’ */
export type AuctionListingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuctionListingFilter>>
  /** Filter by the object’s `auctionDecreeText` field. */
  auctionDecreeText?: InputMaybe<StringFilter>
  /** Filter by the object’s `auctionDecreeUrl` field. */
  auctionDecreeUrl?: InputMaybe<StringFilter>
  /** Filter by the object’s `auctionNumber` field. */
  auctionNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `auctionedOn` field. */
  auctionedOn?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `detailUrl` field. */
  detailUrl?: InputMaybe<StringFilter>
  /** Filter by the object’s `endDate` field. */
  endDate?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `ku` field. */
  ku?: InputMaybe<IntFilter>
  /** Filter by the object’s `lat` field. */
  lat?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `long` field. */
  long?: InputMaybe<BigFloatFilter>
  /** Negates the expression. */
  not?: InputMaybe<AuctionListingFilter>
  /** Filter by the object’s `obec` field. */
  obec?: InputMaybe<IntFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuctionListingFilter>>
  /** Filter by the object’s `photoUrl` field. */
  photoUrl?: InputMaybe<StringFilter>
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `ruianId` field. */
  ruianId?: InputMaybe<StringFilter>
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<StringFilter>
  /** Filter by the object’s `sourceHostname` field. */
  sourceHostname?: InputMaybe<StringFilter>
  /** Filter by the object’s `startDate` field. */
  startDate?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<StringFilter>
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
}

/** An input for mutations affecting `AuctionListing` */
export type AuctionListingInput = {
  auctionDecreeText?: InputMaybe<Scalars['String']>
  auctionDecreeUrl?: InputMaybe<Scalars['String']>
  auctionNumber?: InputMaybe<Scalars['String']>
  auctionedOn?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  description: Scalars['String']
  detailUrl: Scalars['String']
  endDate?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  ku?: InputMaybe<Scalars['Int']>
  lat?: InputMaybe<Scalars['BigFloat']>
  long?: InputMaybe<Scalars['BigFloat']>
  obec?: InputMaybe<Scalars['Int']>
  photoUrl?: InputMaybe<Scalars['String']>
  price: Scalars['BigFloat']
  ruianId?: InputMaybe<Scalars['String']>
  slug: Scalars['String']
  sourceHostname: Scalars['String']
  startDate?: InputMaybe<Scalars['Datetime']>
  state: Scalars['String']
  title: Scalars['String']
  type: Scalars['String']
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** Represents an update to a `AuctionListing`. Fields that are set will be updated. */
export type AuctionListingPatch = {
  auctionDecreeText?: InputMaybe<Scalars['String']>
  auctionDecreeUrl?: InputMaybe<Scalars['String']>
  auctionNumber?: InputMaybe<Scalars['String']>
  auctionedOn?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  detailUrl?: InputMaybe<Scalars['String']>
  endDate?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  ku?: InputMaybe<Scalars['Int']>
  lat?: InputMaybe<Scalars['BigFloat']>
  long?: InputMaybe<Scalars['BigFloat']>
  obec?: InputMaybe<Scalars['Int']>
  photoUrl?: InputMaybe<Scalars['String']>
  price?: InputMaybe<Scalars['BigFloat']>
  ruianId?: InputMaybe<Scalars['String']>
  slug?: InputMaybe<Scalars['String']>
  sourceHostname?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['Datetime']>
  state?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** A connection to a list of `AuctionListing` values. */
export type AuctionListingsConnection = {
  __typename: 'AuctionListingsConnection'
  /** A list of edges which contains the `AuctionListing` and cursor to aid in pagination. */
  edges: Array<AuctionListingsEdge>
  /** A list of `AuctionListing` objects. */
  nodes: Array<Maybe<AuctionListing>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `AuctionListing` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `AuctionListing` edge in the connection. */
export type AuctionListingsEdge = {
  __typename: 'AuctionListingsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `AuctionListing` at the end of the edge. */
  node?: Maybe<AuctionListing>
}

/** Methods to use when ordering `AuctionListing`. */
export enum AuctionListingsOrderBy {
  AuctionedOnAsc = 'AUCTIONED_ON_ASC',
  AuctionedOnDesc = 'AUCTIONED_ON_DESC',
  AuctionDecreeTextAsc = 'AUCTION_DECREE_TEXT_ASC',
  AuctionDecreeTextDesc = 'AUCTION_DECREE_TEXT_DESC',
  AuctionDecreeUrlAsc = 'AUCTION_DECREE_URL_ASC',
  AuctionDecreeUrlDesc = 'AUCTION_DECREE_URL_DESC',
  AuctionNumberAsc = 'AUCTION_NUMBER_ASC',
  AuctionNumberDesc = 'AUCTION_NUMBER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DetailUrlAsc = 'DETAIL_URL_ASC',
  DetailUrlDesc = 'DETAIL_URL_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KuAsc = 'KU_ASC',
  KuDesc = 'KU_DESC',
  LatAsc = 'LAT_ASC',
  LatDesc = 'LAT_DESC',
  LongAsc = 'LONG_ASC',
  LongDesc = 'LONG_DESC',
  Natural = 'NATURAL',
  ObecAsc = 'OBEC_ASC',
  ObecDesc = 'OBEC_DESC',
  PhotoUrlAsc = 'PHOTO_URL_ASC',
  PhotoUrlDesc = 'PHOTO_URL_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RuianIdAsc = 'RUIAN_ID_ASC',
  RuianIdDesc = 'RUIAN_ID_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  SourceHostnameAsc = 'SOURCE_HOSTNAME_ASC',
  SourceHostnameDesc = 'SOURCE_HOSTNAME_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
}

/** A connection to a list of `AuctionProperty` values. */
export type AuctionPropertiesConnection = {
  __typename: 'AuctionPropertiesConnection'
  /** A list of edges which contains the `AuctionProperty` and cursor to aid in pagination. */
  edges: Array<AuctionPropertiesEdge>
  /** A list of `AuctionProperty` objects. */
  nodes: Array<Maybe<AuctionProperty>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `AuctionProperty` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `AuctionProperty` edge in the connection. */
export type AuctionPropertiesEdge = {
  __typename: 'AuctionPropertiesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `AuctionProperty` at the end of the edge. */
  node?: Maybe<AuctionProperty>
}

/** Methods to use when ordering `AuctionProperty`. */
export enum AuctionPropertiesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  AuctionIdAsc = 'AUCTION_ID_ASC',
  AuctionIdDesc = 'AUCTION_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyIdAsc = 'PROPERTY_ID_ASC',
  PropertyIdDesc = 'PROPERTY_ID_DESC',
  PropertyNameAsc = 'PROPERTY_NAME_ASC',
  PropertyNameDesc = 'PROPERTY_NAME_DESC',
  PropertyTypeAsc = 'PROPERTY_TYPE_ASC',
  PropertyTypeDesc = 'PROPERTY_TYPE_DESC',
}

export type AuctionProperty = Node & {
  __typename: 'AuctionProperty'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  auctionId: Scalars['UUID']
  /** Reads a single `AuctionListing` that is related to this `AuctionProperty`. */
  auctionListingByAuctionId?: Maybe<AuctionListing>
  createdAt: Scalars['Datetime']
  id: Scalars['UUID']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  propertyId: Scalars['UUID']
  propertyName: Scalars['String']
  propertyType: Scalars['String']
}

/**
 * A condition to be used against `AuctionProperty` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuctionPropertyCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `auctionId` field. */
  auctionId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyId` field. */
  propertyId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyName` field. */
  propertyName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyType` field. */
  propertyType?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `AuctionProperty` object types. All fields are combined with a logical ‘and.’ */
export type AuctionPropertyFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuctionPropertyFilter>>
  /** Filter by the object’s `auctionId` field. */
  auctionId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Negates the expression. */
  not?: InputMaybe<AuctionPropertyFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuctionPropertyFilter>>
  /** Filter by the object’s `propertyId` field. */
  propertyId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyName` field. */
  propertyName?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyType` field. */
  propertyType?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `AuctionProperty` */
export type AuctionPropertyInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  auctionId: Scalars['UUID']
  createdAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  propertyId: Scalars['UUID']
  propertyName: Scalars['String']
  propertyType: Scalars['String']
}

/** Represents an update to a `AuctionProperty`. Fields that are set will be updated. */
export type AuctionPropertyPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  auctionId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
}

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']>>
}

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']>>
}

export type Bpej = Node & {
  __typename: 'Bpej'
  cena?: Maybe<Scalars['BigFloat']>
  id: Scalars['UUID']
  kod: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  platnostDo?: Maybe<Scalars['Date']>
  platnostOd?: Maybe<Scalars['Date']>
  popis?: Maybe<Scalars['String']>
}

/** A condition to be used against `Bpej` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BpejCondition = {
  /** Checks for equality with the object’s `cena` field. */
  cena?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `kod` field. */
  kod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `platnostDo` field. */
  platnostDo?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `platnostOd` field. */
  platnostOd?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `popis` field. */
  popis?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `Bpej` object types. All fields are combined with a logical ‘and.’ */
export type BpejFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BpejFilter>>
  /** Filter by the object’s `cena` field. */
  cena?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `kod` field. */
  kod?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<BpejFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BpejFilter>>
  /** Filter by the object’s `platnostDo` field. */
  platnostDo?: InputMaybe<DateFilter>
  /** Filter by the object’s `platnostOd` field. */
  platnostOd?: InputMaybe<DateFilter>
  /** Filter by the object’s `popis` field. */
  popis?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `Bpej` */
export type BpejInput = {
  cena?: InputMaybe<Scalars['BigFloat']>
  id?: InputMaybe<Scalars['UUID']>
  kod: Scalars['String']
  platnostDo?: InputMaybe<Scalars['Date']>
  platnostOd?: InputMaybe<Scalars['Date']>
  popis?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `Bpej`. Fields that are set will be updated. */
export type BpejPatch = {
  cena?: InputMaybe<Scalars['BigFloat']>
  id?: InputMaybe<Scalars['UUID']>
  kod?: InputMaybe<Scalars['String']>
  platnostDo?: InputMaybe<Scalars['Date']>
  platnostOd?: InputMaybe<Scalars['Date']>
  popis?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `Bpej` values. */
export type BpejsConnection = {
  __typename: 'BpejsConnection'
  /** A list of edges which contains the `Bpej` and cursor to aid in pagination. */
  edges: Array<BpejsEdge>
  /** A list of `Bpej` objects. */
  nodes: Array<Maybe<Bpej>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Bpej` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `Bpej` edge in the connection. */
export type BpejsEdge = {
  __typename: 'BpejsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `Bpej` at the end of the edge. */
  node?: Maybe<Bpej>
}

/** Methods to use when ordering `Bpej`. */
export enum BpejsOrderBy {
  CenaAsc = 'CENA_ASC',
  CenaDesc = 'CENA_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KodAsc = 'KOD_ASC',
  KodDesc = 'KOD_DESC',
  Natural = 'NATURAL',
  PlatnostDoAsc = 'PLATNOST_DO_ASC',
  PlatnostDoDesc = 'PLATNOST_DO_DESC',
  PlatnostOdAsc = 'PLATNOST_OD_ASC',
  PlatnostOdDesc = 'PLATNOST_OD_DESC',
  PopisAsc = 'POPIS_ASC',
  PopisDesc = 'POPIS_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type BuybackCalculation = Node & {
  __typename: 'BuybackCalculation'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  cadastralCode?: Maybe<Scalars['String']>
  calculatorVersion?: Maybe<Scalars['String']>
  createdAt: Scalars['Datetime']
  deletedAt?: Maybe<Scalars['Datetime']>
  description?: Maybe<Scalars['String']>
  formData: Scalars['JSON']
  id: Scalars['UUID']
  lv?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  priceEstimateId?: Maybe<Scalars['UUID']>
  propertyId: Scalars['UUID']
  propertyName: Scalars['String']
  propertyType: Scalars['String']
  title?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['Datetime']>
}

/**
 * A condition to be used against `BuybackCalculation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BuybackCalculationCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `cadastralCode` field. */
  cadastralCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `calculatorVersion` field. */
  calculatorVersion?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `formData` field. */
  formData?: InputMaybe<Scalars['JSON']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `lv` field. */
  lv?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `priceEstimateId` field. */
  priceEstimateId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyId` field. */
  propertyId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyName` field. */
  propertyName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyType` field. */
  propertyType?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** A filter to be used against `BuybackCalculation` object types. All fields are combined with a logical ‘and.’ */
export type BuybackCalculationFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BuybackCalculationFilter>>
  /** Filter by the object’s `cadastralCode` field. */
  cadastralCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `calculatorVersion` field. */
  calculatorVersion?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `formData` field. */
  formData?: InputMaybe<JsonFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `lv` field. */
  lv?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<BuybackCalculationFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BuybackCalculationFilter>>
  /** Filter by the object’s `priceEstimateId` field. */
  priceEstimateId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyId` field. */
  propertyId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyName` field. */
  propertyName?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyType` field. */
  propertyType?: InputMaybe<StringFilter>
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
}

/** An input for mutations affecting `BuybackCalculation` */
export type BuybackCalculationInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  cadastralCode?: InputMaybe<Scalars['String']>
  calculatorVersion?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  formData: Scalars['JSON']
  id?: InputMaybe<Scalars['UUID']>
  lv?: InputMaybe<Scalars['String']>
  priceEstimateId?: InputMaybe<Scalars['UUID']>
  propertyId: Scalars['UUID']
  propertyName: Scalars['String']
  propertyType: Scalars['String']
  title?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** Represents an update to a `BuybackCalculation`. Fields that are set will be updated. */
export type BuybackCalculationPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  cadastralCode?: InputMaybe<Scalars['String']>
  calculatorVersion?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  formData?: InputMaybe<Scalars['JSON']>
  id?: InputMaybe<Scalars['UUID']>
  lv?: InputMaybe<Scalars['String']>
  priceEstimateId?: InputMaybe<Scalars['UUID']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** A connection to a list of `BuybackCalculation` values. */
export type BuybackCalculationsConnection = {
  __typename: 'BuybackCalculationsConnection'
  /** A list of edges which contains the `BuybackCalculation` and cursor to aid in pagination. */
  edges: Array<BuybackCalculationsEdge>
  /** A list of `BuybackCalculation` objects. */
  nodes: Array<Maybe<BuybackCalculation>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `BuybackCalculation` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `BuybackCalculation` edge in the connection. */
export type BuybackCalculationsEdge = {
  __typename: 'BuybackCalculationsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `BuybackCalculation` at the end of the edge. */
  node?: Maybe<BuybackCalculation>
}

/** Methods to use when ordering `BuybackCalculation`. */
export enum BuybackCalculationsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CadastralCodeAsc = 'CADASTRAL_CODE_ASC',
  CadastralCodeDesc = 'CADASTRAL_CODE_DESC',
  CalculatorVersionAsc = 'CALCULATOR_VERSION_ASC',
  CalculatorVersionDesc = 'CALCULATOR_VERSION_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  FormDataAsc = 'FORM_DATA_ASC',
  FormDataDesc = 'FORM_DATA_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LvAsc = 'LV_ASC',
  LvDesc = 'LV_DESC',
  Natural = 'NATURAL',
  PriceEstimateIdAsc = 'PRICE_ESTIMATE_ID_ASC',
  PriceEstimateIdDesc = 'PRICE_ESTIMATE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyIdAsc = 'PROPERTY_ID_ASC',
  PropertyIdDesc = 'PROPERTY_ID_DESC',
  PropertyNameAsc = 'PROPERTY_NAME_ASC',
  PropertyNameDesc = 'PROPERTY_NAME_DESC',
  PropertyTypeAsc = 'PROPERTY_TYPE_ASC',
  PropertyTypeDesc = 'PROPERTY_TYPE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
}

export type CeeExecution = Node & {
  __typename: 'CeeExecution'
  address?: Maybe<Scalars['String']>
  birthDate?: Maybe<Scalars['Date']>
  ceeEvent?: Maybe<Scalars['String']>
  /** Reads and enables pagination through a set of `CeeExecutionDetail`. */
  ceeExecutionDetailsByCeeExecutionId: CeeExecutionDetailsConnection
  /** Reads a single `CeeOffice` that is related to this `CeeExecution`. */
  ceeOfficeByExecutorCode?: Maybe<CeeOffice>
  createdAt: Scalars['Datetime']
  detailCode?: Maybe<Scalars['String']>
  executionDate?: Maybe<Scalars['Date']>
  executorCode?: Maybe<Scalars['String']>
  executorName?: Maybe<Scalars['String']>
  fullname?: Maybe<Scalars['String']>
  ico?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  identificationCode?: Maybe<Scalars['String']>
  /** Reads a single `MonitoringCee` that is related to this `CeeExecution`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  monitoringCeeId?: Maybe<Scalars['UUID']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  rc?: Maybe<Scalars['String']>
  spzn?: Maybe<Scalars['String']>
  updateDate?: Maybe<Scalars['Date']>
}

export type CeeExecutionCeeExecutionDetailsByCeeExecutionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CeeExecutionDetailCondition>
  filter?: InputMaybe<CeeExecutionDetailFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CeeExecutionDetailsOrderBy>>
}

/**
 * A condition to be used against `CeeExecution` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CeeExecutionCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `birthDate` field. */
  birthDate?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `ceeEvent` field. */
  ceeEvent?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `detailCode` field. */
  detailCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `executionDate` field. */
  executionDate?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `executorCode` field. */
  executorCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `executorName` field. */
  executorName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `fullname` field. */
  fullname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ico` field. */
  ico?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `identificationCode` field. */
  identificationCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `monitoringCeeId` field. */
  monitoringCeeId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `rc` field. */
  rc?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `spzn` field. */
  spzn?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `updateDate` field. */
  updateDate?: InputMaybe<Scalars['Date']>
}

export type CeeExecutionDetail = Node & {
  __typename: 'CeeExecutionDetail'
  accountId?: Maybe<Scalars['UUID']>
  accountUserId?: Maybe<Scalars['UUID']>
  castka?: Maybe<Scalars['String']>
  /** Reads a single `CeeExecution` that is related to this `CeeExecutionDetail`. */
  ceeExecutionByCeeExecutionId?: Maybe<CeeExecution>
  ceeExecutionId?: Maybe<Scalars['UUID']>
  createdAt?: Maybe<Scalars['Datetime']>
  datum?: Maybe<Scalars['String']>
  detailCode?: Maybe<Scalars['String']>
  exekutorskyUrad?: Maybe<Scalars['String']>
  ico?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  nepenezitaPovinost?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  povinnaOsoba?: Maybe<Scalars['String']>
  pravidelnaSplatka?: Maybe<Scalars['String']>
  rc?: Maybe<Scalars['String']>
  soud?: Maybe<Scalars['String']>
  spznExekutora?: Maybe<Scalars['String']>
  spznSoudu?: Maybe<Scalars['String']>
  titul?: Maybe<Scalars['String']>
}

/**
 * A condition to be used against `CeeExecutionDetail` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CeeExecutionDetailCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `castka` field. */
  castka?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ceeExecutionId` field. */
  ceeExecutionId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `datum` field. */
  datum?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `detailCode` field. */
  detailCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `exekutorskyUrad` field. */
  exekutorskyUrad?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ico` field. */
  ico?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `nepenezitaPovinost` field. */
  nepenezitaPovinost?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `povinnaOsoba` field. */
  povinnaOsoba?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `pravidelnaSplatka` field. */
  pravidelnaSplatka?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `rc` field. */
  rc?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `soud` field. */
  soud?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `spznExekutora` field. */
  spznExekutora?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `spznSoudu` field. */
  spznSoudu?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `titul` field. */
  titul?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `CeeExecutionDetail` object types. All fields are combined with a logical ‘and.’ */
export type CeeExecutionDetailFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CeeExecutionDetailFilter>>
  /** Filter by the object’s `castka` field. */
  castka?: InputMaybe<StringFilter>
  /** Filter by the object’s `ceeExecutionId` field. */
  ceeExecutionId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `datum` field. */
  datum?: InputMaybe<StringFilter>
  /** Filter by the object’s `detailCode` field. */
  detailCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `exekutorskyUrad` field. */
  exekutorskyUrad?: InputMaybe<StringFilter>
  /** Filter by the object’s `ico` field. */
  ico?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `nepenezitaPovinost` field. */
  nepenezitaPovinost?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<CeeExecutionDetailFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CeeExecutionDetailFilter>>
  /** Filter by the object’s `povinnaOsoba` field. */
  povinnaOsoba?: InputMaybe<StringFilter>
  /** Filter by the object’s `pravidelnaSplatka` field. */
  pravidelnaSplatka?: InputMaybe<StringFilter>
  /** Filter by the object’s `rc` field. */
  rc?: InputMaybe<StringFilter>
  /** Filter by the object’s `soud` field. */
  soud?: InputMaybe<StringFilter>
  /** Filter by the object’s `spznExekutora` field. */
  spznExekutora?: InputMaybe<StringFilter>
  /** Filter by the object’s `spznSoudu` field. */
  spznSoudu?: InputMaybe<StringFilter>
  /** Filter by the object’s `titul` field. */
  titul?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `CeeExecutionDetail` */
export type CeeExecutionDetailInput = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  castka?: InputMaybe<Scalars['String']>
  ceeExecutionId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  datum?: InputMaybe<Scalars['String']>
  detailCode?: InputMaybe<Scalars['String']>
  exekutorskyUrad?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  nepenezitaPovinost?: InputMaybe<Scalars['String']>
  povinnaOsoba?: InputMaybe<Scalars['String']>
  pravidelnaSplatka?: InputMaybe<Scalars['String']>
  rc?: InputMaybe<Scalars['String']>
  soud?: InputMaybe<Scalars['String']>
  spznExekutora?: InputMaybe<Scalars['String']>
  spznSoudu?: InputMaybe<Scalars['String']>
  titul?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `CeeExecutionDetail`. Fields that are set will be updated. */
export type CeeExecutionDetailPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  castka?: InputMaybe<Scalars['String']>
  ceeExecutionId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  datum?: InputMaybe<Scalars['String']>
  detailCode?: InputMaybe<Scalars['String']>
  exekutorskyUrad?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  nepenezitaPovinost?: InputMaybe<Scalars['String']>
  povinnaOsoba?: InputMaybe<Scalars['String']>
  pravidelnaSplatka?: InputMaybe<Scalars['String']>
  rc?: InputMaybe<Scalars['String']>
  soud?: InputMaybe<Scalars['String']>
  spznExekutora?: InputMaybe<Scalars['String']>
  spznSoudu?: InputMaybe<Scalars['String']>
  titul?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `CeeExecutionDetail` values. */
export type CeeExecutionDetailsConnection = {
  __typename: 'CeeExecutionDetailsConnection'
  /** A list of edges which contains the `CeeExecutionDetail` and cursor to aid in pagination. */
  edges: Array<CeeExecutionDetailsEdge>
  /** A list of `CeeExecutionDetail` objects. */
  nodes: Array<Maybe<CeeExecutionDetail>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `CeeExecutionDetail` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `CeeExecutionDetail` edge in the connection. */
export type CeeExecutionDetailsEdge = {
  __typename: 'CeeExecutionDetailsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `CeeExecutionDetail` at the end of the edge. */
  node?: Maybe<CeeExecutionDetail>
}

/** Methods to use when ordering `CeeExecutionDetail`. */
export enum CeeExecutionDetailsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CastkaAsc = 'CASTKA_ASC',
  CastkaDesc = 'CASTKA_DESC',
  CeeExecutionIdAsc = 'CEE_EXECUTION_ID_ASC',
  CeeExecutionIdDesc = 'CEE_EXECUTION_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DatumAsc = 'DATUM_ASC',
  DatumDesc = 'DATUM_DESC',
  DetailCodeAsc = 'DETAIL_CODE_ASC',
  DetailCodeDesc = 'DETAIL_CODE_DESC',
  ExekutorskyUradAsc = 'EXEKUTORSKY_URAD_ASC',
  ExekutorskyUradDesc = 'EXEKUTORSKY_URAD_DESC',
  IcoAsc = 'ICO_ASC',
  IcoDesc = 'ICO_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NepenezitaPovinostAsc = 'NEPENEZITA_POVINOST_ASC',
  NepenezitaPovinostDesc = 'NEPENEZITA_POVINOST_DESC',
  PovinnaOsobaAsc = 'POVINNA_OSOBA_ASC',
  PovinnaOsobaDesc = 'POVINNA_OSOBA_DESC',
  PravidelnaSplatkaAsc = 'PRAVIDELNA_SPLATKA_ASC',
  PravidelnaSplatkaDesc = 'PRAVIDELNA_SPLATKA_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RcAsc = 'RC_ASC',
  RcDesc = 'RC_DESC',
  SoudAsc = 'SOUD_ASC',
  SoudDesc = 'SOUD_DESC',
  SpznExekutoraAsc = 'SPZN_EXEKUTORA_ASC',
  SpznExekutoraDesc = 'SPZN_EXEKUTORA_DESC',
  SpznSouduAsc = 'SPZN_SOUDU_ASC',
  SpznSouduDesc = 'SPZN_SOUDU_DESC',
  TitulAsc = 'TITUL_ASC',
  TitulDesc = 'TITUL_DESC',
}

/** A filter to be used against `CeeExecution` object types. All fields are combined with a logical ‘and.’ */
export type CeeExecutionFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CeeExecutionFilter>>
  /** Filter by the object’s `birthDate` field. */
  birthDate?: InputMaybe<DateFilter>
  /** Filter by the object’s `ceeEvent` field. */
  ceeEvent?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `detailCode` field. */
  detailCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `executionDate` field. */
  executionDate?: InputMaybe<DateFilter>
  /** Filter by the object’s `executorCode` field. */
  executorCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `executorName` field. */
  executorName?: InputMaybe<StringFilter>
  /** Filter by the object’s `fullname` field. */
  fullname?: InputMaybe<StringFilter>
  /** Filter by the object’s `ico` field. */
  ico?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `identificationCode` field. */
  identificationCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `monitoringCeeId` field. */
  monitoringCeeId?: InputMaybe<UuidFilter>
  /** Negates the expression. */
  not?: InputMaybe<CeeExecutionFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CeeExecutionFilter>>
  /** Filter by the object’s `rc` field. */
  rc?: InputMaybe<StringFilter>
  /** Filter by the object’s `spzn` field. */
  spzn?: InputMaybe<StringFilter>
  /** Filter by the object’s `updateDate` field. */
  updateDate?: InputMaybe<DateFilter>
}

/** An input for mutations affecting `CeeExecution` */
export type CeeExecutionInput = {
  address?: InputMaybe<Scalars['String']>
  birthDate?: InputMaybe<Scalars['Date']>
  ceeEvent?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  detailCode?: InputMaybe<Scalars['String']>
  executionDate?: InputMaybe<Scalars['Date']>
  executorCode?: InputMaybe<Scalars['String']>
  executorName?: InputMaybe<Scalars['String']>
  fullname?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  identificationCode?: InputMaybe<Scalars['String']>
  monitoringCeeId?: InputMaybe<Scalars['UUID']>
  rc?: InputMaybe<Scalars['String']>
  spzn?: InputMaybe<Scalars['String']>
  updateDate?: InputMaybe<Scalars['Date']>
}

/** Represents an update to a `CeeExecution`. Fields that are set will be updated. */
export type CeeExecutionPatch = {
  address?: InputMaybe<Scalars['String']>
  birthDate?: InputMaybe<Scalars['Date']>
  ceeEvent?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  detailCode?: InputMaybe<Scalars['String']>
  executionDate?: InputMaybe<Scalars['Date']>
  executorCode?: InputMaybe<Scalars['String']>
  executorName?: InputMaybe<Scalars['String']>
  fullname?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  identificationCode?: InputMaybe<Scalars['String']>
  monitoringCeeId?: InputMaybe<Scalars['UUID']>
  rc?: InputMaybe<Scalars['String']>
  spzn?: InputMaybe<Scalars['String']>
  updateDate?: InputMaybe<Scalars['Date']>
}

/** A connection to a list of `CeeExecution` values. */
export type CeeExecutionsConnection = {
  __typename: 'CeeExecutionsConnection'
  /** A list of edges which contains the `CeeExecution` and cursor to aid in pagination. */
  edges: Array<CeeExecutionsEdge>
  /** A list of `CeeExecution` objects. */
  nodes: Array<Maybe<CeeExecution>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `CeeExecution` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `CeeExecution` edge in the connection. */
export type CeeExecutionsEdge = {
  __typename: 'CeeExecutionsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `CeeExecution` at the end of the edge. */
  node?: Maybe<CeeExecution>
}

/** Methods to use when ordering `CeeExecution`. */
export enum CeeExecutionsOrderBy {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  BirthDateAsc = 'BIRTH_DATE_ASC',
  BirthDateDesc = 'BIRTH_DATE_DESC',
  CeeEventAsc = 'CEE_EVENT_ASC',
  CeeEventDesc = 'CEE_EVENT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailCodeAsc = 'DETAIL_CODE_ASC',
  DetailCodeDesc = 'DETAIL_CODE_DESC',
  ExecutionDateAsc = 'EXECUTION_DATE_ASC',
  ExecutionDateDesc = 'EXECUTION_DATE_DESC',
  ExecutorCodeAsc = 'EXECUTOR_CODE_ASC',
  ExecutorCodeDesc = 'EXECUTOR_CODE_DESC',
  ExecutorNameAsc = 'EXECUTOR_NAME_ASC',
  ExecutorNameDesc = 'EXECUTOR_NAME_DESC',
  FullnameAsc = 'FULLNAME_ASC',
  FullnameDesc = 'FULLNAME_DESC',
  IcoAsc = 'ICO_ASC',
  IcoDesc = 'ICO_DESC',
  IdentificationCodeAsc = 'IDENTIFICATION_CODE_ASC',
  IdentificationCodeDesc = 'IDENTIFICATION_CODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MonitoringCeeIdAsc = 'MONITORING_CEE_ID_ASC',
  MonitoringCeeIdDesc = 'MONITORING_CEE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RcAsc = 'RC_ASC',
  RcDesc = 'RC_DESC',
  SpznAsc = 'SPZN_ASC',
  SpznDesc = 'SPZN_DESC',
  UpdateDateAsc = 'UPDATE_DATE_ASC',
  UpdateDateDesc = 'UPDATE_DATE_DESC',
}

export type CeeOffice = Node & {
  __typename: 'CeeOffice'
  address?: Maybe<Scalars['String']>
  area?: Maybe<Scalars['String']>
  /** Reads and enables pagination through a set of `CeeExecution`. */
  ceeExecutionsByExecutorCode: CeeExecutionsConnection
  createdAt: Scalars['Datetime']
  databox?: Maybe<Scalars['String']>
  dic?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  executorCode?: Maybe<Scalars['String']>
  ico?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  name: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  note?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
  web?: Maybe<Scalars['String']>
}

export type CeeOfficeCeeExecutionsByExecutorCodeArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CeeExecutionCondition>
  filter?: InputMaybe<CeeExecutionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CeeExecutionsOrderBy>>
}

/**
 * A condition to be used against `CeeOffice` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CeeOfficeCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `area` field. */
  area?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `databox` field. */
  databox?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `dic` field. */
  dic?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `executorCode` field. */
  executorCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ico` field. */
  ico?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `phone` field. */
  phone?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `web` field. */
  web?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `CeeOffice` object types. All fields are combined with a logical ‘and.’ */
export type CeeOfficeFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CeeOfficeFilter>>
  /** Filter by the object’s `area` field. */
  area?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `databox` field. */
  databox?: InputMaybe<StringFilter>
  /** Filter by the object’s `dic` field. */
  dic?: InputMaybe<StringFilter>
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>
  /** Filter by the object’s `executorCode` field. */
  executorCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `ico` field. */
  ico?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<CeeOfficeFilter>
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CeeOfficeFilter>>
  /** Filter by the object’s `phone` field. */
  phone?: InputMaybe<StringFilter>
  /** Filter by the object’s `web` field. */
  web?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `CeeOffice` */
export type CeeOfficeInput = {
  address?: InputMaybe<Scalars['String']>
  area?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  databox?: InputMaybe<Scalars['String']>
  dic?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  executorCode?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  name: Scalars['String']
  note?: InputMaybe<Scalars['String']>
  phone?: InputMaybe<Scalars['String']>
  web?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `CeeOffice`. Fields that are set will be updated. */
export type CeeOfficePatch = {
  address?: InputMaybe<Scalars['String']>
  area?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  databox?: InputMaybe<Scalars['String']>
  dic?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  executorCode?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  name?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  phone?: InputMaybe<Scalars['String']>
  web?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `CeeOffice` values. */
export type CeeOfficesConnection = {
  __typename: 'CeeOfficesConnection'
  /** A list of edges which contains the `CeeOffice` and cursor to aid in pagination. */
  edges: Array<CeeOfficesEdge>
  /** A list of `CeeOffice` objects. */
  nodes: Array<Maybe<CeeOffice>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `CeeOffice` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `CeeOffice` edge in the connection. */
export type CeeOfficesEdge = {
  __typename: 'CeeOfficesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `CeeOffice` at the end of the edge. */
  node?: Maybe<CeeOffice>
}

/** Methods to use when ordering `CeeOffice`. */
export enum CeeOfficesOrderBy {
  AddressAsc = 'ADDRESS_ASC',
  AddressDesc = 'ADDRESS_DESC',
  AreaAsc = 'AREA_ASC',
  AreaDesc = 'AREA_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DataboxAsc = 'DATABOX_ASC',
  DataboxDesc = 'DATABOX_DESC',
  DicAsc = 'DIC_ASC',
  DicDesc = 'DIC_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  ExecutorCodeAsc = 'EXECUTOR_CODE_ASC',
  ExecutorCodeDesc = 'EXECUTOR_CODE_DESC',
  IcoAsc = 'ICO_ASC',
  IcoDesc = 'ICO_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  WebAsc = 'WEB_ASC',
  WebDesc = 'WEB_DESC',
}

/** All input for the create `Address` mutation. */
export type CreateAddressInput = {
  /** The `Address` to be created by this mutation. */
  address: AddressInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** The output of our create `Address` mutation. */
export type CreateAddressPayload = {
  __typename: 'CreateAddressPayload'
  /** The `Address` that was created by this mutation. */
  address?: Maybe<Address>
  /** An edge for our `Address`. May be used by Relay 1. */
  addressEdge?: Maybe<AddressesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `Address` mutation. */
export type CreateAddressPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>
}

/** All input for the create `AuctionListing` mutation. */
export type CreateAuctionListingInput = {
  /** The `AuctionListing` to be created by this mutation. */
  auctionListing: AuctionListingInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** The output of our create `AuctionListing` mutation. */
export type CreateAuctionListingPayload = {
  __typename: 'CreateAuctionListingPayload'
  /** The `AuctionListing` that was created by this mutation. */
  auctionListing?: Maybe<AuctionListing>
  /** An edge for our `AuctionListing`. May be used by Relay 1. */
  auctionListingEdge?: Maybe<AuctionListingsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `AuctionListing` mutation. */
export type CreateAuctionListingPayloadAuctionListingEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionListingsOrderBy>>
}

/** All input for the create `AuctionProperty` mutation. */
export type CreateAuctionPropertyInput = {
  /** The `AuctionProperty` to be created by this mutation. */
  auctionProperty: AuctionPropertyInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** The output of our create `AuctionProperty` mutation. */
export type CreateAuctionPropertyPayload = {
  __typename: 'CreateAuctionPropertyPayload'
  /** Reads a single `AuctionListing` that is related to this `AuctionProperty`. */
  auctionListingByAuctionId?: Maybe<AuctionListing>
  /** The `AuctionProperty` that was created by this mutation. */
  auctionProperty?: Maybe<AuctionProperty>
  /** An edge for our `AuctionProperty`. May be used by Relay 1. */
  auctionPropertyEdge?: Maybe<AuctionPropertiesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `AuctionProperty` mutation. */
export type CreateAuctionPropertyPayloadAuctionPropertyEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionPropertiesOrderBy>>
}

/** All input for the create `Bpej` mutation. */
export type CreateBpejInput = {
  /** The `Bpej` to be created by this mutation. */
  bpej: BpejInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** The output of our create `Bpej` mutation. */
export type CreateBpejPayload = {
  __typename: 'CreateBpejPayload'
  /** The `Bpej` that was created by this mutation. */
  bpej?: Maybe<Bpej>
  /** An edge for our `Bpej`. May be used by Relay 1. */
  bpejEdge?: Maybe<BpejsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `Bpej` mutation. */
export type CreateBpejPayloadBpejEdgeArgs = {
  orderBy?: InputMaybe<Array<BpejsOrderBy>>
}

/** All input for the create `BuybackCalculation` mutation. */
export type CreateBuybackCalculationInput = {
  /** The `BuybackCalculation` to be created by this mutation. */
  buybackCalculation: BuybackCalculationInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** The output of our create `BuybackCalculation` mutation. */
export type CreateBuybackCalculationPayload = {
  __typename: 'CreateBuybackCalculationPayload'
  /** The `BuybackCalculation` that was created by this mutation. */
  buybackCalculation?: Maybe<BuybackCalculation>
  /** An edge for our `BuybackCalculation`. May be used by Relay 1. */
  buybackCalculationEdge?: Maybe<BuybackCalculationsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `BuybackCalculation` mutation. */
export type CreateBuybackCalculationPayloadBuybackCalculationEdgeArgs = {
  orderBy?: InputMaybe<Array<BuybackCalculationsOrderBy>>
}

/** All input for the create `CeeExecutionDetail` mutation. */
export type CreateCeeExecutionDetailInput = {
  /** The `CeeExecutionDetail` to be created by this mutation. */
  ceeExecutionDetail: CeeExecutionDetailInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** The output of our create `CeeExecutionDetail` mutation. */
export type CreateCeeExecutionDetailPayload = {
  __typename: 'CreateCeeExecutionDetailPayload'
  /** Reads a single `CeeExecution` that is related to this `CeeExecutionDetail`. */
  ceeExecutionByCeeExecutionId?: Maybe<CeeExecution>
  /** The `CeeExecutionDetail` that was created by this mutation. */
  ceeExecutionDetail?: Maybe<CeeExecutionDetail>
  /** An edge for our `CeeExecutionDetail`. May be used by Relay 1. */
  ceeExecutionDetailEdge?: Maybe<CeeExecutionDetailsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `CeeExecutionDetail` mutation. */
export type CreateCeeExecutionDetailPayloadCeeExecutionDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<CeeExecutionDetailsOrderBy>>
}

/** All input for the create `CeeExecution` mutation. */
export type CreateCeeExecutionInput = {
  /** The `CeeExecution` to be created by this mutation. */
  ceeExecution: CeeExecutionInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** The output of our create `CeeExecution` mutation. */
export type CreateCeeExecutionPayload = {
  __typename: 'CreateCeeExecutionPayload'
  /** The `CeeExecution` that was created by this mutation. */
  ceeExecution?: Maybe<CeeExecution>
  /** An edge for our `CeeExecution`. May be used by Relay 1. */
  ceeExecutionEdge?: Maybe<CeeExecutionsEdge>
  /** Reads a single `CeeOffice` that is related to this `CeeExecution`. */
  ceeOfficeByExecutorCode?: Maybe<CeeOffice>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `MonitoringCee` that is related to this `CeeExecution`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `CeeExecution` mutation. */
export type CreateCeeExecutionPayloadCeeExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<CeeExecutionsOrderBy>>
}

/** All input for the create `CeeOffice` mutation. */
export type CreateCeeOfficeInput = {
  /** The `CeeOffice` to be created by this mutation. */
  ceeOffice: CeeOfficeInput
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** The output of our create `CeeOffice` mutation. */
export type CreateCeeOfficePayload = {
  __typename: 'CreateCeeOfficePayload'
  /** The `CeeOffice` that was created by this mutation. */
  ceeOffice?: Maybe<CeeOffice>
  /** An edge for our `CeeOffice`. May be used by Relay 1. */
  ceeOfficeEdge?: Maybe<CeeOfficesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `CeeOffice` mutation. */
export type CreateCeeOfficePayloadCeeOfficeEdgeArgs = {
  orderBy?: InputMaybe<Array<CeeOfficesOrderBy>>
}

/** All input for the create `CuzkDocumentCollection` mutation. */
export type CreateCuzkDocumentCollectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `CuzkDocumentCollection` to be created by this mutation. */
  cuzkDocumentCollection: CuzkDocumentCollectionInput
}

/** The output of our create `CuzkDocumentCollection` mutation. */
export type CreateCuzkDocumentCollectionPayload = {
  __typename: 'CreateCuzkDocumentCollectionPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkDocumentCollection` that was created by this mutation. */
  cuzkDocumentCollection?: Maybe<CuzkDocumentCollection>
  /** An edge for our `CuzkDocumentCollection`. May be used by Relay 1. */
  cuzkDocumentCollectionEdge?: Maybe<CuzkDocumentCollectionsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `CuzkDocumentCollection` mutation. */
export type CreateCuzkDocumentCollectionPayloadCuzkDocumentCollectionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<CuzkDocumentCollectionsOrderBy>>
  }

/** All input for the create `CuzkEpo` mutation. */
export type CreateCuzkEpoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `CuzkEpo` to be created by this mutation. */
  cuzkEpo: CuzkEpoInput
}

/** All input for the create `CuzkEpoLien` mutation. */
export type CreateCuzkEpoLienInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `CuzkEpoLien` to be created by this mutation. */
  cuzkEpoLien: CuzkEpoLienInput
}

/** The output of our create `CuzkEpoLien` mutation. */
export type CreateCuzkEpoLienPayload = {
  __typename: 'CreateCuzkEpoLienPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkEpoLien` that was created by this mutation. */
  cuzkEpoLien?: Maybe<CuzkEpoLien>
  /** An edge for our `CuzkEpoLien`. May be used by Relay 1. */
  cuzkEpoLienEdge?: Maybe<CuzkEpoLiensEdge>
  /** Reads a single `CuzkEpoRestrictionCheck` that is related to this `CuzkEpoLien`. */
  cuzkEpoRestrictionCheckByRestrictionCheckId?: Maybe<CuzkEpoRestrictionCheck>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `CuzkEpoLien` mutation. */
export type CreateCuzkEpoLienPayloadCuzkEpoLienEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkEpoLiensOrderBy>>
}

/** The output of our create `CuzkEpo` mutation. */
export type CreateCuzkEpoPayload = {
  __typename: 'CreateCuzkEpoPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkEpo` that was created by this mutation. */
  cuzkEpo?: Maybe<CuzkEpo>
  /** An edge for our `CuzkEpo`. May be used by Relay 1. */
  cuzkEpoEdge?: Maybe<CuzkEposEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `CuzkEpo` mutation. */
export type CreateCuzkEpoPayloadCuzkEpoEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkEposOrderBy>>
}

/** All input for the create `CuzkEpoRestrictionCheck` mutation. */
export type CreateCuzkEpoRestrictionCheckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `CuzkEpoRestrictionCheck` to be created by this mutation. */
  cuzkEpoRestrictionCheck: CuzkEpoRestrictionCheckInput
}

/** The output of our create `CuzkEpoRestrictionCheck` mutation. */
export type CreateCuzkEpoRestrictionCheckPayload = {
  __typename: 'CreateCuzkEpoRestrictionCheckPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `CuzkEpo` that is related to this `CuzkEpoRestrictionCheck`. */
  cuzkEpoByCuzkEpoId?: Maybe<CuzkEpo>
  /** The `CuzkEpoRestrictionCheck` that was created by this mutation. */
  cuzkEpoRestrictionCheck?: Maybe<CuzkEpoRestrictionCheck>
  /** An edge for our `CuzkEpoRestrictionCheck`. May be used by Relay 1. */
  cuzkEpoRestrictionCheckEdge?: Maybe<CuzkEpoRestrictionChecksEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `CuzkEpoRestrictionCheck` mutation. */
export type CreateCuzkEpoRestrictionCheckPayloadCuzkEpoRestrictionCheckEdgeArgs =
  {
    orderBy?: InputMaybe<Array<CuzkEpoRestrictionChecksOrderBy>>
  }

/** All input for the create `CuzkLv` mutation. */
export type CreateCuzkLvInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `CuzkLv` to be created by this mutation. */
  cuzkLv: CuzkLvInput
}

/** The output of our create `CuzkLv` mutation. */
export type CreateCuzkLvPayload = {
  __typename: 'CreateCuzkLvPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkLv` that was created by this mutation. */
  cuzkLv?: Maybe<CuzkLv>
  /** An edge for our `CuzkLv`. May be used by Relay 1. */
  cuzkLvEdge?: Maybe<CuzkLvsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `CuzkLv` mutation. */
export type CreateCuzkLvPayloadCuzkLvEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkLvsOrderBy>>
}

/** All input for the create `CuzkO` mutation. */
export type CreateCuzkOInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `CuzkO` to be created by this mutation. */
  cuzkO: CuzkOInput
}

/** The output of our create `CuzkO` mutation. */
export type CreateCuzkOPayload = {
  __typename: 'CreateCuzkOPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkO` that was created by this mutation. */
  cuzkO?: Maybe<CuzkO>
  /** Reads a single `CuzkO` that is related to this `CuzkO`. */
  cuzkOByPartner1?: Maybe<CuzkO>
  /** Reads a single `CuzkO` that is related to this `CuzkO`. */
  cuzkOByPartner2?: Maybe<CuzkO>
  /** An edge for our `CuzkO`. May be used by Relay 1. */
  cuzkOEdge?: Maybe<CuzkOsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `CuzkO` mutation. */
export type CreateCuzkOPayloadCuzkOEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkOsOrderBy>>
}

/** All input for the create `Databox` mutation. */
export type CreateDataboxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `Databox` to be created by this mutation. */
  databox: DataboxInput
}

/** The output of our create `Databox` mutation. */
export type CreateDataboxPayload = {
  __typename: 'CreateDataboxPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `Databox` that was created by this mutation. */
  databox?: Maybe<Databox>
  /** An edge for our `Databox`. May be used by Relay 1. */
  databoxEdge?: Maybe<DataboxesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `Databox` mutation. */
export type CreateDataboxPayloadDataboxEdgeArgs = {
  orderBy?: InputMaybe<Array<DataboxesOrderBy>>
}

/** All input for the create `KuArea` mutation. */
export type CreateKuAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `KuArea` to be created by this mutation. */
  kuArea: KuAreaInput
}

/** The output of our create `KuArea` mutation. */
export type CreateKuAreaPayload = {
  __typename: 'CreateKuAreaPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `KuArea` that was created by this mutation. */
  kuArea?: Maybe<KuArea>
  /** An edge for our `KuArea`. May be used by Relay 1. */
  kuAreaEdge?: Maybe<KuAreasEdge>
  /** Reads a single `KuWorkplace` that is related to this `KuArea`. */
  kuWorkplaceByPraresKod?: Maybe<KuWorkplace>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `KuArea` mutation. */
export type CreateKuAreaPayloadKuAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<KuAreasOrderBy>>
}

/** All input for the create `KuWorkplace` mutation. */
export type CreateKuWorkplaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `KuWorkplace` to be created by this mutation. */
  kuWorkplace: KuWorkplaceInput
}

/** The output of our create `KuWorkplace` mutation. */
export type CreateKuWorkplacePayload = {
  __typename: 'CreateKuWorkplacePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `KuWorkplace` that was created by this mutation. */
  kuWorkplace?: Maybe<KuWorkplace>
  /** Reads a single `KuWorkplace` that is related to this `KuWorkplace`. */
  kuWorkplaceByNadrizPrac?: Maybe<KuWorkplace>
  /** An edge for our `KuWorkplace`. May be used by Relay 1. */
  kuWorkplaceEdge?: Maybe<KuWorkplacesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `KuWorkplace` mutation. */
export type CreateKuWorkplacePayloadKuWorkplaceEdgeArgs = {
  orderBy?: InputMaybe<Array<KuWorkplacesOrderBy>>
}

/** All input for the create `LabelConnection` mutation. */
export type CreateLabelConnectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `LabelConnection` to be created by this mutation. */
  labelConnection: LabelConnectionInput
}

/** The output of our create `LabelConnection` mutation. */
export type CreateLabelConnectionPayload = {
  __typename: 'CreateLabelConnectionPayload'
  /** Reads a single `AuctionListing` that is related to this `LabelConnection`. */
  auctionListingByAuctionListingId?: Maybe<AuctionListing>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `CuzkDocumentCollection` that is related to this `LabelConnection`. */
  cuzkDocumentCollectionByCuzkDocumentCollectionId?: Maybe<CuzkDocumentCollection>
  /** Reads a single `CuzkEpo` that is related to this `LabelConnection`. */
  cuzkEpoByCuzkEpoId?: Maybe<CuzkEpo>
  /** Reads a single `CuzkEpoLien` that is related to this `LabelConnection`. */
  cuzkEpoLienByCuzkEpoLienId?: Maybe<CuzkEpoLien>
  /** Reads a single `CuzkLv` that is related to this `LabelConnection`. */
  cuzkLvByCuzkLvId?: Maybe<CuzkLv>
  /** Reads a single `Label` that is related to this `LabelConnection`. */
  labelByLabelId?: Maybe<Label>
  /** The `LabelConnection` that was created by this mutation. */
  labelConnection?: Maybe<LabelConnection>
  /** An edge for our `LabelConnection`. May be used by Relay 1. */
  labelConnectionEdge?: Maybe<LabelConnectionsEdge>
  /** Reads a single `MarketplaceOffer` that is related to this `LabelConnection`. */
  marketplaceOfferByMarketplaceOfferId?: Maybe<MarketplaceOffer>
  /** Reads a single `Monit` that is related to this `LabelConnection`. */
  monitByMonitId?: Maybe<Monit>
  /** Reads a single `MonitoringCee` that is related to this `LabelConnection`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  /** Reads a single `MonitoringCuzkRc` that is related to this `LabelConnection`. */
  monitoringCuzkRcByMonitoringCuzkRcId?: Maybe<MonitoringCuzkRc>
  /** Reads a single `PostserviceList` that is related to this `LabelConnection`. */
  postserviceListByPostserviceListId?: Maybe<PostserviceList>
  /** Reads a single `PropertyLabel` that is related to this `LabelConnection`. */
  propertyLabelByPropertyLabelId?: Maybe<PropertyLabel>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** Reads a single `RecipientList` that is related to this `LabelConnection`. */
  recipientListByRecipientListId?: Maybe<RecipientList>
}

/** The output of our create `LabelConnection` mutation. */
export type CreateLabelConnectionPayloadLabelConnectionEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

/** All input for the create `Label` mutation. */
export type CreateLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `Label` to be created by this mutation. */
  label: LabelInput
}

/** All input for the create `LabelMonitoringCuzkRc` mutation. */
export type CreateLabelMonitoringCuzkRcInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `LabelMonitoringCuzkRc` to be created by this mutation. */
  labelMonitoringCuzkRc: LabelMonitoringCuzkRcInput
}

/** The output of our create `LabelMonitoringCuzkRc` mutation. */
export type CreateLabelMonitoringCuzkRcPayload = {
  __typename: 'CreateLabelMonitoringCuzkRcPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `Label` that is related to this `LabelMonitoringCuzkRc`. */
  labelByLabelId?: Maybe<Label>
  /** The `LabelMonitoringCuzkRc` that was created by this mutation. */
  labelMonitoringCuzkRc?: Maybe<LabelMonitoringCuzkRc>
  /** An edge for our `LabelMonitoringCuzkRc`. May be used by Relay 1. */
  labelMonitoringCuzkRcEdge?: Maybe<LabelMonitoringCuzkRcsEdge>
  /** Reads a single `MonitoringCuzkRc` that is related to this `LabelMonitoringCuzkRc`. */
  monitoringCuzkRcByMonitoringCuzkRcId?: Maybe<MonitoringCuzkRc>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `LabelMonitoringCuzkRc` mutation. */
export type CreateLabelMonitoringCuzkRcPayloadLabelMonitoringCuzkRcEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelMonitoringCuzkRcsOrderBy>>
}

/** The output of our create `Label` mutation. */
export type CreateLabelPayload = {
  __typename: 'CreateLabelPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `Label` that was created by this mutation. */
  label?: Maybe<Label>
  /** An edge for our `Label`. May be used by Relay 1. */
  labelEdge?: Maybe<LabelsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `Label` mutation. */
export type CreateLabelPayloadLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelsOrderBy>>
}

/** All input for the create `MarketplaceOfferAccess` mutation. */
export type CreateMarketplaceOfferAccessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `MarketplaceOfferAccess` to be created by this mutation. */
  marketplaceOfferAccess: MarketplaceOfferAccessInput
}

/** The output of our create `MarketplaceOfferAccess` mutation. */
export type CreateMarketplaceOfferAccessPayload = {
  __typename: 'CreateMarketplaceOfferAccessPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `MarketplaceOfferAccess` that was created by this mutation. */
  marketplaceOfferAccess?: Maybe<MarketplaceOfferAccess>
  /** An edge for our `MarketplaceOfferAccess`. May be used by Relay 1. */
  marketplaceOfferAccessEdge?: Maybe<MarketplaceOfferAccessesEdge>
  /** Reads a single `MarketplaceOffer` that is related to this `MarketplaceOfferAccess`. */
  marketplaceOfferByOfferId?: Maybe<MarketplaceOffer>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `MarketplaceOfferAccess` mutation. */
export type CreateMarketplaceOfferAccessPayloadMarketplaceOfferAccessEdgeArgs =
  {
    orderBy?: InputMaybe<Array<MarketplaceOfferAccessesOrderBy>>
  }

/** All input for the create `MarketplaceOffer` mutation. */
export type CreateMarketplaceOfferInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `MarketplaceOffer` to be created by this mutation. */
  marketplaceOffer: MarketplaceOfferInput
}

/** The output of our create `MarketplaceOffer` mutation. */
export type CreateMarketplaceOfferPayload = {
  __typename: 'CreateMarketplaceOfferPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `MarketplaceOffer` that was created by this mutation. */
  marketplaceOffer?: Maybe<MarketplaceOffer>
  /** An edge for our `MarketplaceOffer`. May be used by Relay 1. */
  marketplaceOfferEdge?: Maybe<MarketplaceOffersEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `MarketplaceOffer` mutation. */
export type CreateMarketplaceOfferPayloadMarketplaceOfferEdgeArgs = {
  orderBy?: InputMaybe<Array<MarketplaceOffersOrderBy>>
}

/** All input for the create `Monit` mutation. */
export type CreateMonitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `Monit` to be created by this mutation. */
  monit: MonitInput
}

/** The output of our create `Monit` mutation. */
export type CreateMonitPayload = {
  __typename: 'CreateMonitPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `Monit` that was created by this mutation. */
  monit?: Maybe<Monit>
  /** An edge for our `Monit`. May be used by Relay 1. */
  monitEdge?: Maybe<MonitsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `Monit` mutation. */
export type CreateMonitPayloadMonitEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitsOrderBy>>
}

/** All input for the create `MonitoringCee` mutation. */
export type CreateMonitoringCeeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `MonitoringCee` to be created by this mutation. */
  monitoringCee: MonitoringCeeInput
}

/** The output of our create `MonitoringCee` mutation. */
export type CreateMonitoringCeePayload = {
  __typename: 'CreateMonitoringCeePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `MonitoringCee` that was created by this mutation. */
  monitoringCee?: Maybe<MonitoringCee>
  /** An edge for our `MonitoringCee`. May be used by Relay 1. */
  monitoringCeeEdge?: Maybe<MonitoringCeesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `MonitoringCee` mutation. */
export type CreateMonitoringCeePayloadMonitoringCeeEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitoringCeesOrderBy>>
}

/** All input for the create `MonitoringCuzkRc` mutation. */
export type CreateMonitoringCuzkRcInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `MonitoringCuzkRc` to be created by this mutation. */
  monitoringCuzkRc: MonitoringCuzkRcInput
}

/** The output of our create `MonitoringCuzkRc` mutation. */
export type CreateMonitoringCuzkRcPayload = {
  __typename: 'CreateMonitoringCuzkRcPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `CuzkO` that is related to this `MonitoringCuzkRc`. */
  cuzkOByCuzkOsId?: Maybe<CuzkO>
  /** Reads a single `MonitoringCee` that is related to this `MonitoringCuzkRc`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  /** The `MonitoringCuzkRc` that was created by this mutation. */
  monitoringCuzkRc?: Maybe<MonitoringCuzkRc>
  /** An edge for our `MonitoringCuzkRc`. May be used by Relay 1. */
  monitoringCuzkRcEdge?: Maybe<MonitoringCuzkRcsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `MonitoringCuzkRc` mutation. */
export type CreateMonitoringCuzkRcPayloadMonitoringCuzkRcEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitoringCuzkRcsOrderBy>>
}

/** All input for the create `MunicipalOffice` mutation. */
export type CreateMunicipalOfficeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `MunicipalOffice` to be created by this mutation. */
  municipalOffice: MunicipalOfficeInput
}

/** The output of our create `MunicipalOffice` mutation. */
export type CreateMunicipalOfficePayload = {
  __typename: 'CreateMunicipalOfficePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `MunicipalOffice` that was created by this mutation. */
  municipalOffice?: Maybe<MunicipalOffice>
  /** An edge for our `MunicipalOffice`. May be used by Relay 1. */
  municipalOfficeEdge?: Maybe<MunicipalOfficesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `MunicipalOffice` mutation. */
export type CreateMunicipalOfficePayloadMunicipalOfficeEdgeArgs = {
  orderBy?: InputMaybe<Array<MunicipalOfficesOrderBy>>
}

/** All input for the create `PostserviceList` mutation. */
export type CreatePostserviceListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `PostserviceList` to be created by this mutation. */
  postserviceList: PostserviceListInput
}

/** The output of our create `PostserviceList` mutation. */
export type CreatePostserviceListPayload = {
  __typename: 'CreatePostserviceListPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `PostserviceList` that was created by this mutation. */
  postserviceList?: Maybe<PostserviceList>
  /** An edge for our `PostserviceList`. May be used by Relay 1. */
  postserviceListEdge?: Maybe<PostserviceListsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `PostserviceList` mutation. */
export type CreatePostserviceListPayloadPostserviceListEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceListsOrderBy>>
}

/** All input for the create `PostserviceRecipient` mutation. */
export type CreatePostserviceRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `PostserviceRecipient` to be created by this mutation. */
  postserviceRecipient: PostserviceRecipientInput
}

/** The output of our create `PostserviceRecipient` mutation. */
export type CreatePostserviceRecipientPayload = {
  __typename: 'CreatePostserviceRecipientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `PostserviceList` that is related to this `PostserviceRecipient`. */
  postserviceListByPostserviceListId?: Maybe<PostserviceList>
  /** The `PostserviceRecipient` that was created by this mutation. */
  postserviceRecipient?: Maybe<PostserviceRecipient>
  /** An edge for our `PostserviceRecipient`. May be used by Relay 1. */
  postserviceRecipientEdge?: Maybe<PostserviceRecipientsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `PostserviceRecipient` mutation. */
export type CreatePostserviceRecipientPayloadPostserviceRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceRecipientsOrderBy>>
}

/** All input for the create `PostserviceSentLetter` mutation. */
export type CreatePostserviceSentLetterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `PostserviceSentLetter` to be created by this mutation. */
  postserviceSentLetter: PostserviceSentLetterInput
}

/** The output of our create `PostserviceSentLetter` mutation. */
export type CreatePostserviceSentLetterPayload = {
  __typename: 'CreatePostserviceSentLetterPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `PostserviceList` that is related to this `PostserviceSentLetter`. */
  postserviceListByOriginalListId?: Maybe<PostserviceList>
  /** The `PostserviceSentLetter` that was created by this mutation. */
  postserviceSentLetter?: Maybe<PostserviceSentLetter>
  /** An edge for our `PostserviceSentLetter`. May be used by Relay 1. */
  postserviceSentLetterEdge?: Maybe<PostserviceSentLettersEdge>
  /** Reads a single `PostserviceTemplate` that is related to this `PostserviceSentLetter`. */
  postserviceTemplateByOriginalTemplateId?: Maybe<PostserviceTemplate>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** Reads a single `SenderAddress` that is related to this `PostserviceSentLetter`. */
  senderAddressBySenderAddressId?: Maybe<SenderAddress>
}

/** The output of our create `PostserviceSentLetter` mutation. */
export type CreatePostserviceSentLetterPayloadPostserviceSentLetterEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceSentLettersOrderBy>>
}

/** All input for the create `PostserviceSentRecipient` mutation. */
export type CreatePostserviceSentRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `PostserviceSentRecipient` to be created by this mutation. */
  postserviceSentRecipient: PostserviceSentRecipientInput
}

/** The output of our create `PostserviceSentRecipient` mutation. */
export type CreatePostserviceSentRecipientPayload = {
  __typename: 'CreatePostserviceSentRecipientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `PostserviceRecipient` that is related to this `PostserviceSentRecipient`. */
  postserviceRecipientByOriginalRecipientId?: Maybe<PostserviceRecipient>
  /** Reads a single `PostserviceSentLetter` that is related to this `PostserviceSentRecipient`. */
  postserviceSentLetterBySentLetterId?: Maybe<PostserviceSentLetter>
  /** The `PostserviceSentRecipient` that was created by this mutation. */
  postserviceSentRecipient?: Maybe<PostserviceSentRecipient>
  /** An edge for our `PostserviceSentRecipient`. May be used by Relay 1. */
  postserviceSentRecipientEdge?: Maybe<PostserviceSentRecipientsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `PostserviceSentRecipient` mutation. */
export type CreatePostserviceSentRecipientPayloadPostserviceSentRecipientEdgeArgs =
  {
    orderBy?: InputMaybe<Array<PostserviceSentRecipientsOrderBy>>
  }

/** All input for the create `PostserviceTemplate` mutation. */
export type CreatePostserviceTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `PostserviceTemplate` to be created by this mutation. */
  postserviceTemplate: PostserviceTemplateInput
}

/** The output of our create `PostserviceTemplate` mutation. */
export type CreatePostserviceTemplatePayload = {
  __typename: 'CreatePostserviceTemplatePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `PostserviceTemplate` that was created by this mutation. */
  postserviceTemplate?: Maybe<PostserviceTemplate>
  /** An edge for our `PostserviceTemplate`. May be used by Relay 1. */
  postserviceTemplateEdge?: Maybe<PostserviceTemplatesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `PostserviceTemplate` mutation. */
export type CreatePostserviceTemplatePayloadPostserviceTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceTemplatesOrderBy>>
}

/** All input for the create `PropertyLabel` mutation. */
export type CreatePropertyLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `PropertyLabel` to be created by this mutation. */
  propertyLabel: PropertyLabelInput
}

/** The output of our create `PropertyLabel` mutation. */
export type CreatePropertyLabelPayload = {
  __typename: 'CreatePropertyLabelPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `PropertyLabel` that was created by this mutation. */
  propertyLabel?: Maybe<PropertyLabel>
  /** An edge for our `PropertyLabel`. May be used by Relay 1. */
  propertyLabelEdge?: Maybe<PropertyLabelsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `PropertyLabel` mutation. */
export type CreatePropertyLabelPayloadPropertyLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyLabelsOrderBy>>
}

/** All input for the create `PropertyList` mutation. */
export type CreatePropertyListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `PropertyList` to be created by this mutation. */
  propertyList: PropertyListInput
}

/** The output of our create `PropertyList` mutation. */
export type CreatePropertyListPayload = {
  __typename: 'CreatePropertyListPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `PropertyList` that was created by this mutation. */
  propertyList?: Maybe<PropertyList>
  /** An edge for our `PropertyList`. May be used by Relay 1. */
  propertyListEdge?: Maybe<PropertyListsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `PropertyList` mutation. */
export type CreatePropertyListPayloadPropertyListEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyListsOrderBy>>
}

/** All input for the create `PropertyNote` mutation. */
export type CreatePropertyNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `PropertyNote` to be created by this mutation. */
  propertyNote: PropertyNoteInput
}

/** The output of our create `PropertyNote` mutation. */
export type CreatePropertyNotePayload = {
  __typename: 'CreatePropertyNotePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `PropertyNote` that was created by this mutation. */
  propertyNote?: Maybe<PropertyNote>
  /** An edge for our `PropertyNote`. May be used by Relay 1. */
  propertyNoteEdge?: Maybe<PropertyNotesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our create `PropertyNote` mutation. */
export type CreatePropertyNotePayloadPropertyNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyNotesOrderBy>>
}

/** All input for the create `Recipient` mutation. */
export type CreateRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `Recipient` to be created by this mutation. */
  recipient: RecipientInput
}

/** All input for the create `RecipientList` mutation. */
export type CreateRecipientListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `RecipientList` to be created by this mutation. */
  recipientList: RecipientListInput
}

/** The output of our create `RecipientList` mutation. */
export type CreateRecipientListPayload = {
  __typename: 'CreateRecipientListPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `RecipientList` that was created by this mutation. */
  recipientList?: Maybe<RecipientList>
  /** An edge for our `RecipientList`. May be used by Relay 1. */
  recipientListEdge?: Maybe<RecipientListsEdge>
  /** Reads a single `SenderAddress` that is related to this `RecipientList`. */
  senderAddressBySenderAddressId?: Maybe<SenderAddress>
}

/** The output of our create `RecipientList` mutation. */
export type CreateRecipientListPayloadRecipientListEdgeArgs = {
  orderBy?: InputMaybe<Array<RecipientListsOrderBy>>
}

/** All input for the create `RecipientListRecipient` mutation. */
export type CreateRecipientListRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `RecipientListRecipient` to be created by this mutation. */
  recipientListRecipient: RecipientListRecipientInput
}

/** The output of our create `RecipientListRecipient` mutation. */
export type CreateRecipientListRecipientPayload = {
  __typename: 'CreateRecipientListRecipientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** Reads a single `Recipient` that is related to this `RecipientListRecipient`. */
  recipientByRecipientId?: Maybe<Recipient>
  /** Reads a single `RecipientList` that is related to this `RecipientListRecipient`. */
  recipientListByRecipientListId?: Maybe<RecipientList>
  /** The `RecipientListRecipient` that was created by this mutation. */
  recipientListRecipient?: Maybe<RecipientListRecipient>
  /** An edge for our `RecipientListRecipient`. May be used by Relay 1. */
  recipientListRecipientEdge?: Maybe<RecipientListRecipientsEdge>
}

/** The output of our create `RecipientListRecipient` mutation. */
export type CreateRecipientListRecipientPayloadRecipientListRecipientEdgeArgs =
  {
    orderBy?: InputMaybe<Array<RecipientListRecipientsOrderBy>>
  }

/** The output of our create `Recipient` mutation. */
export type CreateRecipientPayload = {
  __typename: 'CreateRecipientPayload'
  /** Reads a single `Address` that is related to this `Recipient`. */
  addressByAdresnimistokod?: Maybe<Address>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `Recipient` that was created by this mutation. */
  recipient?: Maybe<Recipient>
  /** An edge for our `Recipient`. May be used by Relay 1. */
  recipientEdge?: Maybe<RecipientsEdge>
}

/** The output of our create `Recipient` mutation. */
export type CreateRecipientPayloadRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<RecipientsOrderBy>>
}

/** All input for the create `SenderAddress` mutation. */
export type CreateSenderAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `SenderAddress` to be created by this mutation. */
  senderAddress: SenderAddressInput
}

/** The output of our create `SenderAddress` mutation. */
export type CreateSenderAddressPayload = {
  __typename: 'CreateSenderAddressPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `SenderAddress` that was created by this mutation. */
  senderAddress?: Maybe<SenderAddress>
  /** An edge for our `SenderAddress`. May be used by Relay 1. */
  senderAddressEdge?: Maybe<SenderAddressesEdge>
}

/** The output of our create `SenderAddress` mutation. */
export type CreateSenderAddressPayloadSenderAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<SenderAddressesOrderBy>>
}

/** All input for the create `UnitRent` mutation. */
export type CreateUnitRentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `UnitRent` to be created by this mutation. */
  unitRent: UnitRentInput
}

/** The output of our create `UnitRent` mutation. */
export type CreateUnitRentPayload = {
  __typename: 'CreateUnitRentPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `UnitRent` that was created by this mutation. */
  unitRent?: Maybe<UnitRent>
  /** An edge for our `UnitRent`. May be used by Relay 1. */
  unitRentEdge?: Maybe<UnitRentsEdge>
}

/** The output of our create `UnitRent` mutation. */
export type CreateUnitRentPayloadUnitRentEdgeArgs = {
  orderBy?: InputMaybe<Array<UnitRentsOrderBy>>
}

/** All input for the create `UserActivityLog` mutation. */
export type CreateUserActivityLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The `UserActivityLog` to be created by this mutation. */
  userActivityLog: UserActivityLogInput
}

/** The output of our create `UserActivityLog` mutation. */
export type CreateUserActivityLogPayload = {
  __typename: 'CreateUserActivityLogPayload'
  /** Reads a single `AuctionListing` that is related to this `UserActivityLog`. */
  auctionListingByAuctionListingId?: Maybe<AuctionListing>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `UserActivityLog` that was created by this mutation. */
  userActivityLog?: Maybe<UserActivityLog>
  /** An edge for our `UserActivityLog`. May be used by Relay 1. */
  userActivityLogEdge?: Maybe<UserActivityLogsEdge>
}

/** The output of our create `UserActivityLog` mutation. */
export type CreateUserActivityLogPayloadUserActivityLogEdgeArgs = {
  orderBy?: InputMaybe<Array<UserActivityLogsOrderBy>>
}

export type CuzkDocumentCollection = Node & {
  __typename: 'CuzkDocumentCollection'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  casoveraziko?: Maybe<Scalars['String']>
  cena?: Maybe<Scalars['BigFloat']>
  createdAt: Scalars['Datetime']
  cuzkCollectionId: Scalars['String']
  cuzkDocumentId: Scalars['String']
  datumpozadavku: Scalars['Datetime']
  datumspusteni: Scalars['Datetime']
  datumvytvoreni?: Maybe<Scalars['Datetime']>
  elznacka?: Maybe<Scalars['String']>
  format: Scalars['String']
  id: Scalars['UUID']
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByCuzkDocumentCollectionId: LabelConnectionsConnection
  nazev: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  pocetjednotek?: Maybe<Scalars['Int']>
  pocetstran?: Maybe<Scalars['Int']>
  rizeni: Scalars['String']
  stav: Scalars['String']
}

export type CuzkDocumentCollectionLabelConnectionsByCuzkDocumentCollectionIdArgs =
  {
    after?: InputMaybe<Scalars['Cursor']>
    before?: InputMaybe<Scalars['Cursor']>
    condition?: InputMaybe<LabelConnectionCondition>
    filter?: InputMaybe<LabelConnectionFilter>
    first?: InputMaybe<Scalars['Int']>
    last?: InputMaybe<Scalars['Int']>
    offset?: InputMaybe<Scalars['Int']>
    orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
  }

/**
 * A condition to be used against `CuzkDocumentCollection` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CuzkDocumentCollectionCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `casoveraziko` field. */
  casoveraziko?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `cena` field. */
  cena?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `cuzkCollectionId` field. */
  cuzkCollectionId?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `cuzkDocumentId` field. */
  cuzkDocumentId?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `datumpozadavku` field. */
  datumpozadavku?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `datumspusteni` field. */
  datumspusteni?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `datumvytvoreni` field. */
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `elznacka` field. */
  elznacka?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `format` field. */
  format?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `nazev` field. */
  nazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `pocetjednotek` field. */
  pocetjednotek?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `pocetstran` field. */
  pocetstran?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `rizeni` field. */
  rizeni?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `stav` field. */
  stav?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `CuzkDocumentCollection` object types. All fields are combined with a logical ‘and.’ */
export type CuzkDocumentCollectionFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CuzkDocumentCollectionFilter>>
  /** Filter by the object’s `casoveraziko` field. */
  casoveraziko?: InputMaybe<StringFilter>
  /** Filter by the object’s `cena` field. */
  cena?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `cuzkCollectionId` field. */
  cuzkCollectionId?: InputMaybe<StringFilter>
  /** Filter by the object’s `cuzkDocumentId` field. */
  cuzkDocumentId?: InputMaybe<StringFilter>
  /** Filter by the object’s `datumpozadavku` field. */
  datumpozadavku?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `datumspusteni` field. */
  datumspusteni?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `datumvytvoreni` field. */
  datumvytvoreni?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `elznacka` field. */
  elznacka?: InputMaybe<StringFilter>
  /** Filter by the object’s `format` field. */
  format?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `nazev` field. */
  nazev?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<CuzkDocumentCollectionFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CuzkDocumentCollectionFilter>>
  /** Filter by the object’s `pocetjednotek` field. */
  pocetjednotek?: InputMaybe<IntFilter>
  /** Filter by the object’s `pocetstran` field. */
  pocetstran?: InputMaybe<IntFilter>
  /** Filter by the object’s `rizeni` field. */
  rizeni?: InputMaybe<StringFilter>
  /** Filter by the object’s `stav` field. */
  stav?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `CuzkDocumentCollection` */
export type CuzkDocumentCollectionInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  casoveraziko?: InputMaybe<Scalars['String']>
  cena?: InputMaybe<Scalars['BigFloat']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkCollectionId: Scalars['String']
  cuzkDocumentId: Scalars['String']
  datumpozadavku: Scalars['Datetime']
  datumspusteni: Scalars['Datetime']
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  elznacka?: InputMaybe<Scalars['String']>
  format: Scalars['String']
  id?: InputMaybe<Scalars['UUID']>
  nazev: Scalars['String']
  pocetjednotek?: InputMaybe<Scalars['Int']>
  pocetstran?: InputMaybe<Scalars['Int']>
  rizeni: Scalars['String']
  stav: Scalars['String']
}

/** Represents an update to a `CuzkDocumentCollection`. Fields that are set will be updated. */
export type CuzkDocumentCollectionPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  casoveraziko?: InputMaybe<Scalars['String']>
  cena?: InputMaybe<Scalars['BigFloat']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkCollectionId?: InputMaybe<Scalars['String']>
  cuzkDocumentId?: InputMaybe<Scalars['String']>
  datumpozadavku?: InputMaybe<Scalars['Datetime']>
  datumspusteni?: InputMaybe<Scalars['Datetime']>
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  elznacka?: InputMaybe<Scalars['String']>
  format?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  nazev?: InputMaybe<Scalars['String']>
  pocetjednotek?: InputMaybe<Scalars['Int']>
  pocetstran?: InputMaybe<Scalars['Int']>
  rizeni?: InputMaybe<Scalars['String']>
  stav?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `CuzkDocumentCollection` values. */
export type CuzkDocumentCollectionsConnection = {
  __typename: 'CuzkDocumentCollectionsConnection'
  /** A list of edges which contains the `CuzkDocumentCollection` and cursor to aid in pagination. */
  edges: Array<CuzkDocumentCollectionsEdge>
  /** A list of `CuzkDocumentCollection` objects. */
  nodes: Array<Maybe<CuzkDocumentCollection>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `CuzkDocumentCollection` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `CuzkDocumentCollection` edge in the connection. */
export type CuzkDocumentCollectionsEdge = {
  __typename: 'CuzkDocumentCollectionsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `CuzkDocumentCollection` at the end of the edge. */
  node?: Maybe<CuzkDocumentCollection>
}

/** Methods to use when ordering `CuzkDocumentCollection`. */
export enum CuzkDocumentCollectionsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CasoverazikoAsc = 'CASOVERAZIKO_ASC',
  CasoverazikoDesc = 'CASOVERAZIKO_DESC',
  CenaAsc = 'CENA_ASC',
  CenaDesc = 'CENA_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CuzkCollectionIdAsc = 'CUZK_COLLECTION_ID_ASC',
  CuzkCollectionIdDesc = 'CUZK_COLLECTION_ID_DESC',
  CuzkDocumentIdAsc = 'CUZK_DOCUMENT_ID_ASC',
  CuzkDocumentIdDesc = 'CUZK_DOCUMENT_ID_DESC',
  DatumpozadavkuAsc = 'DATUMPOZADAVKU_ASC',
  DatumpozadavkuDesc = 'DATUMPOZADAVKU_DESC',
  DatumspusteniAsc = 'DATUMSPUSTENI_ASC',
  DatumspusteniDesc = 'DATUMSPUSTENI_DESC',
  DatumvytvoreniAsc = 'DATUMVYTVORENI_ASC',
  DatumvytvoreniDesc = 'DATUMVYTVORENI_DESC',
  ElznackaAsc = 'ELZNACKA_ASC',
  ElznackaDesc = 'ELZNACKA_DESC',
  FormatAsc = 'FORMAT_ASC',
  FormatDesc = 'FORMAT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NazevAsc = 'NAZEV_ASC',
  NazevDesc = 'NAZEV_DESC',
  PocetjednotekAsc = 'POCETJEDNOTEK_ASC',
  PocetjednotekDesc = 'POCETJEDNOTEK_DESC',
  PocetstranAsc = 'POCETSTRAN_ASC',
  PocetstranDesc = 'POCETSTRAN_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RizeniAsc = 'RIZENI_ASC',
  RizeniDesc = 'RIZENI_DESC',
  StavAsc = 'STAV_ASC',
  StavDesc = 'STAV_DESC',
}

export type CuzkEpo = Node & {
  __typename: 'CuzkEpo'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  adresnimistokod?: Maybe<Scalars['String']>
  cena?: Maybe<Scalars['BigFloat']>
  createdAt: Scalars['Datetime']
  cuzkCollectionId: Scalars['String']
  /** Reads and enables pagination through a set of `CuzkEpoRestrictionCheck`. */
  cuzkEpoRestrictionChecksByCuzkEpoId: CuzkEpoRestrictionChecksConnection
  datumpozadavku: Scalars['Datetime']
  datumspusteni: Scalars['Datetime']
  datumvytvoreni?: Maybe<Scalars['Datetime']>
  elznacka?: Maybe<Scalars['String']>
  format: Scalars['String']
  id: Scalars['UUID']
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByCuzkEpoId: LabelConnectionsConnection
  nazev: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  pocetLv?: Maybe<Scalars['Int']>
  pocetjednotek?: Maybe<Scalars['Int']>
  pocetstran?: Maybe<Scalars['Int']>
  rcIco: Scalars['String']
  stav: Scalars['String']
  typ: Scalars['String']
}

export type CuzkEpoCuzkEpoRestrictionChecksByCuzkEpoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CuzkEpoRestrictionCheckCondition>
  filter?: InputMaybe<CuzkEpoRestrictionCheckFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CuzkEpoRestrictionChecksOrderBy>>
}

export type CuzkEpoLabelConnectionsByCuzkEpoIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

/** A condition to be used against `CuzkEpo` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CuzkEpoCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `adresnimistokod` field. */
  adresnimistokod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `cena` field. */
  cena?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `cuzkCollectionId` field. */
  cuzkCollectionId?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `datumpozadavku` field. */
  datumpozadavku?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `datumspusteni` field. */
  datumspusteni?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `datumvytvoreni` field. */
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `elznacka` field. */
  elznacka?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `format` field. */
  format?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `nazev` field. */
  nazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `pocetLv` field. */
  pocetLv?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `pocetjednotek` field. */
  pocetjednotek?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `pocetstran` field. */
  pocetstran?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `rcIco` field. */
  rcIco?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `stav` field. */
  stav?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `typ` field. */
  typ?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `CuzkEpo` object types. All fields are combined with a logical ‘and.’ */
export type CuzkEpoFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `adresnimistokod` field. */
  adresnimistokod?: InputMaybe<StringFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CuzkEpoFilter>>
  /** Filter by the object’s `cena` field. */
  cena?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `cuzkCollectionId` field. */
  cuzkCollectionId?: InputMaybe<StringFilter>
  /** Filter by the object’s `datumpozadavku` field. */
  datumpozadavku?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `datumspusteni` field. */
  datumspusteni?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `datumvytvoreni` field. */
  datumvytvoreni?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `elznacka` field. */
  elznacka?: InputMaybe<StringFilter>
  /** Filter by the object’s `format` field. */
  format?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `nazev` field. */
  nazev?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<CuzkEpoFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CuzkEpoFilter>>
  /** Filter by the object’s `pocetLv` field. */
  pocetLv?: InputMaybe<IntFilter>
  /** Filter by the object’s `pocetjednotek` field. */
  pocetjednotek?: InputMaybe<IntFilter>
  /** Filter by the object’s `pocetstran` field. */
  pocetstran?: InputMaybe<IntFilter>
  /** Filter by the object’s `rcIco` field. */
  rcIco?: InputMaybe<StringFilter>
  /** Filter by the object’s `stav` field. */
  stav?: InputMaybe<StringFilter>
  /** Filter by the object’s `typ` field. */
  typ?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `CuzkEpo` */
export type CuzkEpoInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  adresnimistokod?: InputMaybe<Scalars['String']>
  cena?: InputMaybe<Scalars['BigFloat']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkCollectionId: Scalars['String']
  datumpozadavku: Scalars['Datetime']
  datumspusteni: Scalars['Datetime']
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  elznacka?: InputMaybe<Scalars['String']>
  format: Scalars['String']
  id?: InputMaybe<Scalars['UUID']>
  nazev: Scalars['String']
  pocetLv?: InputMaybe<Scalars['Int']>
  pocetjednotek?: InputMaybe<Scalars['Int']>
  pocetstran?: InputMaybe<Scalars['Int']>
  rcIco: Scalars['String']
  stav: Scalars['String']
  typ: Scalars['String']
}

export type CuzkEpoLien = Node & {
  __typename: 'CuzkEpoLien'
  budovyPocet: Scalars['Int']
  /** Reads a single `CuzkEpoRestrictionCheck` that is related to this `CuzkEpoLien`. */
  cuzkEpoRestrictionCheckByRestrictionCheckId?: Maybe<CuzkEpoRestrictionCheck>
  exekuce: Scalars['Boolean']
  id: Scalars['UUID']
  insolvence: Scalars['Boolean']
  jednotkyPocet: Scalars['Int']
  katastralniUzemiKod: Scalars['String']
  katastralniUzemiNazev: Scalars['String']
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByCuzkEpoLienId: LabelConnectionsConnection
  lv: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  obec?: Maybe<Scalars['String']>
  okres?: Maybe<Scalars['String']>
  parcelyPocet: Scalars['Int']
  predkupniPravo: Scalars['Boolean']
  restrictionCheckId: Scalars['UUID']
  rizeni?: Maybe<Array<Maybe<Scalars['String']>>>
  vlastniciPocet?: Maybe<Scalars['Int']>
  zastavyNedobrovolne: Scalars['Boolean']
}

export type CuzkEpoLienLabelConnectionsByCuzkEpoLienIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

/**
 * A condition to be used against `CuzkEpoLien` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CuzkEpoLienCondition = {
  /** Checks for equality with the object’s `budovyPocet` field. */
  budovyPocet?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `exekuce` field. */
  exekuce?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `insolvence` field. */
  insolvence?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `jednotkyPocet` field. */
  jednotkyPocet?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `katastralniUzemiKod` field. */
  katastralniUzemiKod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `katastralniUzemiNazev` field. */
  katastralniUzemiNazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `lv` field. */
  lv?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `obec` field. */
  obec?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `okres` field. */
  okres?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `parcelyPocet` field. */
  parcelyPocet?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `predkupniPravo` field. */
  predkupniPravo?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `restrictionCheckId` field. */
  restrictionCheckId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `rizeni` field. */
  rizeni?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Checks for equality with the object’s `vlastniciPocet` field. */
  vlastniciPocet?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `zastavyNedobrovolne` field. */
  zastavyNedobrovolne?: InputMaybe<Scalars['Boolean']>
}

/** A filter to be used against `CuzkEpoLien` object types. All fields are combined with a logical ‘and.’ */
export type CuzkEpoLienFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CuzkEpoLienFilter>>
  /** Filter by the object’s `budovyPocet` field. */
  budovyPocet?: InputMaybe<IntFilter>
  /** Filter by the object’s `exekuce` field. */
  exekuce?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `insolvence` field. */
  insolvence?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `jednotkyPocet` field. */
  jednotkyPocet?: InputMaybe<IntFilter>
  /** Filter by the object’s `katastralniUzemiKod` field. */
  katastralniUzemiKod?: InputMaybe<StringFilter>
  /** Filter by the object’s `katastralniUzemiNazev` field. */
  katastralniUzemiNazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `lv` field. */
  lv?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<CuzkEpoLienFilter>
  /** Filter by the object’s `obec` field. */
  obec?: InputMaybe<StringFilter>
  /** Filter by the object’s `okres` field. */
  okres?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CuzkEpoLienFilter>>
  /** Filter by the object’s `parcelyPocet` field. */
  parcelyPocet?: InputMaybe<IntFilter>
  /** Filter by the object’s `predkupniPravo` field. */
  predkupniPravo?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `restrictionCheckId` field. */
  restrictionCheckId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `rizeni` field. */
  rizeni?: InputMaybe<StringListFilter>
  /** Filter by the object’s `vlastniciPocet` field. */
  vlastniciPocet?: InputMaybe<IntFilter>
  /** Filter by the object’s `zastavyNedobrovolne` field. */
  zastavyNedobrovolne?: InputMaybe<BooleanFilter>
}

/** An input for mutations affecting `CuzkEpoLien` */
export type CuzkEpoLienInput = {
  budovyPocet?: InputMaybe<Scalars['Int']>
  exekuce?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['UUID']>
  insolvence?: InputMaybe<Scalars['Boolean']>
  jednotkyPocet?: InputMaybe<Scalars['Int']>
  katastralniUzemiKod: Scalars['String']
  katastralniUzemiNazev: Scalars['String']
  lv: Scalars['String']
  obec?: InputMaybe<Scalars['String']>
  okres?: InputMaybe<Scalars['String']>
  parcelyPocet?: InputMaybe<Scalars['Int']>
  predkupniPravo?: InputMaybe<Scalars['Boolean']>
  restrictionCheckId: Scalars['UUID']
  rizeni?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  vlastniciPocet?: InputMaybe<Scalars['Int']>
  zastavyNedobrovolne?: InputMaybe<Scalars['Boolean']>
}

/** Represents an update to a `CuzkEpoLien`. Fields that are set will be updated. */
export type CuzkEpoLienPatch = {
  budovyPocet?: InputMaybe<Scalars['Int']>
  exekuce?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['UUID']>
  insolvence?: InputMaybe<Scalars['Boolean']>
  jednotkyPocet?: InputMaybe<Scalars['Int']>
  katastralniUzemiKod?: InputMaybe<Scalars['String']>
  katastralniUzemiNazev?: InputMaybe<Scalars['String']>
  lv?: InputMaybe<Scalars['String']>
  obec?: InputMaybe<Scalars['String']>
  okres?: InputMaybe<Scalars['String']>
  parcelyPocet?: InputMaybe<Scalars['Int']>
  predkupniPravo?: InputMaybe<Scalars['Boolean']>
  restrictionCheckId?: InputMaybe<Scalars['UUID']>
  rizeni?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  vlastniciPocet?: InputMaybe<Scalars['Int']>
  zastavyNedobrovolne?: InputMaybe<Scalars['Boolean']>
}

/** A connection to a list of `CuzkEpoLien` values. */
export type CuzkEpoLiensConnection = {
  __typename: 'CuzkEpoLiensConnection'
  /** A list of edges which contains the `CuzkEpoLien` and cursor to aid in pagination. */
  edges: Array<CuzkEpoLiensEdge>
  /** A list of `CuzkEpoLien` objects. */
  nodes: Array<Maybe<CuzkEpoLien>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `CuzkEpoLien` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `CuzkEpoLien` edge in the connection. */
export type CuzkEpoLiensEdge = {
  __typename: 'CuzkEpoLiensEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `CuzkEpoLien` at the end of the edge. */
  node?: Maybe<CuzkEpoLien>
}

/** Methods to use when ordering `CuzkEpoLien`. */
export enum CuzkEpoLiensOrderBy {
  BudovyPocetAsc = 'BUDOVY_POCET_ASC',
  BudovyPocetDesc = 'BUDOVY_POCET_DESC',
  ExekuceAsc = 'EXEKUCE_ASC',
  ExekuceDesc = 'EXEKUCE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InsolvenceAsc = 'INSOLVENCE_ASC',
  InsolvenceDesc = 'INSOLVENCE_DESC',
  JednotkyPocetAsc = 'JEDNOTKY_POCET_ASC',
  JednotkyPocetDesc = 'JEDNOTKY_POCET_DESC',
  KatastralniUzemiKodAsc = 'KATASTRALNI_UZEMI_KOD_ASC',
  KatastralniUzemiKodDesc = 'KATASTRALNI_UZEMI_KOD_DESC',
  KatastralniUzemiNazevAsc = 'KATASTRALNI_UZEMI_NAZEV_ASC',
  KatastralniUzemiNazevDesc = 'KATASTRALNI_UZEMI_NAZEV_DESC',
  LvAsc = 'LV_ASC',
  LvDesc = 'LV_DESC',
  Natural = 'NATURAL',
  ObecAsc = 'OBEC_ASC',
  ObecDesc = 'OBEC_DESC',
  OkresAsc = 'OKRES_ASC',
  OkresDesc = 'OKRES_DESC',
  ParcelyPocetAsc = 'PARCELY_POCET_ASC',
  ParcelyPocetDesc = 'PARCELY_POCET_DESC',
  PredkupniPravoAsc = 'PREDKUPNI_PRAVO_ASC',
  PredkupniPravoDesc = 'PREDKUPNI_PRAVO_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RestrictionCheckIdAsc = 'RESTRICTION_CHECK_ID_ASC',
  RestrictionCheckIdDesc = 'RESTRICTION_CHECK_ID_DESC',
  RizeniAsc = 'RIZENI_ASC',
  RizeniDesc = 'RIZENI_DESC',
  VlastniciPocetAsc = 'VLASTNICI_POCET_ASC',
  VlastniciPocetDesc = 'VLASTNICI_POCET_DESC',
  ZastavyNedobrovolneAsc = 'ZASTAVY_NEDOBROVOLNE_ASC',
  ZastavyNedobrovolneDesc = 'ZASTAVY_NEDOBROVOLNE_DESC',
}

/** Represents an update to a `CuzkEpo`. Fields that are set will be updated. */
export type CuzkEpoPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  adresnimistokod?: InputMaybe<Scalars['String']>
  cena?: InputMaybe<Scalars['BigFloat']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkCollectionId?: InputMaybe<Scalars['String']>
  datumpozadavku?: InputMaybe<Scalars['Datetime']>
  datumspusteni?: InputMaybe<Scalars['Datetime']>
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  elznacka?: InputMaybe<Scalars['String']>
  format?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  nazev?: InputMaybe<Scalars['String']>
  pocetLv?: InputMaybe<Scalars['Int']>
  pocetjednotek?: InputMaybe<Scalars['Int']>
  pocetstran?: InputMaybe<Scalars['Int']>
  rcIco?: InputMaybe<Scalars['String']>
  stav?: InputMaybe<Scalars['String']>
  typ?: InputMaybe<Scalars['String']>
}

export type CuzkEpoRestrictionCheck = Node & {
  __typename: 'CuzkEpoRestrictionCheck'
  accountId: Scalars['UUID']
  boughtAt?: Maybe<Scalars['Datetime']>
  boughtBy?: Maybe<Scalars['UUID']>
  checkedAt?: Maybe<Scalars['Datetime']>
  checkedBy?: Maybe<Scalars['UUID']>
  createdAt?: Maybe<Scalars['Datetime']>
  /** Reads a single `CuzkEpo` that is related to this `CuzkEpoRestrictionCheck`. */
  cuzkEpoByCuzkEpoId?: Maybe<CuzkEpo>
  cuzkEpoId: Scalars['UUID']
  /** Reads and enables pagination through a set of `CuzkEpoLien`. */
  cuzkEpoLiensByRestrictionCheckId: CuzkEpoLiensConnection
  id: Scalars['UUID']
  katastralniPracovisteKod: Scalars['String']
  katastralniPracovisteNazev?: Maybe<Scalars['String']>
  katastralniUradKod: Scalars['String']
  katastralniUradNazev?: Maybe<Scalars['String']>
  lvKeKontrolePocet?: Maybe<Scalars['Int']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  state: RestrictionCheckState
}

export type CuzkEpoRestrictionCheckCuzkEpoLiensByRestrictionCheckIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CuzkEpoLienCondition>
  filter?: InputMaybe<CuzkEpoLienFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CuzkEpoLiensOrderBy>>
}

/**
 * A condition to be used against `CuzkEpoRestrictionCheck` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type CuzkEpoRestrictionCheckCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `boughtAt` field. */
  boughtAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `boughtBy` field. */
  boughtBy?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `checkedAt` field. */
  checkedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `checkedBy` field. */
  checkedBy?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `cuzkEpoId` field. */
  cuzkEpoId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `katastralniPracovisteKod` field. */
  katastralniPracovisteKod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `katastralniPracovisteNazev` field. */
  katastralniPracovisteNazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `katastralniUradKod` field. */
  katastralniUradKod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `katastralniUradNazev` field. */
  katastralniUradNazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `lvKeKontrolePocet` field. */
  lvKeKontrolePocet?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<RestrictionCheckState>
}

/** A filter to be used against `CuzkEpoRestrictionCheck` object types. All fields are combined with a logical ‘and.’ */
export type CuzkEpoRestrictionCheckFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CuzkEpoRestrictionCheckFilter>>
  /** Filter by the object’s `boughtAt` field. */
  boughtAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `boughtBy` field. */
  boughtBy?: InputMaybe<UuidFilter>
  /** Filter by the object’s `checkedAt` field. */
  checkedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `checkedBy` field. */
  checkedBy?: InputMaybe<UuidFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `cuzkEpoId` field. */
  cuzkEpoId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `katastralniPracovisteKod` field. */
  katastralniPracovisteKod?: InputMaybe<StringFilter>
  /** Filter by the object’s `katastralniPracovisteNazev` field. */
  katastralniPracovisteNazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `katastralniUradKod` field. */
  katastralniUradKod?: InputMaybe<StringFilter>
  /** Filter by the object’s `katastralniUradNazev` field. */
  katastralniUradNazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `lvKeKontrolePocet` field. */
  lvKeKontrolePocet?: InputMaybe<IntFilter>
  /** Negates the expression. */
  not?: InputMaybe<CuzkEpoRestrictionCheckFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CuzkEpoRestrictionCheckFilter>>
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<RestrictionCheckStateFilter>
}

/** An input for mutations affecting `CuzkEpoRestrictionCheck` */
export type CuzkEpoRestrictionCheckInput = {
  accountId: Scalars['UUID']
  boughtAt?: InputMaybe<Scalars['Datetime']>
  boughtBy?: InputMaybe<Scalars['UUID']>
  checkedAt?: InputMaybe<Scalars['Datetime']>
  checkedBy?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkEpoId: Scalars['UUID']
  id?: InputMaybe<Scalars['UUID']>
  katastralniPracovisteKod: Scalars['String']
  katastralniPracovisteNazev?: InputMaybe<Scalars['String']>
  katastralniUradKod: Scalars['String']
  katastralniUradNazev?: InputMaybe<Scalars['String']>
  lvKeKontrolePocet?: InputMaybe<Scalars['Int']>
  state?: InputMaybe<RestrictionCheckState>
}

/** Represents an update to a `CuzkEpoRestrictionCheck`. Fields that are set will be updated. */
export type CuzkEpoRestrictionCheckPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  boughtAt?: InputMaybe<Scalars['Datetime']>
  boughtBy?: InputMaybe<Scalars['UUID']>
  checkedAt?: InputMaybe<Scalars['Datetime']>
  checkedBy?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkEpoId?: InputMaybe<Scalars['UUID']>
  id?: InputMaybe<Scalars['UUID']>
  katastralniPracovisteKod?: InputMaybe<Scalars['String']>
  katastralniPracovisteNazev?: InputMaybe<Scalars['String']>
  katastralniUradKod?: InputMaybe<Scalars['String']>
  katastralniUradNazev?: InputMaybe<Scalars['String']>
  lvKeKontrolePocet?: InputMaybe<Scalars['Int']>
  state?: InputMaybe<RestrictionCheckState>
}

/** A connection to a list of `CuzkEpoRestrictionCheck` values. */
export type CuzkEpoRestrictionChecksConnection = {
  __typename: 'CuzkEpoRestrictionChecksConnection'
  /** A list of edges which contains the `CuzkEpoRestrictionCheck` and cursor to aid in pagination. */
  edges: Array<CuzkEpoRestrictionChecksEdge>
  /** A list of `CuzkEpoRestrictionCheck` objects. */
  nodes: Array<Maybe<CuzkEpoRestrictionCheck>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `CuzkEpoRestrictionCheck` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `CuzkEpoRestrictionCheck` edge in the connection. */
export type CuzkEpoRestrictionChecksEdge = {
  __typename: 'CuzkEpoRestrictionChecksEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `CuzkEpoRestrictionCheck` at the end of the edge. */
  node?: Maybe<CuzkEpoRestrictionCheck>
}

/** Methods to use when ordering `CuzkEpoRestrictionCheck`. */
export enum CuzkEpoRestrictionChecksOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  BoughtAtAsc = 'BOUGHT_AT_ASC',
  BoughtAtDesc = 'BOUGHT_AT_DESC',
  BoughtByAsc = 'BOUGHT_BY_ASC',
  BoughtByDesc = 'BOUGHT_BY_DESC',
  CheckedAtAsc = 'CHECKED_AT_ASC',
  CheckedAtDesc = 'CHECKED_AT_DESC',
  CheckedByAsc = 'CHECKED_BY_ASC',
  CheckedByDesc = 'CHECKED_BY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CuzkEpoIdAsc = 'CUZK_EPO_ID_ASC',
  CuzkEpoIdDesc = 'CUZK_EPO_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KatastralniPracovisteKodAsc = 'KATASTRALNI_PRACOVISTE_KOD_ASC',
  KatastralniPracovisteKodDesc = 'KATASTRALNI_PRACOVISTE_KOD_DESC',
  KatastralniPracovisteNazevAsc = 'KATASTRALNI_PRACOVISTE_NAZEV_ASC',
  KatastralniPracovisteNazevDesc = 'KATASTRALNI_PRACOVISTE_NAZEV_DESC',
  KatastralniUradKodAsc = 'KATASTRALNI_URAD_KOD_ASC',
  KatastralniUradKodDesc = 'KATASTRALNI_URAD_KOD_DESC',
  KatastralniUradNazevAsc = 'KATASTRALNI_URAD_NAZEV_ASC',
  KatastralniUradNazevDesc = 'KATASTRALNI_URAD_NAZEV_DESC',
  LvKeKontrolePocetAsc = 'LV_KE_KONTROLE_POCET_ASC',
  LvKeKontrolePocetDesc = 'LV_KE_KONTROLE_POCET_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
}

/** A connection to a list of `CuzkEpo` values. */
export type CuzkEposConnection = {
  __typename: 'CuzkEposConnection'
  /** A list of edges which contains the `CuzkEpo` and cursor to aid in pagination. */
  edges: Array<CuzkEposEdge>
  /** A list of `CuzkEpo` objects. */
  nodes: Array<Maybe<CuzkEpo>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `CuzkEpo` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `CuzkEpo` edge in the connection. */
export type CuzkEposEdge = {
  __typename: 'CuzkEposEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `CuzkEpo` at the end of the edge. */
  node?: Maybe<CuzkEpo>
}

/** Methods to use when ordering `CuzkEpo`. */
export enum CuzkEposOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  AdresnimistokodAsc = 'ADRESNIMISTOKOD_ASC',
  AdresnimistokodDesc = 'ADRESNIMISTOKOD_DESC',
  CenaAsc = 'CENA_ASC',
  CenaDesc = 'CENA_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CuzkCollectionIdAsc = 'CUZK_COLLECTION_ID_ASC',
  CuzkCollectionIdDesc = 'CUZK_COLLECTION_ID_DESC',
  DatumpozadavkuAsc = 'DATUMPOZADAVKU_ASC',
  DatumpozadavkuDesc = 'DATUMPOZADAVKU_DESC',
  DatumspusteniAsc = 'DATUMSPUSTENI_ASC',
  DatumspusteniDesc = 'DATUMSPUSTENI_DESC',
  DatumvytvoreniAsc = 'DATUMVYTVORENI_ASC',
  DatumvytvoreniDesc = 'DATUMVYTVORENI_DESC',
  ElznackaAsc = 'ELZNACKA_ASC',
  ElznackaDesc = 'ELZNACKA_DESC',
  FormatAsc = 'FORMAT_ASC',
  FormatDesc = 'FORMAT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NazevAsc = 'NAZEV_ASC',
  NazevDesc = 'NAZEV_DESC',
  PocetjednotekAsc = 'POCETJEDNOTEK_ASC',
  PocetjednotekDesc = 'POCETJEDNOTEK_DESC',
  PocetstranAsc = 'POCETSTRAN_ASC',
  PocetstranDesc = 'POCETSTRAN_DESC',
  PocetLvAsc = 'POCET_LV_ASC',
  PocetLvDesc = 'POCET_LV_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RcIcoAsc = 'RC_ICO_ASC',
  RcIcoDesc = 'RC_ICO_DESC',
  StavAsc = 'STAV_ASC',
  StavDesc = 'STAV_DESC',
  TypAsc = 'TYP_ASC',
  TypDesc = 'TYP_DESC',
}

export type CuzkLv = Node & {
  __typename: 'CuzkLv'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  cena?: Maybe<Scalars['BigFloat']>
  createdAt: Scalars['Datetime']
  cuzkCollectionId: Scalars['String']
  datumK: Scalars['Date']
  datumpozadavku: Scalars['Datetime']
  datumspusteni: Scalars['Datetime']
  datumvytvoreni?: Maybe<Scalars['Datetime']>
  elznacka?: Maybe<Scalars['String']>
  format: Scalars['String']
  id: Scalars['UUID']
  katastralniUzemiKod: Scalars['String']
  katastralniUzemiNazev?: Maybe<Scalars['String']>
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByCuzkLvId: LabelConnectionsConnection
  lv: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  obec?: Maybe<Scalars['String']>
  pocetjednotek?: Maybe<Scalars['Int']>
  pocetstran?: Maybe<Scalars['Int']>
  stav: Scalars['String']
}

export type CuzkLvLabelConnectionsByCuzkLvIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

/** A condition to be used against `CuzkLv` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CuzkLvCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `cena` field. */
  cena?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `cuzkCollectionId` field. */
  cuzkCollectionId?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `datumK` field. */
  datumK?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `datumpozadavku` field. */
  datumpozadavku?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `datumspusteni` field. */
  datumspusteni?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `datumvytvoreni` field. */
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `elznacka` field. */
  elznacka?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `format` field. */
  format?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `katastralniUzemiKod` field. */
  katastralniUzemiKod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `katastralniUzemiNazev` field. */
  katastralniUzemiNazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `lv` field. */
  lv?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `obec` field. */
  obec?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `pocetjednotek` field. */
  pocetjednotek?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `pocetstran` field. */
  pocetstran?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `stav` field. */
  stav?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `CuzkLv` object types. All fields are combined with a logical ‘and.’ */
export type CuzkLvFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CuzkLvFilter>>
  /** Filter by the object’s `cena` field. */
  cena?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `cuzkCollectionId` field. */
  cuzkCollectionId?: InputMaybe<StringFilter>
  /** Filter by the object’s `datumK` field. */
  datumK?: InputMaybe<DateFilter>
  /** Filter by the object’s `datumpozadavku` field. */
  datumpozadavku?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `datumspusteni` field. */
  datumspusteni?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `datumvytvoreni` field. */
  datumvytvoreni?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `elznacka` field. */
  elznacka?: InputMaybe<StringFilter>
  /** Filter by the object’s `format` field. */
  format?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `katastralniUzemiKod` field. */
  katastralniUzemiKod?: InputMaybe<StringFilter>
  /** Filter by the object’s `katastralniUzemiNazev` field. */
  katastralniUzemiNazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `lv` field. */
  lv?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<CuzkLvFilter>
  /** Filter by the object’s `obec` field. */
  obec?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CuzkLvFilter>>
  /** Filter by the object’s `pocetjednotek` field. */
  pocetjednotek?: InputMaybe<IntFilter>
  /** Filter by the object’s `pocetstran` field. */
  pocetstran?: InputMaybe<IntFilter>
  /** Filter by the object’s `stav` field. */
  stav?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `CuzkLv` */
export type CuzkLvInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  cena?: InputMaybe<Scalars['BigFloat']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkCollectionId: Scalars['String']
  datumK?: InputMaybe<Scalars['Date']>
  datumpozadavku: Scalars['Datetime']
  datumspusteni: Scalars['Datetime']
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  elznacka?: InputMaybe<Scalars['String']>
  format: Scalars['String']
  id?: InputMaybe<Scalars['UUID']>
  katastralniUzemiKod: Scalars['String']
  katastralniUzemiNazev?: InputMaybe<Scalars['String']>
  lv: Scalars['String']
  obec?: InputMaybe<Scalars['String']>
  pocetjednotek?: InputMaybe<Scalars['Int']>
  pocetstran?: InputMaybe<Scalars['Int']>
  stav: Scalars['String']
}

/** Represents an update to a `CuzkLv`. Fields that are set will be updated. */
export type CuzkLvPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  cena?: InputMaybe<Scalars['BigFloat']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkCollectionId?: InputMaybe<Scalars['String']>
  datumK?: InputMaybe<Scalars['Date']>
  datumpozadavku?: InputMaybe<Scalars['Datetime']>
  datumspusteni?: InputMaybe<Scalars['Datetime']>
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  elznacka?: InputMaybe<Scalars['String']>
  format?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  katastralniUzemiKod?: InputMaybe<Scalars['String']>
  katastralniUzemiNazev?: InputMaybe<Scalars['String']>
  lv?: InputMaybe<Scalars['String']>
  obec?: InputMaybe<Scalars['String']>
  pocetjednotek?: InputMaybe<Scalars['Int']>
  pocetstran?: InputMaybe<Scalars['Int']>
  stav?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `CuzkLv` values. */
export type CuzkLvsConnection = {
  __typename: 'CuzkLvsConnection'
  /** A list of edges which contains the `CuzkLv` and cursor to aid in pagination. */
  edges: Array<CuzkLvsEdge>
  /** A list of `CuzkLv` objects. */
  nodes: Array<Maybe<CuzkLv>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `CuzkLv` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `CuzkLv` edge in the connection. */
export type CuzkLvsEdge = {
  __typename: 'CuzkLvsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `CuzkLv` at the end of the edge. */
  node?: Maybe<CuzkLv>
}

/** Methods to use when ordering `CuzkLv`. */
export enum CuzkLvsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CenaAsc = 'CENA_ASC',
  CenaDesc = 'CENA_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CuzkCollectionIdAsc = 'CUZK_COLLECTION_ID_ASC',
  CuzkCollectionIdDesc = 'CUZK_COLLECTION_ID_DESC',
  DatumpozadavkuAsc = 'DATUMPOZADAVKU_ASC',
  DatumpozadavkuDesc = 'DATUMPOZADAVKU_DESC',
  DatumspusteniAsc = 'DATUMSPUSTENI_ASC',
  DatumspusteniDesc = 'DATUMSPUSTENI_DESC',
  DatumvytvoreniAsc = 'DATUMVYTVORENI_ASC',
  DatumvytvoreniDesc = 'DATUMVYTVORENI_DESC',
  DatumKAsc = 'DATUM_K_ASC',
  DatumKDesc = 'DATUM_K_DESC',
  ElznackaAsc = 'ELZNACKA_ASC',
  ElznackaDesc = 'ELZNACKA_DESC',
  FormatAsc = 'FORMAT_ASC',
  FormatDesc = 'FORMAT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KatastralniUzemiKodAsc = 'KATASTRALNI_UZEMI_KOD_ASC',
  KatastralniUzemiKodDesc = 'KATASTRALNI_UZEMI_KOD_DESC',
  KatastralniUzemiNazevAsc = 'KATASTRALNI_UZEMI_NAZEV_ASC',
  KatastralniUzemiNazevDesc = 'KATASTRALNI_UZEMI_NAZEV_DESC',
  LvAsc = 'LV_ASC',
  LvDesc = 'LV_DESC',
  Natural = 'NATURAL',
  ObecAsc = 'OBEC_ASC',
  ObecDesc = 'OBEC_DESC',
  PocetjednotekAsc = 'POCETJEDNOTEK_ASC',
  PocetjednotekDesc = 'POCETJEDNOTEK_DESC',
  PocetstranAsc = 'POCETSTRAN_ASC',
  PocetstranDesc = 'POCETSTRAN_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StavAsc = 'STAV_ASC',
  StavDesc = 'STAV_DESC',
}

export type CuzkO = Node & {
  __typename: 'CuzkO'
  castobcenazev?: Maybe<Scalars['String']>
  charostype?: Maybe<Scalars['Int']>
  cislodomovni?: Maybe<Scalars['Int']>
  cisloorientacni?: Maybe<Scalars['String']>
  createdAt: Scalars['Datetime']
  /** Reads a single `CuzkO` that is related to this `CuzkO`. */
  cuzkOByPartner1?: Maybe<CuzkO>
  /** Reads a single `CuzkO` that is related to this `CuzkO`. */
  cuzkOByPartner2?: Maybe<CuzkO>
  /** Reads and enables pagination through a set of `CuzkO`. */
  cuzkOsByPartner1: CuzkOsConnection
  /** Reads and enables pagination through a set of `CuzkO`. */
  cuzkOsByPartner2: CuzkOsConnection
  doplnekico?: Maybe<Scalars['String']>
  ico?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  idOs?: Maybe<Scalars['String']>
  jmeno?: Maybe<Scalars['String']>
  lastCheck?: Maybe<Scalars['Datetime']>
  mestskacastnazev?: Maybe<Scalars['String']>
  mestskyobvodnazev?: Maybe<Scalars['String']>
  /** Reads and enables pagination through a set of `MonitoringCuzkRc`. */
  monitoringCuzkRcsByCuzkOsId: MonitoringCuzkRcsConnection
  nazev?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  obecnazev?: Maybe<Scalars['String']>
  okresnazev?: Maybe<Scalars['String']>
  partner1?: Maybe<Scalars['UUID']>
  partner2?: Maybe<Scalars['UUID']>
  prijmeni?: Maybe<Scalars['String']>
  psc?: Maybe<Scalars['String']>
  rc?: Maybe<Scalars['String']>
  rczkracene?: Maybe<Scalars['String']>
  statnazev?: Maybe<Scalars['String']>
  titulpred?: Maybe<Scalars['String']>
  titulza?: Maybe<Scalars['String']>
  typcpce?: Maybe<Scalars['String']>
  ulice?: Maybe<Scalars['String']>
  updatedAt: Scalars['Datetime']
  vlastniktyp?: Maybe<Scalars['String']>
}

export type CuzkOCuzkOsByPartner1Args = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CuzkOCondition>
  filter?: InputMaybe<CuzkOFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CuzkOsOrderBy>>
}

export type CuzkOCuzkOsByPartner2Args = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CuzkOCondition>
  filter?: InputMaybe<CuzkOFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CuzkOsOrderBy>>
}

export type CuzkOMonitoringCuzkRcsByCuzkOsIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<MonitoringCuzkRcCondition>
  filter?: InputMaybe<MonitoringCuzkRcFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<MonitoringCuzkRcsOrderBy>>
}

/** A condition to be used against `CuzkO` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type CuzkOCondition = {
  /** Checks for equality with the object’s `castobcenazev` field. */
  castobcenazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `charostype` field. */
  charostype?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `cislodomovni` field. */
  cislodomovni?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `cisloorientacni` field. */
  cisloorientacni?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `doplnekico` field. */
  doplnekico?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ico` field. */
  ico?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `idOs` field. */
  idOs?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `jmeno` field. */
  jmeno?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `lastCheck` field. */
  lastCheck?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `mestskacastnazev` field. */
  mestskacastnazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `mestskyobvodnazev` field. */
  mestskyobvodnazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `nazev` field. */
  nazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `obecnazev` field. */
  obecnazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `okresnazev` field. */
  okresnazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `partner1` field. */
  partner1?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `partner2` field. */
  partner2?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `prijmeni` field. */
  prijmeni?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `psc` field. */
  psc?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `rc` field. */
  rc?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `rczkracene` field. */
  rczkracene?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `statnazev` field. */
  statnazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `titulpred` field. */
  titulpred?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `titulza` field. */
  titulza?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `typcpce` field. */
  typcpce?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ulice` field. */
  ulice?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `vlastniktyp` field. */
  vlastniktyp?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `CuzkO` object types. All fields are combined with a logical ‘and.’ */
export type CuzkOFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CuzkOFilter>>
  /** Filter by the object’s `castobcenazev` field. */
  castobcenazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `charostype` field. */
  charostype?: InputMaybe<IntFilter>
  /** Filter by the object’s `cislodomovni` field. */
  cislodomovni?: InputMaybe<IntFilter>
  /** Filter by the object’s `cisloorientacni` field. */
  cisloorientacni?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `doplnekico` field. */
  doplnekico?: InputMaybe<StringFilter>
  /** Filter by the object’s `ico` field. */
  ico?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `idOs` field. */
  idOs?: InputMaybe<StringFilter>
  /** Filter by the object’s `jmeno` field. */
  jmeno?: InputMaybe<StringFilter>
  /** Filter by the object’s `lastCheck` field. */
  lastCheck?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `mestskacastnazev` field. */
  mestskacastnazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `mestskyobvodnazev` field. */
  mestskyobvodnazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `nazev` field. */
  nazev?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<CuzkOFilter>
  /** Filter by the object’s `obecnazev` field. */
  obecnazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `okresnazev` field. */
  okresnazev?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CuzkOFilter>>
  /** Filter by the object’s `partner1` field. */
  partner1?: InputMaybe<UuidFilter>
  /** Filter by the object’s `partner2` field. */
  partner2?: InputMaybe<UuidFilter>
  /** Filter by the object’s `prijmeni` field. */
  prijmeni?: InputMaybe<StringFilter>
  /** Filter by the object’s `psc` field. */
  psc?: InputMaybe<StringFilter>
  /** Filter by the object’s `rc` field. */
  rc?: InputMaybe<StringFilter>
  /** Filter by the object’s `rczkracene` field. */
  rczkracene?: InputMaybe<StringFilter>
  /** Filter by the object’s `statnazev` field. */
  statnazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `titulpred` field. */
  titulpred?: InputMaybe<StringFilter>
  /** Filter by the object’s `titulza` field. */
  titulza?: InputMaybe<StringFilter>
  /** Filter by the object’s `typcpce` field. */
  typcpce?: InputMaybe<StringFilter>
  /** Filter by the object’s `ulice` field. */
  ulice?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `vlastniktyp` field. */
  vlastniktyp?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `CuzkO` */
export type CuzkOInput = {
  castobcenazev?: InputMaybe<Scalars['String']>
  charostype?: InputMaybe<Scalars['Int']>
  cislodomovni?: InputMaybe<Scalars['Int']>
  cisloorientacni?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  doplnekico?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  idOs?: InputMaybe<Scalars['String']>
  jmeno?: InputMaybe<Scalars['String']>
  lastCheck?: InputMaybe<Scalars['Datetime']>
  mestskacastnazev?: InputMaybe<Scalars['String']>
  mestskyobvodnazev?: InputMaybe<Scalars['String']>
  nazev?: InputMaybe<Scalars['String']>
  obecnazev?: InputMaybe<Scalars['String']>
  okresnazev?: InputMaybe<Scalars['String']>
  partner1?: InputMaybe<Scalars['UUID']>
  partner2?: InputMaybe<Scalars['UUID']>
  prijmeni?: InputMaybe<Scalars['String']>
  psc?: InputMaybe<Scalars['String']>
  rc?: InputMaybe<Scalars['String']>
  rczkracene?: InputMaybe<Scalars['String']>
  statnazev?: InputMaybe<Scalars['String']>
  titulpred?: InputMaybe<Scalars['String']>
  titulza?: InputMaybe<Scalars['String']>
  typcpce?: InputMaybe<Scalars['String']>
  ulice?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['Datetime']>
  vlastniktyp?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `CuzkO`. Fields that are set will be updated. */
export type CuzkOPatch = {
  castobcenazev?: InputMaybe<Scalars['String']>
  charostype?: InputMaybe<Scalars['Int']>
  cislodomovni?: InputMaybe<Scalars['Int']>
  cisloorientacni?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  doplnekico?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  idOs?: InputMaybe<Scalars['String']>
  jmeno?: InputMaybe<Scalars['String']>
  lastCheck?: InputMaybe<Scalars['Datetime']>
  mestskacastnazev?: InputMaybe<Scalars['String']>
  mestskyobvodnazev?: InputMaybe<Scalars['String']>
  nazev?: InputMaybe<Scalars['String']>
  obecnazev?: InputMaybe<Scalars['String']>
  okresnazev?: InputMaybe<Scalars['String']>
  partner1?: InputMaybe<Scalars['UUID']>
  partner2?: InputMaybe<Scalars['UUID']>
  prijmeni?: InputMaybe<Scalars['String']>
  psc?: InputMaybe<Scalars['String']>
  rc?: InputMaybe<Scalars['String']>
  rczkracene?: InputMaybe<Scalars['String']>
  statnazev?: InputMaybe<Scalars['String']>
  titulpred?: InputMaybe<Scalars['String']>
  titulza?: InputMaybe<Scalars['String']>
  typcpce?: InputMaybe<Scalars['String']>
  ulice?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['Datetime']>
  vlastniktyp?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `CuzkO` values. */
export type CuzkOsConnection = {
  __typename: 'CuzkOsConnection'
  /** A list of edges which contains the `CuzkO` and cursor to aid in pagination. */
  edges: Array<CuzkOsEdge>
  /** A list of `CuzkO` objects. */
  nodes: Array<Maybe<CuzkO>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `CuzkO` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `CuzkO` edge in the connection. */
export type CuzkOsEdge = {
  __typename: 'CuzkOsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `CuzkO` at the end of the edge. */
  node?: Maybe<CuzkO>
}

/** Methods to use when ordering `CuzkO`. */
export enum CuzkOsOrderBy {
  CastobcenazevAsc = 'CASTOBCENAZEV_ASC',
  CastobcenazevDesc = 'CASTOBCENAZEV_DESC',
  CharostypeAsc = 'CHAROSTYPE_ASC',
  CharostypeDesc = 'CHAROSTYPE_DESC',
  CislodomovniAsc = 'CISLODOMOVNI_ASC',
  CislodomovniDesc = 'CISLODOMOVNI_DESC',
  CisloorientacniAsc = 'CISLOORIENTACNI_ASC',
  CisloorientacniDesc = 'CISLOORIENTACNI_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DoplnekicoAsc = 'DOPLNEKICO_ASC',
  DoplnekicoDesc = 'DOPLNEKICO_DESC',
  IcoAsc = 'ICO_ASC',
  IcoDesc = 'ICO_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IdOsAsc = 'ID_OS_ASC',
  IdOsDesc = 'ID_OS_DESC',
  JmenoAsc = 'JMENO_ASC',
  JmenoDesc = 'JMENO_DESC',
  LastCheckAsc = 'LAST_CHECK_ASC',
  LastCheckDesc = 'LAST_CHECK_DESC',
  MestskacastnazevAsc = 'MESTSKACASTNAZEV_ASC',
  MestskacastnazevDesc = 'MESTSKACASTNAZEV_DESC',
  MestskyobvodnazevAsc = 'MESTSKYOBVODNAZEV_ASC',
  MestskyobvodnazevDesc = 'MESTSKYOBVODNAZEV_DESC',
  Natural = 'NATURAL',
  NazevAsc = 'NAZEV_ASC',
  NazevDesc = 'NAZEV_DESC',
  ObecnazevAsc = 'OBECNAZEV_ASC',
  ObecnazevDesc = 'OBECNAZEV_DESC',
  OkresnazevAsc = 'OKRESNAZEV_ASC',
  OkresnazevDesc = 'OKRESNAZEV_DESC',
  Partner1Asc = 'PARTNER1_ASC',
  Partner1Desc = 'PARTNER1_DESC',
  Partner2Asc = 'PARTNER2_ASC',
  Partner2Desc = 'PARTNER2_DESC',
  PrijmeniAsc = 'PRIJMENI_ASC',
  PrijmeniDesc = 'PRIJMENI_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PscAsc = 'PSC_ASC',
  PscDesc = 'PSC_DESC',
  RczkraceneAsc = 'RCZKRACENE_ASC',
  RczkraceneDesc = 'RCZKRACENE_DESC',
  RcAsc = 'RC_ASC',
  RcDesc = 'RC_DESC',
  StatnazevAsc = 'STATNAZEV_ASC',
  StatnazevDesc = 'STATNAZEV_DESC',
  TitulpredAsc = 'TITULPRED_ASC',
  TitulpredDesc = 'TITULPRED_DESC',
  TitulzaAsc = 'TITULZA_ASC',
  TitulzaDesc = 'TITULZA_DESC',
  TypcpceAsc = 'TYPCPCE_ASC',
  TypcpceDesc = 'TYPCPCE_DESC',
  UliceAsc = 'ULICE_ASC',
  UliceDesc = 'ULICE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  VlastniktypAsc = 'VLASTNIKTYP_ASC',
  VlastniktypDesc = 'VLASTNIKTYP_DESC',
}

export type Databox = Node & {
  __typename: 'Databox'
  adresnimistokod?: Maybe<Scalars['String']>
  birthname?: Maybe<Scalars['String']>
  businessname?: Maybe<Scalars['String']>
  createdat?: Maybe<Scalars['Datetime']>
  databoxid: Scalars['String']
  firstname?: Maybe<Scalars['String']>
  fulladdress?: Maybe<Scalars['String']>
  fullname?: Maybe<Scalars['String']>
  ico?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  idovm?: Maybe<Scalars['String']>
  ismaster?: Maybe<Scalars['Boolean']>
  lastname?: Maybe<Scalars['String']>
  masterid?: Maybe<Scalars['String']>
  middlename?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  ovm?: Maybe<Scalars['Boolean']>
  pdz?: Maybe<Scalars['Boolean']>
  subtype?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedat?: Maybe<Scalars['Datetime']>
}

/** A condition to be used against `Databox` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type DataboxCondition = {
  /** Checks for equality with the object’s `adresnimistokod` field. */
  adresnimistokod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `birthname` field. */
  birthname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `businessname` field. */
  businessname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdat` field. */
  createdat?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `databoxid` field. */
  databoxid?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `firstname` field. */
  firstname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `fulladdress` field. */
  fulladdress?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `fullname` field. */
  fullname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ico` field. */
  ico?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `idovm` field. */
  idovm?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ismaster` field. */
  ismaster?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `lastname` field. */
  lastname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `masterid` field. */
  masterid?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `middlename` field. */
  middlename?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ovm` field. */
  ovm?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `pdz` field. */
  pdz?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `subtype` field. */
  subtype?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `updatedat` field. */
  updatedat?: InputMaybe<Scalars['Datetime']>
}

/** A filter to be used against `Databox` object types. All fields are combined with a logical ‘and.’ */
export type DataboxFilter = {
  /** Filter by the object’s `adresnimistokod` field. */
  adresnimistokod?: InputMaybe<StringFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DataboxFilter>>
  /** Filter by the object’s `birthname` field. */
  birthname?: InputMaybe<StringFilter>
  /** Filter by the object’s `businessname` field. */
  businessname?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdat` field. */
  createdat?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `databoxid` field. */
  databoxid?: InputMaybe<StringFilter>
  /** Filter by the object’s `firstname` field. */
  firstname?: InputMaybe<StringFilter>
  /** Filter by the object’s `fulladdress` field. */
  fulladdress?: InputMaybe<StringFilter>
  /** Filter by the object’s `fullname` field. */
  fullname?: InputMaybe<StringFilter>
  /** Filter by the object’s `ico` field. */
  ico?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `idovm` field. */
  idovm?: InputMaybe<StringFilter>
  /** Filter by the object’s `ismaster` field. */
  ismaster?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `lastname` field. */
  lastname?: InputMaybe<StringFilter>
  /** Filter by the object’s `masterid` field. */
  masterid?: InputMaybe<StringFilter>
  /** Filter by the object’s `middlename` field. */
  middlename?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<DataboxFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DataboxFilter>>
  /** Filter by the object’s `ovm` field. */
  ovm?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `pdz` field. */
  pdz?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `subtype` field. */
  subtype?: InputMaybe<StringFilter>
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>
  /** Filter by the object’s `updatedat` field. */
  updatedat?: InputMaybe<DatetimeFilter>
}

/** An input for mutations affecting `Databox` */
export type DataboxInput = {
  adresnimistokod?: InputMaybe<Scalars['String']>
  birthname?: InputMaybe<Scalars['String']>
  businessname?: InputMaybe<Scalars['String']>
  createdat?: InputMaybe<Scalars['Datetime']>
  databoxid: Scalars['String']
  firstname?: InputMaybe<Scalars['String']>
  fulladdress?: InputMaybe<Scalars['String']>
  fullname?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  idovm?: InputMaybe<Scalars['String']>
  ismaster?: InputMaybe<Scalars['Boolean']>
  lastname?: InputMaybe<Scalars['String']>
  masterid?: InputMaybe<Scalars['String']>
  middlename?: InputMaybe<Scalars['String']>
  ovm?: InputMaybe<Scalars['Boolean']>
  pdz?: InputMaybe<Scalars['Boolean']>
  subtype?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  updatedat?: InputMaybe<Scalars['Datetime']>
}

/** Represents an update to a `Databox`. Fields that are set will be updated. */
export type DataboxPatch = {
  adresnimistokod?: InputMaybe<Scalars['String']>
  birthname?: InputMaybe<Scalars['String']>
  businessname?: InputMaybe<Scalars['String']>
  createdat?: InputMaybe<Scalars['Datetime']>
  databoxid?: InputMaybe<Scalars['String']>
  firstname?: InputMaybe<Scalars['String']>
  fulladdress?: InputMaybe<Scalars['String']>
  fullname?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  idovm?: InputMaybe<Scalars['String']>
  ismaster?: InputMaybe<Scalars['Boolean']>
  lastname?: InputMaybe<Scalars['String']>
  masterid?: InputMaybe<Scalars['String']>
  middlename?: InputMaybe<Scalars['String']>
  ovm?: InputMaybe<Scalars['Boolean']>
  pdz?: InputMaybe<Scalars['Boolean']>
  subtype?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  updatedat?: InputMaybe<Scalars['Datetime']>
}

/** A connection to a list of `Databox` values. */
export type DataboxesConnection = {
  __typename: 'DataboxesConnection'
  /** A list of edges which contains the `Databox` and cursor to aid in pagination. */
  edges: Array<DataboxesEdge>
  /** A list of `Databox` objects. */
  nodes: Array<Maybe<Databox>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Databox` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `Databox` edge in the connection. */
export type DataboxesEdge = {
  __typename: 'DataboxesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `Databox` at the end of the edge. */
  node?: Maybe<Databox>
}

/** Methods to use when ordering `Databox`. */
export enum DataboxesOrderBy {
  AdresnimistokodAsc = 'ADRESNIMISTOKOD_ASC',
  AdresnimistokodDesc = 'ADRESNIMISTOKOD_DESC',
  BirthnameAsc = 'BIRTHNAME_ASC',
  BirthnameDesc = 'BIRTHNAME_DESC',
  BusinessnameAsc = 'BUSINESSNAME_ASC',
  BusinessnameDesc = 'BUSINESSNAME_DESC',
  CreatedatAsc = 'CREATEDAT_ASC',
  CreatedatDesc = 'CREATEDAT_DESC',
  DataboxidAsc = 'DATABOXID_ASC',
  DataboxidDesc = 'DATABOXID_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  FulladdressAsc = 'FULLADDRESS_ASC',
  FulladdressDesc = 'FULLADDRESS_DESC',
  FullnameAsc = 'FULLNAME_ASC',
  FullnameDesc = 'FULLNAME_DESC',
  IcoAsc = 'ICO_ASC',
  IcoDesc = 'ICO_DESC',
  IdovmAsc = 'IDOVM_ASC',
  IdovmDesc = 'IDOVM_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsmasterAsc = 'ISMASTER_ASC',
  IsmasterDesc = 'ISMASTER_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  MasteridAsc = 'MASTERID_ASC',
  MasteridDesc = 'MASTERID_DESC',
  MiddlenameAsc = 'MIDDLENAME_ASC',
  MiddlenameDesc = 'MIDDLENAME_DESC',
  Natural = 'NATURAL',
  OvmAsc = 'OVM_ASC',
  OvmDesc = 'OVM_DESC',
  PdzAsc = 'PDZ_ASC',
  PdzDesc = 'PDZ_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SubtypeAsc = 'SUBTYPE_ASC',
  SubtypeDesc = 'SUBTYPE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
}

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']>>
}

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']>>
}

/** All input for the `deleteAddressById` mutation. */
export type DeleteAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteAddressByKod` mutation. */
export type DeleteAddressByKodInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  kod: Scalars['String']
}

/** All input for the `deleteAddress` mutation. */
export type DeleteAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `Address` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `Address` mutation. */
export type DeleteAddressPayload = {
  __typename: 'DeleteAddressPayload'
  /** The `Address` that was deleted by this mutation. */
  address?: Maybe<Address>
  /** An edge for our `Address`. May be used by Relay 1. */
  addressEdge?: Maybe<AddressesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedAddressId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `Address` mutation. */
export type DeleteAddressPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>
}

/** All input for the `deleteAuctionListingById` mutation. */
export type DeleteAuctionListingByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteAuctionListing` mutation. */
export type DeleteAuctionListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `AuctionListing` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `AuctionListing` mutation. */
export type DeleteAuctionListingPayload = {
  __typename: 'DeleteAuctionListingPayload'
  /** The `AuctionListing` that was deleted by this mutation. */
  auctionListing?: Maybe<AuctionListing>
  /** An edge for our `AuctionListing`. May be used by Relay 1. */
  auctionListingEdge?: Maybe<AuctionListingsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedAuctionListingId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `AuctionListing` mutation. */
export type DeleteAuctionListingPayloadAuctionListingEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionListingsOrderBy>>
}

/** All input for the `deleteAuctionPropertyById` mutation. */
export type DeleteAuctionPropertyByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteAuctionProperty` mutation. */
export type DeleteAuctionPropertyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `AuctionProperty` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `AuctionProperty` mutation. */
export type DeleteAuctionPropertyPayload = {
  __typename: 'DeleteAuctionPropertyPayload'
  /** Reads a single `AuctionListing` that is related to this `AuctionProperty`. */
  auctionListingByAuctionId?: Maybe<AuctionListing>
  /** The `AuctionProperty` that was deleted by this mutation. */
  auctionProperty?: Maybe<AuctionProperty>
  /** An edge for our `AuctionProperty`. May be used by Relay 1. */
  auctionPropertyEdge?: Maybe<AuctionPropertiesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedAuctionPropertyId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `AuctionProperty` mutation. */
export type DeleteAuctionPropertyPayloadAuctionPropertyEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionPropertiesOrderBy>>
}

/** All input for the `deleteBpejById` mutation. */
export type DeleteBpejByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteBpej` mutation. */
export type DeleteBpejInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `Bpej` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `Bpej` mutation. */
export type DeleteBpejPayload = {
  __typename: 'DeleteBpejPayload'
  /** The `Bpej` that was deleted by this mutation. */
  bpej?: Maybe<Bpej>
  /** An edge for our `Bpej`. May be used by Relay 1. */
  bpejEdge?: Maybe<BpejsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedBpejId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `Bpej` mutation. */
export type DeleteBpejPayloadBpejEdgeArgs = {
  orderBy?: InputMaybe<Array<BpejsOrderBy>>
}

/** All input for the `deleteBuybackCalculationById` mutation. */
export type DeleteBuybackCalculationByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteBuybackCalculation` mutation. */
export type DeleteBuybackCalculationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `BuybackCalculation` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `BuybackCalculation` mutation. */
export type DeleteBuybackCalculationPayload = {
  __typename: 'DeleteBuybackCalculationPayload'
  /** The `BuybackCalculation` that was deleted by this mutation. */
  buybackCalculation?: Maybe<BuybackCalculation>
  /** An edge for our `BuybackCalculation`. May be used by Relay 1. */
  buybackCalculationEdge?: Maybe<BuybackCalculationsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedBuybackCalculationId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `BuybackCalculation` mutation. */
export type DeleteBuybackCalculationPayloadBuybackCalculationEdgeArgs = {
  orderBy?: InputMaybe<Array<BuybackCalculationsOrderBy>>
}

/** All input for the `deleteCeeExecutionById` mutation. */
export type DeleteCeeExecutionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteCeeExecutionDetailById` mutation. */
export type DeleteCeeExecutionDetailByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteCeeExecutionDetail` mutation. */
export type DeleteCeeExecutionDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CeeExecutionDetail` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `CeeExecutionDetail` mutation. */
export type DeleteCeeExecutionDetailPayload = {
  __typename: 'DeleteCeeExecutionDetailPayload'
  /** Reads a single `CeeExecution` that is related to this `CeeExecutionDetail`. */
  ceeExecutionByCeeExecutionId?: Maybe<CeeExecution>
  /** The `CeeExecutionDetail` that was deleted by this mutation. */
  ceeExecutionDetail?: Maybe<CeeExecutionDetail>
  /** An edge for our `CeeExecutionDetail`. May be used by Relay 1. */
  ceeExecutionDetailEdge?: Maybe<CeeExecutionDetailsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedCeeExecutionDetailId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `CeeExecutionDetail` mutation. */
export type DeleteCeeExecutionDetailPayloadCeeExecutionDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<CeeExecutionDetailsOrderBy>>
}

/** All input for the `deleteCeeExecution` mutation. */
export type DeleteCeeExecutionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CeeExecution` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `CeeExecution` mutation. */
export type DeleteCeeExecutionPayload = {
  __typename: 'DeleteCeeExecutionPayload'
  /** The `CeeExecution` that was deleted by this mutation. */
  ceeExecution?: Maybe<CeeExecution>
  /** An edge for our `CeeExecution`. May be used by Relay 1. */
  ceeExecutionEdge?: Maybe<CeeExecutionsEdge>
  /** Reads a single `CeeOffice` that is related to this `CeeExecution`. */
  ceeOfficeByExecutorCode?: Maybe<CeeOffice>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedCeeExecutionId?: Maybe<Scalars['ID']>
  /** Reads a single `MonitoringCee` that is related to this `CeeExecution`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `CeeExecution` mutation. */
export type DeleteCeeExecutionPayloadCeeExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<CeeExecutionsOrderBy>>
}

/** All input for the `deleteCeeOfficeById` mutation. */
export type DeleteCeeOfficeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteCeeOffice` mutation. */
export type DeleteCeeOfficeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CeeOffice` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `CeeOffice` mutation. */
export type DeleteCeeOfficePayload = {
  __typename: 'DeleteCeeOfficePayload'
  /** The `CeeOffice` that was deleted by this mutation. */
  ceeOffice?: Maybe<CeeOffice>
  /** An edge for our `CeeOffice`. May be used by Relay 1. */
  ceeOfficeEdge?: Maybe<CeeOfficesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedCeeOfficeId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `CeeOffice` mutation. */
export type DeleteCeeOfficePayloadCeeOfficeEdgeArgs = {
  orderBy?: InputMaybe<Array<CeeOfficesOrderBy>>
}

/** All input for the `deleteCuzkDocumentCollectionById` mutation. */
export type DeleteCuzkDocumentCollectionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteCuzkDocumentCollection` mutation. */
export type DeleteCuzkDocumentCollectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CuzkDocumentCollection` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `CuzkDocumentCollection` mutation. */
export type DeleteCuzkDocumentCollectionPayload = {
  __typename: 'DeleteCuzkDocumentCollectionPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkDocumentCollection` that was deleted by this mutation. */
  cuzkDocumentCollection?: Maybe<CuzkDocumentCollection>
  /** An edge for our `CuzkDocumentCollection`. May be used by Relay 1. */
  cuzkDocumentCollectionEdge?: Maybe<CuzkDocumentCollectionsEdge>
  deletedCuzkDocumentCollectionId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `CuzkDocumentCollection` mutation. */
export type DeleteCuzkDocumentCollectionPayloadCuzkDocumentCollectionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<CuzkDocumentCollectionsOrderBy>>
  }

/** All input for the `deleteCuzkEpoById` mutation. */
export type DeleteCuzkEpoByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteCuzkEpo` mutation. */
export type DeleteCuzkEpoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CuzkEpo` to be deleted. */
  nodeId: Scalars['ID']
}

/** All input for the `deleteCuzkEpoLienById` mutation. */
export type DeleteCuzkEpoLienByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteCuzkEpoLien` mutation. */
export type DeleteCuzkEpoLienInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CuzkEpoLien` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `CuzkEpoLien` mutation. */
export type DeleteCuzkEpoLienPayload = {
  __typename: 'DeleteCuzkEpoLienPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkEpoLien` that was deleted by this mutation. */
  cuzkEpoLien?: Maybe<CuzkEpoLien>
  /** An edge for our `CuzkEpoLien`. May be used by Relay 1. */
  cuzkEpoLienEdge?: Maybe<CuzkEpoLiensEdge>
  /** Reads a single `CuzkEpoRestrictionCheck` that is related to this `CuzkEpoLien`. */
  cuzkEpoRestrictionCheckByRestrictionCheckId?: Maybe<CuzkEpoRestrictionCheck>
  deletedCuzkEpoLienId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `CuzkEpoLien` mutation. */
export type DeleteCuzkEpoLienPayloadCuzkEpoLienEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkEpoLiensOrderBy>>
}

/** The output of our delete `CuzkEpo` mutation. */
export type DeleteCuzkEpoPayload = {
  __typename: 'DeleteCuzkEpoPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkEpo` that was deleted by this mutation. */
  cuzkEpo?: Maybe<CuzkEpo>
  /** An edge for our `CuzkEpo`. May be used by Relay 1. */
  cuzkEpoEdge?: Maybe<CuzkEposEdge>
  deletedCuzkEpoId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `CuzkEpo` mutation. */
export type DeleteCuzkEpoPayloadCuzkEpoEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkEposOrderBy>>
}

/** All input for the `deleteCuzkEpoRestrictionCheckById` mutation. */
export type DeleteCuzkEpoRestrictionCheckByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteCuzkEpoRestrictionCheck` mutation. */
export type DeleteCuzkEpoRestrictionCheckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CuzkEpoRestrictionCheck` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `CuzkEpoRestrictionCheck` mutation. */
export type DeleteCuzkEpoRestrictionCheckPayload = {
  __typename: 'DeleteCuzkEpoRestrictionCheckPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `CuzkEpo` that is related to this `CuzkEpoRestrictionCheck`. */
  cuzkEpoByCuzkEpoId?: Maybe<CuzkEpo>
  /** The `CuzkEpoRestrictionCheck` that was deleted by this mutation. */
  cuzkEpoRestrictionCheck?: Maybe<CuzkEpoRestrictionCheck>
  /** An edge for our `CuzkEpoRestrictionCheck`. May be used by Relay 1. */
  cuzkEpoRestrictionCheckEdge?: Maybe<CuzkEpoRestrictionChecksEdge>
  deletedCuzkEpoRestrictionCheckId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `CuzkEpoRestrictionCheck` mutation. */
export type DeleteCuzkEpoRestrictionCheckPayloadCuzkEpoRestrictionCheckEdgeArgs =
  {
    orderBy?: InputMaybe<Array<CuzkEpoRestrictionChecksOrderBy>>
  }

/** All input for the `deleteCuzkLvById` mutation. */
export type DeleteCuzkLvByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteCuzkLv` mutation. */
export type DeleteCuzkLvInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CuzkLv` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `CuzkLv` mutation. */
export type DeleteCuzkLvPayload = {
  __typename: 'DeleteCuzkLvPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkLv` that was deleted by this mutation. */
  cuzkLv?: Maybe<CuzkLv>
  /** An edge for our `CuzkLv`. May be used by Relay 1. */
  cuzkLvEdge?: Maybe<CuzkLvsEdge>
  deletedCuzkLvId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `CuzkLv` mutation. */
export type DeleteCuzkLvPayloadCuzkLvEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkLvsOrderBy>>
}

/** All input for the `deleteCuzkOById` mutation. */
export type DeleteCuzkOByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteCuzkO` mutation. */
export type DeleteCuzkOInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CuzkO` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `CuzkO` mutation. */
export type DeleteCuzkOPayload = {
  __typename: 'DeleteCuzkOPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkO` that was deleted by this mutation. */
  cuzkO?: Maybe<CuzkO>
  /** Reads a single `CuzkO` that is related to this `CuzkO`. */
  cuzkOByPartner1?: Maybe<CuzkO>
  /** Reads a single `CuzkO` that is related to this `CuzkO`. */
  cuzkOByPartner2?: Maybe<CuzkO>
  /** An edge for our `CuzkO`. May be used by Relay 1. */
  cuzkOEdge?: Maybe<CuzkOsEdge>
  deletedCuzkOId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `CuzkO` mutation. */
export type DeleteCuzkOPayloadCuzkOEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkOsOrderBy>>
}

/** All input for the `deleteDataboxByDataboxid` mutation. */
export type DeleteDataboxByDataboxidInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  databoxid: Scalars['String']
}

/** All input for the `deleteDataboxById` mutation. */
export type DeleteDataboxByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteDatabox` mutation. */
export type DeleteDataboxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `Databox` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `Databox` mutation. */
export type DeleteDataboxPayload = {
  __typename: 'DeleteDataboxPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `Databox` that was deleted by this mutation. */
  databox?: Maybe<Databox>
  /** An edge for our `Databox`. May be used by Relay 1. */
  databoxEdge?: Maybe<DataboxesEdge>
  deletedDataboxId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `Databox` mutation. */
export type DeleteDataboxPayloadDataboxEdgeArgs = {
  orderBy?: InputMaybe<Array<DataboxesOrderBy>>
}

/** All input for the `deleteKuAreaByAreaId` mutation. */
export type DeleteKuAreaByAreaIdInput = {
  areaId: Scalars['UUID']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** All input for the `deleteKuArea` mutation. */
export type DeleteKuAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `KuArea` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `KuArea` mutation. */
export type DeleteKuAreaPayload = {
  __typename: 'DeleteKuAreaPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedKuAreaId?: Maybe<Scalars['ID']>
  /** The `KuArea` that was deleted by this mutation. */
  kuArea?: Maybe<KuArea>
  /** An edge for our `KuArea`. May be used by Relay 1. */
  kuAreaEdge?: Maybe<KuAreasEdge>
  /** Reads a single `KuWorkplace` that is related to this `KuArea`. */
  kuWorkplaceByPraresKod?: Maybe<KuWorkplace>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `KuArea` mutation. */
export type DeleteKuAreaPayloadKuAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<KuAreasOrderBy>>
}

/** All input for the `deleteKuWorkplaceById` mutation. */
export type DeleteKuWorkplaceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteKuWorkplaceByKod` mutation. */
export type DeleteKuWorkplaceByKodInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  kod: Scalars['String']
}

/** All input for the `deleteKuWorkplace` mutation. */
export type DeleteKuWorkplaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `KuWorkplace` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `KuWorkplace` mutation. */
export type DeleteKuWorkplacePayload = {
  __typename: 'DeleteKuWorkplacePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedKuWorkplaceId?: Maybe<Scalars['ID']>
  /** The `KuWorkplace` that was deleted by this mutation. */
  kuWorkplace?: Maybe<KuWorkplace>
  /** Reads a single `KuWorkplace` that is related to this `KuWorkplace`. */
  kuWorkplaceByNadrizPrac?: Maybe<KuWorkplace>
  /** An edge for our `KuWorkplace`. May be used by Relay 1. */
  kuWorkplaceEdge?: Maybe<KuWorkplacesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `KuWorkplace` mutation. */
export type DeleteKuWorkplacePayloadKuWorkplaceEdgeArgs = {
  orderBy?: InputMaybe<Array<KuWorkplacesOrderBy>>
}

/** All input for the `deleteLabelById` mutation. */
export type DeleteLabelByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteLabelConnectionById` mutation. */
export type DeleteLabelConnectionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteLabelConnection` mutation. */
export type DeleteLabelConnectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `LabelConnection` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `LabelConnection` mutation. */
export type DeleteLabelConnectionPayload = {
  __typename: 'DeleteLabelConnectionPayload'
  /** Reads a single `AuctionListing` that is related to this `LabelConnection`. */
  auctionListingByAuctionListingId?: Maybe<AuctionListing>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `CuzkDocumentCollection` that is related to this `LabelConnection`. */
  cuzkDocumentCollectionByCuzkDocumentCollectionId?: Maybe<CuzkDocumentCollection>
  /** Reads a single `CuzkEpo` that is related to this `LabelConnection`. */
  cuzkEpoByCuzkEpoId?: Maybe<CuzkEpo>
  /** Reads a single `CuzkEpoLien` that is related to this `LabelConnection`. */
  cuzkEpoLienByCuzkEpoLienId?: Maybe<CuzkEpoLien>
  /** Reads a single `CuzkLv` that is related to this `LabelConnection`. */
  cuzkLvByCuzkLvId?: Maybe<CuzkLv>
  deletedLabelConnectionId?: Maybe<Scalars['ID']>
  /** Reads a single `Label` that is related to this `LabelConnection`. */
  labelByLabelId?: Maybe<Label>
  /** The `LabelConnection` that was deleted by this mutation. */
  labelConnection?: Maybe<LabelConnection>
  /** An edge for our `LabelConnection`. May be used by Relay 1. */
  labelConnectionEdge?: Maybe<LabelConnectionsEdge>
  /** Reads a single `MarketplaceOffer` that is related to this `LabelConnection`. */
  marketplaceOfferByMarketplaceOfferId?: Maybe<MarketplaceOffer>
  /** Reads a single `Monit` that is related to this `LabelConnection`. */
  monitByMonitId?: Maybe<Monit>
  /** Reads a single `MonitoringCee` that is related to this `LabelConnection`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  /** Reads a single `MonitoringCuzkRc` that is related to this `LabelConnection`. */
  monitoringCuzkRcByMonitoringCuzkRcId?: Maybe<MonitoringCuzkRc>
  /** Reads a single `PostserviceList` that is related to this `LabelConnection`. */
  postserviceListByPostserviceListId?: Maybe<PostserviceList>
  /** Reads a single `PropertyLabel` that is related to this `LabelConnection`. */
  propertyLabelByPropertyLabelId?: Maybe<PropertyLabel>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** Reads a single `RecipientList` that is related to this `LabelConnection`. */
  recipientListByRecipientListId?: Maybe<RecipientList>
}

/** The output of our delete `LabelConnection` mutation. */
export type DeleteLabelConnectionPayloadLabelConnectionEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

/** All input for the `deleteLabel` mutation. */
export type DeleteLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `Label` to be deleted. */
  nodeId: Scalars['ID']
}

/** All input for the `deleteLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcId` mutation. */
export type DeleteLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  labelId: Scalars['UUID']
  monitoringCuzkRcId: Scalars['UUID']
}

/** All input for the `deleteLabelMonitoringCuzkRc` mutation. */
export type DeleteLabelMonitoringCuzkRcInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `LabelMonitoringCuzkRc` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `LabelMonitoringCuzkRc` mutation. */
export type DeleteLabelMonitoringCuzkRcPayload = {
  __typename: 'DeleteLabelMonitoringCuzkRcPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedLabelMonitoringCuzkRcId?: Maybe<Scalars['ID']>
  /** Reads a single `Label` that is related to this `LabelMonitoringCuzkRc`. */
  labelByLabelId?: Maybe<Label>
  /** The `LabelMonitoringCuzkRc` that was deleted by this mutation. */
  labelMonitoringCuzkRc?: Maybe<LabelMonitoringCuzkRc>
  /** An edge for our `LabelMonitoringCuzkRc`. May be used by Relay 1. */
  labelMonitoringCuzkRcEdge?: Maybe<LabelMonitoringCuzkRcsEdge>
  /** Reads a single `MonitoringCuzkRc` that is related to this `LabelMonitoringCuzkRc`. */
  monitoringCuzkRcByMonitoringCuzkRcId?: Maybe<MonitoringCuzkRc>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `LabelMonitoringCuzkRc` mutation. */
export type DeleteLabelMonitoringCuzkRcPayloadLabelMonitoringCuzkRcEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelMonitoringCuzkRcsOrderBy>>
}

/** The output of our delete `Label` mutation. */
export type DeleteLabelPayload = {
  __typename: 'DeleteLabelPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedLabelId?: Maybe<Scalars['ID']>
  /** The `Label` that was deleted by this mutation. */
  label?: Maybe<Label>
  /** An edge for our `Label`. May be used by Relay 1. */
  labelEdge?: Maybe<LabelsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `Label` mutation. */
export type DeleteLabelPayloadLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelsOrderBy>>
}

/** All input for the `deleteMarketplaceOfferAccessById` mutation. */
export type DeleteMarketplaceOfferAccessByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteMarketplaceOfferAccess` mutation. */
export type DeleteMarketplaceOfferAccessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `MarketplaceOfferAccess` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `MarketplaceOfferAccess` mutation. */
export type DeleteMarketplaceOfferAccessPayload = {
  __typename: 'DeleteMarketplaceOfferAccessPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedMarketplaceOfferAccessId?: Maybe<Scalars['ID']>
  /** The `MarketplaceOfferAccess` that was deleted by this mutation. */
  marketplaceOfferAccess?: Maybe<MarketplaceOfferAccess>
  /** An edge for our `MarketplaceOfferAccess`. May be used by Relay 1. */
  marketplaceOfferAccessEdge?: Maybe<MarketplaceOfferAccessesEdge>
  /** Reads a single `MarketplaceOffer` that is related to this `MarketplaceOfferAccess`. */
  marketplaceOfferByOfferId?: Maybe<MarketplaceOffer>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `MarketplaceOfferAccess` mutation. */
export type DeleteMarketplaceOfferAccessPayloadMarketplaceOfferAccessEdgeArgs =
  {
    orderBy?: InputMaybe<Array<MarketplaceOfferAccessesOrderBy>>
  }

/** All input for the `deleteMarketplaceOfferById` mutation. */
export type DeleteMarketplaceOfferByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteMarketplaceOffer` mutation. */
export type DeleteMarketplaceOfferInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `MarketplaceOffer` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `MarketplaceOffer` mutation. */
export type DeleteMarketplaceOfferPayload = {
  __typename: 'DeleteMarketplaceOfferPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedMarketplaceOfferId?: Maybe<Scalars['ID']>
  /** The `MarketplaceOffer` that was deleted by this mutation. */
  marketplaceOffer?: Maybe<MarketplaceOffer>
  /** An edge for our `MarketplaceOffer`. May be used by Relay 1. */
  marketplaceOfferEdge?: Maybe<MarketplaceOffersEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `MarketplaceOffer` mutation. */
export type DeleteMarketplaceOfferPayloadMarketplaceOfferEdgeArgs = {
  orderBy?: InputMaybe<Array<MarketplaceOffersOrderBy>>
}

/** All input for the `deleteMonitById` mutation. */
export type DeleteMonitByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteMonit` mutation. */
export type DeleteMonitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `Monit` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `Monit` mutation. */
export type DeleteMonitPayload = {
  __typename: 'DeleteMonitPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedMonitId?: Maybe<Scalars['ID']>
  /** The `Monit` that was deleted by this mutation. */
  monit?: Maybe<Monit>
  /** An edge for our `Monit`. May be used by Relay 1. */
  monitEdge?: Maybe<MonitsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `Monit` mutation. */
export type DeleteMonitPayloadMonitEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitsOrderBy>>
}

/** All input for the `deleteMonitoringCeeById` mutation. */
export type DeleteMonitoringCeeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteMonitoringCee` mutation. */
export type DeleteMonitoringCeeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `MonitoringCee` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `MonitoringCee` mutation. */
export type DeleteMonitoringCeePayload = {
  __typename: 'DeleteMonitoringCeePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedMonitoringCeeId?: Maybe<Scalars['ID']>
  /** The `MonitoringCee` that was deleted by this mutation. */
  monitoringCee?: Maybe<MonitoringCee>
  /** An edge for our `MonitoringCee`. May be used by Relay 1. */
  monitoringCeeEdge?: Maybe<MonitoringCeesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `MonitoringCee` mutation. */
export type DeleteMonitoringCeePayloadMonitoringCeeEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitoringCeesOrderBy>>
}

/** All input for the `deleteMonitoringCuzkRcById` mutation. */
export type DeleteMonitoringCuzkRcByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteMonitoringCuzkRc` mutation. */
export type DeleteMonitoringCuzkRcInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `MonitoringCuzkRc` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `MonitoringCuzkRc` mutation. */
export type DeleteMonitoringCuzkRcPayload = {
  __typename: 'DeleteMonitoringCuzkRcPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `CuzkO` that is related to this `MonitoringCuzkRc`. */
  cuzkOByCuzkOsId?: Maybe<CuzkO>
  deletedMonitoringCuzkRcId?: Maybe<Scalars['ID']>
  /** Reads a single `MonitoringCee` that is related to this `MonitoringCuzkRc`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  /** The `MonitoringCuzkRc` that was deleted by this mutation. */
  monitoringCuzkRc?: Maybe<MonitoringCuzkRc>
  /** An edge for our `MonitoringCuzkRc`. May be used by Relay 1. */
  monitoringCuzkRcEdge?: Maybe<MonitoringCuzkRcsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `MonitoringCuzkRc` mutation. */
export type DeleteMonitoringCuzkRcPayloadMonitoringCuzkRcEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitoringCuzkRcsOrderBy>>
}

/** All input for the `deleteMunicipalOfficeByAdresnimistokod` mutation. */
export type DeleteMunicipalOfficeByAdresnimistokodInput = {
  adresnimistokod: Scalars['String']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** All input for the `deleteMunicipalOfficeById` mutation. */
export type DeleteMunicipalOfficeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteMunicipalOffice` mutation. */
export type DeleteMunicipalOfficeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `MunicipalOffice` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `MunicipalOffice` mutation. */
export type DeleteMunicipalOfficePayload = {
  __typename: 'DeleteMunicipalOfficePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedMunicipalOfficeId?: Maybe<Scalars['ID']>
  /** The `MunicipalOffice` that was deleted by this mutation. */
  municipalOffice?: Maybe<MunicipalOffice>
  /** An edge for our `MunicipalOffice`. May be used by Relay 1. */
  municipalOfficeEdge?: Maybe<MunicipalOfficesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `MunicipalOffice` mutation. */
export type DeleteMunicipalOfficePayloadMunicipalOfficeEdgeArgs = {
  orderBy?: InputMaybe<Array<MunicipalOfficesOrderBy>>
}

/** All input for the `deletePostserviceListById` mutation. */
export type DeletePostserviceListByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deletePostserviceList` mutation. */
export type DeletePostserviceListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PostserviceList` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `PostserviceList` mutation. */
export type DeletePostserviceListPayload = {
  __typename: 'DeletePostserviceListPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedPostserviceListId?: Maybe<Scalars['ID']>
  /** The `PostserviceList` that was deleted by this mutation. */
  postserviceList?: Maybe<PostserviceList>
  /** An edge for our `PostserviceList`. May be used by Relay 1. */
  postserviceListEdge?: Maybe<PostserviceListsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `PostserviceList` mutation. */
export type DeletePostserviceListPayloadPostserviceListEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceListsOrderBy>>
}

/** All input for the `deletePostserviceRecipientById` mutation. */
export type DeletePostserviceRecipientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deletePostserviceRecipient` mutation. */
export type DeletePostserviceRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PostserviceRecipient` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `PostserviceRecipient` mutation. */
export type DeletePostserviceRecipientPayload = {
  __typename: 'DeletePostserviceRecipientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedPostserviceRecipientId?: Maybe<Scalars['ID']>
  /** Reads a single `PostserviceList` that is related to this `PostserviceRecipient`. */
  postserviceListByPostserviceListId?: Maybe<PostserviceList>
  /** The `PostserviceRecipient` that was deleted by this mutation. */
  postserviceRecipient?: Maybe<PostserviceRecipient>
  /** An edge for our `PostserviceRecipient`. May be used by Relay 1. */
  postserviceRecipientEdge?: Maybe<PostserviceRecipientsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `PostserviceRecipient` mutation. */
export type DeletePostserviceRecipientPayloadPostserviceRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceRecipientsOrderBy>>
}

/** All input for the `deletePostserviceSentLetterById` mutation. */
export type DeletePostserviceSentLetterByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deletePostserviceSentLetter` mutation. */
export type DeletePostserviceSentLetterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PostserviceSentLetter` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `PostserviceSentLetter` mutation. */
export type DeletePostserviceSentLetterPayload = {
  __typename: 'DeletePostserviceSentLetterPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedPostserviceSentLetterId?: Maybe<Scalars['ID']>
  /** Reads a single `PostserviceList` that is related to this `PostserviceSentLetter`. */
  postserviceListByOriginalListId?: Maybe<PostserviceList>
  /** The `PostserviceSentLetter` that was deleted by this mutation. */
  postserviceSentLetter?: Maybe<PostserviceSentLetter>
  /** An edge for our `PostserviceSentLetter`. May be used by Relay 1. */
  postserviceSentLetterEdge?: Maybe<PostserviceSentLettersEdge>
  /** Reads a single `PostserviceTemplate` that is related to this `PostserviceSentLetter`. */
  postserviceTemplateByOriginalTemplateId?: Maybe<PostserviceTemplate>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** Reads a single `SenderAddress` that is related to this `PostserviceSentLetter`. */
  senderAddressBySenderAddressId?: Maybe<SenderAddress>
}

/** The output of our delete `PostserviceSentLetter` mutation. */
export type DeletePostserviceSentLetterPayloadPostserviceSentLetterEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceSentLettersOrderBy>>
}

/** All input for the `deletePostserviceSentRecipientById` mutation. */
export type DeletePostserviceSentRecipientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deletePostserviceSentRecipient` mutation. */
export type DeletePostserviceSentRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PostserviceSentRecipient` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `PostserviceSentRecipient` mutation. */
export type DeletePostserviceSentRecipientPayload = {
  __typename: 'DeletePostserviceSentRecipientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedPostserviceSentRecipientId?: Maybe<Scalars['ID']>
  /** Reads a single `PostserviceRecipient` that is related to this `PostserviceSentRecipient`. */
  postserviceRecipientByOriginalRecipientId?: Maybe<PostserviceRecipient>
  /** Reads a single `PostserviceSentLetter` that is related to this `PostserviceSentRecipient`. */
  postserviceSentLetterBySentLetterId?: Maybe<PostserviceSentLetter>
  /** The `PostserviceSentRecipient` that was deleted by this mutation. */
  postserviceSentRecipient?: Maybe<PostserviceSentRecipient>
  /** An edge for our `PostserviceSentRecipient`. May be used by Relay 1. */
  postserviceSentRecipientEdge?: Maybe<PostserviceSentRecipientsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `PostserviceSentRecipient` mutation. */
export type DeletePostserviceSentRecipientPayloadPostserviceSentRecipientEdgeArgs =
  {
    orderBy?: InputMaybe<Array<PostserviceSentRecipientsOrderBy>>
  }

/** All input for the `deletePostserviceTemplateById` mutation. */
export type DeletePostserviceTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deletePostserviceTemplate` mutation. */
export type DeletePostserviceTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PostserviceTemplate` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `PostserviceTemplate` mutation. */
export type DeletePostserviceTemplatePayload = {
  __typename: 'DeletePostserviceTemplatePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedPostserviceTemplateId?: Maybe<Scalars['ID']>
  /** The `PostserviceTemplate` that was deleted by this mutation. */
  postserviceTemplate?: Maybe<PostserviceTemplate>
  /** An edge for our `PostserviceTemplate`. May be used by Relay 1. */
  postserviceTemplateEdge?: Maybe<PostserviceTemplatesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `PostserviceTemplate` mutation. */
export type DeletePostserviceTemplatePayloadPostserviceTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceTemplatesOrderBy>>
}

/** All input for the `deletePropertyLabelById` mutation. */
export type DeletePropertyLabelByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deletePropertyLabel` mutation. */
export type DeletePropertyLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PropertyLabel` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `PropertyLabel` mutation. */
export type DeletePropertyLabelPayload = {
  __typename: 'DeletePropertyLabelPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedPropertyLabelId?: Maybe<Scalars['ID']>
  /** The `PropertyLabel` that was deleted by this mutation. */
  propertyLabel?: Maybe<PropertyLabel>
  /** An edge for our `PropertyLabel`. May be used by Relay 1. */
  propertyLabelEdge?: Maybe<PropertyLabelsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `PropertyLabel` mutation. */
export type DeletePropertyLabelPayloadPropertyLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyLabelsOrderBy>>
}

/** All input for the `deletePropertyListById` mutation. */
export type DeletePropertyListByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deletePropertyList` mutation. */
export type DeletePropertyListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PropertyList` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `PropertyList` mutation. */
export type DeletePropertyListPayload = {
  __typename: 'DeletePropertyListPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedPropertyListId?: Maybe<Scalars['ID']>
  /** The `PropertyList` that was deleted by this mutation. */
  propertyList?: Maybe<PropertyList>
  /** An edge for our `PropertyList`. May be used by Relay 1. */
  propertyListEdge?: Maybe<PropertyListsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `PropertyList` mutation. */
export type DeletePropertyListPayloadPropertyListEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyListsOrderBy>>
}

/** All input for the `deletePropertyNoteById` mutation. */
export type DeletePropertyNoteByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deletePropertyNote` mutation. */
export type DeletePropertyNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PropertyNote` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `PropertyNote` mutation. */
export type DeletePropertyNotePayload = {
  __typename: 'DeletePropertyNotePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedPropertyNoteId?: Maybe<Scalars['ID']>
  /** The `PropertyNote` that was deleted by this mutation. */
  propertyNote?: Maybe<PropertyNote>
  /** An edge for our `PropertyNote`. May be used by Relay 1. */
  propertyNoteEdge?: Maybe<PropertyNotesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our delete `PropertyNote` mutation. */
export type DeletePropertyNotePayloadPropertyNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyNotesOrderBy>>
}

/** All input for the `deleteRecipientById` mutation. */
export type DeleteRecipientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteRecipient` mutation. */
export type DeleteRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `Recipient` to be deleted. */
  nodeId: Scalars['ID']
}

/** All input for the `deleteRecipientListById` mutation. */
export type DeleteRecipientListByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteRecipientList` mutation. */
export type DeleteRecipientListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `RecipientList` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `RecipientList` mutation. */
export type DeleteRecipientListPayload = {
  __typename: 'DeleteRecipientListPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedRecipientListId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `RecipientList` that was deleted by this mutation. */
  recipientList?: Maybe<RecipientList>
  /** An edge for our `RecipientList`. May be used by Relay 1. */
  recipientListEdge?: Maybe<RecipientListsEdge>
  /** Reads a single `SenderAddress` that is related to this `RecipientList`. */
  senderAddressBySenderAddressId?: Maybe<SenderAddress>
}

/** The output of our delete `RecipientList` mutation. */
export type DeleteRecipientListPayloadRecipientListEdgeArgs = {
  orderBy?: InputMaybe<Array<RecipientListsOrderBy>>
}

/** All input for the `deleteRecipientListRecipientById` mutation. */
export type DeleteRecipientListRecipientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteRecipientListRecipientByRecipientListIdAndRecipientId` mutation. */
export type DeleteRecipientListRecipientByRecipientListIdAndRecipientIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  recipientId: Scalars['UUID']
  recipientListId: Scalars['UUID']
}

/** All input for the `deleteRecipientListRecipient` mutation. */
export type DeleteRecipientListRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `RecipientListRecipient` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `RecipientListRecipient` mutation. */
export type DeleteRecipientListRecipientPayload = {
  __typename: 'DeleteRecipientListRecipientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedRecipientListRecipientId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** Reads a single `Recipient` that is related to this `RecipientListRecipient`. */
  recipientByRecipientId?: Maybe<Recipient>
  /** Reads a single `RecipientList` that is related to this `RecipientListRecipient`. */
  recipientListByRecipientListId?: Maybe<RecipientList>
  /** The `RecipientListRecipient` that was deleted by this mutation. */
  recipientListRecipient?: Maybe<RecipientListRecipient>
  /** An edge for our `RecipientListRecipient`. May be used by Relay 1. */
  recipientListRecipientEdge?: Maybe<RecipientListRecipientsEdge>
}

/** The output of our delete `RecipientListRecipient` mutation. */
export type DeleteRecipientListRecipientPayloadRecipientListRecipientEdgeArgs =
  {
    orderBy?: InputMaybe<Array<RecipientListRecipientsOrderBy>>
  }

/** The output of our delete `Recipient` mutation. */
export type DeleteRecipientPayload = {
  __typename: 'DeleteRecipientPayload'
  /** Reads a single `Address` that is related to this `Recipient`. */
  addressByAdresnimistokod?: Maybe<Address>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedRecipientId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `Recipient` that was deleted by this mutation. */
  recipient?: Maybe<Recipient>
  /** An edge for our `Recipient`. May be used by Relay 1. */
  recipientEdge?: Maybe<RecipientsEdge>
}

/** The output of our delete `Recipient` mutation. */
export type DeleteRecipientPayloadRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<RecipientsOrderBy>>
}

/** All input for the `deleteSenderAddressById` mutation. */
export type DeleteSenderAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteSenderAddress` mutation. */
export type DeleteSenderAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `SenderAddress` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `SenderAddress` mutation. */
export type DeleteSenderAddressPayload = {
  __typename: 'DeleteSenderAddressPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedSenderAddressId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `SenderAddress` that was deleted by this mutation. */
  senderAddress?: Maybe<SenderAddress>
  /** An edge for our `SenderAddress`. May be used by Relay 1. */
  senderAddressEdge?: Maybe<SenderAddressesEdge>
}

/** The output of our delete `SenderAddress` mutation. */
export type DeleteSenderAddressPayloadSenderAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<SenderAddressesOrderBy>>
}

/** All input for the `deleteUnitRentByCadastralAreaCode` mutation. */
export type DeleteUnitRentByCadastralAreaCodeInput = {
  cadastralAreaCode: Scalars['String']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
}

/** All input for the `deleteUnitRentById` mutation. */
export type DeleteUnitRentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteUnitRent` mutation. */
export type DeleteUnitRentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `UnitRent` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `UnitRent` mutation. */
export type DeleteUnitRentPayload = {
  __typename: 'DeleteUnitRentPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedUnitRentId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `UnitRent` that was deleted by this mutation. */
  unitRent?: Maybe<UnitRent>
  /** An edge for our `UnitRent`. May be used by Relay 1. */
  unitRentEdge?: Maybe<UnitRentsEdge>
}

/** The output of our delete `UnitRent` mutation. */
export type DeleteUnitRentPayloadUnitRentEdgeArgs = {
  orderBy?: InputMaybe<Array<UnitRentsOrderBy>>
}

/** All input for the `deleteUserActivityLogById` mutation. */
export type DeleteUserActivityLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `deleteUserActivityLog` mutation. */
export type DeleteUserActivityLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `UserActivityLog` to be deleted. */
  nodeId: Scalars['ID']
}

/** The output of our delete `UserActivityLog` mutation. */
export type DeleteUserActivityLogPayload = {
  __typename: 'DeleteUserActivityLogPayload'
  /** Reads a single `AuctionListing` that is related to this `UserActivityLog`. */
  auctionListingByAuctionListingId?: Maybe<AuctionListing>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  deletedUserActivityLogId?: Maybe<Scalars['ID']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `UserActivityLog` that was deleted by this mutation. */
  userActivityLog?: Maybe<UserActivityLog>
  /** An edge for our `UserActivityLog`. May be used by Relay 1. */
  userActivityLogEdge?: Maybe<UserActivityLogsEdge>
}

/** The output of our delete `UserActivityLog` mutation. */
export type DeleteUserActivityLogPayloadUserActivityLogEdgeArgs = {
  orderBy?: InputMaybe<Array<UserActivityLogsOrderBy>>
}

/** All input for the `filmInStock` mutation. */
export type FilmInStockInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  pFilmId?: InputMaybe<Scalars['Int']>
  pStoreId?: InputMaybe<Scalars['Int']>
}

/** The output of our `filmInStock` mutation. */
export type FilmInStockPayload = {
  __typename: 'FilmInStockPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  pFilmCounts?: Maybe<Array<Maybe<Scalars['Int']>>>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** All input for the `filmNotInStock` mutation. */
export type FilmNotInStockInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  pFilmId?: InputMaybe<Scalars['Int']>
  pStoreId?: InputMaybe<Scalars['Int']>
}

/** The output of our `filmNotInStock` mutation. */
export type FilmNotInStockPayload = {
  __typename: 'FilmNotInStockPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  pFilmCounts?: Maybe<Array<Maybe<Scalars['Int']>>>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** All input for the `getCustomerBalance` mutation. */
export type GetCustomerBalanceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  pCustomerId?: InputMaybe<Scalars['Int']>
  pEffectiveDate?: InputMaybe<Scalars['Datetime']>
}

/** The output of our `getCustomerBalance` mutation. */
export type GetCustomerBalancePayload = {
  __typename: 'GetCustomerBalancePayload'
  bigFloat?: Maybe<Scalars['BigFloat']>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']>>
}

/** All input for the `inventoryHeldByCustomer` mutation. */
export type InventoryHeldByCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  pInventoryId?: InputMaybe<Scalars['Int']>
}

/** The output of our `inventoryHeldByCustomer` mutation. */
export type InventoryHeldByCustomerPayload = {
  __typename: 'InventoryHeldByCustomerPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  integer?: Maybe<Scalars['Int']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** All input for the `inventoryInStock` mutation. */
export type InventoryInStockInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  pInventoryId?: InputMaybe<Scalars['Int']>
}

/** The output of our `inventoryInStock` mutation. */
export type InventoryInStockPayload = {
  __typename: 'InventoryInStockPayload'
  boolean?: Maybe<Scalars['Boolean']>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']>
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']>
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']>>
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']>>
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']>
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']>>
}

export type KuArea = Node & {
  __typename: 'KuArea'
  areaId: Scalars['UUID']
  ciselnaRada?: Maybe<Scalars['Int']>
  krajKod?: Maybe<Scalars['String']>
  kuKod?: Maybe<Scalars['String']>
  kuNazev?: Maybe<Scalars['String']>
  kuPrac?: Maybe<Scalars['String']>
  /** Reads a single `KuWorkplace` that is related to this `KuArea`. */
  kuWorkplaceByPraresKod?: Maybe<KuWorkplace>
  mapa?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  nuts4?: Maybe<Scalars['String']>
  obecKod?: Maybe<Scalars['String']>
  obecNazev?: Maybe<Scalars['String']>
  okresKod?: Maybe<Scalars['String']>
  platnostDo?: Maybe<Scalars['Date']>
  platnostOd?: Maybe<Scalars['Date']>
  poznamka?: Maybe<Scalars['String']>
  praresKod?: Maybe<Scalars['String']>
}

/** A condition to be used against `KuArea` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type KuAreaCondition = {
  /** Checks for equality with the object’s `areaId` field. */
  areaId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `ciselnaRada` field. */
  ciselnaRada?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `krajKod` field. */
  krajKod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `kuKod` field. */
  kuKod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `kuNazev` field. */
  kuNazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `kuPrac` field. */
  kuPrac?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `mapa` field. */
  mapa?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `nuts4` field. */
  nuts4?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `obecKod` field. */
  obecKod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `obecNazev` field. */
  obecNazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `okresKod` field. */
  okresKod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `platnostDo` field. */
  platnostDo?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `platnostOd` field. */
  platnostOd?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `poznamka` field. */
  poznamka?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `praresKod` field. */
  praresKod?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `KuArea` object types. All fields are combined with a logical ‘and.’ */
export type KuAreaFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<KuAreaFilter>>
  /** Filter by the object’s `areaId` field. */
  areaId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `ciselnaRada` field. */
  ciselnaRada?: InputMaybe<IntFilter>
  /** Filter by the object’s `krajKod` field. */
  krajKod?: InputMaybe<StringFilter>
  /** Filter by the object’s `kuKod` field. */
  kuKod?: InputMaybe<StringFilter>
  /** Filter by the object’s `kuNazev` field. */
  kuNazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `kuPrac` field. */
  kuPrac?: InputMaybe<StringFilter>
  /** Filter by the object’s `mapa` field. */
  mapa?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<KuAreaFilter>
  /** Filter by the object’s `nuts4` field. */
  nuts4?: InputMaybe<StringFilter>
  /** Filter by the object’s `obecKod` field. */
  obecKod?: InputMaybe<StringFilter>
  /** Filter by the object’s `obecNazev` field. */
  obecNazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `okresKod` field. */
  okresKod?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<KuAreaFilter>>
  /** Filter by the object’s `platnostDo` field. */
  platnostDo?: InputMaybe<DateFilter>
  /** Filter by the object’s `platnostOd` field. */
  platnostOd?: InputMaybe<DateFilter>
  /** Filter by the object’s `poznamka` field. */
  poznamka?: InputMaybe<StringFilter>
  /** Filter by the object’s `praresKod` field. */
  praresKod?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `KuArea` */
export type KuAreaInput = {
  areaId?: InputMaybe<Scalars['UUID']>
  ciselnaRada?: InputMaybe<Scalars['Int']>
  krajKod?: InputMaybe<Scalars['String']>
  kuKod?: InputMaybe<Scalars['String']>
  kuNazev?: InputMaybe<Scalars['String']>
  kuPrac?: InputMaybe<Scalars['String']>
  mapa?: InputMaybe<Scalars['String']>
  nuts4?: InputMaybe<Scalars['String']>
  obecKod?: InputMaybe<Scalars['String']>
  obecNazev?: InputMaybe<Scalars['String']>
  okresKod?: InputMaybe<Scalars['String']>
  platnostDo?: InputMaybe<Scalars['Date']>
  platnostOd?: InputMaybe<Scalars['Date']>
  poznamka?: InputMaybe<Scalars['String']>
  praresKod?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `KuArea`. Fields that are set will be updated. */
export type KuAreaPatch = {
  areaId?: InputMaybe<Scalars['UUID']>
  ciselnaRada?: InputMaybe<Scalars['Int']>
  krajKod?: InputMaybe<Scalars['String']>
  kuKod?: InputMaybe<Scalars['String']>
  kuNazev?: InputMaybe<Scalars['String']>
  kuPrac?: InputMaybe<Scalars['String']>
  mapa?: InputMaybe<Scalars['String']>
  nuts4?: InputMaybe<Scalars['String']>
  obecKod?: InputMaybe<Scalars['String']>
  obecNazev?: InputMaybe<Scalars['String']>
  okresKod?: InputMaybe<Scalars['String']>
  platnostDo?: InputMaybe<Scalars['Date']>
  platnostOd?: InputMaybe<Scalars['Date']>
  poznamka?: InputMaybe<Scalars['String']>
  praresKod?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `KuArea` values. */
export type KuAreasConnection = {
  __typename: 'KuAreasConnection'
  /** A list of edges which contains the `KuArea` and cursor to aid in pagination. */
  edges: Array<KuAreasEdge>
  /** A list of `KuArea` objects. */
  nodes: Array<Maybe<KuArea>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `KuArea` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `KuArea` edge in the connection. */
export type KuAreasEdge = {
  __typename: 'KuAreasEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `KuArea` at the end of the edge. */
  node?: Maybe<KuArea>
}

/** Methods to use when ordering `KuArea`. */
export enum KuAreasOrderBy {
  AreaIdAsc = 'AREA_ID_ASC',
  AreaIdDesc = 'AREA_ID_DESC',
  CiselnaRadaAsc = 'CISELNA_RADA_ASC',
  CiselnaRadaDesc = 'CISELNA_RADA_DESC',
  KrajKodAsc = 'KRAJ_KOD_ASC',
  KrajKodDesc = 'KRAJ_KOD_DESC',
  KuKodAsc = 'KU_KOD_ASC',
  KuKodDesc = 'KU_KOD_DESC',
  KuNazevAsc = 'KU_NAZEV_ASC',
  KuNazevDesc = 'KU_NAZEV_DESC',
  KuPracAsc = 'KU_PRAC_ASC',
  KuPracDesc = 'KU_PRAC_DESC',
  MapaAsc = 'MAPA_ASC',
  MapaDesc = 'MAPA_DESC',
  Natural = 'NATURAL',
  Nuts4Asc = 'NUTS4_ASC',
  Nuts4Desc = 'NUTS4_DESC',
  ObecKodAsc = 'OBEC_KOD_ASC',
  ObecKodDesc = 'OBEC_KOD_DESC',
  ObecNazevAsc = 'OBEC_NAZEV_ASC',
  ObecNazevDesc = 'OBEC_NAZEV_DESC',
  OkresKodAsc = 'OKRES_KOD_ASC',
  OkresKodDesc = 'OKRES_KOD_DESC',
  PlatnostDoAsc = 'PLATNOST_DO_ASC',
  PlatnostDoDesc = 'PLATNOST_DO_DESC',
  PlatnostOdAsc = 'PLATNOST_OD_ASC',
  PlatnostOdDesc = 'PLATNOST_OD_DESC',
  PoznamkaAsc = 'POZNAMKA_ASC',
  PoznamkaDesc = 'POZNAMKA_DESC',
  PraresKodAsc = 'PRARES_KOD_ASC',
  PraresKodDesc = 'PRARES_KOD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type KuWorkplace = Node & {
  __typename: 'KuWorkplace'
  castObce?: Maybe<Scalars['String']>
  cisloDomovni?: Maybe<Scalars['Int']>
  cisloOrientacni?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  fax?: Maybe<Scalars['String']>
  ico?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  kod: Scalars['String']
  kodProVs?: Maybe<Scalars['String']>
  /** Reads and enables pagination through a set of `KuArea`. */
  kuAreasByPraresKod: KuAreasConnection
  /** Reads a single `KuWorkplace` that is related to this `KuWorkplace`. */
  kuWorkplaceByNadrizPrac?: Maybe<KuWorkplace>
  /** Reads and enables pagination through a set of `KuWorkplace`. */
  kuWorkplacesByNadrizPrac: KuWorkplacesConnection
  mestskaCast?: Maybe<Scalars['String']>
  nadrizPrac?: Maybe<Scalars['String']>
  nazev?: Maybe<Scalars['String']>
  nazevUlice?: Maybe<Scalars['String']>
  nazevZkraceny?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  obec?: Maybe<Scalars['String']>
  okres?: Maybe<Scalars['String']>
  platnostDo?: Maybe<Scalars['Date']>
  platnostOd?: Maybe<Scalars['Date']>
  psc?: Maybe<Scalars['String']>
  stat?: Maybe<Scalars['String']>
  telefon?: Maybe<Scalars['String']>
  typAdresy?: Maybe<Scalars['Int']>
  typPrac?: Maybe<Scalars['Int']>
  web?: Maybe<Scalars['String']>
  zkratka?: Maybe<Scalars['String']>
}

export type KuWorkplaceKuAreasByPraresKodArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<KuAreaCondition>
  filter?: InputMaybe<KuAreaFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<KuAreasOrderBy>>
}

export type KuWorkplaceKuWorkplacesByNadrizPracArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<KuWorkplaceCondition>
  filter?: InputMaybe<KuWorkplaceFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<KuWorkplacesOrderBy>>
}

/**
 * A condition to be used against `KuWorkplace` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type KuWorkplaceCondition = {
  /** Checks for equality with the object’s `castObce` field. */
  castObce?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `cisloDomovni` field. */
  cisloDomovni?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `cisloOrientacni` field. */
  cisloOrientacni?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `fax` field. */
  fax?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ico` field. */
  ico?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `kod` field. */
  kod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `kodProVs` field. */
  kodProVs?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `mestskaCast` field. */
  mestskaCast?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `nadrizPrac` field. */
  nadrizPrac?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `nazev` field. */
  nazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `nazevUlice` field. */
  nazevUlice?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `nazevZkraceny` field. */
  nazevZkraceny?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `obec` field. */
  obec?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `okres` field. */
  okres?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `platnostDo` field. */
  platnostDo?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `platnostOd` field. */
  platnostOd?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `psc` field. */
  psc?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `stat` field. */
  stat?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `telefon` field. */
  telefon?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `typAdresy` field. */
  typAdresy?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `typPrac` field. */
  typPrac?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `web` field. */
  web?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `zkratka` field. */
  zkratka?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `KuWorkplace` object types. All fields are combined with a logical ‘and.’ */
export type KuWorkplaceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<KuWorkplaceFilter>>
  /** Filter by the object’s `castObce` field. */
  castObce?: InputMaybe<StringFilter>
  /** Filter by the object’s `cisloDomovni` field. */
  cisloDomovni?: InputMaybe<IntFilter>
  /** Filter by the object’s `cisloOrientacni` field. */
  cisloOrientacni?: InputMaybe<StringFilter>
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<StringFilter>
  /** Filter by the object’s `fax` field. */
  fax?: InputMaybe<StringFilter>
  /** Filter by the object’s `ico` field. */
  ico?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `kod` field. */
  kod?: InputMaybe<StringFilter>
  /** Filter by the object’s `kodProVs` field. */
  kodProVs?: InputMaybe<StringFilter>
  /** Filter by the object’s `mestskaCast` field. */
  mestskaCast?: InputMaybe<StringFilter>
  /** Filter by the object’s `nadrizPrac` field. */
  nadrizPrac?: InputMaybe<StringFilter>
  /** Filter by the object’s `nazev` field. */
  nazev?: InputMaybe<StringFilter>
  /** Filter by the object’s `nazevUlice` field. */
  nazevUlice?: InputMaybe<StringFilter>
  /** Filter by the object’s `nazevZkraceny` field. */
  nazevZkraceny?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<KuWorkplaceFilter>
  /** Filter by the object’s `obec` field. */
  obec?: InputMaybe<StringFilter>
  /** Filter by the object’s `okres` field. */
  okres?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<KuWorkplaceFilter>>
  /** Filter by the object’s `platnostDo` field. */
  platnostDo?: InputMaybe<DateFilter>
  /** Filter by the object’s `platnostOd` field. */
  platnostOd?: InputMaybe<DateFilter>
  /** Filter by the object’s `psc` field. */
  psc?: InputMaybe<StringFilter>
  /** Filter by the object’s `stat` field. */
  stat?: InputMaybe<StringFilter>
  /** Filter by the object’s `telefon` field. */
  telefon?: InputMaybe<StringFilter>
  /** Filter by the object’s `typAdresy` field. */
  typAdresy?: InputMaybe<IntFilter>
  /** Filter by the object’s `typPrac` field. */
  typPrac?: InputMaybe<IntFilter>
  /** Filter by the object’s `web` field. */
  web?: InputMaybe<StringFilter>
  /** Filter by the object’s `zkratka` field. */
  zkratka?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `KuWorkplace` */
export type KuWorkplaceInput = {
  castObce?: InputMaybe<Scalars['String']>
  cisloDomovni?: InputMaybe<Scalars['Int']>
  cisloOrientacni?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  fax?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  kod: Scalars['String']
  kodProVs?: InputMaybe<Scalars['String']>
  mestskaCast?: InputMaybe<Scalars['String']>
  nadrizPrac?: InputMaybe<Scalars['String']>
  nazev?: InputMaybe<Scalars['String']>
  nazevUlice?: InputMaybe<Scalars['String']>
  nazevZkraceny?: InputMaybe<Scalars['String']>
  obec?: InputMaybe<Scalars['String']>
  okres?: InputMaybe<Scalars['String']>
  platnostDo?: InputMaybe<Scalars['Date']>
  platnostOd?: InputMaybe<Scalars['Date']>
  psc?: InputMaybe<Scalars['String']>
  stat?: InputMaybe<Scalars['String']>
  telefon?: InputMaybe<Scalars['String']>
  typAdresy?: InputMaybe<Scalars['Int']>
  typPrac?: InputMaybe<Scalars['Int']>
  web?: InputMaybe<Scalars['String']>
  zkratka?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `KuWorkplace`. Fields that are set will be updated. */
export type KuWorkplacePatch = {
  castObce?: InputMaybe<Scalars['String']>
  cisloDomovni?: InputMaybe<Scalars['Int']>
  cisloOrientacni?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  fax?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  kod?: InputMaybe<Scalars['String']>
  kodProVs?: InputMaybe<Scalars['String']>
  mestskaCast?: InputMaybe<Scalars['String']>
  nadrizPrac?: InputMaybe<Scalars['String']>
  nazev?: InputMaybe<Scalars['String']>
  nazevUlice?: InputMaybe<Scalars['String']>
  nazevZkraceny?: InputMaybe<Scalars['String']>
  obec?: InputMaybe<Scalars['String']>
  okres?: InputMaybe<Scalars['String']>
  platnostDo?: InputMaybe<Scalars['Date']>
  platnostOd?: InputMaybe<Scalars['Date']>
  psc?: InputMaybe<Scalars['String']>
  stat?: InputMaybe<Scalars['String']>
  telefon?: InputMaybe<Scalars['String']>
  typAdresy?: InputMaybe<Scalars['Int']>
  typPrac?: InputMaybe<Scalars['Int']>
  web?: InputMaybe<Scalars['String']>
  zkratka?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `KuWorkplace` values. */
export type KuWorkplacesConnection = {
  __typename: 'KuWorkplacesConnection'
  /** A list of edges which contains the `KuWorkplace` and cursor to aid in pagination. */
  edges: Array<KuWorkplacesEdge>
  /** A list of `KuWorkplace` objects. */
  nodes: Array<Maybe<KuWorkplace>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `KuWorkplace` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `KuWorkplace` edge in the connection. */
export type KuWorkplacesEdge = {
  __typename: 'KuWorkplacesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `KuWorkplace` at the end of the edge. */
  node?: Maybe<KuWorkplace>
}

/** Methods to use when ordering `KuWorkplace`. */
export enum KuWorkplacesOrderBy {
  CastObceAsc = 'CAST_OBCE_ASC',
  CastObceDesc = 'CAST_OBCE_DESC',
  CisloDomovniAsc = 'CISLO_DOMOVNI_ASC',
  CisloDomovniDesc = 'CISLO_DOMOVNI_DESC',
  CisloOrientacniAsc = 'CISLO_ORIENTACNI_ASC',
  CisloOrientacniDesc = 'CISLO_ORIENTACNI_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FaxAsc = 'FAX_ASC',
  FaxDesc = 'FAX_DESC',
  IcoAsc = 'ICO_ASC',
  IcoDesc = 'ICO_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KodAsc = 'KOD_ASC',
  KodDesc = 'KOD_DESC',
  KodProVsAsc = 'KOD_PRO_VS_ASC',
  KodProVsDesc = 'KOD_PRO_VS_DESC',
  MestskaCastAsc = 'MESTSKA_CAST_ASC',
  MestskaCastDesc = 'MESTSKA_CAST_DESC',
  NadrizPracAsc = 'NADRIZ_PRAC_ASC',
  NadrizPracDesc = 'NADRIZ_PRAC_DESC',
  Natural = 'NATURAL',
  NazevAsc = 'NAZEV_ASC',
  NazevDesc = 'NAZEV_DESC',
  NazevUliceAsc = 'NAZEV_ULICE_ASC',
  NazevUliceDesc = 'NAZEV_ULICE_DESC',
  NazevZkracenyAsc = 'NAZEV_ZKRACENY_ASC',
  NazevZkracenyDesc = 'NAZEV_ZKRACENY_DESC',
  ObecAsc = 'OBEC_ASC',
  ObecDesc = 'OBEC_DESC',
  OkresAsc = 'OKRES_ASC',
  OkresDesc = 'OKRES_DESC',
  PlatnostDoAsc = 'PLATNOST_DO_ASC',
  PlatnostDoDesc = 'PLATNOST_DO_DESC',
  PlatnostOdAsc = 'PLATNOST_OD_ASC',
  PlatnostOdDesc = 'PLATNOST_OD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PscAsc = 'PSC_ASC',
  PscDesc = 'PSC_DESC',
  StatAsc = 'STAT_ASC',
  StatDesc = 'STAT_DESC',
  TelefonAsc = 'TELEFON_ASC',
  TelefonDesc = 'TELEFON_DESC',
  TypAdresyAsc = 'TYP_ADRESY_ASC',
  TypAdresyDesc = 'TYP_ADRESY_DESC',
  TypPracAsc = 'TYP_PRAC_ASC',
  TypPracDesc = 'TYP_PRAC_DESC',
  WebAsc = 'WEB_ASC',
  WebDesc = 'WEB_DESC',
  ZkratkaAsc = 'ZKRATKA_ASC',
  ZkratkaDesc = 'ZKRATKA_DESC',
}

export type Label = Node & {
  __typename: 'Label'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  colorKey?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['Datetime']>
  description?: Maybe<Scalars['String']>
  editedAt?: Maybe<Scalars['Datetime']>
  iconKey?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByLabelId: LabelConnectionsConnection
  /** Reads and enables pagination through a set of `LabelMonitoringCuzkRc`. */
  labelMonitoringCuzkRcsByLabelId: LabelMonitoringCuzkRcsConnection
  name?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
}

export type LabelLabelConnectionsByLabelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

export type LabelLabelMonitoringCuzkRcsByLabelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelMonitoringCuzkRcCondition>
  filter?: InputMaybe<LabelMonitoringCuzkRcFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelMonitoringCuzkRcsOrderBy>>
}

/** A condition to be used against `Label` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type LabelCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `colorKey` field. */
  colorKey?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `editedAt` field. */
  editedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `iconKey` field. */
  iconKey?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>
}

export type LabelConnection = Node & {
  __typename: 'LabelConnection'
  /** Reads a single `AuctionListing` that is related to this `LabelConnection`. */
  auctionListingByAuctionListingId?: Maybe<AuctionListing>
  auctionListingId?: Maybe<Scalars['UUID']>
  createdAt: Scalars['Datetime']
  /** Reads a single `CuzkDocumentCollection` that is related to this `LabelConnection`. */
  cuzkDocumentCollectionByCuzkDocumentCollectionId?: Maybe<CuzkDocumentCollection>
  cuzkDocumentCollectionId?: Maybe<Scalars['UUID']>
  /** Reads a single `CuzkEpo` that is related to this `LabelConnection`. */
  cuzkEpoByCuzkEpoId?: Maybe<CuzkEpo>
  cuzkEpoId?: Maybe<Scalars['UUID']>
  /** Reads a single `CuzkEpoLien` that is related to this `LabelConnection`. */
  cuzkEpoLienByCuzkEpoLienId?: Maybe<CuzkEpoLien>
  cuzkEpoLienId?: Maybe<Scalars['UUID']>
  /** Reads a single `CuzkLv` that is related to this `LabelConnection`. */
  cuzkLvByCuzkLvId?: Maybe<CuzkLv>
  cuzkLvId?: Maybe<Scalars['UUID']>
  id: Scalars['UUID']
  /** Reads a single `Label` that is related to this `LabelConnection`. */
  labelByLabelId?: Maybe<Label>
  labelId: Scalars['UUID']
  /** Reads a single `MarketplaceOffer` that is related to this `LabelConnection`. */
  marketplaceOfferByMarketplaceOfferId?: Maybe<MarketplaceOffer>
  marketplaceOfferId?: Maybe<Scalars['UUID']>
  /** Reads a single `Monit` that is related to this `LabelConnection`. */
  monitByMonitId?: Maybe<Monit>
  monitId?: Maybe<Scalars['UUID']>
  /** Reads a single `MonitoringCee` that is related to this `LabelConnection`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  monitoringCeeId?: Maybe<Scalars['UUID']>
  /** Reads a single `MonitoringCuzkRc` that is related to this `LabelConnection`. */
  monitoringCuzkRcByMonitoringCuzkRcId?: Maybe<MonitoringCuzkRc>
  monitoringCuzkRcId?: Maybe<Scalars['UUID']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  /** Reads a single `PostserviceList` that is related to this `LabelConnection`. */
  postserviceListByPostserviceListId?: Maybe<PostserviceList>
  postserviceListId?: Maybe<Scalars['UUID']>
  /** Reads a single `PropertyLabel` that is related to this `LabelConnection`. */
  propertyLabelByPropertyLabelId?: Maybe<PropertyLabel>
  propertyLabelId?: Maybe<Scalars['UUID']>
  /** Reads a single `RecipientList` that is related to this `LabelConnection`. */
  recipientListByRecipientListId?: Maybe<RecipientList>
  recipientListId?: Maybe<Scalars['UUID']>
}

/**
 * A condition to be used against `LabelConnection` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LabelConnectionCondition = {
  /** Checks for equality with the object’s `auctionListingId` field. */
  auctionListingId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `cuzkDocumentCollectionId` field. */
  cuzkDocumentCollectionId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `cuzkEpoId` field. */
  cuzkEpoId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `cuzkEpoLienId` field. */
  cuzkEpoLienId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `cuzkLvId` field. */
  cuzkLvId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `labelId` field. */
  labelId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `marketplaceOfferId` field. */
  marketplaceOfferId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `monitId` field. */
  monitId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `monitoringCeeId` field. */
  monitoringCeeId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `monitoringCuzkRcId` field. */
  monitoringCuzkRcId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `postserviceListId` field. */
  postserviceListId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyLabelId` field. */
  propertyLabelId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `recipientListId` field. */
  recipientListId?: InputMaybe<Scalars['UUID']>
}

/** A filter to be used against `LabelConnection` object types. All fields are combined with a logical ‘and.’ */
export type LabelConnectionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LabelConnectionFilter>>
  /** Filter by the object’s `auctionListingId` field. */
  auctionListingId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `cuzkDocumentCollectionId` field. */
  cuzkDocumentCollectionId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `cuzkEpoId` field. */
  cuzkEpoId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `cuzkEpoLienId` field. */
  cuzkEpoLienId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `cuzkLvId` field. */
  cuzkLvId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `labelId` field. */
  labelId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `marketplaceOfferId` field. */
  marketplaceOfferId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `monitId` field. */
  monitId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `monitoringCeeId` field. */
  monitoringCeeId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `monitoringCuzkRcId` field. */
  monitoringCuzkRcId?: InputMaybe<UuidFilter>
  /** Negates the expression. */
  not?: InputMaybe<LabelConnectionFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LabelConnectionFilter>>
  /** Filter by the object’s `postserviceListId` field. */
  postserviceListId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyLabelId` field. */
  propertyLabelId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `recipientListId` field. */
  recipientListId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `LabelConnection` */
export type LabelConnectionInput = {
  auctionListingId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkDocumentCollectionId?: InputMaybe<Scalars['UUID']>
  cuzkEpoId?: InputMaybe<Scalars['UUID']>
  cuzkEpoLienId?: InputMaybe<Scalars['UUID']>
  cuzkLvId?: InputMaybe<Scalars['UUID']>
  id?: InputMaybe<Scalars['UUID']>
  labelId: Scalars['UUID']
  marketplaceOfferId?: InputMaybe<Scalars['UUID']>
  monitId?: InputMaybe<Scalars['UUID']>
  monitoringCeeId?: InputMaybe<Scalars['UUID']>
  monitoringCuzkRcId?: InputMaybe<Scalars['UUID']>
  postserviceListId?: InputMaybe<Scalars['UUID']>
  propertyLabelId?: InputMaybe<Scalars['UUID']>
  recipientListId?: InputMaybe<Scalars['UUID']>
}

/** Represents an update to a `LabelConnection`. Fields that are set will be updated. */
export type LabelConnectionPatch = {
  auctionListingId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkDocumentCollectionId?: InputMaybe<Scalars['UUID']>
  cuzkEpoId?: InputMaybe<Scalars['UUID']>
  cuzkEpoLienId?: InputMaybe<Scalars['UUID']>
  cuzkLvId?: InputMaybe<Scalars['UUID']>
  id?: InputMaybe<Scalars['UUID']>
  labelId?: InputMaybe<Scalars['UUID']>
  marketplaceOfferId?: InputMaybe<Scalars['UUID']>
  monitId?: InputMaybe<Scalars['UUID']>
  monitoringCeeId?: InputMaybe<Scalars['UUID']>
  monitoringCuzkRcId?: InputMaybe<Scalars['UUID']>
  postserviceListId?: InputMaybe<Scalars['UUID']>
  propertyLabelId?: InputMaybe<Scalars['UUID']>
  recipientListId?: InputMaybe<Scalars['UUID']>
}

/** A connection to a list of `LabelConnection` values. */
export type LabelConnectionsConnection = {
  __typename: 'LabelConnectionsConnection'
  /** A list of edges which contains the `LabelConnection` and cursor to aid in pagination. */
  edges: Array<LabelConnectionsEdge>
  /** A list of `LabelConnection` objects. */
  nodes: Array<Maybe<LabelConnection>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `LabelConnection` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `LabelConnection` edge in the connection. */
export type LabelConnectionsEdge = {
  __typename: 'LabelConnectionsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `LabelConnection` at the end of the edge. */
  node?: Maybe<LabelConnection>
}

/** Methods to use when ordering `LabelConnection`. */
export enum LabelConnectionsOrderBy {
  AuctionListingIdAsc = 'AUCTION_LISTING_ID_ASC',
  AuctionListingIdDesc = 'AUCTION_LISTING_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CuzkDocumentCollectionIdAsc = 'CUZK_DOCUMENT_COLLECTION_ID_ASC',
  CuzkDocumentCollectionIdDesc = 'CUZK_DOCUMENT_COLLECTION_ID_DESC',
  CuzkEpoIdAsc = 'CUZK_EPO_ID_ASC',
  CuzkEpoIdDesc = 'CUZK_EPO_ID_DESC',
  CuzkEpoLienIdAsc = 'CUZK_EPO_LIEN_ID_ASC',
  CuzkEpoLienIdDesc = 'CUZK_EPO_LIEN_ID_DESC',
  CuzkLvIdAsc = 'CUZK_LV_ID_ASC',
  CuzkLvIdDesc = 'CUZK_LV_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelIdAsc = 'LABEL_ID_ASC',
  LabelIdDesc = 'LABEL_ID_DESC',
  MarketplaceOfferIdAsc = 'MARKETPLACE_OFFER_ID_ASC',
  MarketplaceOfferIdDesc = 'MARKETPLACE_OFFER_ID_DESC',
  MonitoringCeeIdAsc = 'MONITORING_CEE_ID_ASC',
  MonitoringCeeIdDesc = 'MONITORING_CEE_ID_DESC',
  MonitoringCuzkRcIdAsc = 'MONITORING_CUZK_RC_ID_ASC',
  MonitoringCuzkRcIdDesc = 'MONITORING_CUZK_RC_ID_DESC',
  MonitIdAsc = 'MONIT_ID_ASC',
  MonitIdDesc = 'MONIT_ID_DESC',
  Natural = 'NATURAL',
  PostserviceListIdAsc = 'POSTSERVICE_LIST_ID_ASC',
  PostserviceListIdDesc = 'POSTSERVICE_LIST_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyLabelIdAsc = 'PROPERTY_LABEL_ID_ASC',
  PropertyLabelIdDesc = 'PROPERTY_LABEL_ID_DESC',
  RecipientListIdAsc = 'RECIPIENT_LIST_ID_ASC',
  RecipientListIdDesc = 'RECIPIENT_LIST_ID_DESC',
}

/** A filter to be used against `Label` object types. All fields are combined with a logical ‘and.’ */
export type LabelFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LabelFilter>>
  /** Filter by the object’s `colorKey` field. */
  colorKey?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `editedAt` field. */
  editedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `iconKey` field. */
  iconKey?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<LabelFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LabelFilter>>
}

/** An input for mutations affecting `Label` */
export type LabelInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  colorKey?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  iconKey?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  name?: InputMaybe<Scalars['String']>
}

export type LabelMonitoringCuzkRc = Node & {
  __typename: 'LabelMonitoringCuzkRc'
  /** Reads a single `Label` that is related to this `LabelMonitoringCuzkRc`. */
  labelByLabelId?: Maybe<Label>
  labelId: Scalars['UUID']
  /** Reads a single `MonitoringCuzkRc` that is related to this `LabelMonitoringCuzkRc`. */
  monitoringCuzkRcByMonitoringCuzkRcId?: Maybe<MonitoringCuzkRc>
  monitoringCuzkRcId: Scalars['UUID']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  updatedAt: Scalars['Datetime']
}

/**
 * A condition to be used against `LabelMonitoringCuzkRc` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LabelMonitoringCuzkRcCondition = {
  /** Checks for equality with the object’s `labelId` field. */
  labelId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `monitoringCuzkRcId` field. */
  monitoringCuzkRcId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** A filter to be used against `LabelMonitoringCuzkRc` object types. All fields are combined with a logical ‘and.’ */
export type LabelMonitoringCuzkRcFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LabelMonitoringCuzkRcFilter>>
  /** Filter by the object’s `labelId` field. */
  labelId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `monitoringCuzkRcId` field. */
  monitoringCuzkRcId?: InputMaybe<UuidFilter>
  /** Negates the expression. */
  not?: InputMaybe<LabelMonitoringCuzkRcFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LabelMonitoringCuzkRcFilter>>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
}

/** An input for mutations affecting `LabelMonitoringCuzkRc` */
export type LabelMonitoringCuzkRcInput = {
  labelId: Scalars['UUID']
  monitoringCuzkRcId: Scalars['UUID']
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** Represents an update to a `LabelMonitoringCuzkRc`. Fields that are set will be updated. */
export type LabelMonitoringCuzkRcPatch = {
  labelId?: InputMaybe<Scalars['UUID']>
  monitoringCuzkRcId?: InputMaybe<Scalars['UUID']>
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** A connection to a list of `LabelMonitoringCuzkRc` values. */
export type LabelMonitoringCuzkRcsConnection = {
  __typename: 'LabelMonitoringCuzkRcsConnection'
  /** A list of edges which contains the `LabelMonitoringCuzkRc` and cursor to aid in pagination. */
  edges: Array<LabelMonitoringCuzkRcsEdge>
  /** A list of `LabelMonitoringCuzkRc` objects. */
  nodes: Array<Maybe<LabelMonitoringCuzkRc>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `LabelMonitoringCuzkRc` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `LabelMonitoringCuzkRc` edge in the connection. */
export type LabelMonitoringCuzkRcsEdge = {
  __typename: 'LabelMonitoringCuzkRcsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `LabelMonitoringCuzkRc` at the end of the edge. */
  node?: Maybe<LabelMonitoringCuzkRc>
}

/** Methods to use when ordering `LabelMonitoringCuzkRc`. */
export enum LabelMonitoringCuzkRcsOrderBy {
  LabelIdAsc = 'LABEL_ID_ASC',
  LabelIdDesc = 'LABEL_ID_DESC',
  MonitoringCuzkRcIdAsc = 'MONITORING_CUZK_RC_ID_ASC',
  MonitoringCuzkRcIdDesc = 'MONITORING_CUZK_RC_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
}

/** Represents an update to a `Label`. Fields that are set will be updated. */
export type LabelPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  colorKey?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  iconKey?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  name?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `Label` values. */
export type LabelsConnection = {
  __typename: 'LabelsConnection'
  /** A list of edges which contains the `Label` and cursor to aid in pagination. */
  edges: Array<LabelsEdge>
  /** A list of `Label` objects. */
  nodes: Array<Maybe<Label>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Label` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `Label` edge in the connection. */
export type LabelsEdge = {
  __typename: 'LabelsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `Label` at the end of the edge. */
  node?: Maybe<Label>
}

/** Methods to use when ordering `Label`. */
export enum LabelsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  ColorKeyAsc = 'COLOR_KEY_ASC',
  ColorKeyDesc = 'COLOR_KEY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EditedAtAsc = 'EDITED_AT_ASC',
  EditedAtDesc = 'EDITED_AT_DESC',
  IconKeyAsc = 'ICON_KEY_ASC',
  IconKeyDesc = 'ICON_KEY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type MarketplaceOffer = Node & {
  __typename: 'MarketplaceOffer'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  contactDescription?: Maybe<Scalars['String']>
  contactEmail: Scalars['String']
  contactName: Scalars['String']
  contactPhone: Scalars['String']
  createdAt: Scalars['Datetime']
  description?: Maybe<Scalars['String']>
  expirationDate: Scalars['Datetime']
  id: Scalars['UUID']
  images?: Maybe<Array<Maybe<Scalars['String']>>>
  interestAmount: Scalars['BigFloat']
  investmentAmount: Scalars['BigFloat']
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByMarketplaceOfferId: LabelConnectionsConnection
  ltv?: Maybe<Scalars['BigFloat']>
  /** Reads and enables pagination through a set of `MarketplaceOfferAccess`. */
  marketplaceOfferAccessesByOfferId: MarketplaceOfferAccessesConnection
  monthlyPayment: Scalars['BigFloat']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  offerLocation: Scalars['String']
  offerType: Scalars['String']
  propertyValue: Scalars['BigFloat']
  state: MarketplaceOfferState
  title: Scalars['String']
}

export type MarketplaceOfferLabelConnectionsByMarketplaceOfferIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

export type MarketplaceOfferMarketplaceOfferAccessesByOfferIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<MarketplaceOfferAccessCondition>
  filter?: InputMaybe<MarketplaceOfferAccessFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<MarketplaceOfferAccessesOrderBy>>
}

export type MarketplaceOfferAccess = Node & {
  __typename: 'MarketplaceOfferAccess'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  createdAt: Scalars['Datetime']
  id: Scalars['UUID']
  isOwner?: Maybe<Scalars['Boolean']>
  /** Reads a single `MarketplaceOffer` that is related to this `MarketplaceOfferAccess`. */
  marketplaceOfferByOfferId?: Maybe<MarketplaceOffer>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  offerId: Scalars['UUID']
}

/**
 * A condition to be used against `MarketplaceOfferAccess` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type MarketplaceOfferAccessCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `isOwner` field. */
  isOwner?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `offerId` field. */
  offerId?: InputMaybe<Scalars['UUID']>
}

/** A filter to be used against `MarketplaceOfferAccess` object types. All fields are combined with a logical ‘and.’ */
export type MarketplaceOfferAccessFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MarketplaceOfferAccessFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `isOwner` field. */
  isOwner?: InputMaybe<BooleanFilter>
  /** Negates the expression. */
  not?: InputMaybe<MarketplaceOfferAccessFilter>
  /** Filter by the object’s `offerId` field. */
  offerId?: InputMaybe<UuidFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MarketplaceOfferAccessFilter>>
}

/** An input for mutations affecting `MarketplaceOfferAccess` */
export type MarketplaceOfferAccessInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  createdAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  isOwner?: InputMaybe<Scalars['Boolean']>
  offerId: Scalars['UUID']
}

/** Represents an update to a `MarketplaceOfferAccess`. Fields that are set will be updated. */
export type MarketplaceOfferAccessPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  isOwner?: InputMaybe<Scalars['Boolean']>
  offerId?: InputMaybe<Scalars['UUID']>
}

/** A connection to a list of `MarketplaceOfferAccess` values. */
export type MarketplaceOfferAccessesConnection = {
  __typename: 'MarketplaceOfferAccessesConnection'
  /** A list of edges which contains the `MarketplaceOfferAccess` and cursor to aid in pagination. */
  edges: Array<MarketplaceOfferAccessesEdge>
  /** A list of `MarketplaceOfferAccess` objects. */
  nodes: Array<Maybe<MarketplaceOfferAccess>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `MarketplaceOfferAccess` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `MarketplaceOfferAccess` edge in the connection. */
export type MarketplaceOfferAccessesEdge = {
  __typename: 'MarketplaceOfferAccessesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `MarketplaceOfferAccess` at the end of the edge. */
  node?: Maybe<MarketplaceOfferAccess>
}

/** Methods to use when ordering `MarketplaceOfferAccess`. */
export enum MarketplaceOfferAccessesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsOwnerAsc = 'IS_OWNER_ASC',
  IsOwnerDesc = 'IS_OWNER_DESC',
  Natural = 'NATURAL',
  OfferIdAsc = 'OFFER_ID_ASC',
  OfferIdDesc = 'OFFER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

/**
 * A condition to be used against `MarketplaceOffer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MarketplaceOfferCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `contactDescription` field. */
  contactDescription?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `contactEmail` field. */
  contactEmail?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `contactName` field. */
  contactName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `contactPhone` field. */
  contactPhone?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `expirationDate` field. */
  expirationDate?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `images` field. */
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Checks for equality with the object’s `interestAmount` field. */
  interestAmount?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `investmentAmount` field. */
  investmentAmount?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `ltv` field. */
  ltv?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `monthlyPayment` field. */
  monthlyPayment?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `offerLocation` field. */
  offerLocation?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `offerType` field. */
  offerType?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyValue` field. */
  propertyValue?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<MarketplaceOfferState>
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `MarketplaceOffer` object types. All fields are combined with a logical ‘and.’ */
export type MarketplaceOfferFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MarketplaceOfferFilter>>
  /** Filter by the object’s `contactDescription` field. */
  contactDescription?: InputMaybe<StringFilter>
  /** Filter by the object’s `contactEmail` field. */
  contactEmail?: InputMaybe<StringFilter>
  /** Filter by the object’s `contactName` field. */
  contactName?: InputMaybe<StringFilter>
  /** Filter by the object’s `contactPhone` field. */
  contactPhone?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `expirationDate` field. */
  expirationDate?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `images` field. */
  images?: InputMaybe<StringListFilter>
  /** Filter by the object’s `interestAmount` field. */
  interestAmount?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `investmentAmount` field. */
  investmentAmount?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `ltv` field. */
  ltv?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `monthlyPayment` field. */
  monthlyPayment?: InputMaybe<BigFloatFilter>
  /** Negates the expression. */
  not?: InputMaybe<MarketplaceOfferFilter>
  /** Filter by the object’s `offerLocation` field. */
  offerLocation?: InputMaybe<StringFilter>
  /** Filter by the object’s `offerType` field. */
  offerType?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MarketplaceOfferFilter>>
  /** Filter by the object’s `propertyValue` field. */
  propertyValue?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<MarketplaceOfferStateFilter>
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `MarketplaceOffer` */
export type MarketplaceOfferInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  contactDescription?: InputMaybe<Scalars['String']>
  contactEmail: Scalars['String']
  contactName: Scalars['String']
  contactPhone: Scalars['String']
  createdAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  expirationDate: Scalars['Datetime']
  id?: InputMaybe<Scalars['UUID']>
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  interestAmount: Scalars['BigFloat']
  investmentAmount: Scalars['BigFloat']
  ltv?: InputMaybe<Scalars['BigFloat']>
  monthlyPayment: Scalars['BigFloat']
  offerLocation: Scalars['String']
  offerType: Scalars['String']
  propertyValue: Scalars['BigFloat']
  state?: InputMaybe<MarketplaceOfferState>
  title: Scalars['String']
}

/** Represents an update to a `MarketplaceOffer`. Fields that are set will be updated. */
export type MarketplaceOfferPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  contactDescription?: InputMaybe<Scalars['String']>
  contactEmail?: InputMaybe<Scalars['String']>
  contactName?: InputMaybe<Scalars['String']>
  contactPhone?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  expirationDate?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  images?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  interestAmount?: InputMaybe<Scalars['BigFloat']>
  investmentAmount?: InputMaybe<Scalars['BigFloat']>
  ltv?: InputMaybe<Scalars['BigFloat']>
  monthlyPayment?: InputMaybe<Scalars['BigFloat']>
  offerLocation?: InputMaybe<Scalars['String']>
  offerType?: InputMaybe<Scalars['String']>
  propertyValue?: InputMaybe<Scalars['BigFloat']>
  state?: InputMaybe<MarketplaceOfferState>
  title?: InputMaybe<Scalars['String']>
}

export enum MarketplaceOfferState {
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Concept = 'CONCEPT',
  Error = 'ERROR',
  Expired = 'EXPIRED',
  Rejected = 'REJECTED',
  Verifying = 'VERIFYING',
}

/** A filter to be used against MarketplaceOfferState fields. All fields are combined with a logical ‘and.’ */
export type MarketplaceOfferStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MarketplaceOfferState>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MarketplaceOfferState>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MarketplaceOfferState>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MarketplaceOfferState>
  /** Included in the specified list. */
  in?: InputMaybe<Array<MarketplaceOfferState>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<MarketplaceOfferState>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MarketplaceOfferState>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MarketplaceOfferState>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MarketplaceOfferState>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MarketplaceOfferState>>
}

/** A connection to a list of `MarketplaceOffer` values. */
export type MarketplaceOffersConnection = {
  __typename: 'MarketplaceOffersConnection'
  /** A list of edges which contains the `MarketplaceOffer` and cursor to aid in pagination. */
  edges: Array<MarketplaceOffersEdge>
  /** A list of `MarketplaceOffer` objects. */
  nodes: Array<Maybe<MarketplaceOffer>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `MarketplaceOffer` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `MarketplaceOffer` edge in the connection. */
export type MarketplaceOffersEdge = {
  __typename: 'MarketplaceOffersEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `MarketplaceOffer` at the end of the edge. */
  node?: Maybe<MarketplaceOffer>
}

/** Methods to use when ordering `MarketplaceOffer`. */
export enum MarketplaceOffersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  ContactDescriptionAsc = 'CONTACT_DESCRIPTION_ASC',
  ContactDescriptionDesc = 'CONTACT_DESCRIPTION_DESC',
  ContactEmailAsc = 'CONTACT_EMAIL_ASC',
  ContactEmailDesc = 'CONTACT_EMAIL_DESC',
  ContactNameAsc = 'CONTACT_NAME_ASC',
  ContactNameDesc = 'CONTACT_NAME_DESC',
  ContactPhoneAsc = 'CONTACT_PHONE_ASC',
  ContactPhoneDesc = 'CONTACT_PHONE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExpirationDateAsc = 'EXPIRATION_DATE_ASC',
  ExpirationDateDesc = 'EXPIRATION_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ImagesAsc = 'IMAGES_ASC',
  ImagesDesc = 'IMAGES_DESC',
  InterestAmountAsc = 'INTEREST_AMOUNT_ASC',
  InterestAmountDesc = 'INTEREST_AMOUNT_DESC',
  InvestmentAmountAsc = 'INVESTMENT_AMOUNT_ASC',
  InvestmentAmountDesc = 'INVESTMENT_AMOUNT_DESC',
  LtvAsc = 'LTV_ASC',
  LtvDesc = 'LTV_DESC',
  MonthlyPaymentAsc = 'MONTHLY_PAYMENT_ASC',
  MonthlyPaymentDesc = 'MONTHLY_PAYMENT_DESC',
  Natural = 'NATURAL',
  OfferLocationAsc = 'OFFER_LOCATION_ASC',
  OfferLocationDesc = 'OFFER_LOCATION_DESC',
  OfferTypeAsc = 'OFFER_TYPE_ASC',
  OfferTypeDesc = 'OFFER_TYPE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyValueAsc = 'PROPERTY_VALUE_ASC',
  PropertyValueDesc = 'PROPERTY_VALUE_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
}

export type Monit = Node & {
  __typename: 'Monit'
  accountId: Scalars['UUID']
  accountUserId?: Maybe<Scalars['UUID']>
  cenaM2Nab?: Maybe<Scalars['BigFloat']>
  cenaM2Real?: Maybe<Scalars['BigFloat']>
  cenaNab?: Maybe<Scalars['BigFloat']>
  cenaReal?: Maybe<Scalars['BigFloat']>
  createdAt: Scalars['Datetime']
  decompNab?: Maybe<Scalars['String']>
  decompReal?: Maybe<Scalars['String']>
  estimateToDate: Scalars['Date']
  graphImageString?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  kodObce?: Maybe<Scalars['Int']>
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByMonitId: LabelConnectionsConnection
  lat: Scalars['BigFloat']
  lon: Scalars['BigFloat']
  lvData?: Maybe<Scalars['String']>
  modelVersion?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  note?: Maybe<Scalars['String']>
  polygon?: Maybe<Scalars['String']>
  propertyId: Scalars['UUID']
  propertyType: Scalars['Int']
  publicNote?: Maybe<Scalars['String']>
  requestData: Scalars['String']
  risyData?: Maybe<Scalars['String']>
  timeSeriesGraph?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type MonitLabelConnectionsByMonitIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

/** A condition to be used against `Monit` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type MonitCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `cenaM2Nab` field. */
  cenaM2Nab?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `cenaM2Real` field. */
  cenaM2Real?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `cenaNab` field. */
  cenaNab?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `cenaReal` field. */
  cenaReal?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `decompNab` field. */
  decompNab?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `decompReal` field. */
  decompReal?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `estimateToDate` field. */
  estimateToDate?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `graphImageString` field. */
  graphImageString?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `kodObce` field. */
  kodObce?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `lat` field. */
  lat?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `lon` field. */
  lon?: InputMaybe<Scalars['BigFloat']>
  /** Checks for equality with the object’s `lvData` field. */
  lvData?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `modelVersion` field. */
  modelVersion?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `polygon` field. */
  polygon?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyId` field. */
  propertyId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyType` field. */
  propertyType?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `publicNote` field. */
  publicNote?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `requestData` field. */
  requestData?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `risyData` field. */
  risyData?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `timeSeriesGraph` field. */
  timeSeriesGraph?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `Monit` object types. All fields are combined with a logical ‘and.’ */
export type MonitFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitFilter>>
  /** Filter by the object’s `cenaM2Nab` field. */
  cenaM2Nab?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `cenaM2Real` field. */
  cenaM2Real?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `cenaNab` field. */
  cenaNab?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `cenaReal` field. */
  cenaReal?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `decompNab` field. */
  decompNab?: InputMaybe<StringFilter>
  /** Filter by the object’s `decompReal` field. */
  decompReal?: InputMaybe<StringFilter>
  /** Filter by the object’s `estimateToDate` field. */
  estimateToDate?: InputMaybe<DateFilter>
  /** Filter by the object’s `graphImageString` field. */
  graphImageString?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `kodObce` field. */
  kodObce?: InputMaybe<IntFilter>
  /** Filter by the object’s `lat` field. */
  lat?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `lon` field. */
  lon?: InputMaybe<BigFloatFilter>
  /** Filter by the object’s `lvData` field. */
  lvData?: InputMaybe<StringFilter>
  /** Filter by the object’s `modelVersion` field. */
  modelVersion?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<MonitFilter>
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitFilter>>
  /** Filter by the object’s `polygon` field. */
  polygon?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyId` field. */
  propertyId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyType` field. */
  propertyType?: InputMaybe<IntFilter>
  /** Filter by the object’s `publicNote` field. */
  publicNote?: InputMaybe<StringFilter>
  /** Filter by the object’s `requestData` field. */
  requestData?: InputMaybe<StringFilter>
  /** Filter by the object’s `risyData` field. */
  risyData?: InputMaybe<StringFilter>
  /** Filter by the object’s `timeSeriesGraph` field. */
  timeSeriesGraph?: InputMaybe<StringFilter>
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `Monit` */
export type MonitInput = {
  accountId: Scalars['UUID']
  accountUserId?: InputMaybe<Scalars['UUID']>
  cenaM2Nab?: InputMaybe<Scalars['BigFloat']>
  cenaM2Real?: InputMaybe<Scalars['BigFloat']>
  cenaNab?: InputMaybe<Scalars['BigFloat']>
  cenaReal?: InputMaybe<Scalars['BigFloat']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  decompNab?: InputMaybe<Scalars['String']>
  decompReal?: InputMaybe<Scalars['String']>
  estimateToDate: Scalars['Date']
  graphImageString?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  kodObce?: InputMaybe<Scalars['Int']>
  lat: Scalars['BigFloat']
  lon: Scalars['BigFloat']
  lvData?: InputMaybe<Scalars['String']>
  modelVersion?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  polygon?: InputMaybe<Scalars['String']>
  propertyId: Scalars['UUID']
  propertyType: Scalars['Int']
  publicNote?: InputMaybe<Scalars['String']>
  requestData: Scalars['String']
  risyData?: InputMaybe<Scalars['String']>
  timeSeriesGraph?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `Monit`. Fields that are set will be updated. */
export type MonitPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  cenaM2Nab?: InputMaybe<Scalars['BigFloat']>
  cenaM2Real?: InputMaybe<Scalars['BigFloat']>
  cenaNab?: InputMaybe<Scalars['BigFloat']>
  cenaReal?: InputMaybe<Scalars['BigFloat']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  decompNab?: InputMaybe<Scalars['String']>
  decompReal?: InputMaybe<Scalars['String']>
  estimateToDate?: InputMaybe<Scalars['Date']>
  graphImageString?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  kodObce?: InputMaybe<Scalars['Int']>
  lat?: InputMaybe<Scalars['BigFloat']>
  lon?: InputMaybe<Scalars['BigFloat']>
  lvData?: InputMaybe<Scalars['String']>
  modelVersion?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  polygon?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyType?: InputMaybe<Scalars['Int']>
  publicNote?: InputMaybe<Scalars['String']>
  requestData?: InputMaybe<Scalars['String']>
  risyData?: InputMaybe<Scalars['String']>
  timeSeriesGraph?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
}

export type MonitoringCee = Node & {
  __typename: 'MonitoringCee'
  accountId: Scalars['UUID']
  accountUserId?: Maybe<Scalars['UUID']>
  birthDate?: Maybe<Scalars['Date']>
  /** Reads and enables pagination through a set of `CeeExecution`. */
  ceeExecutionsByMonitoringCeeId: CeeExecutionsConnection
  checkFrequency?: Maybe<Scalars['Int']>
  createdAt: Scalars['Datetime']
  editedAt?: Maybe<Scalars['Datetime']>
  errorState?: Maybe<Scalars['Boolean']>
  executionCount: Scalars['Int']
  firstname?: Maybe<Scalars['String']>
  found?: Maybe<Scalars['Boolean']>
  ico?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByMonitoringCeeId: LabelConnectionsConnection
  lastCheck?: Maybe<Scalars['Datetime']>
  lastname?: Maybe<Scalars['String']>
  monitoring?: Maybe<Scalars['Boolean']>
  /** Reads and enables pagination through a set of `MonitoringCuzkRc`. */
  monitoringCuzkRcsByMonitoringCeeId: MonitoringCuzkRcsConnection
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  note?: Maybe<Scalars['String']>
  rc?: Maybe<Scalars['String']>
  validatedCode?: Maybe<Scalars['Int']>
}

export type MonitoringCeeCeeExecutionsByMonitoringCeeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CeeExecutionCondition>
  filter?: InputMaybe<CeeExecutionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CeeExecutionsOrderBy>>
}

export type MonitoringCeeLabelConnectionsByMonitoringCeeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

export type MonitoringCeeMonitoringCuzkRcsByMonitoringCeeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<MonitoringCuzkRcCondition>
  filter?: InputMaybe<MonitoringCuzkRcFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<MonitoringCuzkRcsOrderBy>>
}

/**
 * A condition to be used against `MonitoringCee` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MonitoringCeeCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `birthDate` field. */
  birthDate?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `checkFrequency` field. */
  checkFrequency?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `editedAt` field. */
  editedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `errorState` field. */
  errorState?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `executionCount` field. */
  executionCount?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `firstname` field. */
  firstname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `found` field. */
  found?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `ico` field. */
  ico?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `lastCheck` field. */
  lastCheck?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `lastname` field. */
  lastname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `monitoring` field. */
  monitoring?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `rc` field. */
  rc?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `validatedCode` field. */
  validatedCode?: InputMaybe<Scalars['Int']>
}

/** A filter to be used against `MonitoringCee` object types. All fields are combined with a logical ‘and.’ */
export type MonitoringCeeFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitoringCeeFilter>>
  /** Filter by the object’s `birthDate` field. */
  birthDate?: InputMaybe<DateFilter>
  /** Filter by the object’s `checkFrequency` field. */
  checkFrequency?: InputMaybe<IntFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `editedAt` field. */
  editedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `errorState` field. */
  errorState?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `executionCount` field. */
  executionCount?: InputMaybe<IntFilter>
  /** Filter by the object’s `firstname` field. */
  firstname?: InputMaybe<StringFilter>
  /** Filter by the object’s `found` field. */
  found?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `ico` field. */
  ico?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `lastCheck` field. */
  lastCheck?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `lastname` field. */
  lastname?: InputMaybe<StringFilter>
  /** Filter by the object’s `monitoring` field. */
  monitoring?: InputMaybe<BooleanFilter>
  /** Negates the expression. */
  not?: InputMaybe<MonitoringCeeFilter>
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitoringCeeFilter>>
  /** Filter by the object’s `rc` field. */
  rc?: InputMaybe<StringFilter>
  /** Filter by the object’s `validatedCode` field. */
  validatedCode?: InputMaybe<IntFilter>
}

/** An input for mutations affecting `MonitoringCee` */
export type MonitoringCeeInput = {
  accountId: Scalars['UUID']
  accountUserId?: InputMaybe<Scalars['UUID']>
  birthDate?: InputMaybe<Scalars['Date']>
  checkFrequency?: InputMaybe<Scalars['Int']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  errorState?: InputMaybe<Scalars['Boolean']>
  executionCount?: InputMaybe<Scalars['Int']>
  firstname?: InputMaybe<Scalars['String']>
  found?: InputMaybe<Scalars['Boolean']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  lastCheck?: InputMaybe<Scalars['Datetime']>
  lastname?: InputMaybe<Scalars['String']>
  monitoring?: InputMaybe<Scalars['Boolean']>
  note?: InputMaybe<Scalars['String']>
  rc?: InputMaybe<Scalars['String']>
  validatedCode?: InputMaybe<Scalars['Int']>
}

/** Represents an update to a `MonitoringCee`. Fields that are set will be updated. */
export type MonitoringCeePatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  birthDate?: InputMaybe<Scalars['Date']>
  checkFrequency?: InputMaybe<Scalars['Int']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  errorState?: InputMaybe<Scalars['Boolean']>
  executionCount?: InputMaybe<Scalars['Int']>
  firstname?: InputMaybe<Scalars['String']>
  found?: InputMaybe<Scalars['Boolean']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  lastCheck?: InputMaybe<Scalars['Datetime']>
  lastname?: InputMaybe<Scalars['String']>
  monitoring?: InputMaybe<Scalars['Boolean']>
  note?: InputMaybe<Scalars['String']>
  rc?: InputMaybe<Scalars['String']>
  validatedCode?: InputMaybe<Scalars['Int']>
}

/** A connection to a list of `MonitoringCee` values. */
export type MonitoringCeesConnection = {
  __typename: 'MonitoringCeesConnection'
  /** A list of edges which contains the `MonitoringCee` and cursor to aid in pagination. */
  edges: Array<MonitoringCeesEdge>
  /** A list of `MonitoringCee` objects. */
  nodes: Array<Maybe<MonitoringCee>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `MonitoringCee` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `MonitoringCee` edge in the connection. */
export type MonitoringCeesEdge = {
  __typename: 'MonitoringCeesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `MonitoringCee` at the end of the edge. */
  node?: Maybe<MonitoringCee>
}

/** Methods to use when ordering `MonitoringCee`. */
export enum MonitoringCeesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  BirthDateAsc = 'BIRTH_DATE_ASC',
  BirthDateDesc = 'BIRTH_DATE_DESC',
  CheckFrequencyAsc = 'CHECK_FREQUENCY_ASC',
  CheckFrequencyDesc = 'CHECK_FREQUENCY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EditedAtAsc = 'EDITED_AT_ASC',
  EditedAtDesc = 'EDITED_AT_DESC',
  ErrorStateAsc = 'ERROR_STATE_ASC',
  ErrorStateDesc = 'ERROR_STATE_DESC',
  ExecutionCountAsc = 'EXECUTION_COUNT_ASC',
  ExecutionCountDesc = 'EXECUTION_COUNT_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  FoundAsc = 'FOUND_ASC',
  FoundDesc = 'FOUND_DESC',
  IcoAsc = 'ICO_ASC',
  IcoDesc = 'ICO_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  LastCheckAsc = 'LAST_CHECK_ASC',
  LastCheckDesc = 'LAST_CHECK_DESC',
  MonitoringAsc = 'MONITORING_ASC',
  MonitoringDesc = 'MONITORING_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RcAsc = 'RC_ASC',
  RcDesc = 'RC_DESC',
  ValidatedCodeAsc = 'VALIDATED_CODE_ASC',
  ValidatedCodeDesc = 'VALIDATED_CODE_DESC',
}

export type MonitoringCuzkRc = Node & {
  __typename: 'MonitoringCuzkRc'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  birthDate?: Maybe<Scalars['Date']>
  checkFrequency?: Maybe<Scalars['Int']>
  createdAt?: Maybe<Scalars['Datetime']>
  /** Reads a single `CuzkO` that is related to this `MonitoringCuzkRc`. */
  cuzkOByCuzkOsId?: Maybe<CuzkO>
  cuzkOsId?: Maybe<Scalars['UUID']>
  description?: Maybe<Scalars['String']>
  editedAt?: Maybe<Scalars['Datetime']>
  firstname?: Maybe<Scalars['String']>
  found?: Maybe<Scalars['Boolean']>
  ico?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByMonitoringCuzkRcId: LabelConnectionsConnection
  /** Reads and enables pagination through a set of `LabelMonitoringCuzkRc`. */
  labelMonitoringCuzkRcsByMonitoringCuzkRcId: LabelMonitoringCuzkRcsConnection
  lastCheck?: Maybe<Scalars['Datetime']>
  lastname?: Maybe<Scalars['String']>
  /** Reads a single `MonitoringCee` that is related to this `MonitoringCuzkRc`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  monitoringCeeId?: Maybe<Scalars['UUID']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  rc?: Maybe<Scalars['String']>
  validatedCode: Scalars['Int']
}

export type MonitoringCuzkRcLabelConnectionsByMonitoringCuzkRcIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

export type MonitoringCuzkRcLabelMonitoringCuzkRcsByMonitoringCuzkRcIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelMonitoringCuzkRcCondition>
  filter?: InputMaybe<LabelMonitoringCuzkRcFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelMonitoringCuzkRcsOrderBy>>
}

/**
 * A condition to be used against `MonitoringCuzkRc` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MonitoringCuzkRcCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `birthDate` field. */
  birthDate?: InputMaybe<Scalars['Date']>
  /** Checks for equality with the object’s `checkFrequency` field. */
  checkFrequency?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `cuzkOsId` field. */
  cuzkOsId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `editedAt` field. */
  editedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `firstname` field. */
  firstname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `found` field. */
  found?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `ico` field. */
  ico?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `lastCheck` field. */
  lastCheck?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `lastname` field. */
  lastname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `monitoringCeeId` field. */
  monitoringCeeId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `rc` field. */
  rc?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `validatedCode` field. */
  validatedCode?: InputMaybe<Scalars['Int']>
}

/** A filter to be used against `MonitoringCuzkRc` object types. All fields are combined with a logical ‘and.’ */
export type MonitoringCuzkRcFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MonitoringCuzkRcFilter>>
  /** Filter by the object’s `birthDate` field. */
  birthDate?: InputMaybe<DateFilter>
  /** Filter by the object’s `checkFrequency` field. */
  checkFrequency?: InputMaybe<IntFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `cuzkOsId` field. */
  cuzkOsId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `editedAt` field. */
  editedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `firstname` field. */
  firstname?: InputMaybe<StringFilter>
  /** Filter by the object’s `found` field. */
  found?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `ico` field. */
  ico?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `lastCheck` field. */
  lastCheck?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `lastname` field. */
  lastname?: InputMaybe<StringFilter>
  /** Filter by the object’s `monitoringCeeId` field. */
  monitoringCeeId?: InputMaybe<UuidFilter>
  /** Negates the expression. */
  not?: InputMaybe<MonitoringCuzkRcFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MonitoringCuzkRcFilter>>
  /** Filter by the object’s `rc` field. */
  rc?: InputMaybe<StringFilter>
  /** Filter by the object’s `validatedCode` field. */
  validatedCode?: InputMaybe<IntFilter>
}

/** An input for mutations affecting `MonitoringCuzkRc` */
export type MonitoringCuzkRcInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  birthDate?: InputMaybe<Scalars['Date']>
  checkFrequency?: InputMaybe<Scalars['Int']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkOsId?: InputMaybe<Scalars['UUID']>
  description?: InputMaybe<Scalars['String']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  firstname?: InputMaybe<Scalars['String']>
  found?: InputMaybe<Scalars['Boolean']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  lastCheck?: InputMaybe<Scalars['Datetime']>
  lastname?: InputMaybe<Scalars['String']>
  monitoringCeeId?: InputMaybe<Scalars['UUID']>
  rc?: InputMaybe<Scalars['String']>
  validatedCode: Scalars['Int']
}

/** Represents an update to a `MonitoringCuzkRc`. Fields that are set will be updated. */
export type MonitoringCuzkRcPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  birthDate?: InputMaybe<Scalars['Date']>
  checkFrequency?: InputMaybe<Scalars['Int']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  cuzkOsId?: InputMaybe<Scalars['UUID']>
  description?: InputMaybe<Scalars['String']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  firstname?: InputMaybe<Scalars['String']>
  found?: InputMaybe<Scalars['Boolean']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  lastCheck?: InputMaybe<Scalars['Datetime']>
  lastname?: InputMaybe<Scalars['String']>
  monitoringCeeId?: InputMaybe<Scalars['UUID']>
  rc?: InputMaybe<Scalars['String']>
  validatedCode?: InputMaybe<Scalars['Int']>
}

/** A connection to a list of `MonitoringCuzkRc` values. */
export type MonitoringCuzkRcsConnection = {
  __typename: 'MonitoringCuzkRcsConnection'
  /** A list of edges which contains the `MonitoringCuzkRc` and cursor to aid in pagination. */
  edges: Array<MonitoringCuzkRcsEdge>
  /** A list of `MonitoringCuzkRc` objects. */
  nodes: Array<Maybe<MonitoringCuzkRc>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `MonitoringCuzkRc` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `MonitoringCuzkRc` edge in the connection. */
export type MonitoringCuzkRcsEdge = {
  __typename: 'MonitoringCuzkRcsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `MonitoringCuzkRc` at the end of the edge. */
  node?: Maybe<MonitoringCuzkRc>
}

/** Methods to use when ordering `MonitoringCuzkRc`. */
export enum MonitoringCuzkRcsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  BirthDateAsc = 'BIRTH_DATE_ASC',
  BirthDateDesc = 'BIRTH_DATE_DESC',
  CheckFrequencyAsc = 'CHECK_FREQUENCY_ASC',
  CheckFrequencyDesc = 'CHECK_FREQUENCY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CuzkOsIdAsc = 'CUZK_OS_ID_ASC',
  CuzkOsIdDesc = 'CUZK_OS_ID_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EditedAtAsc = 'EDITED_AT_ASC',
  EditedAtDesc = 'EDITED_AT_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  FoundAsc = 'FOUND_ASC',
  FoundDesc = 'FOUND_DESC',
  IcoAsc = 'ICO_ASC',
  IcoDesc = 'ICO_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  LastCheckAsc = 'LAST_CHECK_ASC',
  LastCheckDesc = 'LAST_CHECK_DESC',
  MonitoringCeeIdAsc = 'MONITORING_CEE_ID_ASC',
  MonitoringCeeIdDesc = 'MONITORING_CEE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RcAsc = 'RC_ASC',
  RcDesc = 'RC_DESC',
  ValidatedCodeAsc = 'VALIDATED_CODE_ASC',
  ValidatedCodeDesc = 'VALIDATED_CODE_DESC',
}

/** A connection to a list of `Monit` values. */
export type MonitsConnection = {
  __typename: 'MonitsConnection'
  /** A list of edges which contains the `Monit` and cursor to aid in pagination. */
  edges: Array<MonitsEdge>
  /** A list of `Monit` objects. */
  nodes: Array<Maybe<Monit>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Monit` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `Monit` edge in the connection. */
export type MonitsEdge = {
  __typename: 'MonitsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `Monit` at the end of the edge. */
  node?: Maybe<Monit>
}

/** Methods to use when ordering `Monit`. */
export enum MonitsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CenaM2NabAsc = 'CENA_M2_NAB_ASC',
  CenaM2NabDesc = 'CENA_M2_NAB_DESC',
  CenaM2RealAsc = 'CENA_M2_REAL_ASC',
  CenaM2RealDesc = 'CENA_M2_REAL_DESC',
  CenaNabAsc = 'CENA_NAB_ASC',
  CenaNabDesc = 'CENA_NAB_DESC',
  CenaRealAsc = 'CENA_REAL_ASC',
  CenaRealDesc = 'CENA_REAL_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DecompNabAsc = 'DECOMP_NAB_ASC',
  DecompNabDesc = 'DECOMP_NAB_DESC',
  DecompRealAsc = 'DECOMP_REAL_ASC',
  DecompRealDesc = 'DECOMP_REAL_DESC',
  EstimateToDateAsc = 'ESTIMATE_TO_DATE_ASC',
  EstimateToDateDesc = 'ESTIMATE_TO_DATE_DESC',
  GraphImageStringAsc = 'GRAPH_IMAGE_STRING_ASC',
  GraphImageStringDesc = 'GRAPH_IMAGE_STRING_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KodObceAsc = 'KOD_OBCE_ASC',
  KodObceDesc = 'KOD_OBCE_DESC',
  LatAsc = 'LAT_ASC',
  LatDesc = 'LAT_DESC',
  LonAsc = 'LON_ASC',
  LonDesc = 'LON_DESC',
  LvDataAsc = 'LV_DATA_ASC',
  LvDataDesc = 'LV_DATA_DESC',
  ModelVersionAsc = 'MODEL_VERSION_ASC',
  ModelVersionDesc = 'MODEL_VERSION_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PolygonAsc = 'POLYGON_ASC',
  PolygonDesc = 'POLYGON_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyIdAsc = 'PROPERTY_ID_ASC',
  PropertyIdDesc = 'PROPERTY_ID_DESC',
  PropertyTypeAsc = 'PROPERTY_TYPE_ASC',
  PropertyTypeDesc = 'PROPERTY_TYPE_DESC',
  PublicNoteAsc = 'PUBLIC_NOTE_ASC',
  PublicNoteDesc = 'PUBLIC_NOTE_DESC',
  RequestDataAsc = 'REQUEST_DATA_ASC',
  RequestDataDesc = 'REQUEST_DATA_DESC',
  RisyDataAsc = 'RISY_DATA_ASC',
  RisyDataDesc = 'RISY_DATA_DESC',
  TimeSeriesGraphAsc = 'TIME_SERIES_GRAPH_ASC',
  TimeSeriesGraphDesc = 'TIME_SERIES_GRAPH_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
}

export type MunicipalOffice = Node & {
  __typename: 'MunicipalOffice'
  adresnimistokod: Scalars['String']
  cityName?: Maybe<Scalars['String']>
  cityPartName?: Maybe<Scalars['String']>
  houseNumber?: Maybe<Scalars['String']>
  ico?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  officeName?: Maybe<Scalars['String']>
  orientationNumber?: Maybe<Scalars['String']>
  streetName?: Maybe<Scalars['String']>
  zipCode?: Maybe<Scalars['String']>
}

/**
 * A condition to be used against `MunicipalOffice` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type MunicipalOfficeCondition = {
  /** Checks for equality with the object’s `adresnimistokod` field. */
  adresnimistokod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `cityName` field. */
  cityName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `cityPartName` field. */
  cityPartName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `ico` field. */
  ico?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `officeName` field. */
  officeName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `orientationNumber` field. */
  orientationNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `streetName` field. */
  streetName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `MunicipalOffice` object types. All fields are combined with a logical ‘and.’ */
export type MunicipalOfficeFilter = {
  /** Filter by the object’s `adresnimistokod` field. */
  adresnimistokod?: InputMaybe<StringFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MunicipalOfficeFilter>>
  /** Filter by the object’s `cityName` field. */
  cityName?: InputMaybe<StringFilter>
  /** Filter by the object’s `cityPartName` field. */
  cityPartName?: InputMaybe<StringFilter>
  /** Filter by the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `ico` field. */
  ico?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Negates the expression. */
  not?: InputMaybe<MunicipalOfficeFilter>
  /** Filter by the object’s `officeName` field. */
  officeName?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MunicipalOfficeFilter>>
  /** Filter by the object’s `orientationNumber` field. */
  orientationNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `streetName` field. */
  streetName?: InputMaybe<StringFilter>
  /** Filter by the object’s `zipCode` field. */
  zipCode?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `MunicipalOffice` */
export type MunicipalOfficeInput = {
  adresnimistokod: Scalars['String']
  cityName?: InputMaybe<Scalars['String']>
  cityPartName?: InputMaybe<Scalars['String']>
  houseNumber?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  officeName?: InputMaybe<Scalars['String']>
  orientationNumber?: InputMaybe<Scalars['String']>
  streetName?: InputMaybe<Scalars['String']>
  zipCode?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `MunicipalOffice`. Fields that are set will be updated. */
export type MunicipalOfficePatch = {
  adresnimistokod?: InputMaybe<Scalars['String']>
  cityName?: InputMaybe<Scalars['String']>
  cityPartName?: InputMaybe<Scalars['String']>
  houseNumber?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  officeName?: InputMaybe<Scalars['String']>
  orientationNumber?: InputMaybe<Scalars['String']>
  streetName?: InputMaybe<Scalars['String']>
  zipCode?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `MunicipalOffice` values. */
export type MunicipalOfficesConnection = {
  __typename: 'MunicipalOfficesConnection'
  /** A list of edges which contains the `MunicipalOffice` and cursor to aid in pagination. */
  edges: Array<MunicipalOfficesEdge>
  /** A list of `MunicipalOffice` objects. */
  nodes: Array<Maybe<MunicipalOffice>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `MunicipalOffice` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `MunicipalOffice` edge in the connection. */
export type MunicipalOfficesEdge = {
  __typename: 'MunicipalOfficesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `MunicipalOffice` at the end of the edge. */
  node?: Maybe<MunicipalOffice>
}

/** Methods to use when ordering `MunicipalOffice`. */
export enum MunicipalOfficesOrderBy {
  AdresnimistokodAsc = 'ADRESNIMISTOKOD_ASC',
  AdresnimistokodDesc = 'ADRESNIMISTOKOD_DESC',
  CityNameAsc = 'CITY_NAME_ASC',
  CityNameDesc = 'CITY_NAME_DESC',
  CityPartNameAsc = 'CITY_PART_NAME_ASC',
  CityPartNameDesc = 'CITY_PART_NAME_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  IcoAsc = 'ICO_ASC',
  IcoDesc = 'ICO_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OfficeNameAsc = 'OFFICE_NAME_ASC',
  OfficeNameDesc = 'OFFICE_NAME_DESC',
  OrientationNumberAsc = 'ORIENTATION_NUMBER_ASC',
  OrientationNumberDesc = 'ORIENTATION_NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StreetNameAsc = 'STREET_NAME_ASC',
  StreetNameDesc = 'STREET_NAME_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC',
}

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename: 'Mutation'
  /** Creates a single `Address`. */
  createAddress?: Maybe<CreateAddressPayload>
  /** Creates a single `AuctionListing`. */
  createAuctionListing?: Maybe<CreateAuctionListingPayload>
  /** Creates a single `AuctionProperty`. */
  createAuctionProperty?: Maybe<CreateAuctionPropertyPayload>
  /** Creates a single `Bpej`. */
  createBpej?: Maybe<CreateBpejPayload>
  /** Creates a single `BuybackCalculation`. */
  createBuybackCalculation?: Maybe<CreateBuybackCalculationPayload>
  /** Creates a single `CeeExecution`. */
  createCeeExecution?: Maybe<CreateCeeExecutionPayload>
  /** Creates a single `CeeExecutionDetail`. */
  createCeeExecutionDetail?: Maybe<CreateCeeExecutionDetailPayload>
  /** Creates a single `CeeOffice`. */
  createCeeOffice?: Maybe<CreateCeeOfficePayload>
  /** Creates a single `CuzkDocumentCollection`. */
  createCuzkDocumentCollection?: Maybe<CreateCuzkDocumentCollectionPayload>
  /** Creates a single `CuzkEpo`. */
  createCuzkEpo?: Maybe<CreateCuzkEpoPayload>
  /** Creates a single `CuzkEpoLien`. */
  createCuzkEpoLien?: Maybe<CreateCuzkEpoLienPayload>
  /** Creates a single `CuzkEpoRestrictionCheck`. */
  createCuzkEpoRestrictionCheck?: Maybe<CreateCuzkEpoRestrictionCheckPayload>
  /** Creates a single `CuzkLv`. */
  createCuzkLv?: Maybe<CreateCuzkLvPayload>
  /** Creates a single `CuzkO`. */
  createCuzkO?: Maybe<CreateCuzkOPayload>
  /** Creates a single `Databox`. */
  createDatabox?: Maybe<CreateDataboxPayload>
  /** Creates a single `KuArea`. */
  createKuArea?: Maybe<CreateKuAreaPayload>
  /** Creates a single `KuWorkplace`. */
  createKuWorkplace?: Maybe<CreateKuWorkplacePayload>
  /** Creates a single `Label`. */
  createLabel?: Maybe<CreateLabelPayload>
  /** Creates a single `LabelConnection`. */
  createLabelConnection?: Maybe<CreateLabelConnectionPayload>
  /** Creates a single `LabelMonitoringCuzkRc`. */
  createLabelMonitoringCuzkRc?: Maybe<CreateLabelMonitoringCuzkRcPayload>
  /** Creates a single `MarketplaceOffer`. */
  createMarketplaceOffer?: Maybe<CreateMarketplaceOfferPayload>
  /** Creates a single `MarketplaceOfferAccess`. */
  createMarketplaceOfferAccess?: Maybe<CreateMarketplaceOfferAccessPayload>
  /** Creates a single `Monit`. */
  createMonit?: Maybe<CreateMonitPayload>
  /** Creates a single `MonitoringCee`. */
  createMonitoringCee?: Maybe<CreateMonitoringCeePayload>
  /** Creates a single `MonitoringCuzkRc`. */
  createMonitoringCuzkRc?: Maybe<CreateMonitoringCuzkRcPayload>
  /** Creates a single `MunicipalOffice`. */
  createMunicipalOffice?: Maybe<CreateMunicipalOfficePayload>
  /** Creates a single `PostserviceList`. */
  createPostserviceList?: Maybe<CreatePostserviceListPayload>
  /** Creates a single `PostserviceRecipient`. */
  createPostserviceRecipient?: Maybe<CreatePostserviceRecipientPayload>
  /** Creates a single `PostserviceSentLetter`. */
  createPostserviceSentLetter?: Maybe<CreatePostserviceSentLetterPayload>
  /** Creates a single `PostserviceSentRecipient`. */
  createPostserviceSentRecipient?: Maybe<CreatePostserviceSentRecipientPayload>
  /** Creates a single `PostserviceTemplate`. */
  createPostserviceTemplate?: Maybe<CreatePostserviceTemplatePayload>
  /** Creates a single `PropertyLabel`. */
  createPropertyLabel?: Maybe<CreatePropertyLabelPayload>
  /** Creates a single `PropertyList`. */
  createPropertyList?: Maybe<CreatePropertyListPayload>
  /** Creates a single `PropertyNote`. */
  createPropertyNote?: Maybe<CreatePropertyNotePayload>
  /** Creates a single `Recipient`. */
  createRecipient?: Maybe<CreateRecipientPayload>
  /** Creates a single `RecipientList`. */
  createRecipientList?: Maybe<CreateRecipientListPayload>
  /** Creates a single `RecipientListRecipient`. */
  createRecipientListRecipient?: Maybe<CreateRecipientListRecipientPayload>
  /** Creates a single `SenderAddress`. */
  createSenderAddress?: Maybe<CreateSenderAddressPayload>
  /** Creates a single `UnitRent`. */
  createUnitRent?: Maybe<CreateUnitRentPayload>
  /** Creates a single `UserActivityLog`. */
  createUserActivityLog?: Maybe<CreateUserActivityLogPayload>
  /** Deletes a single `Address` using its globally unique id. */
  deleteAddress?: Maybe<DeleteAddressPayload>
  /** Deletes a single `Address` using a unique key. */
  deleteAddressById?: Maybe<DeleteAddressPayload>
  /** Deletes a single `Address` using a unique key. */
  deleteAddressByKod?: Maybe<DeleteAddressPayload>
  /** Deletes a single `AuctionListing` using its globally unique id. */
  deleteAuctionListing?: Maybe<DeleteAuctionListingPayload>
  /** Deletes a single `AuctionListing` using a unique key. */
  deleteAuctionListingById?: Maybe<DeleteAuctionListingPayload>
  /** Deletes a single `AuctionProperty` using its globally unique id. */
  deleteAuctionProperty?: Maybe<DeleteAuctionPropertyPayload>
  /** Deletes a single `AuctionProperty` using a unique key. */
  deleteAuctionPropertyById?: Maybe<DeleteAuctionPropertyPayload>
  /** Deletes a single `Bpej` using its globally unique id. */
  deleteBpej?: Maybe<DeleteBpejPayload>
  /** Deletes a single `Bpej` using a unique key. */
  deleteBpejById?: Maybe<DeleteBpejPayload>
  /** Deletes a single `BuybackCalculation` using its globally unique id. */
  deleteBuybackCalculation?: Maybe<DeleteBuybackCalculationPayload>
  /** Deletes a single `BuybackCalculation` using a unique key. */
  deleteBuybackCalculationById?: Maybe<DeleteBuybackCalculationPayload>
  /** Deletes a single `CeeExecution` using its globally unique id. */
  deleteCeeExecution?: Maybe<DeleteCeeExecutionPayload>
  /** Deletes a single `CeeExecution` using a unique key. */
  deleteCeeExecutionById?: Maybe<DeleteCeeExecutionPayload>
  /** Deletes a single `CeeExecutionDetail` using its globally unique id. */
  deleteCeeExecutionDetail?: Maybe<DeleteCeeExecutionDetailPayload>
  /** Deletes a single `CeeExecutionDetail` using a unique key. */
  deleteCeeExecutionDetailById?: Maybe<DeleteCeeExecutionDetailPayload>
  /** Deletes a single `CeeOffice` using its globally unique id. */
  deleteCeeOffice?: Maybe<DeleteCeeOfficePayload>
  /** Deletes a single `CeeOffice` using a unique key. */
  deleteCeeOfficeById?: Maybe<DeleteCeeOfficePayload>
  /** Deletes a single `CuzkDocumentCollection` using its globally unique id. */
  deleteCuzkDocumentCollection?: Maybe<DeleteCuzkDocumentCollectionPayload>
  /** Deletes a single `CuzkDocumentCollection` using a unique key. */
  deleteCuzkDocumentCollectionById?: Maybe<DeleteCuzkDocumentCollectionPayload>
  /** Deletes a single `CuzkEpo` using its globally unique id. */
  deleteCuzkEpo?: Maybe<DeleteCuzkEpoPayload>
  /** Deletes a single `CuzkEpo` using a unique key. */
  deleteCuzkEpoById?: Maybe<DeleteCuzkEpoPayload>
  /** Deletes a single `CuzkEpoLien` using its globally unique id. */
  deleteCuzkEpoLien?: Maybe<DeleteCuzkEpoLienPayload>
  /** Deletes a single `CuzkEpoLien` using a unique key. */
  deleteCuzkEpoLienById?: Maybe<DeleteCuzkEpoLienPayload>
  /** Deletes a single `CuzkEpoRestrictionCheck` using its globally unique id. */
  deleteCuzkEpoRestrictionCheck?: Maybe<DeleteCuzkEpoRestrictionCheckPayload>
  /** Deletes a single `CuzkEpoRestrictionCheck` using a unique key. */
  deleteCuzkEpoRestrictionCheckById?: Maybe<DeleteCuzkEpoRestrictionCheckPayload>
  /** Deletes a single `CuzkLv` using its globally unique id. */
  deleteCuzkLv?: Maybe<DeleteCuzkLvPayload>
  /** Deletes a single `CuzkLv` using a unique key. */
  deleteCuzkLvById?: Maybe<DeleteCuzkLvPayload>
  /** Deletes a single `CuzkO` using its globally unique id. */
  deleteCuzkO?: Maybe<DeleteCuzkOPayload>
  /** Deletes a single `CuzkO` using a unique key. */
  deleteCuzkOById?: Maybe<DeleteCuzkOPayload>
  /** Deletes a single `Databox` using its globally unique id. */
  deleteDatabox?: Maybe<DeleteDataboxPayload>
  /** Deletes a single `Databox` using a unique key. */
  deleteDataboxByDataboxid?: Maybe<DeleteDataboxPayload>
  /** Deletes a single `Databox` using a unique key. */
  deleteDataboxById?: Maybe<DeleteDataboxPayload>
  /** Deletes a single `KuArea` using its globally unique id. */
  deleteKuArea?: Maybe<DeleteKuAreaPayload>
  /** Deletes a single `KuArea` using a unique key. */
  deleteKuAreaByAreaId?: Maybe<DeleteKuAreaPayload>
  /** Deletes a single `KuWorkplace` using its globally unique id. */
  deleteKuWorkplace?: Maybe<DeleteKuWorkplacePayload>
  /** Deletes a single `KuWorkplace` using a unique key. */
  deleteKuWorkplaceById?: Maybe<DeleteKuWorkplacePayload>
  /** Deletes a single `KuWorkplace` using a unique key. */
  deleteKuWorkplaceByKod?: Maybe<DeleteKuWorkplacePayload>
  /** Deletes a single `Label` using its globally unique id. */
  deleteLabel?: Maybe<DeleteLabelPayload>
  /** Deletes a single `Label` using a unique key. */
  deleteLabelById?: Maybe<DeleteLabelPayload>
  /** Deletes a single `LabelConnection` using its globally unique id. */
  deleteLabelConnection?: Maybe<DeleteLabelConnectionPayload>
  /** Deletes a single `LabelConnection` using a unique key. */
  deleteLabelConnectionById?: Maybe<DeleteLabelConnectionPayload>
  /** Deletes a single `LabelMonitoringCuzkRc` using its globally unique id. */
  deleteLabelMonitoringCuzkRc?: Maybe<DeleteLabelMonitoringCuzkRcPayload>
  /** Deletes a single `LabelMonitoringCuzkRc` using a unique key. */
  deleteLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcId?: Maybe<DeleteLabelMonitoringCuzkRcPayload>
  /** Deletes a single `MarketplaceOffer` using its globally unique id. */
  deleteMarketplaceOffer?: Maybe<DeleteMarketplaceOfferPayload>
  /** Deletes a single `MarketplaceOfferAccess` using its globally unique id. */
  deleteMarketplaceOfferAccess?: Maybe<DeleteMarketplaceOfferAccessPayload>
  /** Deletes a single `MarketplaceOfferAccess` using a unique key. */
  deleteMarketplaceOfferAccessById?: Maybe<DeleteMarketplaceOfferAccessPayload>
  /** Deletes a single `MarketplaceOffer` using a unique key. */
  deleteMarketplaceOfferById?: Maybe<DeleteMarketplaceOfferPayload>
  /** Deletes a single `Monit` using its globally unique id. */
  deleteMonit?: Maybe<DeleteMonitPayload>
  /** Deletes a single `Monit` using a unique key. */
  deleteMonitById?: Maybe<DeleteMonitPayload>
  /** Deletes a single `MonitoringCee` using its globally unique id. */
  deleteMonitoringCee?: Maybe<DeleteMonitoringCeePayload>
  /** Deletes a single `MonitoringCee` using a unique key. */
  deleteMonitoringCeeById?: Maybe<DeleteMonitoringCeePayload>
  /** Deletes a single `MonitoringCuzkRc` using its globally unique id. */
  deleteMonitoringCuzkRc?: Maybe<DeleteMonitoringCuzkRcPayload>
  /** Deletes a single `MonitoringCuzkRc` using a unique key. */
  deleteMonitoringCuzkRcById?: Maybe<DeleteMonitoringCuzkRcPayload>
  /** Deletes a single `MunicipalOffice` using its globally unique id. */
  deleteMunicipalOffice?: Maybe<DeleteMunicipalOfficePayload>
  /** Deletes a single `MunicipalOffice` using a unique key. */
  deleteMunicipalOfficeByAdresnimistokod?: Maybe<DeleteMunicipalOfficePayload>
  /** Deletes a single `MunicipalOffice` using a unique key. */
  deleteMunicipalOfficeById?: Maybe<DeleteMunicipalOfficePayload>
  /** Deletes a single `PostserviceList` using its globally unique id. */
  deletePostserviceList?: Maybe<DeletePostserviceListPayload>
  /** Deletes a single `PostserviceList` using a unique key. */
  deletePostserviceListById?: Maybe<DeletePostserviceListPayload>
  /** Deletes a single `PostserviceRecipient` using its globally unique id. */
  deletePostserviceRecipient?: Maybe<DeletePostserviceRecipientPayload>
  /** Deletes a single `PostserviceRecipient` using a unique key. */
  deletePostserviceRecipientById?: Maybe<DeletePostserviceRecipientPayload>
  /** Deletes a single `PostserviceSentLetter` using its globally unique id. */
  deletePostserviceSentLetter?: Maybe<DeletePostserviceSentLetterPayload>
  /** Deletes a single `PostserviceSentLetter` using a unique key. */
  deletePostserviceSentLetterById?: Maybe<DeletePostserviceSentLetterPayload>
  /** Deletes a single `PostserviceSentRecipient` using its globally unique id. */
  deletePostserviceSentRecipient?: Maybe<DeletePostserviceSentRecipientPayload>
  /** Deletes a single `PostserviceSentRecipient` using a unique key. */
  deletePostserviceSentRecipientById?: Maybe<DeletePostserviceSentRecipientPayload>
  /** Deletes a single `PostserviceTemplate` using its globally unique id. */
  deletePostserviceTemplate?: Maybe<DeletePostserviceTemplatePayload>
  /** Deletes a single `PostserviceTemplate` using a unique key. */
  deletePostserviceTemplateById?: Maybe<DeletePostserviceTemplatePayload>
  /** Deletes a single `PropertyLabel` using its globally unique id. */
  deletePropertyLabel?: Maybe<DeletePropertyLabelPayload>
  /** Deletes a single `PropertyLabel` using a unique key. */
  deletePropertyLabelById?: Maybe<DeletePropertyLabelPayload>
  /** Deletes a single `PropertyList` using its globally unique id. */
  deletePropertyList?: Maybe<DeletePropertyListPayload>
  /** Deletes a single `PropertyList` using a unique key. */
  deletePropertyListById?: Maybe<DeletePropertyListPayload>
  /** Deletes a single `PropertyNote` using its globally unique id. */
  deletePropertyNote?: Maybe<DeletePropertyNotePayload>
  /** Deletes a single `PropertyNote` using a unique key. */
  deletePropertyNoteById?: Maybe<DeletePropertyNotePayload>
  /** Deletes a single `Recipient` using its globally unique id. */
  deleteRecipient?: Maybe<DeleteRecipientPayload>
  /** Deletes a single `Recipient` using a unique key. */
  deleteRecipientById?: Maybe<DeleteRecipientPayload>
  /** Deletes a single `RecipientList` using its globally unique id. */
  deleteRecipientList?: Maybe<DeleteRecipientListPayload>
  /** Deletes a single `RecipientList` using a unique key. */
  deleteRecipientListById?: Maybe<DeleteRecipientListPayload>
  /** Deletes a single `RecipientListRecipient` using its globally unique id. */
  deleteRecipientListRecipient?: Maybe<DeleteRecipientListRecipientPayload>
  /** Deletes a single `RecipientListRecipient` using a unique key. */
  deleteRecipientListRecipientById?: Maybe<DeleteRecipientListRecipientPayload>
  /** Deletes a single `RecipientListRecipient` using a unique key. */
  deleteRecipientListRecipientByRecipientListIdAndRecipientId?: Maybe<DeleteRecipientListRecipientPayload>
  /** Deletes a single `SenderAddress` using its globally unique id. */
  deleteSenderAddress?: Maybe<DeleteSenderAddressPayload>
  /** Deletes a single `SenderAddress` using a unique key. */
  deleteSenderAddressById?: Maybe<DeleteSenderAddressPayload>
  /** Deletes a single `UnitRent` using its globally unique id. */
  deleteUnitRent?: Maybe<DeleteUnitRentPayload>
  /** Deletes a single `UnitRent` using a unique key. */
  deleteUnitRentByCadastralAreaCode?: Maybe<DeleteUnitRentPayload>
  /** Deletes a single `UnitRent` using a unique key. */
  deleteUnitRentById?: Maybe<DeleteUnitRentPayload>
  /** Deletes a single `UserActivityLog` using its globally unique id. */
  deleteUserActivityLog?: Maybe<DeleteUserActivityLogPayload>
  /** Deletes a single `UserActivityLog` using a unique key. */
  deleteUserActivityLogById?: Maybe<DeleteUserActivityLogPayload>
  filmInStock?: Maybe<FilmInStockPayload>
  filmNotInStock?: Maybe<FilmNotInStockPayload>
  getCustomerBalance?: Maybe<GetCustomerBalancePayload>
  inventoryHeldByCustomer?: Maybe<InventoryHeldByCustomerPayload>
  inventoryInStock?: Maybe<InventoryInStockPayload>
  /** Updates a single `Address` using its globally unique id and a patch. */
  updateAddress?: Maybe<UpdateAddressPayload>
  /** Updates a single `Address` using a unique key and a patch. */
  updateAddressById?: Maybe<UpdateAddressPayload>
  /** Updates a single `Address` using a unique key and a patch. */
  updateAddressByKod?: Maybe<UpdateAddressPayload>
  /** Updates a single `AuctionListing` using its globally unique id and a patch. */
  updateAuctionListing?: Maybe<UpdateAuctionListingPayload>
  /** Updates a single `AuctionListing` using a unique key and a patch. */
  updateAuctionListingById?: Maybe<UpdateAuctionListingPayload>
  /** Updates a single `AuctionProperty` using its globally unique id and a patch. */
  updateAuctionProperty?: Maybe<UpdateAuctionPropertyPayload>
  /** Updates a single `AuctionProperty` using a unique key and a patch. */
  updateAuctionPropertyById?: Maybe<UpdateAuctionPropertyPayload>
  /** Updates a single `Bpej` using its globally unique id and a patch. */
  updateBpej?: Maybe<UpdateBpejPayload>
  /** Updates a single `Bpej` using a unique key and a patch. */
  updateBpejById?: Maybe<UpdateBpejPayload>
  /** Updates a single `BuybackCalculation` using its globally unique id and a patch. */
  updateBuybackCalculation?: Maybe<UpdateBuybackCalculationPayload>
  /** Updates a single `BuybackCalculation` using a unique key and a patch. */
  updateBuybackCalculationById?: Maybe<UpdateBuybackCalculationPayload>
  /** Updates a single `CeeExecution` using its globally unique id and a patch. */
  updateCeeExecution?: Maybe<UpdateCeeExecutionPayload>
  /** Updates a single `CeeExecution` using a unique key and a patch. */
  updateCeeExecutionById?: Maybe<UpdateCeeExecutionPayload>
  /** Updates a single `CeeExecutionDetail` using its globally unique id and a patch. */
  updateCeeExecutionDetail?: Maybe<UpdateCeeExecutionDetailPayload>
  /** Updates a single `CeeExecutionDetail` using a unique key and a patch. */
  updateCeeExecutionDetailById?: Maybe<UpdateCeeExecutionDetailPayload>
  /** Updates a single `CeeOffice` using its globally unique id and a patch. */
  updateCeeOffice?: Maybe<UpdateCeeOfficePayload>
  /** Updates a single `CeeOffice` using a unique key and a patch. */
  updateCeeOfficeById?: Maybe<UpdateCeeOfficePayload>
  /** Updates a single `CuzkDocumentCollection` using its globally unique id and a patch. */
  updateCuzkDocumentCollection?: Maybe<UpdateCuzkDocumentCollectionPayload>
  /** Updates a single `CuzkDocumentCollection` using a unique key and a patch. */
  updateCuzkDocumentCollectionById?: Maybe<UpdateCuzkDocumentCollectionPayload>
  /** Updates a single `CuzkEpo` using its globally unique id and a patch. */
  updateCuzkEpo?: Maybe<UpdateCuzkEpoPayload>
  /** Updates a single `CuzkEpo` using a unique key and a patch. */
  updateCuzkEpoById?: Maybe<UpdateCuzkEpoPayload>
  /** Updates a single `CuzkEpoLien` using its globally unique id and a patch. */
  updateCuzkEpoLien?: Maybe<UpdateCuzkEpoLienPayload>
  /** Updates a single `CuzkEpoLien` using a unique key and a patch. */
  updateCuzkEpoLienById?: Maybe<UpdateCuzkEpoLienPayload>
  /** Updates a single `CuzkEpoRestrictionCheck` using its globally unique id and a patch. */
  updateCuzkEpoRestrictionCheck?: Maybe<UpdateCuzkEpoRestrictionCheckPayload>
  /** Updates a single `CuzkEpoRestrictionCheck` using a unique key and a patch. */
  updateCuzkEpoRestrictionCheckById?: Maybe<UpdateCuzkEpoRestrictionCheckPayload>
  /** Updates a single `CuzkLv` using its globally unique id and a patch. */
  updateCuzkLv?: Maybe<UpdateCuzkLvPayload>
  /** Updates a single `CuzkLv` using a unique key and a patch. */
  updateCuzkLvById?: Maybe<UpdateCuzkLvPayload>
  /** Updates a single `CuzkO` using its globally unique id and a patch. */
  updateCuzkO?: Maybe<UpdateCuzkOPayload>
  /** Updates a single `CuzkO` using a unique key and a patch. */
  updateCuzkOById?: Maybe<UpdateCuzkOPayload>
  /** Updates a single `Databox` using its globally unique id and a patch. */
  updateDatabox?: Maybe<UpdateDataboxPayload>
  /** Updates a single `Databox` using a unique key and a patch. */
  updateDataboxByDataboxid?: Maybe<UpdateDataboxPayload>
  /** Updates a single `Databox` using a unique key and a patch. */
  updateDataboxById?: Maybe<UpdateDataboxPayload>
  /** Updates a single `KuArea` using its globally unique id and a patch. */
  updateKuArea?: Maybe<UpdateKuAreaPayload>
  /** Updates a single `KuArea` using a unique key and a patch. */
  updateKuAreaByAreaId?: Maybe<UpdateKuAreaPayload>
  /** Updates a single `KuWorkplace` using its globally unique id and a patch. */
  updateKuWorkplace?: Maybe<UpdateKuWorkplacePayload>
  /** Updates a single `KuWorkplace` using a unique key and a patch. */
  updateKuWorkplaceById?: Maybe<UpdateKuWorkplacePayload>
  /** Updates a single `KuWorkplace` using a unique key and a patch. */
  updateKuWorkplaceByKod?: Maybe<UpdateKuWorkplacePayload>
  /** Updates a single `Label` using its globally unique id and a patch. */
  updateLabel?: Maybe<UpdateLabelPayload>
  /** Updates a single `Label` using a unique key and a patch. */
  updateLabelById?: Maybe<UpdateLabelPayload>
  /** Updates a single `LabelConnection` using its globally unique id and a patch. */
  updateLabelConnection?: Maybe<UpdateLabelConnectionPayload>
  /** Updates a single `LabelConnection` using a unique key and a patch. */
  updateLabelConnectionById?: Maybe<UpdateLabelConnectionPayload>
  /** Updates a single `LabelMonitoringCuzkRc` using its globally unique id and a patch. */
  updateLabelMonitoringCuzkRc?: Maybe<UpdateLabelMonitoringCuzkRcPayload>
  /** Updates a single `LabelMonitoringCuzkRc` using a unique key and a patch. */
  updateLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcId?: Maybe<UpdateLabelMonitoringCuzkRcPayload>
  /** Updates a single `MarketplaceOffer` using its globally unique id and a patch. */
  updateMarketplaceOffer?: Maybe<UpdateMarketplaceOfferPayload>
  /** Updates a single `MarketplaceOfferAccess` using its globally unique id and a patch. */
  updateMarketplaceOfferAccess?: Maybe<UpdateMarketplaceOfferAccessPayload>
  /** Updates a single `MarketplaceOfferAccess` using a unique key and a patch. */
  updateMarketplaceOfferAccessById?: Maybe<UpdateMarketplaceOfferAccessPayload>
  /** Updates a single `MarketplaceOffer` using a unique key and a patch. */
  updateMarketplaceOfferById?: Maybe<UpdateMarketplaceOfferPayload>
  /** Updates a single `Monit` using its globally unique id and a patch. */
  updateMonit?: Maybe<UpdateMonitPayload>
  /** Updates a single `Monit` using a unique key and a patch. */
  updateMonitById?: Maybe<UpdateMonitPayload>
  /** Updates a single `MonitoringCee` using its globally unique id and a patch. */
  updateMonitoringCee?: Maybe<UpdateMonitoringCeePayload>
  /** Updates a single `MonitoringCee` using a unique key and a patch. */
  updateMonitoringCeeById?: Maybe<UpdateMonitoringCeePayload>
  /** Updates a single `MonitoringCuzkRc` using its globally unique id and a patch. */
  updateMonitoringCuzkRc?: Maybe<UpdateMonitoringCuzkRcPayload>
  /** Updates a single `MonitoringCuzkRc` using a unique key and a patch. */
  updateMonitoringCuzkRcById?: Maybe<UpdateMonitoringCuzkRcPayload>
  /** Updates a single `MunicipalOffice` using its globally unique id and a patch. */
  updateMunicipalOffice?: Maybe<UpdateMunicipalOfficePayload>
  /** Updates a single `MunicipalOffice` using a unique key and a patch. */
  updateMunicipalOfficeByAdresnimistokod?: Maybe<UpdateMunicipalOfficePayload>
  /** Updates a single `MunicipalOffice` using a unique key and a patch. */
  updateMunicipalOfficeById?: Maybe<UpdateMunicipalOfficePayload>
  /** Updates a single `PostserviceList` using its globally unique id and a patch. */
  updatePostserviceList?: Maybe<UpdatePostserviceListPayload>
  /** Updates a single `PostserviceList` using a unique key and a patch. */
  updatePostserviceListById?: Maybe<UpdatePostserviceListPayload>
  /** Updates a single `PostserviceRecipient` using its globally unique id and a patch. */
  updatePostserviceRecipient?: Maybe<UpdatePostserviceRecipientPayload>
  /** Updates a single `PostserviceRecipient` using a unique key and a patch. */
  updatePostserviceRecipientById?: Maybe<UpdatePostserviceRecipientPayload>
  /** Updates a single `PostserviceSentLetter` using its globally unique id and a patch. */
  updatePostserviceSentLetter?: Maybe<UpdatePostserviceSentLetterPayload>
  /** Updates a single `PostserviceSentLetter` using a unique key and a patch. */
  updatePostserviceSentLetterById?: Maybe<UpdatePostserviceSentLetterPayload>
  /** Updates a single `PostserviceSentRecipient` using its globally unique id and a patch. */
  updatePostserviceSentRecipient?: Maybe<UpdatePostserviceSentRecipientPayload>
  /** Updates a single `PostserviceSentRecipient` using a unique key and a patch. */
  updatePostserviceSentRecipientById?: Maybe<UpdatePostserviceSentRecipientPayload>
  /** Updates a single `PostserviceTemplate` using its globally unique id and a patch. */
  updatePostserviceTemplate?: Maybe<UpdatePostserviceTemplatePayload>
  /** Updates a single `PostserviceTemplate` using a unique key and a patch. */
  updatePostserviceTemplateById?: Maybe<UpdatePostserviceTemplatePayload>
  /** Updates a single `PropertyLabel` using its globally unique id and a patch. */
  updatePropertyLabel?: Maybe<UpdatePropertyLabelPayload>
  /** Updates a single `PropertyLabel` using a unique key and a patch. */
  updatePropertyLabelById?: Maybe<UpdatePropertyLabelPayload>
  /** Updates a single `PropertyList` using its globally unique id and a patch. */
  updatePropertyList?: Maybe<UpdatePropertyListPayload>
  /** Updates a single `PropertyList` using a unique key and a patch. */
  updatePropertyListById?: Maybe<UpdatePropertyListPayload>
  /** Updates a single `PropertyNote` using its globally unique id and a patch. */
  updatePropertyNote?: Maybe<UpdatePropertyNotePayload>
  /** Updates a single `PropertyNote` using a unique key and a patch. */
  updatePropertyNoteById?: Maybe<UpdatePropertyNotePayload>
  /** Updates a single `Recipient` using its globally unique id and a patch. */
  updateRecipient?: Maybe<UpdateRecipientPayload>
  /** Updates a single `Recipient` using a unique key and a patch. */
  updateRecipientById?: Maybe<UpdateRecipientPayload>
  /** Updates a single `RecipientList` using its globally unique id and a patch. */
  updateRecipientList?: Maybe<UpdateRecipientListPayload>
  /** Updates a single `RecipientList` using a unique key and a patch. */
  updateRecipientListById?: Maybe<UpdateRecipientListPayload>
  /** Updates a single `RecipientListRecipient` using its globally unique id and a patch. */
  updateRecipientListRecipient?: Maybe<UpdateRecipientListRecipientPayload>
  /** Updates a single `RecipientListRecipient` using a unique key and a patch. */
  updateRecipientListRecipientById?: Maybe<UpdateRecipientListRecipientPayload>
  /** Updates a single `RecipientListRecipient` using a unique key and a patch. */
  updateRecipientListRecipientByRecipientListIdAndRecipientId?: Maybe<UpdateRecipientListRecipientPayload>
  /** Updates a single `SenderAddress` using its globally unique id and a patch. */
  updateSenderAddress?: Maybe<UpdateSenderAddressPayload>
  /** Updates a single `SenderAddress` using a unique key and a patch. */
  updateSenderAddressById?: Maybe<UpdateSenderAddressPayload>
  /** Updates a single `UnitRent` using its globally unique id and a patch. */
  updateUnitRent?: Maybe<UpdateUnitRentPayload>
  /** Updates a single `UnitRent` using a unique key and a patch. */
  updateUnitRentByCadastralAreaCode?: Maybe<UpdateUnitRentPayload>
  /** Updates a single `UnitRent` using a unique key and a patch. */
  updateUnitRentById?: Maybe<UpdateUnitRentPayload>
  /** Updates a single `UserActivityLog` using its globally unique id and a patch. */
  updateUserActivityLog?: Maybe<UpdateUserActivityLogPayload>
  /** Updates a single `UserActivityLog` using a unique key and a patch. */
  updateUserActivityLogById?: Maybe<UpdateUserActivityLogPayload>
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAddressArgs = {
  input: CreateAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuctionListingArgs = {
  input: CreateAuctionListingInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAuctionPropertyArgs = {
  input: CreateAuctionPropertyInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBpejArgs = {
  input: CreateBpejInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateBuybackCalculationArgs = {
  input: CreateBuybackCalculationInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCeeExecutionArgs = {
  input: CreateCeeExecutionInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCeeExecutionDetailArgs = {
  input: CreateCeeExecutionDetailInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCeeOfficeArgs = {
  input: CreateCeeOfficeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCuzkDocumentCollectionArgs = {
  input: CreateCuzkDocumentCollectionInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCuzkEpoArgs = {
  input: CreateCuzkEpoInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCuzkEpoLienArgs = {
  input: CreateCuzkEpoLienInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCuzkEpoRestrictionCheckArgs = {
  input: CreateCuzkEpoRestrictionCheckInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCuzkLvArgs = {
  input: CreateCuzkLvInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCuzkOArgs = {
  input: CreateCuzkOInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateDataboxArgs = {
  input: CreateDataboxInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateKuAreaArgs = {
  input: CreateKuAreaInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateKuWorkplaceArgs = {
  input: CreateKuWorkplaceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLabelArgs = {
  input: CreateLabelInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLabelConnectionArgs = {
  input: CreateLabelConnectionInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLabelMonitoringCuzkRcArgs = {
  input: CreateLabelMonitoringCuzkRcInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMarketplaceOfferArgs = {
  input: CreateMarketplaceOfferInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMarketplaceOfferAccessArgs = {
  input: CreateMarketplaceOfferAccessInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMonitArgs = {
  input: CreateMonitInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMonitoringCeeArgs = {
  input: CreateMonitoringCeeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMonitoringCuzkRcArgs = {
  input: CreateMonitoringCuzkRcInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMunicipalOfficeArgs = {
  input: CreateMunicipalOfficeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostserviceListArgs = {
  input: CreatePostserviceListInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostserviceRecipientArgs = {
  input: CreatePostserviceRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostserviceSentLetterArgs = {
  input: CreatePostserviceSentLetterInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostserviceSentRecipientArgs = {
  input: CreatePostserviceSentRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostserviceTemplateArgs = {
  input: CreatePostserviceTemplateInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePropertyLabelArgs = {
  input: CreatePropertyLabelInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePropertyListArgs = {
  input: CreatePropertyListInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePropertyNoteArgs = {
  input: CreatePropertyNoteInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRecipientArgs = {
  input: CreateRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRecipientListArgs = {
  input: CreateRecipientListInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRecipientListRecipientArgs = {
  input: CreateRecipientListRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateSenderAddressArgs = {
  input: CreateSenderAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUnitRentArgs = {
  input: CreateUnitRentInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserActivityLogArgs = {
  input: CreateUserActivityLogInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAddressArgs = {
  input: DeleteAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAddressByIdArgs = {
  input: DeleteAddressByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAddressByKodArgs = {
  input: DeleteAddressByKodInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuctionListingArgs = {
  input: DeleteAuctionListingInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuctionListingByIdArgs = {
  input: DeleteAuctionListingByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuctionPropertyArgs = {
  input: DeleteAuctionPropertyInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAuctionPropertyByIdArgs = {
  input: DeleteAuctionPropertyByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBpejArgs = {
  input: DeleteBpejInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBpejByIdArgs = {
  input: DeleteBpejByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuybackCalculationArgs = {
  input: DeleteBuybackCalculationInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteBuybackCalculationByIdArgs = {
  input: DeleteBuybackCalculationByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCeeExecutionArgs = {
  input: DeleteCeeExecutionInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCeeExecutionByIdArgs = {
  input: DeleteCeeExecutionByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCeeExecutionDetailArgs = {
  input: DeleteCeeExecutionDetailInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCeeExecutionDetailByIdArgs = {
  input: DeleteCeeExecutionDetailByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCeeOfficeArgs = {
  input: DeleteCeeOfficeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCeeOfficeByIdArgs = {
  input: DeleteCeeOfficeByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkDocumentCollectionArgs = {
  input: DeleteCuzkDocumentCollectionInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkDocumentCollectionByIdArgs = {
  input: DeleteCuzkDocumentCollectionByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkEpoArgs = {
  input: DeleteCuzkEpoInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkEpoByIdArgs = {
  input: DeleteCuzkEpoByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkEpoLienArgs = {
  input: DeleteCuzkEpoLienInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkEpoLienByIdArgs = {
  input: DeleteCuzkEpoLienByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkEpoRestrictionCheckArgs = {
  input: DeleteCuzkEpoRestrictionCheckInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkEpoRestrictionCheckByIdArgs = {
  input: DeleteCuzkEpoRestrictionCheckByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkLvArgs = {
  input: DeleteCuzkLvInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkLvByIdArgs = {
  input: DeleteCuzkLvByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkOArgs = {
  input: DeleteCuzkOInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCuzkOByIdArgs = {
  input: DeleteCuzkOByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataboxArgs = {
  input: DeleteDataboxInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataboxByDataboxidArgs = {
  input: DeleteDataboxByDataboxidInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDataboxByIdArgs = {
  input: DeleteDataboxByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteKuAreaArgs = {
  input: DeleteKuAreaInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteKuAreaByAreaIdArgs = {
  input: DeleteKuAreaByAreaIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteKuWorkplaceArgs = {
  input: DeleteKuWorkplaceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteKuWorkplaceByIdArgs = {
  input: DeleteKuWorkplaceByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteKuWorkplaceByKodArgs = {
  input: DeleteKuWorkplaceByKodInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLabelArgs = {
  input: DeleteLabelInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLabelByIdArgs = {
  input: DeleteLabelByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLabelConnectionArgs = {
  input: DeleteLabelConnectionInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLabelConnectionByIdArgs = {
  input: DeleteLabelConnectionByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLabelMonitoringCuzkRcArgs = {
  input: DeleteLabelMonitoringCuzkRcInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcIdArgs =
  {
    input: DeleteLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcIdInput
  }

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMarketplaceOfferArgs = {
  input: DeleteMarketplaceOfferInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMarketplaceOfferAccessArgs = {
  input: DeleteMarketplaceOfferAccessInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMarketplaceOfferAccessByIdArgs = {
  input: DeleteMarketplaceOfferAccessByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMarketplaceOfferByIdArgs = {
  input: DeleteMarketplaceOfferByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitArgs = {
  input: DeleteMonitInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitByIdArgs = {
  input: DeleteMonitByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitoringCeeArgs = {
  input: DeleteMonitoringCeeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitoringCeeByIdArgs = {
  input: DeleteMonitoringCeeByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitoringCuzkRcArgs = {
  input: DeleteMonitoringCuzkRcInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMonitoringCuzkRcByIdArgs = {
  input: DeleteMonitoringCuzkRcByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMunicipalOfficeArgs = {
  input: DeleteMunicipalOfficeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMunicipalOfficeByAdresnimistokodArgs = {
  input: DeleteMunicipalOfficeByAdresnimistokodInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMunicipalOfficeByIdArgs = {
  input: DeleteMunicipalOfficeByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostserviceListArgs = {
  input: DeletePostserviceListInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostserviceListByIdArgs = {
  input: DeletePostserviceListByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostserviceRecipientArgs = {
  input: DeletePostserviceRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostserviceRecipientByIdArgs = {
  input: DeletePostserviceRecipientByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostserviceSentLetterArgs = {
  input: DeletePostserviceSentLetterInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostserviceSentLetterByIdArgs = {
  input: DeletePostserviceSentLetterByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostserviceSentRecipientArgs = {
  input: DeletePostserviceSentRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostserviceSentRecipientByIdArgs = {
  input: DeletePostserviceSentRecipientByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostserviceTemplateArgs = {
  input: DeletePostserviceTemplateInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostserviceTemplateByIdArgs = {
  input: DeletePostserviceTemplateByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePropertyLabelArgs = {
  input: DeletePropertyLabelInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePropertyLabelByIdArgs = {
  input: DeletePropertyLabelByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePropertyListArgs = {
  input: DeletePropertyListInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePropertyListByIdArgs = {
  input: DeletePropertyListByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePropertyNoteArgs = {
  input: DeletePropertyNoteInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePropertyNoteByIdArgs = {
  input: DeletePropertyNoteByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRecipientArgs = {
  input: DeleteRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRecipientByIdArgs = {
  input: DeleteRecipientByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRecipientListArgs = {
  input: DeleteRecipientListInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRecipientListByIdArgs = {
  input: DeleteRecipientListByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRecipientListRecipientArgs = {
  input: DeleteRecipientListRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRecipientListRecipientByIdArgs = {
  input: DeleteRecipientListRecipientByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRecipientListRecipientByRecipientListIdAndRecipientIdArgs =
  {
    input: DeleteRecipientListRecipientByRecipientListIdAndRecipientIdInput
  }

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSenderAddressArgs = {
  input: DeleteSenderAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSenderAddressByIdArgs = {
  input: DeleteSenderAddressByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUnitRentArgs = {
  input: DeleteUnitRentInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUnitRentByCadastralAreaCodeArgs = {
  input: DeleteUnitRentByCadastralAreaCodeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUnitRentByIdArgs = {
  input: DeleteUnitRentByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserActivityLogArgs = {
  input: DeleteUserActivityLogInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserActivityLogByIdArgs = {
  input: DeleteUserActivityLogByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationFilmInStockArgs = {
  input: FilmInStockInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationFilmNotInStockArgs = {
  input: FilmNotInStockInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationGetCustomerBalanceArgs = {
  input: GetCustomerBalanceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationInventoryHeldByCustomerArgs = {
  input: InventoryHeldByCustomerInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationInventoryInStockArgs = {
  input: InventoryInStockInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAddressArgs = {
  input: UpdateAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAddressByIdArgs = {
  input: UpdateAddressByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAddressByKodArgs = {
  input: UpdateAddressByKodInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuctionListingArgs = {
  input: UpdateAuctionListingInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuctionListingByIdArgs = {
  input: UpdateAuctionListingByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuctionPropertyArgs = {
  input: UpdateAuctionPropertyInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAuctionPropertyByIdArgs = {
  input: UpdateAuctionPropertyByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBpejArgs = {
  input: UpdateBpejInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBpejByIdArgs = {
  input: UpdateBpejByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuybackCalculationArgs = {
  input: UpdateBuybackCalculationInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateBuybackCalculationByIdArgs = {
  input: UpdateBuybackCalculationByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCeeExecutionArgs = {
  input: UpdateCeeExecutionInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCeeExecutionByIdArgs = {
  input: UpdateCeeExecutionByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCeeExecutionDetailArgs = {
  input: UpdateCeeExecutionDetailInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCeeExecutionDetailByIdArgs = {
  input: UpdateCeeExecutionDetailByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCeeOfficeArgs = {
  input: UpdateCeeOfficeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCeeOfficeByIdArgs = {
  input: UpdateCeeOfficeByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkDocumentCollectionArgs = {
  input: UpdateCuzkDocumentCollectionInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkDocumentCollectionByIdArgs = {
  input: UpdateCuzkDocumentCollectionByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkEpoArgs = {
  input: UpdateCuzkEpoInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkEpoByIdArgs = {
  input: UpdateCuzkEpoByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkEpoLienArgs = {
  input: UpdateCuzkEpoLienInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkEpoLienByIdArgs = {
  input: UpdateCuzkEpoLienByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkEpoRestrictionCheckArgs = {
  input: UpdateCuzkEpoRestrictionCheckInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkEpoRestrictionCheckByIdArgs = {
  input: UpdateCuzkEpoRestrictionCheckByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkLvArgs = {
  input: UpdateCuzkLvInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkLvByIdArgs = {
  input: UpdateCuzkLvByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkOArgs = {
  input: UpdateCuzkOInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCuzkOByIdArgs = {
  input: UpdateCuzkOByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDataboxArgs = {
  input: UpdateDataboxInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDataboxByDataboxidArgs = {
  input: UpdateDataboxByDataboxidInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateDataboxByIdArgs = {
  input: UpdateDataboxByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateKuAreaArgs = {
  input: UpdateKuAreaInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateKuAreaByAreaIdArgs = {
  input: UpdateKuAreaByAreaIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateKuWorkplaceArgs = {
  input: UpdateKuWorkplaceInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateKuWorkplaceByIdArgs = {
  input: UpdateKuWorkplaceByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateKuWorkplaceByKodArgs = {
  input: UpdateKuWorkplaceByKodInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLabelArgs = {
  input: UpdateLabelInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLabelByIdArgs = {
  input: UpdateLabelByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLabelConnectionArgs = {
  input: UpdateLabelConnectionInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLabelConnectionByIdArgs = {
  input: UpdateLabelConnectionByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLabelMonitoringCuzkRcArgs = {
  input: UpdateLabelMonitoringCuzkRcInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcIdArgs =
  {
    input: UpdateLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcIdInput
  }

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMarketplaceOfferArgs = {
  input: UpdateMarketplaceOfferInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMarketplaceOfferAccessArgs = {
  input: UpdateMarketplaceOfferAccessInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMarketplaceOfferAccessByIdArgs = {
  input: UpdateMarketplaceOfferAccessByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMarketplaceOfferByIdArgs = {
  input: UpdateMarketplaceOfferByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMonitArgs = {
  input: UpdateMonitInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMonitByIdArgs = {
  input: UpdateMonitByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMonitoringCeeArgs = {
  input: UpdateMonitoringCeeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMonitoringCeeByIdArgs = {
  input: UpdateMonitoringCeeByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMonitoringCuzkRcArgs = {
  input: UpdateMonitoringCuzkRcInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMonitoringCuzkRcByIdArgs = {
  input: UpdateMonitoringCuzkRcByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMunicipalOfficeArgs = {
  input: UpdateMunicipalOfficeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMunicipalOfficeByAdresnimistokodArgs = {
  input: UpdateMunicipalOfficeByAdresnimistokodInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMunicipalOfficeByIdArgs = {
  input: UpdateMunicipalOfficeByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostserviceListArgs = {
  input: UpdatePostserviceListInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostserviceListByIdArgs = {
  input: UpdatePostserviceListByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostserviceRecipientArgs = {
  input: UpdatePostserviceRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostserviceRecipientByIdArgs = {
  input: UpdatePostserviceRecipientByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostserviceSentLetterArgs = {
  input: UpdatePostserviceSentLetterInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostserviceSentLetterByIdArgs = {
  input: UpdatePostserviceSentLetterByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostserviceSentRecipientArgs = {
  input: UpdatePostserviceSentRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostserviceSentRecipientByIdArgs = {
  input: UpdatePostserviceSentRecipientByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostserviceTemplateArgs = {
  input: UpdatePostserviceTemplateInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostserviceTemplateByIdArgs = {
  input: UpdatePostserviceTemplateByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePropertyLabelArgs = {
  input: UpdatePropertyLabelInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePropertyLabelByIdArgs = {
  input: UpdatePropertyLabelByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePropertyListArgs = {
  input: UpdatePropertyListInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePropertyListByIdArgs = {
  input: UpdatePropertyListByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePropertyNoteArgs = {
  input: UpdatePropertyNoteInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePropertyNoteByIdArgs = {
  input: UpdatePropertyNoteByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRecipientArgs = {
  input: UpdateRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRecipientByIdArgs = {
  input: UpdateRecipientByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRecipientListArgs = {
  input: UpdateRecipientListInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRecipientListByIdArgs = {
  input: UpdateRecipientListByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRecipientListRecipientArgs = {
  input: UpdateRecipientListRecipientInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRecipientListRecipientByIdArgs = {
  input: UpdateRecipientListRecipientByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRecipientListRecipientByRecipientListIdAndRecipientIdArgs =
  {
    input: UpdateRecipientListRecipientByRecipientListIdAndRecipientIdInput
  }

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSenderAddressArgs = {
  input: UpdateSenderAddressInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateSenderAddressByIdArgs = {
  input: UpdateSenderAddressByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUnitRentArgs = {
  input: UpdateUnitRentInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUnitRentByCadastralAreaCodeArgs = {
  input: UpdateUnitRentByCadastralAreaCodeInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUnitRentByIdArgs = {
  input: UpdateUnitRentByIdInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserActivityLogArgs = {
  input: UpdateUserActivityLogInput
}

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserActivityLogByIdArgs = {
  input: UpdateUserActivityLogByIdInput
}

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>
}

export enum PostserviceLetterType {
  OrdinaryLetter = 'ORDINARY_LETTER',
  OrdinaryLetterInternational = 'ORDINARY_LETTER_INTERNATIONAL',
  Registered = 'REGISTERED',
  RegisteredInternational = 'REGISTERED_INTERNATIONAL',
}

/** A filter to be used against PostserviceLetterType fields. All fields are combined with a logical ‘and.’ */
export type PostserviceLetterTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PostserviceLetterType>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PostserviceLetterType>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PostserviceLetterType>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PostserviceLetterType>
  /** Included in the specified list. */
  in?: InputMaybe<Array<PostserviceLetterType>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<PostserviceLetterType>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PostserviceLetterType>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PostserviceLetterType>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PostserviceLetterType>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PostserviceLetterType>>
}

export type PostserviceList = Node & {
  __typename: 'PostserviceList'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  createdAt: Scalars['Datetime']
  deletedAt?: Maybe<Scalars['Datetime']>
  description?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByPostserviceListId: LabelConnectionsConnection
  listName: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  /** Reads and enables pagination through a set of `PostserviceRecipient`. */
  postserviceRecipientsByPostserviceListId: PostserviceRecipientsConnection
  /** Reads and enables pagination through a set of `PostserviceSentLetter`. */
  postserviceSentLettersByOriginalListId: PostserviceSentLettersConnection
}

export type PostserviceListLabelConnectionsByPostserviceListIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

export type PostserviceListPostserviceRecipientsByPostserviceListIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PostserviceRecipientCondition>
  filter?: InputMaybe<PostserviceRecipientFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PostserviceRecipientsOrderBy>>
}

export type PostserviceListPostserviceSentLettersByOriginalListIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PostserviceSentLetterCondition>
  filter?: InputMaybe<PostserviceSentLetterFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PostserviceSentLettersOrderBy>>
}

/**
 * A condition to be used against `PostserviceList` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PostserviceListCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `listName` field. */
  listName?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `PostserviceList` object types. All fields are combined with a logical ‘and.’ */
export type PostserviceListFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostserviceListFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `listName` field. */
  listName?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<PostserviceListFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostserviceListFilter>>
}

/** An input for mutations affecting `PostserviceList` */
export type PostserviceListInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  listName: Scalars['String']
}

/** Represents an update to a `PostserviceList`. Fields that are set will be updated. */
export type PostserviceListPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  listName?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `PostserviceList` values. */
export type PostserviceListsConnection = {
  __typename: 'PostserviceListsConnection'
  /** A list of edges which contains the `PostserviceList` and cursor to aid in pagination. */
  edges: Array<PostserviceListsEdge>
  /** A list of `PostserviceList` objects. */
  nodes: Array<Maybe<PostserviceList>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `PostserviceList` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `PostserviceList` edge in the connection. */
export type PostserviceListsEdge = {
  __typename: 'PostserviceListsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `PostserviceList` at the end of the edge. */
  node?: Maybe<PostserviceList>
}

/** Methods to use when ordering `PostserviceList`. */
export enum PostserviceListsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ListNameAsc = 'LIST_NAME_ASC',
  ListNameDesc = 'LIST_NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type PostserviceRecipient = Node & {
  __typename: 'PostserviceRecipient'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  addressId?: Maybe<Scalars['String']>
  callName?: Maybe<Scalars['String']>
  city: Scalars['String']
  companyName?: Maybe<Scalars['String']>
  country: Scalars['String']
  createdAt: Scalars['Datetime']
  firstname: Scalars['String']
  gender?: Maybe<Scalars['String']>
  houseNumber: Scalars['String']
  id: Scalars['UUID']
  lastname: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  orientationNumber?: Maybe<Scalars['String']>
  /** Reads a single `PostserviceList` that is related to this `PostserviceRecipient`. */
  postserviceListByPostserviceListId?: Maybe<PostserviceList>
  postserviceListId: Scalars['UUID']
  /** Reads and enables pagination through a set of `PostserviceSentRecipient`. */
  postserviceSentRecipientsByOriginalRecipientId: PostserviceSentRecipientsConnection
  propertyAddress?: Maybe<Scalars['String']>
  propertyAreaNumber?: Maybe<Scalars['String']>
  propertyCadastralCode?: Maybe<Scalars['String']>
  propertyCadastralName?: Maybe<Scalars['String']>
  propertyCity?: Maybe<Scalars['String']>
  propertyId?: Maybe<Scalars['UUID']>
  propertyLv?: Maybe<Scalars['String']>
  propertyName?: Maybe<Scalars['String']>
  propertyType?: Maybe<Scalars['String']>
  street: Scalars['String']
  uniquePersonKey?: Maybe<Scalars['String']>
  variable1?: Maybe<Scalars['String']>
  variable2?: Maybe<Scalars['String']>
  variable3?: Maybe<Scalars['String']>
  variable4?: Maybe<Scalars['String']>
  variable5?: Maybe<Scalars['String']>
  variable6?: Maybe<Scalars['String']>
  variable7?: Maybe<Scalars['String']>
  variable8?: Maybe<Scalars['String']>
  variable9?: Maybe<Scalars['String']>
  variable10?: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type PostserviceRecipientPostserviceSentRecipientsByOriginalRecipientIdArgs =
  {
    after?: InputMaybe<Scalars['Cursor']>
    before?: InputMaybe<Scalars['Cursor']>
    condition?: InputMaybe<PostserviceSentRecipientCondition>
    filter?: InputMaybe<PostserviceSentRecipientFilter>
    first?: InputMaybe<Scalars['Int']>
    last?: InputMaybe<Scalars['Int']>
    offset?: InputMaybe<Scalars['Int']>
    orderBy?: InputMaybe<Array<PostserviceSentRecipientsOrderBy>>
  }

/**
 * A condition to be used against `PostserviceRecipient` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PostserviceRecipientCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `addressId` field. */
  addressId?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `callName` field. */
  callName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `companyName` field. */
  companyName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `country` field. */
  country?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `firstname` field. */
  firstname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `gender` field. */
  gender?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `lastname` field. */
  lastname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `orientationNumber` field. */
  orientationNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `postserviceListId` field. */
  postserviceListId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyAddress` field. */
  propertyAddress?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyAreaNumber` field. */
  propertyAreaNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyCadastralCode` field. */
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyCadastralName` field. */
  propertyCadastralName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyCity` field. */
  propertyCity?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyId` field. */
  propertyId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyLv` field. */
  propertyLv?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyName` field. */
  propertyName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyType` field. */
  propertyType?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `street` field. */
  street?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `uniquePersonKey` field. */
  uniquePersonKey?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable1` field. */
  variable1?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable2` field. */
  variable2?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable3` field. */
  variable3?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable4` field. */
  variable4?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable5` field. */
  variable5?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable6` field. */
  variable6?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable7` field. */
  variable7?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable8` field. */
  variable8?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable9` field. */
  variable9?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable10` field. */
  variable10?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `PostserviceRecipient` object types. All fields are combined with a logical ‘and.’ */
export type PostserviceRecipientFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `addressId` field. */
  addressId?: InputMaybe<StringFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostserviceRecipientFilter>>
  /** Filter by the object’s `callName` field. */
  callName?: InputMaybe<StringFilter>
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>
  /** Filter by the object’s `companyName` field. */
  companyName?: InputMaybe<StringFilter>
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `firstname` field. */
  firstname?: InputMaybe<StringFilter>
  /** Filter by the object’s `gender` field. */
  gender?: InputMaybe<StringFilter>
  /** Filter by the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `lastname` field. */
  lastname?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<PostserviceRecipientFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostserviceRecipientFilter>>
  /** Filter by the object’s `orientationNumber` field. */
  orientationNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `postserviceListId` field. */
  postserviceListId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyAddress` field. */
  propertyAddress?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyAreaNumber` field. */
  propertyAreaNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyCadastralCode` field. */
  propertyCadastralCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyCadastralName` field. */
  propertyCadastralName?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyCity` field. */
  propertyCity?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyId` field. */
  propertyId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyLv` field. */
  propertyLv?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyName` field. */
  propertyName?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyType` field. */
  propertyType?: InputMaybe<StringFilter>
  /** Filter by the object’s `street` field. */
  street?: InputMaybe<StringFilter>
  /** Filter by the object’s `uniquePersonKey` field. */
  uniquePersonKey?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable1` field. */
  variable1?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable2` field. */
  variable2?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable3` field. */
  variable3?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable4` field. */
  variable4?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable5` field. */
  variable5?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable6` field. */
  variable6?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable7` field. */
  variable7?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable8` field. */
  variable8?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable9` field. */
  variable9?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable10` field. */
  variable10?: InputMaybe<StringFilter>
  /** Filter by the object’s `zipCode` field. */
  zipCode?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `PostserviceRecipient` */
export type PostserviceRecipientInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  addressId?: InputMaybe<Scalars['String']>
  callName?: InputMaybe<Scalars['String']>
  city: Scalars['String']
  companyName?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  createdAt?: InputMaybe<Scalars['Datetime']>
  firstname: Scalars['String']
  gender?: InputMaybe<Scalars['String']>
  houseNumber: Scalars['String']
  id?: InputMaybe<Scalars['UUID']>
  lastname: Scalars['String']
  orientationNumber?: InputMaybe<Scalars['String']>
  postserviceListId: Scalars['UUID']
  propertyAddress?: InputMaybe<Scalars['String']>
  propertyAreaNumber?: InputMaybe<Scalars['String']>
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  propertyCadastralName?: InputMaybe<Scalars['String']>
  propertyCity?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyLv?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
  street: Scalars['String']
  uniquePersonKey?: InputMaybe<Scalars['String']>
  variable1?: InputMaybe<Scalars['String']>
  variable2?: InputMaybe<Scalars['String']>
  variable3?: InputMaybe<Scalars['String']>
  variable4?: InputMaybe<Scalars['String']>
  variable5?: InputMaybe<Scalars['String']>
  variable6?: InputMaybe<Scalars['String']>
  variable7?: InputMaybe<Scalars['String']>
  variable8?: InputMaybe<Scalars['String']>
  variable9?: InputMaybe<Scalars['String']>
  variable10?: InputMaybe<Scalars['String']>
  zipCode: Scalars['String']
}

/** Represents an update to a `PostserviceRecipient`. Fields that are set will be updated. */
export type PostserviceRecipientPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  addressId?: InputMaybe<Scalars['String']>
  callName?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  companyName?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  firstname?: InputMaybe<Scalars['String']>
  gender?: InputMaybe<Scalars['String']>
  houseNumber?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  lastname?: InputMaybe<Scalars['String']>
  orientationNumber?: InputMaybe<Scalars['String']>
  postserviceListId?: InputMaybe<Scalars['UUID']>
  propertyAddress?: InputMaybe<Scalars['String']>
  propertyAreaNumber?: InputMaybe<Scalars['String']>
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  propertyCadastralName?: InputMaybe<Scalars['String']>
  propertyCity?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyLv?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
  street?: InputMaybe<Scalars['String']>
  uniquePersonKey?: InputMaybe<Scalars['String']>
  variable1?: InputMaybe<Scalars['String']>
  variable2?: InputMaybe<Scalars['String']>
  variable3?: InputMaybe<Scalars['String']>
  variable4?: InputMaybe<Scalars['String']>
  variable5?: InputMaybe<Scalars['String']>
  variable6?: InputMaybe<Scalars['String']>
  variable7?: InputMaybe<Scalars['String']>
  variable8?: InputMaybe<Scalars['String']>
  variable9?: InputMaybe<Scalars['String']>
  variable10?: InputMaybe<Scalars['String']>
  zipCode?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `PostserviceRecipient` values. */
export type PostserviceRecipientsConnection = {
  __typename: 'PostserviceRecipientsConnection'
  /** A list of edges which contains the `PostserviceRecipient` and cursor to aid in pagination. */
  edges: Array<PostserviceRecipientsEdge>
  /** A list of `PostserviceRecipient` objects. */
  nodes: Array<Maybe<PostserviceRecipient>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `PostserviceRecipient` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `PostserviceRecipient` edge in the connection. */
export type PostserviceRecipientsEdge = {
  __typename: 'PostserviceRecipientsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `PostserviceRecipient` at the end of the edge. */
  node?: Maybe<PostserviceRecipient>
}

/** Methods to use when ordering `PostserviceRecipient`. */
export enum PostserviceRecipientsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  AddressIdAsc = 'ADDRESS_ID_ASC',
  AddressIdDesc = 'ADDRESS_ID_DESC',
  CallNameAsc = 'CALL_NAME_ASC',
  CallNameDesc = 'CALL_NAME_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  CountryAsc = 'COUNTRY_ASC',
  CountryDesc = 'COUNTRY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  Natural = 'NATURAL',
  OrientationNumberAsc = 'ORIENTATION_NUMBER_ASC',
  OrientationNumberDesc = 'ORIENTATION_NUMBER_DESC',
  PostserviceListIdAsc = 'POSTSERVICE_LIST_ID_ASC',
  PostserviceListIdDesc = 'POSTSERVICE_LIST_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyAddressAsc = 'PROPERTY_ADDRESS_ASC',
  PropertyAddressDesc = 'PROPERTY_ADDRESS_DESC',
  PropertyAreaNumberAsc = 'PROPERTY_AREA_NUMBER_ASC',
  PropertyAreaNumberDesc = 'PROPERTY_AREA_NUMBER_DESC',
  PropertyCadastralCodeAsc = 'PROPERTY_CADASTRAL_CODE_ASC',
  PropertyCadastralCodeDesc = 'PROPERTY_CADASTRAL_CODE_DESC',
  PropertyCadastralNameAsc = 'PROPERTY_CADASTRAL_NAME_ASC',
  PropertyCadastralNameDesc = 'PROPERTY_CADASTRAL_NAME_DESC',
  PropertyCityAsc = 'PROPERTY_CITY_ASC',
  PropertyCityDesc = 'PROPERTY_CITY_DESC',
  PropertyIdAsc = 'PROPERTY_ID_ASC',
  PropertyIdDesc = 'PROPERTY_ID_DESC',
  PropertyLvAsc = 'PROPERTY_LV_ASC',
  PropertyLvDesc = 'PROPERTY_LV_DESC',
  PropertyNameAsc = 'PROPERTY_NAME_ASC',
  PropertyNameDesc = 'PROPERTY_NAME_DESC',
  PropertyTypeAsc = 'PROPERTY_TYPE_ASC',
  PropertyTypeDesc = 'PROPERTY_TYPE_DESC',
  StreetAsc = 'STREET_ASC',
  StreetDesc = 'STREET_DESC',
  UniquePersonKeyAsc = 'UNIQUE_PERSON_KEY_ASC',
  UniquePersonKeyDesc = 'UNIQUE_PERSON_KEY_DESC',
  Variable_1Asc = 'VARIABLE_1_ASC',
  Variable_1Desc = 'VARIABLE_1_DESC',
  Variable_2Asc = 'VARIABLE_2_ASC',
  Variable_2Desc = 'VARIABLE_2_DESC',
  Variable_3Asc = 'VARIABLE_3_ASC',
  Variable_3Desc = 'VARIABLE_3_DESC',
  Variable_4Asc = 'VARIABLE_4_ASC',
  Variable_4Desc = 'VARIABLE_4_DESC',
  Variable_5Asc = 'VARIABLE_5_ASC',
  Variable_5Desc = 'VARIABLE_5_DESC',
  Variable_6Asc = 'VARIABLE_6_ASC',
  Variable_6Desc = 'VARIABLE_6_DESC',
  Variable_7Asc = 'VARIABLE_7_ASC',
  Variable_7Desc = 'VARIABLE_7_DESC',
  Variable_8Asc = 'VARIABLE_8_ASC',
  Variable_8Desc = 'VARIABLE_8_DESC',
  Variable_9Asc = 'VARIABLE_9_ASC',
  Variable_9Desc = 'VARIABLE_9_DESC',
  Variable_10Asc = 'VARIABLE_10_ASC',
  Variable_10Desc = 'VARIABLE_10_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC',
}

export type PostserviceSentLetter = Node & {
  __typename: 'PostserviceSentLetter'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  content: Scalars['String']
  createdAt: Scalars['Datetime']
  deletedAt?: Maybe<Scalars['Datetime']>
  description?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  name?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  originalListId?: Maybe<Scalars['UUID']>
  originalTemplateId?: Maybe<Scalars['UUID']>
  /** Reads a single `PostserviceList` that is related to this `PostserviceSentLetter`. */
  postserviceListByOriginalListId?: Maybe<PostserviceList>
  /** Reads and enables pagination through a set of `PostserviceSentRecipient`. */
  postserviceSentRecipientsBySentLetterId: PostserviceSentRecipientsConnection
  /** Reads a single `PostserviceTemplate` that is related to this `PostserviceSentLetter`. */
  postserviceTemplateByOriginalTemplateId?: Maybe<PostserviceTemplate>
  postserviceType?: Maybe<PostserviceLetterType>
  /** Reads a single `SenderAddress` that is related to this `PostserviceSentLetter`. */
  senderAddressBySenderAddressId?: Maybe<SenderAddress>
  senderAddressId?: Maybe<Scalars['UUID']>
  sentAt?: Maybe<Scalars['Datetime']>
  sentByUserId?: Maybe<Scalars['UUID']>
}

export type PostserviceSentLetterPostserviceSentRecipientsBySentLetterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PostserviceSentRecipientCondition>
  filter?: InputMaybe<PostserviceSentRecipientFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PostserviceSentRecipientsOrderBy>>
}

/**
 * A condition to be used against `PostserviceSentLetter` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PostserviceSentLetterCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `originalListId` field. */
  originalListId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `originalTemplateId` field. */
  originalTemplateId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `postserviceType` field. */
  postserviceType?: InputMaybe<PostserviceLetterType>
  /** Checks for equality with the object’s `senderAddressId` field. */
  senderAddressId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `sentAt` field. */
  sentAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `sentByUserId` field. */
  sentByUserId?: InputMaybe<Scalars['UUID']>
}

/** A filter to be used against `PostserviceSentLetter` object types. All fields are combined with a logical ‘and.’ */
export type PostserviceSentLetterFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostserviceSentLetterFilter>>
  /** Filter by the object’s `content` field. */
  content?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<PostserviceSentLetterFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostserviceSentLetterFilter>>
  /** Filter by the object’s `originalListId` field. */
  originalListId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `originalTemplateId` field. */
  originalTemplateId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `postserviceType` field. */
  postserviceType?: InputMaybe<PostserviceLetterTypeFilter>
  /** Filter by the object’s `senderAddressId` field. */
  senderAddressId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `sentAt` field. */
  sentAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `sentByUserId` field. */
  sentByUserId?: InputMaybe<UuidFilter>
}

/** An input for mutations affecting `PostserviceSentLetter` */
export type PostserviceSentLetterInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  content: Scalars['String']
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  name?: InputMaybe<Scalars['String']>
  originalListId?: InputMaybe<Scalars['UUID']>
  originalTemplateId?: InputMaybe<Scalars['UUID']>
  postserviceType?: InputMaybe<PostserviceLetterType>
  senderAddressId?: InputMaybe<Scalars['UUID']>
  sentAt?: InputMaybe<Scalars['Datetime']>
  sentByUserId?: InputMaybe<Scalars['UUID']>
}

/** Represents an update to a `PostserviceSentLetter`. Fields that are set will be updated. */
export type PostserviceSentLetterPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  content?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  name?: InputMaybe<Scalars['String']>
  originalListId?: InputMaybe<Scalars['UUID']>
  originalTemplateId?: InputMaybe<Scalars['UUID']>
  postserviceType?: InputMaybe<PostserviceLetterType>
  senderAddressId?: InputMaybe<Scalars['UUID']>
  sentAt?: InputMaybe<Scalars['Datetime']>
  sentByUserId?: InputMaybe<Scalars['UUID']>
}

/** A connection to a list of `PostserviceSentLetter` values. */
export type PostserviceSentLettersConnection = {
  __typename: 'PostserviceSentLettersConnection'
  /** A list of edges which contains the `PostserviceSentLetter` and cursor to aid in pagination. */
  edges: Array<PostserviceSentLettersEdge>
  /** A list of `PostserviceSentLetter` objects. */
  nodes: Array<Maybe<PostserviceSentLetter>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `PostserviceSentLetter` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `PostserviceSentLetter` edge in the connection. */
export type PostserviceSentLettersEdge = {
  __typename: 'PostserviceSentLettersEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `PostserviceSentLetter` at the end of the edge. */
  node?: Maybe<PostserviceSentLetter>
}

/** Methods to use when ordering `PostserviceSentLetter`. */
export enum PostserviceSentLettersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OriginalListIdAsc = 'ORIGINAL_LIST_ID_ASC',
  OriginalListIdDesc = 'ORIGINAL_LIST_ID_DESC',
  OriginalTemplateIdAsc = 'ORIGINAL_TEMPLATE_ID_ASC',
  OriginalTemplateIdDesc = 'ORIGINAL_TEMPLATE_ID_DESC',
  PostserviceTypeAsc = 'POSTSERVICE_TYPE_ASC',
  PostserviceTypeDesc = 'POSTSERVICE_TYPE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SenderAddressIdAsc = 'SENDER_ADDRESS_ID_ASC',
  SenderAddressIdDesc = 'SENDER_ADDRESS_ID_DESC',
  SentAtAsc = 'SENT_AT_ASC',
  SentAtDesc = 'SENT_AT_DESC',
  SentByUserIdAsc = 'SENT_BY_USER_ID_ASC',
  SentByUserIdDesc = 'SENT_BY_USER_ID_DESC',
}

export type PostserviceSentRecipient = Node & {
  __typename: 'PostserviceSentRecipient'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  addressId?: Maybe<Scalars['String']>
  callName?: Maybe<Scalars['String']>
  city: Scalars['String']
  companyName?: Maybe<Scalars['String']>
  country: Scalars['String']
  createdAt: Scalars['Datetime']
  deletedAt?: Maybe<Scalars['Datetime']>
  firstname: Scalars['String']
  gender?: Maybe<Scalars['String']>
  houseNumber: Scalars['String']
  id: Scalars['UUID']
  lastname: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  orientationNumber?: Maybe<Scalars['String']>
  originalRecipientId?: Maybe<Scalars['UUID']>
  postserviceId?: Maybe<Scalars['String']>
  /** Reads a single `PostserviceRecipient` that is related to this `PostserviceSentRecipient`. */
  postserviceRecipientByOriginalRecipientId?: Maybe<PostserviceRecipient>
  /** Reads a single `PostserviceSentLetter` that is related to this `PostserviceSentRecipient`. */
  postserviceSentLetterBySentLetterId?: Maybe<PostserviceSentLetter>
  postserviceTrackingNumber?: Maybe<Scalars['String']>
  propertyAddress?: Maybe<Scalars['String']>
  propertyAreaNumber?: Maybe<Scalars['String']>
  propertyCadastralCode?: Maybe<Scalars['String']>
  propertyCadastralName?: Maybe<Scalars['String']>
  propertyCity?: Maybe<Scalars['String']>
  propertyId?: Maybe<Scalars['UUID']>
  propertyLv?: Maybe<Scalars['String']>
  propertyName?: Maybe<Scalars['String']>
  propertyType?: Maybe<Scalars['String']>
  sentLetterId?: Maybe<Scalars['UUID']>
  street: Scalars['String']
  uniquePersonKey?: Maybe<Scalars['String']>
  variable1?: Maybe<Scalars['String']>
  variable2?: Maybe<Scalars['String']>
  variable3?: Maybe<Scalars['String']>
  variable4?: Maybe<Scalars['String']>
  variable5?: Maybe<Scalars['String']>
  variable6?: Maybe<Scalars['String']>
  variable7?: Maybe<Scalars['String']>
  variable8?: Maybe<Scalars['String']>
  variable9?: Maybe<Scalars['String']>
  variable10?: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

/**
 * A condition to be used against `PostserviceSentRecipient` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PostserviceSentRecipientCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `addressId` field. */
  addressId?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `callName` field. */
  callName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `companyName` field. */
  companyName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `country` field. */
  country?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `firstname` field. */
  firstname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `gender` field. */
  gender?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `lastname` field. */
  lastname?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `orientationNumber` field. */
  orientationNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `originalRecipientId` field. */
  originalRecipientId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `postserviceId` field. */
  postserviceId?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `postserviceTrackingNumber` field. */
  postserviceTrackingNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyAddress` field. */
  propertyAddress?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyAreaNumber` field. */
  propertyAreaNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyCadastralCode` field. */
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyCadastralName` field. */
  propertyCadastralName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyCity` field. */
  propertyCity?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyId` field. */
  propertyId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyLv` field. */
  propertyLv?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyName` field. */
  propertyName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyType` field. */
  propertyType?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `sentLetterId` field. */
  sentLetterId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `street` field. */
  street?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `uniquePersonKey` field. */
  uniquePersonKey?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable1` field. */
  variable1?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable2` field. */
  variable2?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable3` field. */
  variable3?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable4` field. */
  variable4?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable5` field. */
  variable5?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable6` field. */
  variable6?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable7` field. */
  variable7?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable8` field. */
  variable8?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable9` field. */
  variable9?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `variable10` field. */
  variable10?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `PostserviceSentRecipient` object types. All fields are combined with a logical ‘and.’ */
export type PostserviceSentRecipientFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `addressId` field. */
  addressId?: InputMaybe<StringFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostserviceSentRecipientFilter>>
  /** Filter by the object’s `callName` field. */
  callName?: InputMaybe<StringFilter>
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>
  /** Filter by the object’s `companyName` field. */
  companyName?: InputMaybe<StringFilter>
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `firstname` field. */
  firstname?: InputMaybe<StringFilter>
  /** Filter by the object’s `gender` field. */
  gender?: InputMaybe<StringFilter>
  /** Filter by the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `lastname` field. */
  lastname?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<PostserviceSentRecipientFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostserviceSentRecipientFilter>>
  /** Filter by the object’s `orientationNumber` field. */
  orientationNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `originalRecipientId` field. */
  originalRecipientId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `postserviceId` field. */
  postserviceId?: InputMaybe<StringFilter>
  /** Filter by the object’s `postserviceTrackingNumber` field. */
  postserviceTrackingNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyAddress` field. */
  propertyAddress?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyAreaNumber` field. */
  propertyAreaNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyCadastralCode` field. */
  propertyCadastralCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyCadastralName` field. */
  propertyCadastralName?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyCity` field. */
  propertyCity?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyId` field. */
  propertyId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyLv` field. */
  propertyLv?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyName` field. */
  propertyName?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyType` field. */
  propertyType?: InputMaybe<StringFilter>
  /** Filter by the object’s `sentLetterId` field. */
  sentLetterId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `street` field. */
  street?: InputMaybe<StringFilter>
  /** Filter by the object’s `uniquePersonKey` field. */
  uniquePersonKey?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable1` field. */
  variable1?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable2` field. */
  variable2?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable3` field. */
  variable3?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable4` field. */
  variable4?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable5` field. */
  variable5?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable6` field. */
  variable6?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable7` field. */
  variable7?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable8` field. */
  variable8?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable9` field. */
  variable9?: InputMaybe<StringFilter>
  /** Filter by the object’s `variable10` field. */
  variable10?: InputMaybe<StringFilter>
  /** Filter by the object’s `zipCode` field. */
  zipCode?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `PostserviceSentRecipient` */
export type PostserviceSentRecipientInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  addressId?: InputMaybe<Scalars['String']>
  callName?: InputMaybe<Scalars['String']>
  city: Scalars['String']
  companyName?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  firstname: Scalars['String']
  gender?: InputMaybe<Scalars['String']>
  houseNumber: Scalars['String']
  id?: InputMaybe<Scalars['UUID']>
  lastname: Scalars['String']
  orientationNumber?: InputMaybe<Scalars['String']>
  originalRecipientId?: InputMaybe<Scalars['UUID']>
  postserviceId?: InputMaybe<Scalars['String']>
  postserviceTrackingNumber?: InputMaybe<Scalars['String']>
  propertyAddress?: InputMaybe<Scalars['String']>
  propertyAreaNumber?: InputMaybe<Scalars['String']>
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  propertyCadastralName?: InputMaybe<Scalars['String']>
  propertyCity?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyLv?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
  sentLetterId?: InputMaybe<Scalars['UUID']>
  street: Scalars['String']
  uniquePersonKey?: InputMaybe<Scalars['String']>
  variable1?: InputMaybe<Scalars['String']>
  variable2?: InputMaybe<Scalars['String']>
  variable3?: InputMaybe<Scalars['String']>
  variable4?: InputMaybe<Scalars['String']>
  variable5?: InputMaybe<Scalars['String']>
  variable6?: InputMaybe<Scalars['String']>
  variable7?: InputMaybe<Scalars['String']>
  variable8?: InputMaybe<Scalars['String']>
  variable9?: InputMaybe<Scalars['String']>
  variable10?: InputMaybe<Scalars['String']>
  zipCode: Scalars['String']
}

/** Represents an update to a `PostserviceSentRecipient`. Fields that are set will be updated. */
export type PostserviceSentRecipientPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  addressId?: InputMaybe<Scalars['String']>
  callName?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  companyName?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  firstname?: InputMaybe<Scalars['String']>
  gender?: InputMaybe<Scalars['String']>
  houseNumber?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  lastname?: InputMaybe<Scalars['String']>
  orientationNumber?: InputMaybe<Scalars['String']>
  originalRecipientId?: InputMaybe<Scalars['UUID']>
  postserviceId?: InputMaybe<Scalars['String']>
  postserviceTrackingNumber?: InputMaybe<Scalars['String']>
  propertyAddress?: InputMaybe<Scalars['String']>
  propertyAreaNumber?: InputMaybe<Scalars['String']>
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  propertyCadastralName?: InputMaybe<Scalars['String']>
  propertyCity?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyLv?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
  sentLetterId?: InputMaybe<Scalars['UUID']>
  street?: InputMaybe<Scalars['String']>
  uniquePersonKey?: InputMaybe<Scalars['String']>
  variable1?: InputMaybe<Scalars['String']>
  variable2?: InputMaybe<Scalars['String']>
  variable3?: InputMaybe<Scalars['String']>
  variable4?: InputMaybe<Scalars['String']>
  variable5?: InputMaybe<Scalars['String']>
  variable6?: InputMaybe<Scalars['String']>
  variable7?: InputMaybe<Scalars['String']>
  variable8?: InputMaybe<Scalars['String']>
  variable9?: InputMaybe<Scalars['String']>
  variable10?: InputMaybe<Scalars['String']>
  zipCode?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `PostserviceSentRecipient` values. */
export type PostserviceSentRecipientsConnection = {
  __typename: 'PostserviceSentRecipientsConnection'
  /** A list of edges which contains the `PostserviceSentRecipient` and cursor to aid in pagination. */
  edges: Array<PostserviceSentRecipientsEdge>
  /** A list of `PostserviceSentRecipient` objects. */
  nodes: Array<Maybe<PostserviceSentRecipient>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `PostserviceSentRecipient` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `PostserviceSentRecipient` edge in the connection. */
export type PostserviceSentRecipientsEdge = {
  __typename: 'PostserviceSentRecipientsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `PostserviceSentRecipient` at the end of the edge. */
  node?: Maybe<PostserviceSentRecipient>
}

/** Methods to use when ordering `PostserviceSentRecipient`. */
export enum PostserviceSentRecipientsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  AddressIdAsc = 'ADDRESS_ID_ASC',
  AddressIdDesc = 'ADDRESS_ID_DESC',
  CallNameAsc = 'CALL_NAME_ASC',
  CallNameDesc = 'CALL_NAME_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CompanyNameAsc = 'COMPANY_NAME_ASC',
  CompanyNameDesc = 'COMPANY_NAME_DESC',
  CountryAsc = 'COUNTRY_ASC',
  CountryDesc = 'COUNTRY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  FirstnameAsc = 'FIRSTNAME_ASC',
  FirstnameDesc = 'FIRSTNAME_DESC',
  GenderAsc = 'GENDER_ASC',
  GenderDesc = 'GENDER_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastnameAsc = 'LASTNAME_ASC',
  LastnameDesc = 'LASTNAME_DESC',
  Natural = 'NATURAL',
  OrientationNumberAsc = 'ORIENTATION_NUMBER_ASC',
  OrientationNumberDesc = 'ORIENTATION_NUMBER_DESC',
  OriginalRecipientIdAsc = 'ORIGINAL_RECIPIENT_ID_ASC',
  OriginalRecipientIdDesc = 'ORIGINAL_RECIPIENT_ID_DESC',
  PostserviceIdAsc = 'POSTSERVICE_ID_ASC',
  PostserviceIdDesc = 'POSTSERVICE_ID_DESC',
  PostserviceTrackingNumberAsc = 'POSTSERVICE_TRACKING_NUMBER_ASC',
  PostserviceTrackingNumberDesc = 'POSTSERVICE_TRACKING_NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyAddressAsc = 'PROPERTY_ADDRESS_ASC',
  PropertyAddressDesc = 'PROPERTY_ADDRESS_DESC',
  PropertyAreaNumberAsc = 'PROPERTY_AREA_NUMBER_ASC',
  PropertyAreaNumberDesc = 'PROPERTY_AREA_NUMBER_DESC',
  PropertyCadastralCodeAsc = 'PROPERTY_CADASTRAL_CODE_ASC',
  PropertyCadastralCodeDesc = 'PROPERTY_CADASTRAL_CODE_DESC',
  PropertyCadastralNameAsc = 'PROPERTY_CADASTRAL_NAME_ASC',
  PropertyCadastralNameDesc = 'PROPERTY_CADASTRAL_NAME_DESC',
  PropertyCityAsc = 'PROPERTY_CITY_ASC',
  PropertyCityDesc = 'PROPERTY_CITY_DESC',
  PropertyIdAsc = 'PROPERTY_ID_ASC',
  PropertyIdDesc = 'PROPERTY_ID_DESC',
  PropertyLvAsc = 'PROPERTY_LV_ASC',
  PropertyLvDesc = 'PROPERTY_LV_DESC',
  PropertyNameAsc = 'PROPERTY_NAME_ASC',
  PropertyNameDesc = 'PROPERTY_NAME_DESC',
  PropertyTypeAsc = 'PROPERTY_TYPE_ASC',
  PropertyTypeDesc = 'PROPERTY_TYPE_DESC',
  SentLetterIdAsc = 'SENT_LETTER_ID_ASC',
  SentLetterIdDesc = 'SENT_LETTER_ID_DESC',
  StreetAsc = 'STREET_ASC',
  StreetDesc = 'STREET_DESC',
  UniquePersonKeyAsc = 'UNIQUE_PERSON_KEY_ASC',
  UniquePersonKeyDesc = 'UNIQUE_PERSON_KEY_DESC',
  Variable_1Asc = 'VARIABLE_1_ASC',
  Variable_1Desc = 'VARIABLE_1_DESC',
  Variable_2Asc = 'VARIABLE_2_ASC',
  Variable_2Desc = 'VARIABLE_2_DESC',
  Variable_3Asc = 'VARIABLE_3_ASC',
  Variable_3Desc = 'VARIABLE_3_DESC',
  Variable_4Asc = 'VARIABLE_4_ASC',
  Variable_4Desc = 'VARIABLE_4_DESC',
  Variable_5Asc = 'VARIABLE_5_ASC',
  Variable_5Desc = 'VARIABLE_5_DESC',
  Variable_6Asc = 'VARIABLE_6_ASC',
  Variable_6Desc = 'VARIABLE_6_DESC',
  Variable_7Asc = 'VARIABLE_7_ASC',
  Variable_7Desc = 'VARIABLE_7_DESC',
  Variable_8Asc = 'VARIABLE_8_ASC',
  Variable_8Desc = 'VARIABLE_8_DESC',
  Variable_9Asc = 'VARIABLE_9_ASC',
  Variable_9Desc = 'VARIABLE_9_DESC',
  Variable_10Asc = 'VARIABLE_10_ASC',
  Variable_10Desc = 'VARIABLE_10_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC',
}

export type PostserviceTemplate = Node & {
  __typename: 'PostserviceTemplate'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  content: Scalars['String']
  createdAt: Scalars['Datetime']
  deletedAt?: Maybe<Scalars['Datetime']>
  description: Scalars['String']
  editedAt?: Maybe<Scalars['Datetime']>
  id: Scalars['UUID']
  name: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  /** Reads and enables pagination through a set of `PostserviceSentLetter`. */
  postserviceSentLettersByOriginalTemplateId: PostserviceSentLettersConnection
}

export type PostserviceTemplatePostserviceSentLettersByOriginalTemplateIdArgs =
  {
    after?: InputMaybe<Scalars['Cursor']>
    before?: InputMaybe<Scalars['Cursor']>
    condition?: InputMaybe<PostserviceSentLetterCondition>
    filter?: InputMaybe<PostserviceSentLetterFilter>
    first?: InputMaybe<Scalars['Int']>
    last?: InputMaybe<Scalars['Int']>
    offset?: InputMaybe<Scalars['Int']>
    orderBy?: InputMaybe<Array<PostserviceSentLettersOrderBy>>
  }

/**
 * A condition to be used against `PostserviceTemplate` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type PostserviceTemplateCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `content` field. */
  content?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `editedAt` field. */
  editedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `PostserviceTemplate` object types. All fields are combined with a logical ‘and.’ */
export type PostserviceTemplateFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostserviceTemplateFilter>>
  /** Filter by the object’s `content` field. */
  content?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `editedAt` field. */
  editedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<PostserviceTemplateFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostserviceTemplateFilter>>
}

/** An input for mutations affecting `PostserviceTemplate` */
export type PostserviceTemplateInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  content: Scalars['String']
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description: Scalars['String']
  editedAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  name: Scalars['String']
}

/** Represents an update to a `PostserviceTemplate`. Fields that are set will be updated. */
export type PostserviceTemplatePatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  content?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  name?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `PostserviceTemplate` values. */
export type PostserviceTemplatesConnection = {
  __typename: 'PostserviceTemplatesConnection'
  /** A list of edges which contains the `PostserviceTemplate` and cursor to aid in pagination. */
  edges: Array<PostserviceTemplatesEdge>
  /** A list of `PostserviceTemplate` objects. */
  nodes: Array<Maybe<PostserviceTemplate>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `PostserviceTemplate` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `PostserviceTemplate` edge in the connection. */
export type PostserviceTemplatesEdge = {
  __typename: 'PostserviceTemplatesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `PostserviceTemplate` at the end of the edge. */
  node?: Maybe<PostserviceTemplate>
}

/** Methods to use when ordering `PostserviceTemplate`. */
export enum PostserviceTemplatesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  ContentAsc = 'CONTENT_ASC',
  ContentDesc = 'CONTENT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  EditedAtAsc = 'EDITED_AT_ASC',
  EditedAtDesc = 'EDITED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

/** This table is created to record Label for Property that are not recorded as separate entities in this database and therefore cannot be directly linked to public.label_connection. Additionally, the table allows extra data to be recorded for Property, which simplifies data fetching for cases where it would be expensive to fetch this information by external API calls. Importantly, each property_label record must specify a property_id and property_type, which are the key identifiers needed to identify a specific Property */
export type PropertyLabel = Node & {
  __typename: 'PropertyLabel'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  createdAt: Scalars['Datetime']
  deletedAt?: Maybe<Scalars['Datetime']>
  id: Scalars['UUID']
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByPropertyLabelId: LabelConnectionsConnection
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  propertyCadastralCode: Scalars['String']
  propertyCadastralName: Scalars['String']
  propertyId: Scalars['UUID']
  propertyLv: Scalars['String']
  propertyName: Scalars['String']
  propertyType: Scalars['String']
}

/** This table is created to record Label for Property that are not recorded as separate entities in this database and therefore cannot be directly linked to public.label_connection. Additionally, the table allows extra data to be recorded for Property, which simplifies data fetching for cases where it would be expensive to fetch this information by external API calls. Importantly, each property_label record must specify a property_id and property_type, which are the key identifiers needed to identify a specific Property */
export type PropertyLabelLabelConnectionsByPropertyLabelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

/**
 * A condition to be used against `PropertyLabel` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PropertyLabelCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyCadastralCode` field. */
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyCadastralName` field. */
  propertyCadastralName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyId` field. */
  propertyId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyLv` field. */
  propertyLv?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyName` field. */
  propertyName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyType` field. */
  propertyType?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `PropertyLabel` object types. All fields are combined with a logical ‘and.’ */
export type PropertyLabelFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PropertyLabelFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Negates the expression. */
  not?: InputMaybe<PropertyLabelFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PropertyLabelFilter>>
  /** Filter by the object’s `propertyCadastralCode` field. */
  propertyCadastralCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyCadastralName` field. */
  propertyCadastralName?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyId` field. */
  propertyId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyLv` field. */
  propertyLv?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyName` field. */
  propertyName?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyType` field. */
  propertyType?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `PropertyLabel` */
export type PropertyLabelInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  propertyCadastralCode: Scalars['String']
  propertyCadastralName: Scalars['String']
  propertyId: Scalars['UUID']
  propertyLv: Scalars['String']
  propertyName: Scalars['String']
  propertyType: Scalars['String']
}

/** Represents an update to a `PropertyLabel`. Fields that are set will be updated. */
export type PropertyLabelPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  propertyCadastralName?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyLv?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `PropertyLabel` values. */
export type PropertyLabelsConnection = {
  __typename: 'PropertyLabelsConnection'
  /** A list of edges which contains the `PropertyLabel` and cursor to aid in pagination. */
  edges: Array<PropertyLabelsEdge>
  /** A list of `PropertyLabel` objects. */
  nodes: Array<Maybe<PropertyLabel>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `PropertyLabel` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `PropertyLabel` edge in the connection. */
export type PropertyLabelsEdge = {
  __typename: 'PropertyLabelsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `PropertyLabel` at the end of the edge. */
  node?: Maybe<PropertyLabel>
}

/** Methods to use when ordering `PropertyLabel`. */
export enum PropertyLabelsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyCadastralCodeAsc = 'PROPERTY_CADASTRAL_CODE_ASC',
  PropertyCadastralCodeDesc = 'PROPERTY_CADASTRAL_CODE_DESC',
  PropertyCadastralNameAsc = 'PROPERTY_CADASTRAL_NAME_ASC',
  PropertyCadastralNameDesc = 'PROPERTY_CADASTRAL_NAME_DESC',
  PropertyIdAsc = 'PROPERTY_ID_ASC',
  PropertyIdDesc = 'PROPERTY_ID_DESC',
  PropertyLvAsc = 'PROPERTY_LV_ASC',
  PropertyLvDesc = 'PROPERTY_LV_DESC',
  PropertyNameAsc = 'PROPERTY_NAME_ASC',
  PropertyNameDesc = 'PROPERTY_NAME_DESC',
  PropertyTypeAsc = 'PROPERTY_TYPE_ASC',
  PropertyTypeDesc = 'PROPERTY_TYPE_DESC',
}

export type PropertyList = Node & {
  __typename: 'PropertyList'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  count: Scalars['Int']
  createdAt?: Maybe<Scalars['Datetime']>
  deletedAt?: Maybe<Scalars['Datetime']>
  description?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  name: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  propertyType: Scalars['String']
  whereClause: Scalars['String']
}

/**
 * A condition to be used against `PropertyList` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PropertyListCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `count` field. */
  count?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyType` field. */
  propertyType?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `whereClause` field. */
  whereClause?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `PropertyList` object types. All fields are combined with a logical ‘and.’ */
export type PropertyListFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PropertyListFilter>>
  /** Filter by the object’s `count` field. */
  count?: InputMaybe<IntFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<PropertyListFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PropertyListFilter>>
  /** Filter by the object’s `propertyType` field. */
  propertyType?: InputMaybe<StringFilter>
  /** Filter by the object’s `whereClause` field. */
  whereClause?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `PropertyList` */
export type PropertyListInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  count?: InputMaybe<Scalars['Int']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  name: Scalars['String']
  propertyType: Scalars['String']
  whereClause: Scalars['String']
}

/** Represents an update to a `PropertyList`. Fields that are set will be updated. */
export type PropertyListPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  count?: InputMaybe<Scalars['Int']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  name?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
  whereClause?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `PropertyList` values. */
export type PropertyListsConnection = {
  __typename: 'PropertyListsConnection'
  /** A list of edges which contains the `PropertyList` and cursor to aid in pagination. */
  edges: Array<PropertyListsEdge>
  /** A list of `PropertyList` objects. */
  nodes: Array<Maybe<PropertyList>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `PropertyList` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `PropertyList` edge in the connection. */
export type PropertyListsEdge = {
  __typename: 'PropertyListsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `PropertyList` at the end of the edge. */
  node?: Maybe<PropertyList>
}

/** Methods to use when ordering `PropertyList`. */
export enum PropertyListsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CountAsc = 'COUNT_ASC',
  CountDesc = 'COUNT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyTypeAsc = 'PROPERTY_TYPE_ASC',
  PropertyTypeDesc = 'PROPERTY_TYPE_DESC',
  WhereClauseAsc = 'WHERE_CLAUSE_ASC',
  WhereClauseDesc = 'WHERE_CLAUSE_DESC',
}

export type PropertyNote = Node & {
  __typename: 'PropertyNote'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  colorKey?: Maybe<Scalars['String']>
  createdAt: Scalars['Datetime']
  deletedAt?: Maybe<Scalars['Datetime']>
  editedAt?: Maybe<Scalars['Datetime']>
  iconKey?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  links?: Maybe<Scalars['JSON']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  note: Scalars['String']
  propertyCadastralCode: Scalars['String']
  propertyId: Scalars['UUID']
  propertyLv: Scalars['String']
  propertyName?: Maybe<Scalars['String']>
  propertyType?: Maybe<Scalars['String']>
}

/**
 * A condition to be used against `PropertyNote` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PropertyNoteCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `colorKey` field. */
  colorKey?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `editedAt` field. */
  editedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `iconKey` field. */
  iconKey?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `links` field. */
  links?: InputMaybe<Scalars['JSON']>
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyCadastralCode` field. */
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyId` field. */
  propertyId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyLv` field. */
  propertyLv?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyName` field. */
  propertyName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyType` field. */
  propertyType?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `PropertyNote` object types. All fields are combined with a logical ‘and.’ */
export type PropertyNoteFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PropertyNoteFilter>>
  /** Filter by the object’s `colorKey` field. */
  colorKey?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `editedAt` field. */
  editedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `iconKey` field. */
  iconKey?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `links` field. */
  links?: InputMaybe<JsonFilter>
  /** Negates the expression. */
  not?: InputMaybe<PropertyNoteFilter>
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PropertyNoteFilter>>
  /** Filter by the object’s `propertyCadastralCode` field. */
  propertyCadastralCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyId` field. */
  propertyId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyLv` field. */
  propertyLv?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyName` field. */
  propertyName?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyType` field. */
  propertyType?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `PropertyNote` */
export type PropertyNoteInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  colorKey?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  iconKey?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  links?: InputMaybe<Scalars['JSON']>
  note: Scalars['String']
  propertyCadastralCode: Scalars['String']
  propertyId: Scalars['UUID']
  propertyLv: Scalars['String']
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `PropertyNote`. Fields that are set will be updated. */
export type PropertyNotePatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  colorKey?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  iconKey?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  links?: InputMaybe<Scalars['JSON']>
  note?: InputMaybe<Scalars['String']>
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyLv?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `PropertyNote` values. */
export type PropertyNotesConnection = {
  __typename: 'PropertyNotesConnection'
  /** A list of edges which contains the `PropertyNote` and cursor to aid in pagination. */
  edges: Array<PropertyNotesEdge>
  /** A list of `PropertyNote` objects. */
  nodes: Array<Maybe<PropertyNote>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `PropertyNote` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `PropertyNote` edge in the connection. */
export type PropertyNotesEdge = {
  __typename: 'PropertyNotesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `PropertyNote` at the end of the edge. */
  node?: Maybe<PropertyNote>
}

/** Methods to use when ordering `PropertyNote`. */
export enum PropertyNotesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  ColorKeyAsc = 'COLOR_KEY_ASC',
  ColorKeyDesc = 'COLOR_KEY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  EditedAtAsc = 'EDITED_AT_ASC',
  EditedAtDesc = 'EDITED_AT_DESC',
  IconKeyAsc = 'ICON_KEY_ASC',
  IconKeyDesc = 'ICON_KEY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LinksAsc = 'LINKS_ASC',
  LinksDesc = 'LINKS_DESC',
  Natural = 'NATURAL',
  NoteAsc = 'NOTE_ASC',
  NoteDesc = 'NOTE_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyCadastralCodeAsc = 'PROPERTY_CADASTRAL_CODE_ASC',
  PropertyCadastralCodeDesc = 'PROPERTY_CADASTRAL_CODE_DESC',
  PropertyIdAsc = 'PROPERTY_ID_ASC',
  PropertyIdDesc = 'PROPERTY_ID_DESC',
  PropertyLvAsc = 'PROPERTY_LV_ASC',
  PropertyLvDesc = 'PROPERTY_LV_DESC',
  PropertyNameAsc = 'PROPERTY_NAME_ASC',
  PropertyNameDesc = 'PROPERTY_NAME_DESC',
  PropertyTypeAsc = 'PROPERTY_TYPE_ASC',
  PropertyTypeDesc = 'PROPERTY_TYPE_DESC',
}

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename: 'Query'
  _groupConcat?: Maybe<Scalars['String']>
  /** Reads a single `Address` using its globally unique `ID`. */
  address?: Maybe<Address>
  addressById?: Maybe<Address>
  addressByKod?: Maybe<Address>
  /** Reads and enables pagination through a set of `Address`. */
  allAddresses?: Maybe<AddressesConnection>
  /** Reads and enables pagination through a set of `AuctionListing`. */
  allAuctionListings?: Maybe<AuctionListingsConnection>
  /** Reads and enables pagination through a set of `AuctionProperty`. */
  allAuctionProperties?: Maybe<AuctionPropertiesConnection>
  /** Reads and enables pagination through a set of `Bpej`. */
  allBpejs?: Maybe<BpejsConnection>
  /** Reads and enables pagination through a set of `BuybackCalculation`. */
  allBuybackCalculations?: Maybe<BuybackCalculationsConnection>
  /** Reads and enables pagination through a set of `CeeExecutionDetail`. */
  allCeeExecutionDetails?: Maybe<CeeExecutionDetailsConnection>
  /** Reads and enables pagination through a set of `CeeExecution`. */
  allCeeExecutions?: Maybe<CeeExecutionsConnection>
  /** Reads and enables pagination through a set of `CeeOffice`. */
  allCeeOffices?: Maybe<CeeOfficesConnection>
  /** Reads and enables pagination through a set of `CuzkDocumentCollection`. */
  allCuzkDocumentCollections?: Maybe<CuzkDocumentCollectionsConnection>
  /** Reads and enables pagination through a set of `CuzkEpoLien`. */
  allCuzkEpoLiens?: Maybe<CuzkEpoLiensConnection>
  /** Reads and enables pagination through a set of `CuzkEpoRestrictionCheck`. */
  allCuzkEpoRestrictionChecks?: Maybe<CuzkEpoRestrictionChecksConnection>
  /** Reads and enables pagination through a set of `CuzkEpo`. */
  allCuzkEpos?: Maybe<CuzkEposConnection>
  /** Reads and enables pagination through a set of `CuzkLv`. */
  allCuzkLvs?: Maybe<CuzkLvsConnection>
  /** Reads and enables pagination through a set of `CuzkO`. */
  allCuzkOs?: Maybe<CuzkOsConnection>
  /** Reads and enables pagination through a set of `Databox`. */
  allDataboxes?: Maybe<DataboxesConnection>
  /** Reads and enables pagination through a set of `KuArea`. */
  allKuAreas?: Maybe<KuAreasConnection>
  /** Reads and enables pagination through a set of `KuWorkplace`. */
  allKuWorkplaces?: Maybe<KuWorkplacesConnection>
  /** Reads and enables pagination through a set of `LabelConnection`. */
  allLabelConnections?: Maybe<LabelConnectionsConnection>
  /** Reads and enables pagination through a set of `LabelMonitoringCuzkRc`. */
  allLabelMonitoringCuzkRcs?: Maybe<LabelMonitoringCuzkRcsConnection>
  /** Reads and enables pagination through a set of `Label`. */
  allLabels?: Maybe<LabelsConnection>
  /** Reads and enables pagination through a set of `MarketplaceOfferAccess`. */
  allMarketplaceOfferAccesses?: Maybe<MarketplaceOfferAccessesConnection>
  /** Reads and enables pagination through a set of `MarketplaceOffer`. */
  allMarketplaceOffers?: Maybe<MarketplaceOffersConnection>
  /** Reads and enables pagination through a set of `MonitoringCee`. */
  allMonitoringCees?: Maybe<MonitoringCeesConnection>
  /** Reads and enables pagination through a set of `MonitoringCuzkRc`. */
  allMonitoringCuzkRcs?: Maybe<MonitoringCuzkRcsConnection>
  /** Reads and enables pagination through a set of `Monit`. */
  allMonits?: Maybe<MonitsConnection>
  /** Reads and enables pagination through a set of `MunicipalOffice`. */
  allMunicipalOffices?: Maybe<MunicipalOfficesConnection>
  /** Reads and enables pagination through a set of `PostserviceList`. */
  allPostserviceLists?: Maybe<PostserviceListsConnection>
  /** Reads and enables pagination through a set of `PostserviceRecipient`. */
  allPostserviceRecipients?: Maybe<PostserviceRecipientsConnection>
  /** Reads and enables pagination through a set of `PostserviceSentLetter`. */
  allPostserviceSentLetters?: Maybe<PostserviceSentLettersConnection>
  /** Reads and enables pagination through a set of `PostserviceSentRecipient`. */
  allPostserviceSentRecipients?: Maybe<PostserviceSentRecipientsConnection>
  /** Reads and enables pagination through a set of `PostserviceTemplate`. */
  allPostserviceTemplates?: Maybe<PostserviceTemplatesConnection>
  /** Reads and enables pagination through a set of `PropertyLabel`. */
  allPropertyLabels?: Maybe<PropertyLabelsConnection>
  /** Reads and enables pagination through a set of `PropertyList`. */
  allPropertyLists?: Maybe<PropertyListsConnection>
  /** Reads and enables pagination through a set of `PropertyNote`. */
  allPropertyNotes?: Maybe<PropertyNotesConnection>
  /** Reads and enables pagination through a set of `RecipientListRecipient`. */
  allRecipientListRecipients?: Maybe<RecipientListRecipientsConnection>
  /** Reads and enables pagination through a set of `RecipientList`. */
  allRecipientLists?: Maybe<RecipientListsConnection>
  /** Reads and enables pagination through a set of `Recipient`. */
  allRecipients?: Maybe<RecipientsConnection>
  /** Reads and enables pagination through a set of `SenderAddress`. */
  allSenderAddresses?: Maybe<SenderAddressesConnection>
  /** Reads and enables pagination through a set of `UnitRent`. */
  allUnitRents?: Maybe<UnitRentsConnection>
  /** Reads and enables pagination through a set of `UserActivityLog`. */
  allUserActivityLogs?: Maybe<UserActivityLogsConnection>
  /** Reads a single `AuctionListing` using its globally unique `ID`. */
  auctionListing?: Maybe<AuctionListing>
  auctionListingById?: Maybe<AuctionListing>
  /** Reads a single `AuctionProperty` using its globally unique `ID`. */
  auctionProperty?: Maybe<AuctionProperty>
  auctionPropertyById?: Maybe<AuctionProperty>
  /** Reads a single `Bpej` using its globally unique `ID`. */
  bpej?: Maybe<Bpej>
  bpejById?: Maybe<Bpej>
  /** Reads a single `BuybackCalculation` using its globally unique `ID`. */
  buybackCalculation?: Maybe<BuybackCalculation>
  buybackCalculationById?: Maybe<BuybackCalculation>
  /** Reads a single `CeeExecution` using its globally unique `ID`. */
  ceeExecution?: Maybe<CeeExecution>
  ceeExecutionById?: Maybe<CeeExecution>
  /** Reads a single `CeeExecutionDetail` using its globally unique `ID`. */
  ceeExecutionDetail?: Maybe<CeeExecutionDetail>
  ceeExecutionDetailById?: Maybe<CeeExecutionDetail>
  /** Reads a single `CeeOffice` using its globally unique `ID`. */
  ceeOffice?: Maybe<CeeOffice>
  ceeOfficeById?: Maybe<CeeOffice>
  /** Reads a single `CuzkDocumentCollection` using its globally unique `ID`. */
  cuzkDocumentCollection?: Maybe<CuzkDocumentCollection>
  cuzkDocumentCollectionById?: Maybe<CuzkDocumentCollection>
  /** Reads a single `CuzkEpo` using its globally unique `ID`. */
  cuzkEpo?: Maybe<CuzkEpo>
  cuzkEpoById?: Maybe<CuzkEpo>
  /** Reads a single `CuzkEpoLien` using its globally unique `ID`. */
  cuzkEpoLien?: Maybe<CuzkEpoLien>
  cuzkEpoLienById?: Maybe<CuzkEpoLien>
  /** Reads a single `CuzkEpoRestrictionCheck` using its globally unique `ID`. */
  cuzkEpoRestrictionCheck?: Maybe<CuzkEpoRestrictionCheck>
  cuzkEpoRestrictionCheckById?: Maybe<CuzkEpoRestrictionCheck>
  /** Reads a single `CuzkLv` using its globally unique `ID`. */
  cuzkLv?: Maybe<CuzkLv>
  cuzkLvById?: Maybe<CuzkLv>
  /** Reads a single `CuzkO` using its globally unique `ID`. */
  cuzkO?: Maybe<CuzkO>
  cuzkOById?: Maybe<CuzkO>
  /** Reads a single `Databox` using its globally unique `ID`. */
  databox?: Maybe<Databox>
  databoxByDataboxid?: Maybe<Databox>
  databoxById?: Maybe<Databox>
  /** Reads a single `KuArea` using its globally unique `ID`. */
  kuArea?: Maybe<KuArea>
  kuAreaByAreaId?: Maybe<KuArea>
  /** Reads a single `KuWorkplace` using its globally unique `ID`. */
  kuWorkplace?: Maybe<KuWorkplace>
  kuWorkplaceById?: Maybe<KuWorkplace>
  kuWorkplaceByKod?: Maybe<KuWorkplace>
  /** Reads a single `Label` using its globally unique `ID`. */
  label?: Maybe<Label>
  labelById?: Maybe<Label>
  /** Reads a single `LabelConnection` using its globally unique `ID`. */
  labelConnection?: Maybe<LabelConnection>
  labelConnectionById?: Maybe<LabelConnection>
  /** Reads a single `LabelMonitoringCuzkRc` using its globally unique `ID`. */
  labelMonitoringCuzkRc?: Maybe<LabelMonitoringCuzkRc>
  labelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcId?: Maybe<LabelMonitoringCuzkRc>
  lastDay?: Maybe<Scalars['Date']>
  /** Reads a single `MarketplaceOffer` using its globally unique `ID`. */
  marketplaceOffer?: Maybe<MarketplaceOffer>
  /** Reads a single `MarketplaceOfferAccess` using its globally unique `ID`. */
  marketplaceOfferAccess?: Maybe<MarketplaceOfferAccess>
  marketplaceOfferAccessById?: Maybe<MarketplaceOfferAccess>
  marketplaceOfferById?: Maybe<MarketplaceOffer>
  /** Reads a single `Monit` using its globally unique `ID`. */
  monit?: Maybe<Monit>
  monitById?: Maybe<Monit>
  /** Reads a single `MonitoringCee` using its globally unique `ID`. */
  monitoringCee?: Maybe<MonitoringCee>
  monitoringCeeById?: Maybe<MonitoringCee>
  /** Reads a single `MonitoringCuzkRc` using its globally unique `ID`. */
  monitoringCuzkRc?: Maybe<MonitoringCuzkRc>
  monitoringCuzkRcById?: Maybe<MonitoringCuzkRc>
  /** Reads a single `MunicipalOffice` using its globally unique `ID`. */
  municipalOffice?: Maybe<MunicipalOffice>
  municipalOfficeByAdresnimistokod?: Maybe<MunicipalOffice>
  municipalOfficeById?: Maybe<MunicipalOffice>
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']
  /** Reads a single `PostserviceList` using its globally unique `ID`. */
  postserviceList?: Maybe<PostserviceList>
  postserviceListById?: Maybe<PostserviceList>
  /** Reads a single `PostserviceRecipient` using its globally unique `ID`. */
  postserviceRecipient?: Maybe<PostserviceRecipient>
  postserviceRecipientById?: Maybe<PostserviceRecipient>
  /** Reads a single `PostserviceSentLetter` using its globally unique `ID`. */
  postserviceSentLetter?: Maybe<PostserviceSentLetter>
  postserviceSentLetterById?: Maybe<PostserviceSentLetter>
  /** Reads a single `PostserviceSentRecipient` using its globally unique `ID`. */
  postserviceSentRecipient?: Maybe<PostserviceSentRecipient>
  postserviceSentRecipientById?: Maybe<PostserviceSentRecipient>
  /** Reads a single `PostserviceTemplate` using its globally unique `ID`. */
  postserviceTemplate?: Maybe<PostserviceTemplate>
  postserviceTemplateById?: Maybe<PostserviceTemplate>
  /** Reads a single `PropertyLabel` using its globally unique `ID`. */
  propertyLabel?: Maybe<PropertyLabel>
  propertyLabelById?: Maybe<PropertyLabel>
  /** Reads a single `PropertyList` using its globally unique `ID`. */
  propertyList?: Maybe<PropertyList>
  propertyListById?: Maybe<PropertyList>
  /** Reads a single `PropertyNote` using its globally unique `ID`. */
  propertyNote?: Maybe<PropertyNote>
  propertyNoteById?: Maybe<PropertyNote>
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query
  /** Reads a single `Recipient` using its globally unique `ID`. */
  recipient?: Maybe<Recipient>
  recipientById?: Maybe<Recipient>
  /** Reads a single `RecipientList` using its globally unique `ID`. */
  recipientList?: Maybe<RecipientList>
  recipientListById?: Maybe<RecipientList>
  /** Reads a single `RecipientListRecipient` using its globally unique `ID`. */
  recipientListRecipient?: Maybe<RecipientListRecipient>
  recipientListRecipientById?: Maybe<RecipientListRecipient>
  recipientListRecipientByRecipientListIdAndRecipientId?: Maybe<RecipientListRecipient>
  /** Reads a single `SenderAddress` using its globally unique `ID`. */
  senderAddress?: Maybe<SenderAddress>
  senderAddressById?: Maybe<SenderAddress>
  /** Reads a single `UnitRent` using its globally unique `ID`. */
  unitRent?: Maybe<UnitRent>
  unitRentByCadastralAreaCode?: Maybe<UnitRent>
  unitRentById?: Maybe<UnitRent>
  /** Reads a single `UserActivityLog` using its globally unique `ID`. */
  userActivityLog?: Maybe<UserActivityLog>
  userActivityLogById?: Maybe<UserActivityLog>
}

/** The root query type which gives access points into the data universe. */
export type Query_GroupConcatArgs = {
  arg0?: InputMaybe<Scalars['String']>
  arg1?: InputMaybe<Scalars['String']>
}

/** The root query type which gives access points into the data universe. */
export type QueryAddressArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryAddressByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryAddressByKodArgs = {
  kod: Scalars['String']
}

/** The root query type which gives access points into the data universe. */
export type QueryAllAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<AddressCondition>
  filter?: InputMaybe<AddressFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<AddressesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllAuctionListingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<AuctionListingCondition>
  filter?: InputMaybe<AuctionListingFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<AuctionListingsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllAuctionPropertiesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<AuctionPropertyCondition>
  filter?: InputMaybe<AuctionPropertyFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<AuctionPropertiesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllBpejsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<BpejCondition>
  filter?: InputMaybe<BpejFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<BpejsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllBuybackCalculationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<BuybackCalculationCondition>
  filter?: InputMaybe<BuybackCalculationFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<BuybackCalculationsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllCeeExecutionDetailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CeeExecutionDetailCondition>
  filter?: InputMaybe<CeeExecutionDetailFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CeeExecutionDetailsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllCeeExecutionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CeeExecutionCondition>
  filter?: InputMaybe<CeeExecutionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CeeExecutionsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllCeeOfficesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CeeOfficeCondition>
  filter?: InputMaybe<CeeOfficeFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CeeOfficesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllCuzkDocumentCollectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CuzkDocumentCollectionCondition>
  filter?: InputMaybe<CuzkDocumentCollectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CuzkDocumentCollectionsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllCuzkEpoLiensArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CuzkEpoLienCondition>
  filter?: InputMaybe<CuzkEpoLienFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CuzkEpoLiensOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllCuzkEpoRestrictionChecksArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CuzkEpoRestrictionCheckCondition>
  filter?: InputMaybe<CuzkEpoRestrictionCheckFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CuzkEpoRestrictionChecksOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllCuzkEposArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CuzkEpoCondition>
  filter?: InputMaybe<CuzkEpoFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CuzkEposOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllCuzkLvsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CuzkLvCondition>
  filter?: InputMaybe<CuzkLvFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CuzkLvsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllCuzkOsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<CuzkOCondition>
  filter?: InputMaybe<CuzkOFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<CuzkOsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllDataboxesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<DataboxCondition>
  filter?: InputMaybe<DataboxFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<DataboxesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllKuAreasArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<KuAreaCondition>
  filter?: InputMaybe<KuAreaFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<KuAreasOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllKuWorkplacesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<KuWorkplaceCondition>
  filter?: InputMaybe<KuWorkplaceFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<KuWorkplacesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllLabelConnectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllLabelMonitoringCuzkRcsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelMonitoringCuzkRcCondition>
  filter?: InputMaybe<LabelMonitoringCuzkRcFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelMonitoringCuzkRcsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelCondition>
  filter?: InputMaybe<LabelFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllMarketplaceOfferAccessesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<MarketplaceOfferAccessCondition>
  filter?: InputMaybe<MarketplaceOfferAccessFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<MarketplaceOfferAccessesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllMarketplaceOffersArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<MarketplaceOfferCondition>
  filter?: InputMaybe<MarketplaceOfferFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<MarketplaceOffersOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllMonitoringCeesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<MonitoringCeeCondition>
  filter?: InputMaybe<MonitoringCeeFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<MonitoringCeesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllMonitoringCuzkRcsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<MonitoringCuzkRcCondition>
  filter?: InputMaybe<MonitoringCuzkRcFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<MonitoringCuzkRcsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllMonitsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<MonitCondition>
  filter?: InputMaybe<MonitFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<MonitsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllMunicipalOfficesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<MunicipalOfficeCondition>
  filter?: InputMaybe<MunicipalOfficeFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<MunicipalOfficesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllPostserviceListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PostserviceListCondition>
  filter?: InputMaybe<PostserviceListFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PostserviceListsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllPostserviceRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PostserviceRecipientCondition>
  filter?: InputMaybe<PostserviceRecipientFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PostserviceRecipientsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllPostserviceSentLettersArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PostserviceSentLetterCondition>
  filter?: InputMaybe<PostserviceSentLetterFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PostserviceSentLettersOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllPostserviceSentRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PostserviceSentRecipientCondition>
  filter?: InputMaybe<PostserviceSentRecipientFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PostserviceSentRecipientsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllPostserviceTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PostserviceTemplateCondition>
  filter?: InputMaybe<PostserviceTemplateFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PostserviceTemplatesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllPropertyLabelsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PropertyLabelCondition>
  filter?: InputMaybe<PropertyLabelFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PropertyLabelsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllPropertyListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PropertyListCondition>
  filter?: InputMaybe<PropertyListFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PropertyListsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllPropertyNotesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PropertyNoteCondition>
  filter?: InputMaybe<PropertyNoteFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PropertyNotesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllRecipientListRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<RecipientListRecipientCondition>
  filter?: InputMaybe<RecipientListRecipientFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<RecipientListRecipientsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllRecipientListsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<RecipientListCondition>
  filter?: InputMaybe<RecipientListFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<RecipientListsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllRecipientsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<RecipientCondition>
  filter?: InputMaybe<RecipientFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<RecipientsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllSenderAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<SenderAddressCondition>
  filter?: InputMaybe<SenderAddressFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<SenderAddressesOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllUnitRentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<UnitRentCondition>
  filter?: InputMaybe<UnitRentFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<UnitRentsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAllUserActivityLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<UserActivityLogCondition>
  filter?: InputMaybe<UserActivityLogFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<UserActivityLogsOrderBy>>
}

/** The root query type which gives access points into the data universe. */
export type QueryAuctionListingArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryAuctionListingByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryAuctionPropertyArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryAuctionPropertyByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryBpejArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryBpejByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryBuybackCalculationArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryBuybackCalculationByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCeeExecutionArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCeeExecutionByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCeeExecutionDetailArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCeeExecutionDetailByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCeeOfficeArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCeeOfficeByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkDocumentCollectionArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkDocumentCollectionByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkEpoArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkEpoByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkEpoLienArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkEpoLienByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkEpoRestrictionCheckArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkEpoRestrictionCheckByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkLvArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkLvByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkOArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryCuzkOByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryDataboxArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryDataboxByDataboxidArgs = {
  databoxid: Scalars['String']
}

/** The root query type which gives access points into the data universe. */
export type QueryDataboxByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryKuAreaArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryKuAreaByAreaIdArgs = {
  areaId: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryKuWorkplaceArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryKuWorkplaceByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryKuWorkplaceByKodArgs = {
  kod: Scalars['String']
}

/** The root query type which gives access points into the data universe. */
export type QueryLabelArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryLabelByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryLabelConnectionArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryLabelConnectionByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryLabelMonitoringCuzkRcArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcIdArgs = {
  labelId: Scalars['UUID']
  monitoringCuzkRcId: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryLastDayArgs = {
  arg0: Scalars['Datetime']
}

/** The root query type which gives access points into the data universe. */
export type QueryMarketplaceOfferArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMarketplaceOfferAccessArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMarketplaceOfferAccessByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMarketplaceOfferByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMonitArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMonitByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMonitoringCeeArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMonitoringCeeByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMonitoringCuzkRcArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMonitoringCuzkRcByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMunicipalOfficeArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryMunicipalOfficeByAdresnimistokodArgs = {
  adresnimistokod: Scalars['String']
}

/** The root query type which gives access points into the data universe. */
export type QueryMunicipalOfficeByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPostserviceListArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPostserviceListByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPostserviceRecipientArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPostserviceRecipientByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPostserviceSentLetterArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPostserviceSentLetterByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPostserviceSentRecipientArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPostserviceSentRecipientByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPostserviceTemplateArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPostserviceTemplateByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPropertyLabelArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPropertyLabelByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPropertyListArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPropertyListByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPropertyNoteArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryPropertyNoteByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryRecipientArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryRecipientByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryRecipientListArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryRecipientListByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryRecipientListRecipientArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryRecipientListRecipientByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryRecipientListRecipientByRecipientListIdAndRecipientIdArgs = {
  recipientId: Scalars['UUID']
  recipientListId: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QuerySenderAddressArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QuerySenderAddressByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryUnitRentArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryUnitRentByCadastralAreaCodeArgs = {
  cadastralAreaCode: Scalars['String']
}

/** The root query type which gives access points into the data universe. */
export type QueryUnitRentByIdArgs = {
  id: Scalars['UUID']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserActivityLogArgs = {
  nodeId: Scalars['ID']
}

/** The root query type which gives access points into the data universe. */
export type QueryUserActivityLogByIdArgs = {
  id: Scalars['UUID']
}

export type Recipient = Node & {
  __typename: 'Recipient'
  /** Reads a single `Address` that is related to this `Recipient`. */
  addressByAdresnimistokod?: Maybe<Address>
  adresnimistokod?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['Datetime']>
  fyzickaosoba?: Maybe<Scalars['Boolean']>
  id: Scalars['UUID']
  krestnijmeno?: Maybe<Scalars['String']>
  nazev?: Maybe<Scalars['String']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  osloveni?: Maybe<Scalars['String']>
  pohlavi?: Maybe<Scalars['String']>
  prijmeni?: Maybe<Scalars['String']>
  /** Reads and enables pagination through a set of `RecipientListRecipient`. */
  recipientListRecipientsByRecipientId: RecipientListRecipientsConnection
  titulpred?: Maybe<Scalars['String']>
  titulza?: Maybe<Scalars['String']>
}

export type RecipientRecipientListRecipientsByRecipientIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<RecipientListRecipientCondition>
  filter?: InputMaybe<RecipientListRecipientFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<RecipientListRecipientsOrderBy>>
}

/**
 * A condition to be used against `Recipient` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RecipientCondition = {
  /** Checks for equality with the object’s `adresnimistokod` field. */
  adresnimistokod?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `fyzickaosoba` field. */
  fyzickaosoba?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `krestnijmeno` field. */
  krestnijmeno?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `nazev` field. */
  nazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `osloveni` field. */
  osloveni?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `pohlavi` field. */
  pohlavi?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `prijmeni` field. */
  prijmeni?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `titulpred` field. */
  titulpred?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `titulza` field. */
  titulza?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `Recipient` object types. All fields are combined with a logical ‘and.’ */
export type RecipientFilter = {
  /** Filter by the object’s `adresnimistokod` field. */
  adresnimistokod?: InputMaybe<StringFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RecipientFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `fyzickaosoba` field. */
  fyzickaosoba?: InputMaybe<BooleanFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `krestnijmeno` field. */
  krestnijmeno?: InputMaybe<StringFilter>
  /** Filter by the object’s `nazev` field. */
  nazev?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<RecipientFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RecipientFilter>>
  /** Filter by the object’s `osloveni` field. */
  osloveni?: InputMaybe<StringFilter>
  /** Filter by the object’s `pohlavi` field. */
  pohlavi?: InputMaybe<StringFilter>
  /** Filter by the object’s `prijmeni` field. */
  prijmeni?: InputMaybe<StringFilter>
  /** Filter by the object’s `titulpred` field. */
  titulpred?: InputMaybe<StringFilter>
  /** Filter by the object’s `titulza` field. */
  titulza?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `Recipient` */
export type RecipientInput = {
  adresnimistokod?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  fyzickaosoba?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['UUID']>
  krestnijmeno?: InputMaybe<Scalars['String']>
  nazev?: InputMaybe<Scalars['String']>
  osloveni?: InputMaybe<Scalars['String']>
  pohlavi?: InputMaybe<Scalars['String']>
  prijmeni?: InputMaybe<Scalars['String']>
  titulpred?: InputMaybe<Scalars['String']>
  titulza?: InputMaybe<Scalars['String']>
}

export type RecipientList = Node & {
  __typename: 'RecipientList'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  createdAt: Scalars['Datetime']
  deletedAt?: Maybe<Scalars['Datetime']>
  description?: Maybe<Scalars['String']>
  dispatchDate?: Maybe<Scalars['Datetime']>
  id: Scalars['UUID']
  /** Reads and enables pagination through a set of `LabelConnection`. */
  labelConnectionsByRecipientListId: LabelConnectionsConnection
  letterText?: Maybe<Scalars['String']>
  nazev: Scalars['String']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  /** Reads and enables pagination through a set of `RecipientListRecipient`. */
  recipientListRecipientsByRecipientListId: RecipientListRecipientsConnection
  /** Reads a single `SenderAddress` that is related to this `RecipientList`. */
  senderAddressBySenderAddressId?: Maybe<SenderAddress>
  senderAddressId?: Maybe<Scalars['UUID']>
  temporaryRecipientsJson?: Maybe<Scalars['String']>
}

export type RecipientListLabelConnectionsByRecipientListIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<LabelConnectionCondition>
  filter?: InputMaybe<LabelConnectionFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

export type RecipientListRecipientListRecipientsByRecipientListIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<RecipientListRecipientCondition>
  filter?: InputMaybe<RecipientListRecipientFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<RecipientListRecipientsOrderBy>>
}

/**
 * A condition to be used against `RecipientList` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RecipientListCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `dispatchDate` field. */
  dispatchDate?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `letterText` field. */
  letterText?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `nazev` field. */
  nazev?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `senderAddressId` field. */
  senderAddressId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `temporaryRecipientsJson` field. */
  temporaryRecipientsJson?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `RecipientList` object types. All fields are combined with a logical ‘and.’ */
export type RecipientListFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RecipientListFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `deletedAt` field. */
  deletedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<StringFilter>
  /** Filter by the object’s `dispatchDate` field. */
  dispatchDate?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `letterText` field. */
  letterText?: InputMaybe<StringFilter>
  /** Filter by the object’s `nazev` field. */
  nazev?: InputMaybe<StringFilter>
  /** Negates the expression. */
  not?: InputMaybe<RecipientListFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RecipientListFilter>>
  /** Filter by the object’s `senderAddressId` field. */
  senderAddressId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `temporaryRecipientsJson` field. */
  temporaryRecipientsJson?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `RecipientList` */
export type RecipientListInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  dispatchDate?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  letterText?: InputMaybe<Scalars['String']>
  nazev: Scalars['String']
  senderAddressId?: InputMaybe<Scalars['UUID']>
  temporaryRecipientsJson?: InputMaybe<Scalars['String']>
}

/** Represents an update to a `RecipientList`. Fields that are set will be updated. */
export type RecipientListPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  deletedAt?: InputMaybe<Scalars['Datetime']>
  description?: InputMaybe<Scalars['String']>
  dispatchDate?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  letterText?: InputMaybe<Scalars['String']>
  nazev?: InputMaybe<Scalars['String']>
  senderAddressId?: InputMaybe<Scalars['UUID']>
  temporaryRecipientsJson?: InputMaybe<Scalars['String']>
}

export type RecipientListRecipient = Node & {
  __typename: 'RecipientListRecipient'
  createdAt: Scalars['Datetime']
  id: Scalars['UUID']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  postserviceId?: Maybe<Scalars['String']>
  propertyId?: Maybe<Scalars['UUID']>
  propertyName?: Maybe<Scalars['String']>
  propertyType?: Maybe<Scalars['String']>
  /** Reads a single `Recipient` that is related to this `RecipientListRecipient`. */
  recipientByRecipientId?: Maybe<Recipient>
  recipientId: Scalars['UUID']
  /** Reads a single `RecipientList` that is related to this `RecipientListRecipient`. */
  recipientListByRecipientListId?: Maybe<RecipientList>
  recipientListId: Scalars['UUID']
  updatedAt?: Maybe<Scalars['Datetime']>
}

/**
 * A condition to be used against `RecipientListRecipient` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RecipientListRecipientCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `postserviceId` field. */
  postserviceId?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyId` field. */
  propertyId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `propertyName` field. */
  propertyName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `propertyType` field. */
  propertyType?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `recipientId` field. */
  recipientId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `recipientListId` field. */
  recipientListId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** A filter to be used against `RecipientListRecipient` object types. All fields are combined with a logical ‘and.’ */
export type RecipientListRecipientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RecipientListRecipientFilter>>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Negates the expression. */
  not?: InputMaybe<RecipientListRecipientFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RecipientListRecipientFilter>>
  /** Filter by the object’s `postserviceId` field. */
  postserviceId?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyId` field. */
  propertyId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `propertyName` field. */
  propertyName?: InputMaybe<StringFilter>
  /** Filter by the object’s `propertyType` field. */
  propertyType?: InputMaybe<StringFilter>
  /** Filter by the object’s `recipientId` field. */
  recipientId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `recipientListId` field. */
  recipientListId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>
}

/** An input for mutations affecting `RecipientListRecipient` */
export type RecipientListRecipientInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  postserviceId?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
  recipientId: Scalars['UUID']
  recipientListId: Scalars['UUID']
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** Represents an update to a `RecipientListRecipient`. Fields that are set will be updated. */
export type RecipientListRecipientPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>
  id?: InputMaybe<Scalars['UUID']>
  postserviceId?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyType?: InputMaybe<Scalars['String']>
  recipientId?: InputMaybe<Scalars['UUID']>
  recipientListId?: InputMaybe<Scalars['UUID']>
  updatedAt?: InputMaybe<Scalars['Datetime']>
}

/** A connection to a list of `RecipientListRecipient` values. */
export type RecipientListRecipientsConnection = {
  __typename: 'RecipientListRecipientsConnection'
  /** A list of edges which contains the `RecipientListRecipient` and cursor to aid in pagination. */
  edges: Array<RecipientListRecipientsEdge>
  /** A list of `RecipientListRecipient` objects. */
  nodes: Array<Maybe<RecipientListRecipient>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `RecipientListRecipient` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `RecipientListRecipient` edge in the connection. */
export type RecipientListRecipientsEdge = {
  __typename: 'RecipientListRecipientsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `RecipientListRecipient` at the end of the edge. */
  node?: Maybe<RecipientListRecipient>
}

/** Methods to use when ordering `RecipientListRecipient`. */
export enum RecipientListRecipientsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PostserviceIdAsc = 'POSTSERVICE_ID_ASC',
  PostserviceIdDesc = 'POSTSERVICE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PropertyIdAsc = 'PROPERTY_ID_ASC',
  PropertyIdDesc = 'PROPERTY_ID_DESC',
  PropertyNameAsc = 'PROPERTY_NAME_ASC',
  PropertyNameDesc = 'PROPERTY_NAME_DESC',
  PropertyTypeAsc = 'PROPERTY_TYPE_ASC',
  PropertyTypeDesc = 'PROPERTY_TYPE_DESC',
  RecipientIdAsc = 'RECIPIENT_ID_ASC',
  RecipientIdDesc = 'RECIPIENT_ID_DESC',
  RecipientListIdAsc = 'RECIPIENT_LIST_ID_ASC',
  RecipientListIdDesc = 'RECIPIENT_LIST_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
}

/** A connection to a list of `RecipientList` values. */
export type RecipientListsConnection = {
  __typename: 'RecipientListsConnection'
  /** A list of edges which contains the `RecipientList` and cursor to aid in pagination. */
  edges: Array<RecipientListsEdge>
  /** A list of `RecipientList` objects. */
  nodes: Array<Maybe<RecipientList>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `RecipientList` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `RecipientList` edge in the connection. */
export type RecipientListsEdge = {
  __typename: 'RecipientListsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `RecipientList` at the end of the edge. */
  node?: Maybe<RecipientList>
}

/** Methods to use when ordering `RecipientList`. */
export enum RecipientListsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DeletedAtAsc = 'DELETED_AT_ASC',
  DeletedAtDesc = 'DELETED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DispatchDateAsc = 'DISPATCH_DATE_ASC',
  DispatchDateDesc = 'DISPATCH_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LetterTextAsc = 'LETTER_TEXT_ASC',
  LetterTextDesc = 'LETTER_TEXT_DESC',
  Natural = 'NATURAL',
  NazevAsc = 'NAZEV_ASC',
  NazevDesc = 'NAZEV_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SenderAddressIdAsc = 'SENDER_ADDRESS_ID_ASC',
  SenderAddressIdDesc = 'SENDER_ADDRESS_ID_DESC',
  TemporaryRecipientsJsonAsc = 'TEMPORARY_RECIPIENTS_JSON_ASC',
  TemporaryRecipientsJsonDesc = 'TEMPORARY_RECIPIENTS_JSON_DESC',
}

/** Represents an update to a `Recipient`. Fields that are set will be updated. */
export type RecipientPatch = {
  adresnimistokod?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  fyzickaosoba?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['UUID']>
  krestnijmeno?: InputMaybe<Scalars['String']>
  nazev?: InputMaybe<Scalars['String']>
  osloveni?: InputMaybe<Scalars['String']>
  pohlavi?: InputMaybe<Scalars['String']>
  prijmeni?: InputMaybe<Scalars['String']>
  titulpred?: InputMaybe<Scalars['String']>
  titulza?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `Recipient` values. */
export type RecipientsConnection = {
  __typename: 'RecipientsConnection'
  /** A list of edges which contains the `Recipient` and cursor to aid in pagination. */
  edges: Array<RecipientsEdge>
  /** A list of `Recipient` objects. */
  nodes: Array<Maybe<Recipient>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `Recipient` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `Recipient` edge in the connection. */
export type RecipientsEdge = {
  __typename: 'RecipientsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `Recipient` at the end of the edge. */
  node?: Maybe<Recipient>
}

/** Methods to use when ordering `Recipient`. */
export enum RecipientsOrderBy {
  AdresnimistokodAsc = 'ADRESNIMISTOKOD_ASC',
  AdresnimistokodDesc = 'ADRESNIMISTOKOD_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FyzickaosobaAsc = 'FYZICKAOSOBA_ASC',
  FyzickaosobaDesc = 'FYZICKAOSOBA_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KrestnijmenoAsc = 'KRESTNIJMENO_ASC',
  KrestnijmenoDesc = 'KRESTNIJMENO_DESC',
  Natural = 'NATURAL',
  NazevAsc = 'NAZEV_ASC',
  NazevDesc = 'NAZEV_DESC',
  OsloveniAsc = 'OSLOVENI_ASC',
  OsloveniDesc = 'OSLOVENI_DESC',
  PohlaviAsc = 'POHLAVI_ASC',
  PohlaviDesc = 'POHLAVI_DESC',
  PrijmeniAsc = 'PRIJMENI_ASC',
  PrijmeniDesc = 'PRIJMENI_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TitulpredAsc = 'TITULPRED_ASC',
  TitulpredDesc = 'TITULPRED_DESC',
  TitulzaAsc = 'TITULZA_ASC',
  TitulzaDesc = 'TITULZA_DESC',
}

export enum RestrictionCheckState {
  Checked = 'CHECKED',
  Created = 'CREATED',
  Error = 'ERROR',
  Processing = 'PROCESSING',
}

/** A filter to be used against RestrictionCheckState fields. All fields are combined with a logical ‘and.’ */
export type RestrictionCheckStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RestrictionCheckState>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RestrictionCheckState>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RestrictionCheckState>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RestrictionCheckState>
  /** Included in the specified list. */
  in?: InputMaybe<Array<RestrictionCheckState>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<RestrictionCheckState>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RestrictionCheckState>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RestrictionCheckState>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RestrictionCheckState>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RestrictionCheckState>>
}

export type SenderAddress = Node & {
  __typename: 'SenderAddress'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  city: Scalars['String']
  createdAt?: Maybe<Scalars['Datetime']>
  houseNumber?: Maybe<Scalars['String']>
  id: Scalars['UUID']
  isTemplate?: Maybe<Scalars['Boolean']>
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  orientationNumber?: Maybe<Scalars['String']>
  /** Reads and enables pagination through a set of `PostserviceSentLetter`. */
  postserviceSentLettersBySenderAddressId: PostserviceSentLettersConnection
  /** Reads and enables pagination through a set of `RecipientList`. */
  recipientListsBySenderAddressId: RecipientListsConnection
  senderName: Scalars['String']
  street: Scalars['String']
  templateName?: Maybe<Scalars['String']>
  zipCode: Scalars['String']
}

export type SenderAddressPostserviceSentLettersBySenderAddressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<PostserviceSentLetterCondition>
  filter?: InputMaybe<PostserviceSentLetterFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<PostserviceSentLettersOrderBy>>
}

export type SenderAddressRecipientListsBySenderAddressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>
  before?: InputMaybe<Scalars['Cursor']>
  condition?: InputMaybe<RecipientListCondition>
  filter?: InputMaybe<RecipientListFilter>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  orderBy?: InputMaybe<Array<RecipientListsOrderBy>>
}

/**
 * A condition to be used against `SenderAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SenderAddressCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `isTemplate` field. */
  isTemplate?: InputMaybe<Scalars['Boolean']>
  /** Checks for equality with the object’s `orientationNumber` field. */
  orientationNumber?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `senderName` field. */
  senderName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `street` field. */
  street?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `templateName` field. */
  templateName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `zipCode` field. */
  zipCode?: InputMaybe<Scalars['String']>
}

/** A filter to be used against `SenderAddress` object types. All fields are combined with a logical ‘and.’ */
export type SenderAddressFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SenderAddressFilter>>
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<StringFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `houseNumber` field. */
  houseNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Filter by the object’s `isTemplate` field. */
  isTemplate?: InputMaybe<BooleanFilter>
  /** Negates the expression. */
  not?: InputMaybe<SenderAddressFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SenderAddressFilter>>
  /** Filter by the object’s `orientationNumber` field. */
  orientationNumber?: InputMaybe<StringFilter>
  /** Filter by the object’s `senderName` field. */
  senderName?: InputMaybe<StringFilter>
  /** Filter by the object’s `street` field. */
  street?: InputMaybe<StringFilter>
  /** Filter by the object’s `templateName` field. */
  templateName?: InputMaybe<StringFilter>
  /** Filter by the object’s `zipCode` field. */
  zipCode?: InputMaybe<StringFilter>
}

/** An input for mutations affecting `SenderAddress` */
export type SenderAddressInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  city: Scalars['String']
  createdAt?: InputMaybe<Scalars['Datetime']>
  houseNumber?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  isTemplate?: InputMaybe<Scalars['Boolean']>
  orientationNumber?: InputMaybe<Scalars['String']>
  senderName: Scalars['String']
  street: Scalars['String']
  templateName?: InputMaybe<Scalars['String']>
  zipCode: Scalars['String']
}

/** Represents an update to a `SenderAddress`. Fields that are set will be updated. */
export type SenderAddressPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  city?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  houseNumber?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  isTemplate?: InputMaybe<Scalars['Boolean']>
  orientationNumber?: InputMaybe<Scalars['String']>
  senderName?: InputMaybe<Scalars['String']>
  street?: InputMaybe<Scalars['String']>
  templateName?: InputMaybe<Scalars['String']>
  zipCode?: InputMaybe<Scalars['String']>
}

/** A connection to a list of `SenderAddress` values. */
export type SenderAddressesConnection = {
  __typename: 'SenderAddressesConnection'
  /** A list of edges which contains the `SenderAddress` and cursor to aid in pagination. */
  edges: Array<SenderAddressesEdge>
  /** A list of `SenderAddress` objects. */
  nodes: Array<Maybe<SenderAddress>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `SenderAddress` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `SenderAddress` edge in the connection. */
export type SenderAddressesEdge = {
  __typename: 'SenderAddressesEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `SenderAddress` at the end of the edge. */
  node?: Maybe<SenderAddress>
}

/** Methods to use when ordering `SenderAddress`. */
export enum SenderAddressesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  HouseNumberAsc = 'HOUSE_NUMBER_ASC',
  HouseNumberDesc = 'HOUSE_NUMBER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsTemplateAsc = 'IS_TEMPLATE_ASC',
  IsTemplateDesc = 'IS_TEMPLATE_DESC',
  Natural = 'NATURAL',
  OrientationNumberAsc = 'ORIENTATION_NUMBER_ASC',
  OrientationNumberDesc = 'ORIENTATION_NUMBER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SenderNameAsc = 'SENDER_NAME_ASC',
  SenderNameDesc = 'SENDER_NAME_DESC',
  StreetAsc = 'STREET_ASC',
  StreetDesc = 'STREET_DESC',
  TemplateNameAsc = 'TEMPLATE_NAME_ASC',
  TemplateNameDesc = 'TEMPLATE_NAME_DESC',
  ZipCodeAsc = 'ZIP_CODE_ASC',
  ZipCodeDesc = 'ZIP_CODE_DESC',
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']>
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']>
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']>
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']>
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']>
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']>>
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']>>
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']>
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']>
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']>
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']>
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']>
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']>
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']>>
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']>
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']>
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']>
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']>
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']>
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']>
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']>
}

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']>
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']>
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']>
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']>
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']>
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']>
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
}

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']>
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']>>
}

/**
 * Data source: MFČR - CMNB
 * MAPPING CSV → DATABASE COLUMNS:
 * Kraj → region_code -- !! has to be transformed to 2-digit code before import !!
 * Katastrální území → cadastral_area_name
 * Obec → city_name
 * Kód obce → cadastral_area_code
 * VK → (vk1_, vk2_, vk3_, vk4_) -- number of rooms prefix
 * Nájemné referenčního bytu za m² v Kč za 1 měsíc → vk1_reference
 * Dolní interval nájemného u referenčního bytu za m² v Kč za 1 měsíc → vk1_lower_interval
 * Horní interval nájemného u referenčního bytu za m² v Kč za 1 měsíc → vk1_upper_interval
 * Nájemné referenčního bytu novostavby za m² v Kč za 1 měsíc → vk1_new_building
 * Minimální hodnota nájemného za m² v Kč → vk1_minimum
 * Maximální hodnota nájemného za m² v Kč → vk1_maximum
 * Mediánová hodnota nájemného za m² v Kč → vk1_median
 * Datová pokrytost → vk1_data_coverage
 */
export type UnitRent = Node & {
  __typename: 'UnitRent'
  cadastralAreaCode: Scalars['String']
  cadastralAreaName?: Maybe<Scalars['String']>
  cityName: Scalars['String']
  id: Scalars['UUID']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
  regionCode: Scalars['String']
  vk1DataCoverage?: Maybe<Scalars['Int']>
  vk1LowerInterval?: Maybe<Scalars['Int']>
  vk1Maximum?: Maybe<Scalars['Int']>
  vk1Median?: Maybe<Scalars['Int']>
  vk1Minimum?: Maybe<Scalars['Int']>
  vk1NewBuilding?: Maybe<Scalars['Int']>
  vk1Reference?: Maybe<Scalars['Int']>
  vk1UpperInterval?: Maybe<Scalars['Int']>
  vk2DataCoverage?: Maybe<Scalars['Int']>
  vk2LowerInterval?: Maybe<Scalars['Int']>
  vk2Maximum?: Maybe<Scalars['Int']>
  vk2Median?: Maybe<Scalars['Int']>
  vk2Minimum?: Maybe<Scalars['Int']>
  vk2NewBuilding?: Maybe<Scalars['Int']>
  vk2Reference?: Maybe<Scalars['Int']>
  vk2UpperInterval?: Maybe<Scalars['Int']>
  vk3DataCoverage?: Maybe<Scalars['Int']>
  vk3LowerInterval?: Maybe<Scalars['Int']>
  vk3Maximum?: Maybe<Scalars['Int']>
  vk3Median?: Maybe<Scalars['Int']>
  vk3Minimum?: Maybe<Scalars['Int']>
  vk3NewBuilding?: Maybe<Scalars['Int']>
  vk3Reference?: Maybe<Scalars['Int']>
  vk3UpperInterval?: Maybe<Scalars['Int']>
  vk4DataCoverage?: Maybe<Scalars['Int']>
  vk4LowerInterval?: Maybe<Scalars['Int']>
  vk4Maximum?: Maybe<Scalars['Int']>
  vk4Median?: Maybe<Scalars['Int']>
  vk4Minimum?: Maybe<Scalars['Int']>
  vk4NewBuilding?: Maybe<Scalars['Int']>
  vk4Reference?: Maybe<Scalars['Int']>
  vk4UpperInterval?: Maybe<Scalars['Int']>
}

/**
 * A condition to be used against `UnitRent` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UnitRentCondition = {
  /** Checks for equality with the object’s `cadastralAreaCode` field. */
  cadastralAreaCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `cadastralAreaName` field. */
  cadastralAreaName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `cityName` field. */
  cityName?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `regionCode` field. */
  regionCode?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `vk1DataCoverage` field. */
  vk1DataCoverage?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk1LowerInterval` field. */
  vk1LowerInterval?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk1Maximum` field. */
  vk1Maximum?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk1Median` field. */
  vk1Median?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk1Minimum` field. */
  vk1Minimum?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk1NewBuilding` field. */
  vk1NewBuilding?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk1Reference` field. */
  vk1Reference?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk1UpperInterval` field. */
  vk1UpperInterval?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk2DataCoverage` field. */
  vk2DataCoverage?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk2LowerInterval` field. */
  vk2LowerInterval?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk2Maximum` field. */
  vk2Maximum?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk2Median` field. */
  vk2Median?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk2Minimum` field. */
  vk2Minimum?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk2NewBuilding` field. */
  vk2NewBuilding?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk2Reference` field. */
  vk2Reference?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk2UpperInterval` field. */
  vk2UpperInterval?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk3DataCoverage` field. */
  vk3DataCoverage?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk3LowerInterval` field. */
  vk3LowerInterval?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk3Maximum` field. */
  vk3Maximum?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk3Median` field. */
  vk3Median?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk3Minimum` field. */
  vk3Minimum?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk3NewBuilding` field. */
  vk3NewBuilding?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk3Reference` field. */
  vk3Reference?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk3UpperInterval` field. */
  vk3UpperInterval?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk4DataCoverage` field. */
  vk4DataCoverage?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk4LowerInterval` field. */
  vk4LowerInterval?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk4Maximum` field. */
  vk4Maximum?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk4Median` field. */
  vk4Median?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk4Minimum` field. */
  vk4Minimum?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk4NewBuilding` field. */
  vk4NewBuilding?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk4Reference` field. */
  vk4Reference?: InputMaybe<Scalars['Int']>
  /** Checks for equality with the object’s `vk4UpperInterval` field. */
  vk4UpperInterval?: InputMaybe<Scalars['Int']>
}

/** A filter to be used against `UnitRent` object types. All fields are combined with a logical ‘and.’ */
export type UnitRentFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UnitRentFilter>>
  /** Filter by the object’s `cadastralAreaCode` field. */
  cadastralAreaCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `cadastralAreaName` field. */
  cadastralAreaName?: InputMaybe<StringFilter>
  /** Filter by the object’s `cityName` field. */
  cityName?: InputMaybe<StringFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Negates the expression. */
  not?: InputMaybe<UnitRentFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UnitRentFilter>>
  /** Filter by the object’s `regionCode` field. */
  regionCode?: InputMaybe<StringFilter>
  /** Filter by the object’s `vk1DataCoverage` field. */
  vk1DataCoverage?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk1LowerInterval` field. */
  vk1LowerInterval?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk1Maximum` field. */
  vk1Maximum?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk1Median` field. */
  vk1Median?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk1Minimum` field. */
  vk1Minimum?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk1NewBuilding` field. */
  vk1NewBuilding?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk1Reference` field. */
  vk1Reference?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk1UpperInterval` field. */
  vk1UpperInterval?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk2DataCoverage` field. */
  vk2DataCoverage?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk2LowerInterval` field. */
  vk2LowerInterval?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk2Maximum` field. */
  vk2Maximum?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk2Median` field. */
  vk2Median?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk2Minimum` field. */
  vk2Minimum?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk2NewBuilding` field. */
  vk2NewBuilding?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk2Reference` field. */
  vk2Reference?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk2UpperInterval` field. */
  vk2UpperInterval?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk3DataCoverage` field. */
  vk3DataCoverage?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk3LowerInterval` field. */
  vk3LowerInterval?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk3Maximum` field. */
  vk3Maximum?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk3Median` field. */
  vk3Median?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk3Minimum` field. */
  vk3Minimum?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk3NewBuilding` field. */
  vk3NewBuilding?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk3Reference` field. */
  vk3Reference?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk3UpperInterval` field. */
  vk3UpperInterval?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk4DataCoverage` field. */
  vk4DataCoverage?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk4LowerInterval` field. */
  vk4LowerInterval?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk4Maximum` field. */
  vk4Maximum?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk4Median` field. */
  vk4Median?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk4Minimum` field. */
  vk4Minimum?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk4NewBuilding` field. */
  vk4NewBuilding?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk4Reference` field. */
  vk4Reference?: InputMaybe<IntFilter>
  /** Filter by the object’s `vk4UpperInterval` field. */
  vk4UpperInterval?: InputMaybe<IntFilter>
}

/** An input for mutations affecting `UnitRent` */
export type UnitRentInput = {
  cadastralAreaCode: Scalars['String']
  cadastralAreaName?: InputMaybe<Scalars['String']>
  cityName: Scalars['String']
  id?: InputMaybe<Scalars['UUID']>
  regionCode: Scalars['String']
  vk1DataCoverage?: InputMaybe<Scalars['Int']>
  vk1LowerInterval?: InputMaybe<Scalars['Int']>
  vk1Maximum?: InputMaybe<Scalars['Int']>
  vk1Median?: InputMaybe<Scalars['Int']>
  vk1Minimum?: InputMaybe<Scalars['Int']>
  vk1NewBuilding?: InputMaybe<Scalars['Int']>
  vk1Reference?: InputMaybe<Scalars['Int']>
  vk1UpperInterval?: InputMaybe<Scalars['Int']>
  vk2DataCoverage?: InputMaybe<Scalars['Int']>
  vk2LowerInterval?: InputMaybe<Scalars['Int']>
  vk2Maximum?: InputMaybe<Scalars['Int']>
  vk2Median?: InputMaybe<Scalars['Int']>
  vk2Minimum?: InputMaybe<Scalars['Int']>
  vk2NewBuilding?: InputMaybe<Scalars['Int']>
  vk2Reference?: InputMaybe<Scalars['Int']>
  vk2UpperInterval?: InputMaybe<Scalars['Int']>
  vk3DataCoverage?: InputMaybe<Scalars['Int']>
  vk3LowerInterval?: InputMaybe<Scalars['Int']>
  vk3Maximum?: InputMaybe<Scalars['Int']>
  vk3Median?: InputMaybe<Scalars['Int']>
  vk3Minimum?: InputMaybe<Scalars['Int']>
  vk3NewBuilding?: InputMaybe<Scalars['Int']>
  vk3Reference?: InputMaybe<Scalars['Int']>
  vk3UpperInterval?: InputMaybe<Scalars['Int']>
  vk4DataCoverage?: InputMaybe<Scalars['Int']>
  vk4LowerInterval?: InputMaybe<Scalars['Int']>
  vk4Maximum?: InputMaybe<Scalars['Int']>
  vk4Median?: InputMaybe<Scalars['Int']>
  vk4Minimum?: InputMaybe<Scalars['Int']>
  vk4NewBuilding?: InputMaybe<Scalars['Int']>
  vk4Reference?: InputMaybe<Scalars['Int']>
  vk4UpperInterval?: InputMaybe<Scalars['Int']>
}

/** Represents an update to a `UnitRent`. Fields that are set will be updated. */
export type UnitRentPatch = {
  cadastralAreaCode?: InputMaybe<Scalars['String']>
  cadastralAreaName?: InputMaybe<Scalars['String']>
  cityName?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['UUID']>
  regionCode?: InputMaybe<Scalars['String']>
  vk1DataCoverage?: InputMaybe<Scalars['Int']>
  vk1LowerInterval?: InputMaybe<Scalars['Int']>
  vk1Maximum?: InputMaybe<Scalars['Int']>
  vk1Median?: InputMaybe<Scalars['Int']>
  vk1Minimum?: InputMaybe<Scalars['Int']>
  vk1NewBuilding?: InputMaybe<Scalars['Int']>
  vk1Reference?: InputMaybe<Scalars['Int']>
  vk1UpperInterval?: InputMaybe<Scalars['Int']>
  vk2DataCoverage?: InputMaybe<Scalars['Int']>
  vk2LowerInterval?: InputMaybe<Scalars['Int']>
  vk2Maximum?: InputMaybe<Scalars['Int']>
  vk2Median?: InputMaybe<Scalars['Int']>
  vk2Minimum?: InputMaybe<Scalars['Int']>
  vk2NewBuilding?: InputMaybe<Scalars['Int']>
  vk2Reference?: InputMaybe<Scalars['Int']>
  vk2UpperInterval?: InputMaybe<Scalars['Int']>
  vk3DataCoverage?: InputMaybe<Scalars['Int']>
  vk3LowerInterval?: InputMaybe<Scalars['Int']>
  vk3Maximum?: InputMaybe<Scalars['Int']>
  vk3Median?: InputMaybe<Scalars['Int']>
  vk3Minimum?: InputMaybe<Scalars['Int']>
  vk3NewBuilding?: InputMaybe<Scalars['Int']>
  vk3Reference?: InputMaybe<Scalars['Int']>
  vk3UpperInterval?: InputMaybe<Scalars['Int']>
  vk4DataCoverage?: InputMaybe<Scalars['Int']>
  vk4LowerInterval?: InputMaybe<Scalars['Int']>
  vk4Maximum?: InputMaybe<Scalars['Int']>
  vk4Median?: InputMaybe<Scalars['Int']>
  vk4Minimum?: InputMaybe<Scalars['Int']>
  vk4NewBuilding?: InputMaybe<Scalars['Int']>
  vk4Reference?: InputMaybe<Scalars['Int']>
  vk4UpperInterval?: InputMaybe<Scalars['Int']>
}

/** A connection to a list of `UnitRent` values. */
export type UnitRentsConnection = {
  __typename: 'UnitRentsConnection'
  /** A list of edges which contains the `UnitRent` and cursor to aid in pagination. */
  edges: Array<UnitRentsEdge>
  /** A list of `UnitRent` objects. */
  nodes: Array<Maybe<UnitRent>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UnitRent` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `UnitRent` edge in the connection. */
export type UnitRentsEdge = {
  __typename: 'UnitRentsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `UnitRent` at the end of the edge. */
  node?: Maybe<UnitRent>
}

/** Methods to use when ordering `UnitRent`. */
export enum UnitRentsOrderBy {
  CadastralAreaCodeAsc = 'CADASTRAL_AREA_CODE_ASC',
  CadastralAreaCodeDesc = 'CADASTRAL_AREA_CODE_DESC',
  CadastralAreaNameAsc = 'CADASTRAL_AREA_NAME_ASC',
  CadastralAreaNameDesc = 'CADASTRAL_AREA_NAME_DESC',
  CityNameAsc = 'CITY_NAME_ASC',
  CityNameDesc = 'CITY_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RegionCodeAsc = 'REGION_CODE_ASC',
  RegionCodeDesc = 'REGION_CODE_DESC',
  Vk1DataCoverageAsc = 'VK1_DATA_COVERAGE_ASC',
  Vk1DataCoverageDesc = 'VK1_DATA_COVERAGE_DESC',
  Vk1LowerIntervalAsc = 'VK1_LOWER_INTERVAL_ASC',
  Vk1LowerIntervalDesc = 'VK1_LOWER_INTERVAL_DESC',
  Vk1MaximumAsc = 'VK1_MAXIMUM_ASC',
  Vk1MaximumDesc = 'VK1_MAXIMUM_DESC',
  Vk1MedianAsc = 'VK1_MEDIAN_ASC',
  Vk1MedianDesc = 'VK1_MEDIAN_DESC',
  Vk1MinimumAsc = 'VK1_MINIMUM_ASC',
  Vk1MinimumDesc = 'VK1_MINIMUM_DESC',
  Vk1NewBuildingAsc = 'VK1_NEW_BUILDING_ASC',
  Vk1NewBuildingDesc = 'VK1_NEW_BUILDING_DESC',
  Vk1ReferenceAsc = 'VK1_REFERENCE_ASC',
  Vk1ReferenceDesc = 'VK1_REFERENCE_DESC',
  Vk1UpperIntervalAsc = 'VK1_UPPER_INTERVAL_ASC',
  Vk1UpperIntervalDesc = 'VK1_UPPER_INTERVAL_DESC',
  Vk2DataCoverageAsc = 'VK2_DATA_COVERAGE_ASC',
  Vk2DataCoverageDesc = 'VK2_DATA_COVERAGE_DESC',
  Vk2LowerIntervalAsc = 'VK2_LOWER_INTERVAL_ASC',
  Vk2LowerIntervalDesc = 'VK2_LOWER_INTERVAL_DESC',
  Vk2MaximumAsc = 'VK2_MAXIMUM_ASC',
  Vk2MaximumDesc = 'VK2_MAXIMUM_DESC',
  Vk2MedianAsc = 'VK2_MEDIAN_ASC',
  Vk2MedianDesc = 'VK2_MEDIAN_DESC',
  Vk2MinimumAsc = 'VK2_MINIMUM_ASC',
  Vk2MinimumDesc = 'VK2_MINIMUM_DESC',
  Vk2NewBuildingAsc = 'VK2_NEW_BUILDING_ASC',
  Vk2NewBuildingDesc = 'VK2_NEW_BUILDING_DESC',
  Vk2ReferenceAsc = 'VK2_REFERENCE_ASC',
  Vk2ReferenceDesc = 'VK2_REFERENCE_DESC',
  Vk2UpperIntervalAsc = 'VK2_UPPER_INTERVAL_ASC',
  Vk2UpperIntervalDesc = 'VK2_UPPER_INTERVAL_DESC',
  Vk3DataCoverageAsc = 'VK3_DATA_COVERAGE_ASC',
  Vk3DataCoverageDesc = 'VK3_DATA_COVERAGE_DESC',
  Vk3LowerIntervalAsc = 'VK3_LOWER_INTERVAL_ASC',
  Vk3LowerIntervalDesc = 'VK3_LOWER_INTERVAL_DESC',
  Vk3MaximumAsc = 'VK3_MAXIMUM_ASC',
  Vk3MaximumDesc = 'VK3_MAXIMUM_DESC',
  Vk3MedianAsc = 'VK3_MEDIAN_ASC',
  Vk3MedianDesc = 'VK3_MEDIAN_DESC',
  Vk3MinimumAsc = 'VK3_MINIMUM_ASC',
  Vk3MinimumDesc = 'VK3_MINIMUM_DESC',
  Vk3NewBuildingAsc = 'VK3_NEW_BUILDING_ASC',
  Vk3NewBuildingDesc = 'VK3_NEW_BUILDING_DESC',
  Vk3ReferenceAsc = 'VK3_REFERENCE_ASC',
  Vk3ReferenceDesc = 'VK3_REFERENCE_DESC',
  Vk3UpperIntervalAsc = 'VK3_UPPER_INTERVAL_ASC',
  Vk3UpperIntervalDesc = 'VK3_UPPER_INTERVAL_DESC',
  Vk4DataCoverageAsc = 'VK4_DATA_COVERAGE_ASC',
  Vk4DataCoverageDesc = 'VK4_DATA_COVERAGE_DESC',
  Vk4LowerIntervalAsc = 'VK4_LOWER_INTERVAL_ASC',
  Vk4LowerIntervalDesc = 'VK4_LOWER_INTERVAL_DESC',
  Vk4MaximumAsc = 'VK4_MAXIMUM_ASC',
  Vk4MaximumDesc = 'VK4_MAXIMUM_DESC',
  Vk4MedianAsc = 'VK4_MEDIAN_ASC',
  Vk4MedianDesc = 'VK4_MEDIAN_DESC',
  Vk4MinimumAsc = 'VK4_MINIMUM_ASC',
  Vk4MinimumDesc = 'VK4_MINIMUM_DESC',
  Vk4NewBuildingAsc = 'VK4_NEW_BUILDING_ASC',
  Vk4NewBuildingDesc = 'VK4_NEW_BUILDING_DESC',
  Vk4ReferenceAsc = 'VK4_REFERENCE_ASC',
  Vk4ReferenceDesc = 'VK4_REFERENCE_DESC',
  Vk4UpperIntervalAsc = 'VK4_UPPER_INTERVAL_ASC',
  Vk4UpperIntervalDesc = 'VK4_UPPER_INTERVAL_DESC',
}

/** All input for the `updateAddressById` mutation. */
export type UpdateAddressByIdInput = {
  /** An object where the defined keys will be set on the `Address` being updated. */
  addressPatch: AddressPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `updateAddressByKod` mutation. */
export type UpdateAddressByKodInput = {
  /** An object where the defined keys will be set on the `Address` being updated. */
  addressPatch: AddressPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  kod: Scalars['String']
}

/** All input for the `updateAddress` mutation. */
export type UpdateAddressInput = {
  /** An object where the defined keys will be set on the `Address` being updated. */
  addressPatch: AddressPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `Address` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `Address` mutation. */
export type UpdateAddressPayload = {
  __typename: 'UpdateAddressPayload'
  /** The `Address` that was updated by this mutation. */
  address?: Maybe<Address>
  /** An edge for our `Address`. May be used by Relay 1. */
  addressEdge?: Maybe<AddressesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `Address` mutation. */
export type UpdateAddressPayloadAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<AddressesOrderBy>>
}

/** All input for the `updateAuctionListingById` mutation. */
export type UpdateAuctionListingByIdInput = {
  /** An object where the defined keys will be set on the `AuctionListing` being updated. */
  auctionListingPatch: AuctionListingPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `updateAuctionListing` mutation. */
export type UpdateAuctionListingInput = {
  /** An object where the defined keys will be set on the `AuctionListing` being updated. */
  auctionListingPatch: AuctionListingPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `AuctionListing` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `AuctionListing` mutation. */
export type UpdateAuctionListingPayload = {
  __typename: 'UpdateAuctionListingPayload'
  /** The `AuctionListing` that was updated by this mutation. */
  auctionListing?: Maybe<AuctionListing>
  /** An edge for our `AuctionListing`. May be used by Relay 1. */
  auctionListingEdge?: Maybe<AuctionListingsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `AuctionListing` mutation. */
export type UpdateAuctionListingPayloadAuctionListingEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionListingsOrderBy>>
}

/** All input for the `updateAuctionPropertyById` mutation. */
export type UpdateAuctionPropertyByIdInput = {
  /** An object where the defined keys will be set on the `AuctionProperty` being updated. */
  auctionPropertyPatch: AuctionPropertyPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `updateAuctionProperty` mutation. */
export type UpdateAuctionPropertyInput = {
  /** An object where the defined keys will be set on the `AuctionProperty` being updated. */
  auctionPropertyPatch: AuctionPropertyPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `AuctionProperty` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `AuctionProperty` mutation. */
export type UpdateAuctionPropertyPayload = {
  __typename: 'UpdateAuctionPropertyPayload'
  /** Reads a single `AuctionListing` that is related to this `AuctionProperty`. */
  auctionListingByAuctionId?: Maybe<AuctionListing>
  /** The `AuctionProperty` that was updated by this mutation. */
  auctionProperty?: Maybe<AuctionProperty>
  /** An edge for our `AuctionProperty`. May be used by Relay 1. */
  auctionPropertyEdge?: Maybe<AuctionPropertiesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `AuctionProperty` mutation. */
export type UpdateAuctionPropertyPayloadAuctionPropertyEdgeArgs = {
  orderBy?: InputMaybe<Array<AuctionPropertiesOrderBy>>
}

/** All input for the `updateBpejById` mutation. */
export type UpdateBpejByIdInput = {
  /** An object where the defined keys will be set on the `Bpej` being updated. */
  bpejPatch: BpejPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `updateBpej` mutation. */
export type UpdateBpejInput = {
  /** An object where the defined keys will be set on the `Bpej` being updated. */
  bpejPatch: BpejPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `Bpej` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `Bpej` mutation. */
export type UpdateBpejPayload = {
  __typename: 'UpdateBpejPayload'
  /** The `Bpej` that was updated by this mutation. */
  bpej?: Maybe<Bpej>
  /** An edge for our `Bpej`. May be used by Relay 1. */
  bpejEdge?: Maybe<BpejsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `Bpej` mutation. */
export type UpdateBpejPayloadBpejEdgeArgs = {
  orderBy?: InputMaybe<Array<BpejsOrderBy>>
}

/** All input for the `updateBuybackCalculationById` mutation. */
export type UpdateBuybackCalculationByIdInput = {
  /** An object where the defined keys will be set on the `BuybackCalculation` being updated. */
  buybackCalculationPatch: BuybackCalculationPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `updateBuybackCalculation` mutation. */
export type UpdateBuybackCalculationInput = {
  /** An object where the defined keys will be set on the `BuybackCalculation` being updated. */
  buybackCalculationPatch: BuybackCalculationPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `BuybackCalculation` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `BuybackCalculation` mutation. */
export type UpdateBuybackCalculationPayload = {
  __typename: 'UpdateBuybackCalculationPayload'
  /** The `BuybackCalculation` that was updated by this mutation. */
  buybackCalculation?: Maybe<BuybackCalculation>
  /** An edge for our `BuybackCalculation`. May be used by Relay 1. */
  buybackCalculationEdge?: Maybe<BuybackCalculationsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `BuybackCalculation` mutation. */
export type UpdateBuybackCalculationPayloadBuybackCalculationEdgeArgs = {
  orderBy?: InputMaybe<Array<BuybackCalculationsOrderBy>>
}

/** All input for the `updateCeeExecutionById` mutation. */
export type UpdateCeeExecutionByIdInput = {
  /** An object where the defined keys will be set on the `CeeExecution` being updated. */
  ceeExecutionPatch: CeeExecutionPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `updateCeeExecutionDetailById` mutation. */
export type UpdateCeeExecutionDetailByIdInput = {
  /** An object where the defined keys will be set on the `CeeExecutionDetail` being updated. */
  ceeExecutionDetailPatch: CeeExecutionDetailPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `updateCeeExecutionDetail` mutation. */
export type UpdateCeeExecutionDetailInput = {
  /** An object where the defined keys will be set on the `CeeExecutionDetail` being updated. */
  ceeExecutionDetailPatch: CeeExecutionDetailPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CeeExecutionDetail` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `CeeExecutionDetail` mutation. */
export type UpdateCeeExecutionDetailPayload = {
  __typename: 'UpdateCeeExecutionDetailPayload'
  /** Reads a single `CeeExecution` that is related to this `CeeExecutionDetail`. */
  ceeExecutionByCeeExecutionId?: Maybe<CeeExecution>
  /** The `CeeExecutionDetail` that was updated by this mutation. */
  ceeExecutionDetail?: Maybe<CeeExecutionDetail>
  /** An edge for our `CeeExecutionDetail`. May be used by Relay 1. */
  ceeExecutionDetailEdge?: Maybe<CeeExecutionDetailsEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `CeeExecutionDetail` mutation. */
export type UpdateCeeExecutionDetailPayloadCeeExecutionDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<CeeExecutionDetailsOrderBy>>
}

/** All input for the `updateCeeExecution` mutation. */
export type UpdateCeeExecutionInput = {
  /** An object where the defined keys will be set on the `CeeExecution` being updated. */
  ceeExecutionPatch: CeeExecutionPatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CeeExecution` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `CeeExecution` mutation. */
export type UpdateCeeExecutionPayload = {
  __typename: 'UpdateCeeExecutionPayload'
  /** The `CeeExecution` that was updated by this mutation. */
  ceeExecution?: Maybe<CeeExecution>
  /** An edge for our `CeeExecution`. May be used by Relay 1. */
  ceeExecutionEdge?: Maybe<CeeExecutionsEdge>
  /** Reads a single `CeeOffice` that is related to this `CeeExecution`. */
  ceeOfficeByExecutorCode?: Maybe<CeeOffice>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `MonitoringCee` that is related to this `CeeExecution`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `CeeExecution` mutation. */
export type UpdateCeeExecutionPayloadCeeExecutionEdgeArgs = {
  orderBy?: InputMaybe<Array<CeeExecutionsOrderBy>>
}

/** All input for the `updateCeeOfficeById` mutation. */
export type UpdateCeeOfficeByIdInput = {
  /** An object where the defined keys will be set on the `CeeOffice` being updated. */
  ceeOfficePatch: CeeOfficePatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}

/** All input for the `updateCeeOffice` mutation. */
export type UpdateCeeOfficeInput = {
  /** An object where the defined keys will be set on the `CeeOffice` being updated. */
  ceeOfficePatch: CeeOfficePatch
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `CeeOffice` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `CeeOffice` mutation. */
export type UpdateCeeOfficePayload = {
  __typename: 'UpdateCeeOfficePayload'
  /** The `CeeOffice` that was updated by this mutation. */
  ceeOffice?: Maybe<CeeOffice>
  /** An edge for our `CeeOffice`. May be used by Relay 1. */
  ceeOfficeEdge?: Maybe<CeeOfficesEdge>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `CeeOffice` mutation. */
export type UpdateCeeOfficePayloadCeeOfficeEdgeArgs = {
  orderBy?: InputMaybe<Array<CeeOfficesOrderBy>>
}

/** All input for the `updateCuzkDocumentCollectionById` mutation. */
export type UpdateCuzkDocumentCollectionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkDocumentCollection` being updated. */
  cuzkDocumentCollectionPatch: CuzkDocumentCollectionPatch
  id: Scalars['UUID']
}

/** All input for the `updateCuzkDocumentCollection` mutation. */
export type UpdateCuzkDocumentCollectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkDocumentCollection` being updated. */
  cuzkDocumentCollectionPatch: CuzkDocumentCollectionPatch
  /** The globally unique `ID` which will identify a single `CuzkDocumentCollection` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `CuzkDocumentCollection` mutation. */
export type UpdateCuzkDocumentCollectionPayload = {
  __typename: 'UpdateCuzkDocumentCollectionPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkDocumentCollection` that was updated by this mutation. */
  cuzkDocumentCollection?: Maybe<CuzkDocumentCollection>
  /** An edge for our `CuzkDocumentCollection`. May be used by Relay 1. */
  cuzkDocumentCollectionEdge?: Maybe<CuzkDocumentCollectionsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `CuzkDocumentCollection` mutation. */
export type UpdateCuzkDocumentCollectionPayloadCuzkDocumentCollectionEdgeArgs =
  {
    orderBy?: InputMaybe<Array<CuzkDocumentCollectionsOrderBy>>
  }

/** All input for the `updateCuzkEpoById` mutation. */
export type UpdateCuzkEpoByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkEpo` being updated. */
  cuzkEpoPatch: CuzkEpoPatch
  id: Scalars['UUID']
}

/** All input for the `updateCuzkEpo` mutation. */
export type UpdateCuzkEpoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkEpo` being updated. */
  cuzkEpoPatch: CuzkEpoPatch
  /** The globally unique `ID` which will identify a single `CuzkEpo` to be updated. */
  nodeId: Scalars['ID']
}

/** All input for the `updateCuzkEpoLienById` mutation. */
export type UpdateCuzkEpoLienByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkEpoLien` being updated. */
  cuzkEpoLienPatch: CuzkEpoLienPatch
  id: Scalars['UUID']
}

/** All input for the `updateCuzkEpoLien` mutation. */
export type UpdateCuzkEpoLienInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkEpoLien` being updated. */
  cuzkEpoLienPatch: CuzkEpoLienPatch
  /** The globally unique `ID` which will identify a single `CuzkEpoLien` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `CuzkEpoLien` mutation. */
export type UpdateCuzkEpoLienPayload = {
  __typename: 'UpdateCuzkEpoLienPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkEpoLien` that was updated by this mutation. */
  cuzkEpoLien?: Maybe<CuzkEpoLien>
  /** An edge for our `CuzkEpoLien`. May be used by Relay 1. */
  cuzkEpoLienEdge?: Maybe<CuzkEpoLiensEdge>
  /** Reads a single `CuzkEpoRestrictionCheck` that is related to this `CuzkEpoLien`. */
  cuzkEpoRestrictionCheckByRestrictionCheckId?: Maybe<CuzkEpoRestrictionCheck>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `CuzkEpoLien` mutation. */
export type UpdateCuzkEpoLienPayloadCuzkEpoLienEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkEpoLiensOrderBy>>
}

/** The output of our update `CuzkEpo` mutation. */
export type UpdateCuzkEpoPayload = {
  __typename: 'UpdateCuzkEpoPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkEpo` that was updated by this mutation. */
  cuzkEpo?: Maybe<CuzkEpo>
  /** An edge for our `CuzkEpo`. May be used by Relay 1. */
  cuzkEpoEdge?: Maybe<CuzkEposEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `CuzkEpo` mutation. */
export type UpdateCuzkEpoPayloadCuzkEpoEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkEposOrderBy>>
}

/** All input for the `updateCuzkEpoRestrictionCheckById` mutation. */
export type UpdateCuzkEpoRestrictionCheckByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkEpoRestrictionCheck` being updated. */
  cuzkEpoRestrictionCheckPatch: CuzkEpoRestrictionCheckPatch
  id: Scalars['UUID']
}

/** All input for the `updateCuzkEpoRestrictionCheck` mutation. */
export type UpdateCuzkEpoRestrictionCheckInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkEpoRestrictionCheck` being updated. */
  cuzkEpoRestrictionCheckPatch: CuzkEpoRestrictionCheckPatch
  /** The globally unique `ID` which will identify a single `CuzkEpoRestrictionCheck` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `CuzkEpoRestrictionCheck` mutation. */
export type UpdateCuzkEpoRestrictionCheckPayload = {
  __typename: 'UpdateCuzkEpoRestrictionCheckPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `CuzkEpo` that is related to this `CuzkEpoRestrictionCheck`. */
  cuzkEpoByCuzkEpoId?: Maybe<CuzkEpo>
  /** The `CuzkEpoRestrictionCheck` that was updated by this mutation. */
  cuzkEpoRestrictionCheck?: Maybe<CuzkEpoRestrictionCheck>
  /** An edge for our `CuzkEpoRestrictionCheck`. May be used by Relay 1. */
  cuzkEpoRestrictionCheckEdge?: Maybe<CuzkEpoRestrictionChecksEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `CuzkEpoRestrictionCheck` mutation. */
export type UpdateCuzkEpoRestrictionCheckPayloadCuzkEpoRestrictionCheckEdgeArgs =
  {
    orderBy?: InputMaybe<Array<CuzkEpoRestrictionChecksOrderBy>>
  }

/** All input for the `updateCuzkLvById` mutation. */
export type UpdateCuzkLvByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkLv` being updated. */
  cuzkLvPatch: CuzkLvPatch
  id: Scalars['UUID']
}

/** All input for the `updateCuzkLv` mutation. */
export type UpdateCuzkLvInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkLv` being updated. */
  cuzkLvPatch: CuzkLvPatch
  /** The globally unique `ID` which will identify a single `CuzkLv` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `CuzkLv` mutation. */
export type UpdateCuzkLvPayload = {
  __typename: 'UpdateCuzkLvPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkLv` that was updated by this mutation. */
  cuzkLv?: Maybe<CuzkLv>
  /** An edge for our `CuzkLv`. May be used by Relay 1. */
  cuzkLvEdge?: Maybe<CuzkLvsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `CuzkLv` mutation. */
export type UpdateCuzkLvPayloadCuzkLvEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkLvsOrderBy>>
}

/** All input for the `updateCuzkOById` mutation. */
export type UpdateCuzkOByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkO` being updated. */
  cuzkOPatch: CuzkOPatch
  id: Scalars['UUID']
}

/** All input for the `updateCuzkO` mutation. */
export type UpdateCuzkOInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `CuzkO` being updated. */
  cuzkOPatch: CuzkOPatch
  /** The globally unique `ID` which will identify a single `CuzkO` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `CuzkO` mutation. */
export type UpdateCuzkOPayload = {
  __typename: 'UpdateCuzkOPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `CuzkO` that was updated by this mutation. */
  cuzkO?: Maybe<CuzkO>
  /** Reads a single `CuzkO` that is related to this `CuzkO`. */
  cuzkOByPartner1?: Maybe<CuzkO>
  /** Reads a single `CuzkO` that is related to this `CuzkO`. */
  cuzkOByPartner2?: Maybe<CuzkO>
  /** An edge for our `CuzkO`. May be used by Relay 1. */
  cuzkOEdge?: Maybe<CuzkOsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `CuzkO` mutation. */
export type UpdateCuzkOPayloadCuzkOEdgeArgs = {
  orderBy?: InputMaybe<Array<CuzkOsOrderBy>>
}

/** All input for the `updateDataboxByDataboxid` mutation. */
export type UpdateDataboxByDataboxidInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `Databox` being updated. */
  databoxPatch: DataboxPatch
  databoxid: Scalars['String']
}

/** All input for the `updateDataboxById` mutation. */
export type UpdateDataboxByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `Databox` being updated. */
  databoxPatch: DataboxPatch
  id: Scalars['UUID']
}

/** All input for the `updateDatabox` mutation. */
export type UpdateDataboxInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `Databox` being updated. */
  databoxPatch: DataboxPatch
  /** The globally unique `ID` which will identify a single `Databox` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `Databox` mutation. */
export type UpdateDataboxPayload = {
  __typename: 'UpdateDataboxPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `Databox` that was updated by this mutation. */
  databox?: Maybe<Databox>
  /** An edge for our `Databox`. May be used by Relay 1. */
  databoxEdge?: Maybe<DataboxesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `Databox` mutation. */
export type UpdateDataboxPayloadDataboxEdgeArgs = {
  orderBy?: InputMaybe<Array<DataboxesOrderBy>>
}

/** All input for the `updateKuAreaByAreaId` mutation. */
export type UpdateKuAreaByAreaIdInput = {
  areaId: Scalars['UUID']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `KuArea` being updated. */
  kuAreaPatch: KuAreaPatch
}

/** All input for the `updateKuArea` mutation. */
export type UpdateKuAreaInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `KuArea` being updated. */
  kuAreaPatch: KuAreaPatch
  /** The globally unique `ID` which will identify a single `KuArea` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `KuArea` mutation. */
export type UpdateKuAreaPayload = {
  __typename: 'UpdateKuAreaPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `KuArea` that was updated by this mutation. */
  kuArea?: Maybe<KuArea>
  /** An edge for our `KuArea`. May be used by Relay 1. */
  kuAreaEdge?: Maybe<KuAreasEdge>
  /** Reads a single `KuWorkplace` that is related to this `KuArea`. */
  kuWorkplaceByPraresKod?: Maybe<KuWorkplace>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `KuArea` mutation. */
export type UpdateKuAreaPayloadKuAreaEdgeArgs = {
  orderBy?: InputMaybe<Array<KuAreasOrderBy>>
}

/** All input for the `updateKuWorkplaceById` mutation. */
export type UpdateKuWorkplaceByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `KuWorkplace` being updated. */
  kuWorkplacePatch: KuWorkplacePatch
}

/** All input for the `updateKuWorkplaceByKod` mutation. */
export type UpdateKuWorkplaceByKodInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  kod: Scalars['String']
  /** An object where the defined keys will be set on the `KuWorkplace` being updated. */
  kuWorkplacePatch: KuWorkplacePatch
}

/** All input for the `updateKuWorkplace` mutation. */
export type UpdateKuWorkplaceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `KuWorkplace` being updated. */
  kuWorkplacePatch: KuWorkplacePatch
  /** The globally unique `ID` which will identify a single `KuWorkplace` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `KuWorkplace` mutation. */
export type UpdateKuWorkplacePayload = {
  __typename: 'UpdateKuWorkplacePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `KuWorkplace` that was updated by this mutation. */
  kuWorkplace?: Maybe<KuWorkplace>
  /** Reads a single `KuWorkplace` that is related to this `KuWorkplace`. */
  kuWorkplaceByNadrizPrac?: Maybe<KuWorkplace>
  /** An edge for our `KuWorkplace`. May be used by Relay 1. */
  kuWorkplaceEdge?: Maybe<KuWorkplacesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `KuWorkplace` mutation. */
export type UpdateKuWorkplacePayloadKuWorkplaceEdgeArgs = {
  orderBy?: InputMaybe<Array<KuWorkplacesOrderBy>>
}

/** All input for the `updateLabelById` mutation. */
export type UpdateLabelByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `Label` being updated. */
  labelPatch: LabelPatch
}

/** All input for the `updateLabelConnectionById` mutation. */
export type UpdateLabelConnectionByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `LabelConnection` being updated. */
  labelConnectionPatch: LabelConnectionPatch
}

/** All input for the `updateLabelConnection` mutation. */
export type UpdateLabelConnectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `LabelConnection` being updated. */
  labelConnectionPatch: LabelConnectionPatch
  /** The globally unique `ID` which will identify a single `LabelConnection` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `LabelConnection` mutation. */
export type UpdateLabelConnectionPayload = {
  __typename: 'UpdateLabelConnectionPayload'
  /** Reads a single `AuctionListing` that is related to this `LabelConnection`. */
  auctionListingByAuctionListingId?: Maybe<AuctionListing>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `CuzkDocumentCollection` that is related to this `LabelConnection`. */
  cuzkDocumentCollectionByCuzkDocumentCollectionId?: Maybe<CuzkDocumentCollection>
  /** Reads a single `CuzkEpo` that is related to this `LabelConnection`. */
  cuzkEpoByCuzkEpoId?: Maybe<CuzkEpo>
  /** Reads a single `CuzkEpoLien` that is related to this `LabelConnection`. */
  cuzkEpoLienByCuzkEpoLienId?: Maybe<CuzkEpoLien>
  /** Reads a single `CuzkLv` that is related to this `LabelConnection`. */
  cuzkLvByCuzkLvId?: Maybe<CuzkLv>
  /** Reads a single `Label` that is related to this `LabelConnection`. */
  labelByLabelId?: Maybe<Label>
  /** The `LabelConnection` that was updated by this mutation. */
  labelConnection?: Maybe<LabelConnection>
  /** An edge for our `LabelConnection`. May be used by Relay 1. */
  labelConnectionEdge?: Maybe<LabelConnectionsEdge>
  /** Reads a single `MarketplaceOffer` that is related to this `LabelConnection`. */
  marketplaceOfferByMarketplaceOfferId?: Maybe<MarketplaceOffer>
  /** Reads a single `Monit` that is related to this `LabelConnection`. */
  monitByMonitId?: Maybe<Monit>
  /** Reads a single `MonitoringCee` that is related to this `LabelConnection`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  /** Reads a single `MonitoringCuzkRc` that is related to this `LabelConnection`. */
  monitoringCuzkRcByMonitoringCuzkRcId?: Maybe<MonitoringCuzkRc>
  /** Reads a single `PostserviceList` that is related to this `LabelConnection`. */
  postserviceListByPostserviceListId?: Maybe<PostserviceList>
  /** Reads a single `PropertyLabel` that is related to this `LabelConnection`. */
  propertyLabelByPropertyLabelId?: Maybe<PropertyLabel>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** Reads a single `RecipientList` that is related to this `LabelConnection`. */
  recipientListByRecipientListId?: Maybe<RecipientList>
}

/** The output of our update `LabelConnection` mutation. */
export type UpdateLabelConnectionPayloadLabelConnectionEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelConnectionsOrderBy>>
}

/** All input for the `updateLabel` mutation. */
export type UpdateLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `Label` being updated. */
  labelPatch: LabelPatch
  /** The globally unique `ID` which will identify a single `Label` to be updated. */
  nodeId: Scalars['ID']
}

/** All input for the `updateLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcId` mutation. */
export type UpdateLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  labelId: Scalars['UUID']
  /** An object where the defined keys will be set on the `LabelMonitoringCuzkRc` being updated. */
  labelMonitoringCuzkRcPatch: LabelMonitoringCuzkRcPatch
  monitoringCuzkRcId: Scalars['UUID']
}

/** All input for the `updateLabelMonitoringCuzkRc` mutation. */
export type UpdateLabelMonitoringCuzkRcInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `LabelMonitoringCuzkRc` being updated. */
  labelMonitoringCuzkRcPatch: LabelMonitoringCuzkRcPatch
  /** The globally unique `ID` which will identify a single `LabelMonitoringCuzkRc` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `LabelMonitoringCuzkRc` mutation. */
export type UpdateLabelMonitoringCuzkRcPayload = {
  __typename: 'UpdateLabelMonitoringCuzkRcPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `Label` that is related to this `LabelMonitoringCuzkRc`. */
  labelByLabelId?: Maybe<Label>
  /** The `LabelMonitoringCuzkRc` that was updated by this mutation. */
  labelMonitoringCuzkRc?: Maybe<LabelMonitoringCuzkRc>
  /** An edge for our `LabelMonitoringCuzkRc`. May be used by Relay 1. */
  labelMonitoringCuzkRcEdge?: Maybe<LabelMonitoringCuzkRcsEdge>
  /** Reads a single `MonitoringCuzkRc` that is related to this `LabelMonitoringCuzkRc`. */
  monitoringCuzkRcByMonitoringCuzkRcId?: Maybe<MonitoringCuzkRc>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `LabelMonitoringCuzkRc` mutation. */
export type UpdateLabelMonitoringCuzkRcPayloadLabelMonitoringCuzkRcEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelMonitoringCuzkRcsOrderBy>>
}

/** The output of our update `Label` mutation. */
export type UpdateLabelPayload = {
  __typename: 'UpdateLabelPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `Label` that was updated by this mutation. */
  label?: Maybe<Label>
  /** An edge for our `Label`. May be used by Relay 1. */
  labelEdge?: Maybe<LabelsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `Label` mutation. */
export type UpdateLabelPayloadLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<LabelsOrderBy>>
}

/** All input for the `updateMarketplaceOfferAccessById` mutation. */
export type UpdateMarketplaceOfferAccessByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `MarketplaceOfferAccess` being updated. */
  marketplaceOfferAccessPatch: MarketplaceOfferAccessPatch
}

/** All input for the `updateMarketplaceOfferAccess` mutation. */
export type UpdateMarketplaceOfferAccessInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `MarketplaceOfferAccess` being updated. */
  marketplaceOfferAccessPatch: MarketplaceOfferAccessPatch
  /** The globally unique `ID` which will identify a single `MarketplaceOfferAccess` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `MarketplaceOfferAccess` mutation. */
export type UpdateMarketplaceOfferAccessPayload = {
  __typename: 'UpdateMarketplaceOfferAccessPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `MarketplaceOfferAccess` that was updated by this mutation. */
  marketplaceOfferAccess?: Maybe<MarketplaceOfferAccess>
  /** An edge for our `MarketplaceOfferAccess`. May be used by Relay 1. */
  marketplaceOfferAccessEdge?: Maybe<MarketplaceOfferAccessesEdge>
  /** Reads a single `MarketplaceOffer` that is related to this `MarketplaceOfferAccess`. */
  marketplaceOfferByOfferId?: Maybe<MarketplaceOffer>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `MarketplaceOfferAccess` mutation. */
export type UpdateMarketplaceOfferAccessPayloadMarketplaceOfferAccessEdgeArgs =
  {
    orderBy?: InputMaybe<Array<MarketplaceOfferAccessesOrderBy>>
  }

/** All input for the `updateMarketplaceOfferById` mutation. */
export type UpdateMarketplaceOfferByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `MarketplaceOffer` being updated. */
  marketplaceOfferPatch: MarketplaceOfferPatch
}

/** All input for the `updateMarketplaceOffer` mutation. */
export type UpdateMarketplaceOfferInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `MarketplaceOffer` being updated. */
  marketplaceOfferPatch: MarketplaceOfferPatch
  /** The globally unique `ID` which will identify a single `MarketplaceOffer` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `MarketplaceOffer` mutation. */
export type UpdateMarketplaceOfferPayload = {
  __typename: 'UpdateMarketplaceOfferPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `MarketplaceOffer` that was updated by this mutation. */
  marketplaceOffer?: Maybe<MarketplaceOffer>
  /** An edge for our `MarketplaceOffer`. May be used by Relay 1. */
  marketplaceOfferEdge?: Maybe<MarketplaceOffersEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `MarketplaceOffer` mutation. */
export type UpdateMarketplaceOfferPayloadMarketplaceOfferEdgeArgs = {
  orderBy?: InputMaybe<Array<MarketplaceOffersOrderBy>>
}

/** All input for the `updateMonitById` mutation. */
export type UpdateMonitByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `Monit` being updated. */
  monitPatch: MonitPatch
}

/** All input for the `updateMonit` mutation. */
export type UpdateMonitInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `Monit` being updated. */
  monitPatch: MonitPatch
  /** The globally unique `ID` which will identify a single `Monit` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `Monit` mutation. */
export type UpdateMonitPayload = {
  __typename: 'UpdateMonitPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `Monit` that was updated by this mutation. */
  monit?: Maybe<Monit>
  /** An edge for our `Monit`. May be used by Relay 1. */
  monitEdge?: Maybe<MonitsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `Monit` mutation. */
export type UpdateMonitPayloadMonitEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitsOrderBy>>
}

/** All input for the `updateMonitoringCeeById` mutation. */
export type UpdateMonitoringCeeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `MonitoringCee` being updated. */
  monitoringCeePatch: MonitoringCeePatch
}

/** All input for the `updateMonitoringCee` mutation. */
export type UpdateMonitoringCeeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `MonitoringCee` being updated. */
  monitoringCeePatch: MonitoringCeePatch
  /** The globally unique `ID` which will identify a single `MonitoringCee` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `MonitoringCee` mutation. */
export type UpdateMonitoringCeePayload = {
  __typename: 'UpdateMonitoringCeePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `MonitoringCee` that was updated by this mutation. */
  monitoringCee?: Maybe<MonitoringCee>
  /** An edge for our `MonitoringCee`. May be used by Relay 1. */
  monitoringCeeEdge?: Maybe<MonitoringCeesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `MonitoringCee` mutation. */
export type UpdateMonitoringCeePayloadMonitoringCeeEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitoringCeesOrderBy>>
}

/** All input for the `updateMonitoringCuzkRcById` mutation. */
export type UpdateMonitoringCuzkRcByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `MonitoringCuzkRc` being updated. */
  monitoringCuzkRcPatch: MonitoringCuzkRcPatch
}

/** All input for the `updateMonitoringCuzkRc` mutation. */
export type UpdateMonitoringCuzkRcInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `MonitoringCuzkRc` being updated. */
  monitoringCuzkRcPatch: MonitoringCuzkRcPatch
  /** The globally unique `ID` which will identify a single `MonitoringCuzkRc` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `MonitoringCuzkRc` mutation. */
export type UpdateMonitoringCuzkRcPayload = {
  __typename: 'UpdateMonitoringCuzkRcPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `CuzkO` that is related to this `MonitoringCuzkRc`. */
  cuzkOByCuzkOsId?: Maybe<CuzkO>
  /** Reads a single `MonitoringCee` that is related to this `MonitoringCuzkRc`. */
  monitoringCeeByMonitoringCeeId?: Maybe<MonitoringCee>
  /** The `MonitoringCuzkRc` that was updated by this mutation. */
  monitoringCuzkRc?: Maybe<MonitoringCuzkRc>
  /** An edge for our `MonitoringCuzkRc`. May be used by Relay 1. */
  monitoringCuzkRcEdge?: Maybe<MonitoringCuzkRcsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `MonitoringCuzkRc` mutation. */
export type UpdateMonitoringCuzkRcPayloadMonitoringCuzkRcEdgeArgs = {
  orderBy?: InputMaybe<Array<MonitoringCuzkRcsOrderBy>>
}

/** All input for the `updateMunicipalOfficeByAdresnimistokod` mutation. */
export type UpdateMunicipalOfficeByAdresnimistokodInput = {
  adresnimistokod: Scalars['String']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `MunicipalOffice` being updated. */
  municipalOfficePatch: MunicipalOfficePatch
}

/** All input for the `updateMunicipalOfficeById` mutation. */
export type UpdateMunicipalOfficeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `MunicipalOffice` being updated. */
  municipalOfficePatch: MunicipalOfficePatch
}

/** All input for the `updateMunicipalOffice` mutation. */
export type UpdateMunicipalOfficeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `MunicipalOffice` being updated. */
  municipalOfficePatch: MunicipalOfficePatch
  /** The globally unique `ID` which will identify a single `MunicipalOffice` to be updated. */
  nodeId: Scalars['ID']
}

/** The output of our update `MunicipalOffice` mutation. */
export type UpdateMunicipalOfficePayload = {
  __typename: 'UpdateMunicipalOfficePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `MunicipalOffice` that was updated by this mutation. */
  municipalOffice?: Maybe<MunicipalOffice>
  /** An edge for our `MunicipalOffice`. May be used by Relay 1. */
  municipalOfficeEdge?: Maybe<MunicipalOfficesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `MunicipalOffice` mutation. */
export type UpdateMunicipalOfficePayloadMunicipalOfficeEdgeArgs = {
  orderBy?: InputMaybe<Array<MunicipalOfficesOrderBy>>
}

/** All input for the `updatePostserviceListById` mutation. */
export type UpdatePostserviceListByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `PostserviceList` being updated. */
  postserviceListPatch: PostserviceListPatch
}

/** All input for the `updatePostserviceList` mutation. */
export type UpdatePostserviceListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PostserviceList` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `PostserviceList` being updated. */
  postserviceListPatch: PostserviceListPatch
}

/** The output of our update `PostserviceList` mutation. */
export type UpdatePostserviceListPayload = {
  __typename: 'UpdatePostserviceListPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `PostserviceList` that was updated by this mutation. */
  postserviceList?: Maybe<PostserviceList>
  /** An edge for our `PostserviceList`. May be used by Relay 1. */
  postserviceListEdge?: Maybe<PostserviceListsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `PostserviceList` mutation. */
export type UpdatePostserviceListPayloadPostserviceListEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceListsOrderBy>>
}

/** All input for the `updatePostserviceRecipientById` mutation. */
export type UpdatePostserviceRecipientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `PostserviceRecipient` being updated. */
  postserviceRecipientPatch: PostserviceRecipientPatch
}

/** All input for the `updatePostserviceRecipient` mutation. */
export type UpdatePostserviceRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PostserviceRecipient` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `PostserviceRecipient` being updated. */
  postserviceRecipientPatch: PostserviceRecipientPatch
}

/** The output of our update `PostserviceRecipient` mutation. */
export type UpdatePostserviceRecipientPayload = {
  __typename: 'UpdatePostserviceRecipientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `PostserviceList` that is related to this `PostserviceRecipient`. */
  postserviceListByPostserviceListId?: Maybe<PostserviceList>
  /** The `PostserviceRecipient` that was updated by this mutation. */
  postserviceRecipient?: Maybe<PostserviceRecipient>
  /** An edge for our `PostserviceRecipient`. May be used by Relay 1. */
  postserviceRecipientEdge?: Maybe<PostserviceRecipientsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `PostserviceRecipient` mutation. */
export type UpdatePostserviceRecipientPayloadPostserviceRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceRecipientsOrderBy>>
}

/** All input for the `updatePostserviceSentLetterById` mutation. */
export type UpdatePostserviceSentLetterByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `PostserviceSentLetter` being updated. */
  postserviceSentLetterPatch: PostserviceSentLetterPatch
}

/** All input for the `updatePostserviceSentLetter` mutation. */
export type UpdatePostserviceSentLetterInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PostserviceSentLetter` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `PostserviceSentLetter` being updated. */
  postserviceSentLetterPatch: PostserviceSentLetterPatch
}

/** The output of our update `PostserviceSentLetter` mutation. */
export type UpdatePostserviceSentLetterPayload = {
  __typename: 'UpdatePostserviceSentLetterPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `PostserviceList` that is related to this `PostserviceSentLetter`. */
  postserviceListByOriginalListId?: Maybe<PostserviceList>
  /** The `PostserviceSentLetter` that was updated by this mutation. */
  postserviceSentLetter?: Maybe<PostserviceSentLetter>
  /** An edge for our `PostserviceSentLetter`. May be used by Relay 1. */
  postserviceSentLetterEdge?: Maybe<PostserviceSentLettersEdge>
  /** Reads a single `PostserviceTemplate` that is related to this `PostserviceSentLetter`. */
  postserviceTemplateByOriginalTemplateId?: Maybe<PostserviceTemplate>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** Reads a single `SenderAddress` that is related to this `PostserviceSentLetter`. */
  senderAddressBySenderAddressId?: Maybe<SenderAddress>
}

/** The output of our update `PostserviceSentLetter` mutation. */
export type UpdatePostserviceSentLetterPayloadPostserviceSentLetterEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceSentLettersOrderBy>>
}

/** All input for the `updatePostserviceSentRecipientById` mutation. */
export type UpdatePostserviceSentRecipientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `PostserviceSentRecipient` being updated. */
  postserviceSentRecipientPatch: PostserviceSentRecipientPatch
}

/** All input for the `updatePostserviceSentRecipient` mutation. */
export type UpdatePostserviceSentRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PostserviceSentRecipient` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `PostserviceSentRecipient` being updated. */
  postserviceSentRecipientPatch: PostserviceSentRecipientPatch
}

/** The output of our update `PostserviceSentRecipient` mutation. */
export type UpdatePostserviceSentRecipientPayload = {
  __typename: 'UpdatePostserviceSentRecipientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Reads a single `PostserviceRecipient` that is related to this `PostserviceSentRecipient`. */
  postserviceRecipientByOriginalRecipientId?: Maybe<PostserviceRecipient>
  /** Reads a single `PostserviceSentLetter` that is related to this `PostserviceSentRecipient`. */
  postserviceSentLetterBySentLetterId?: Maybe<PostserviceSentLetter>
  /** The `PostserviceSentRecipient` that was updated by this mutation. */
  postserviceSentRecipient?: Maybe<PostserviceSentRecipient>
  /** An edge for our `PostserviceSentRecipient`. May be used by Relay 1. */
  postserviceSentRecipientEdge?: Maybe<PostserviceSentRecipientsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `PostserviceSentRecipient` mutation. */
export type UpdatePostserviceSentRecipientPayloadPostserviceSentRecipientEdgeArgs =
  {
    orderBy?: InputMaybe<Array<PostserviceSentRecipientsOrderBy>>
  }

/** All input for the `updatePostserviceTemplateById` mutation. */
export type UpdatePostserviceTemplateByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `PostserviceTemplate` being updated. */
  postserviceTemplatePatch: PostserviceTemplatePatch
}

/** All input for the `updatePostserviceTemplate` mutation. */
export type UpdatePostserviceTemplateInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PostserviceTemplate` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `PostserviceTemplate` being updated. */
  postserviceTemplatePatch: PostserviceTemplatePatch
}

/** The output of our update `PostserviceTemplate` mutation. */
export type UpdatePostserviceTemplatePayload = {
  __typename: 'UpdatePostserviceTemplatePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `PostserviceTemplate` that was updated by this mutation. */
  postserviceTemplate?: Maybe<PostserviceTemplate>
  /** An edge for our `PostserviceTemplate`. May be used by Relay 1. */
  postserviceTemplateEdge?: Maybe<PostserviceTemplatesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `PostserviceTemplate` mutation. */
export type UpdatePostserviceTemplatePayloadPostserviceTemplateEdgeArgs = {
  orderBy?: InputMaybe<Array<PostserviceTemplatesOrderBy>>
}

/** All input for the `updatePropertyLabelById` mutation. */
export type UpdatePropertyLabelByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `PropertyLabel` being updated. */
  propertyLabelPatch: PropertyLabelPatch
}

/** All input for the `updatePropertyLabel` mutation. */
export type UpdatePropertyLabelInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PropertyLabel` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `PropertyLabel` being updated. */
  propertyLabelPatch: PropertyLabelPatch
}

/** The output of our update `PropertyLabel` mutation. */
export type UpdatePropertyLabelPayload = {
  __typename: 'UpdatePropertyLabelPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `PropertyLabel` that was updated by this mutation. */
  propertyLabel?: Maybe<PropertyLabel>
  /** An edge for our `PropertyLabel`. May be used by Relay 1. */
  propertyLabelEdge?: Maybe<PropertyLabelsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `PropertyLabel` mutation. */
export type UpdatePropertyLabelPayloadPropertyLabelEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyLabelsOrderBy>>
}

/** All input for the `updatePropertyListById` mutation. */
export type UpdatePropertyListByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `PropertyList` being updated. */
  propertyListPatch: PropertyListPatch
}

/** All input for the `updatePropertyList` mutation. */
export type UpdatePropertyListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PropertyList` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `PropertyList` being updated. */
  propertyListPatch: PropertyListPatch
}

/** The output of our update `PropertyList` mutation. */
export type UpdatePropertyListPayload = {
  __typename: 'UpdatePropertyListPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `PropertyList` that was updated by this mutation. */
  propertyList?: Maybe<PropertyList>
  /** An edge for our `PropertyList`. May be used by Relay 1. */
  propertyListEdge?: Maybe<PropertyListsEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `PropertyList` mutation. */
export type UpdatePropertyListPayloadPropertyListEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyListsOrderBy>>
}

/** All input for the `updatePropertyNoteById` mutation. */
export type UpdatePropertyNoteByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `PropertyNote` being updated. */
  propertyNotePatch: PropertyNotePatch
}

/** All input for the `updatePropertyNote` mutation. */
export type UpdatePropertyNoteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `PropertyNote` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `PropertyNote` being updated. */
  propertyNotePatch: PropertyNotePatch
}

/** The output of our update `PropertyNote` mutation. */
export type UpdatePropertyNotePayload = {
  __typename: 'UpdatePropertyNotePayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** The `PropertyNote` that was updated by this mutation. */
  propertyNote?: Maybe<PropertyNote>
  /** An edge for our `PropertyNote`. May be used by Relay 1. */
  propertyNoteEdge?: Maybe<PropertyNotesEdge>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
}

/** The output of our update `PropertyNote` mutation. */
export type UpdatePropertyNotePayloadPropertyNoteEdgeArgs = {
  orderBy?: InputMaybe<Array<PropertyNotesOrderBy>>
}

/** All input for the `updateRecipientById` mutation. */
export type UpdateRecipientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `Recipient` being updated. */
  recipientPatch: RecipientPatch
}

/** All input for the `updateRecipient` mutation. */
export type UpdateRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `Recipient` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `Recipient` being updated. */
  recipientPatch: RecipientPatch
}

/** All input for the `updateRecipientListById` mutation. */
export type UpdateRecipientListByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `RecipientList` being updated. */
  recipientListPatch: RecipientListPatch
}

/** All input for the `updateRecipientList` mutation. */
export type UpdateRecipientListInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `RecipientList` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `RecipientList` being updated. */
  recipientListPatch: RecipientListPatch
}

/** The output of our update `RecipientList` mutation. */
export type UpdateRecipientListPayload = {
  __typename: 'UpdateRecipientListPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `RecipientList` that was updated by this mutation. */
  recipientList?: Maybe<RecipientList>
  /** An edge for our `RecipientList`. May be used by Relay 1. */
  recipientListEdge?: Maybe<RecipientListsEdge>
  /** Reads a single `SenderAddress` that is related to this `RecipientList`. */
  senderAddressBySenderAddressId?: Maybe<SenderAddress>
}

/** The output of our update `RecipientList` mutation. */
export type UpdateRecipientListPayloadRecipientListEdgeArgs = {
  orderBy?: InputMaybe<Array<RecipientListsOrderBy>>
}

/** All input for the `updateRecipientListRecipientById` mutation. */
export type UpdateRecipientListRecipientByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `RecipientListRecipient` being updated. */
  recipientListRecipientPatch: RecipientListRecipientPatch
}

/** All input for the `updateRecipientListRecipientByRecipientListIdAndRecipientId` mutation. */
export type UpdateRecipientListRecipientByRecipientListIdAndRecipientIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  recipientId: Scalars['UUID']
  recipientListId: Scalars['UUID']
  /** An object where the defined keys will be set on the `RecipientListRecipient` being updated. */
  recipientListRecipientPatch: RecipientListRecipientPatch
}

/** All input for the `updateRecipientListRecipient` mutation. */
export type UpdateRecipientListRecipientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `RecipientListRecipient` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `RecipientListRecipient` being updated. */
  recipientListRecipientPatch: RecipientListRecipientPatch
}

/** The output of our update `RecipientListRecipient` mutation. */
export type UpdateRecipientListRecipientPayload = {
  __typename: 'UpdateRecipientListRecipientPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** Reads a single `Recipient` that is related to this `RecipientListRecipient`. */
  recipientByRecipientId?: Maybe<Recipient>
  /** Reads a single `RecipientList` that is related to this `RecipientListRecipient`. */
  recipientListByRecipientListId?: Maybe<RecipientList>
  /** The `RecipientListRecipient` that was updated by this mutation. */
  recipientListRecipient?: Maybe<RecipientListRecipient>
  /** An edge for our `RecipientListRecipient`. May be used by Relay 1. */
  recipientListRecipientEdge?: Maybe<RecipientListRecipientsEdge>
}

/** The output of our update `RecipientListRecipient` mutation. */
export type UpdateRecipientListRecipientPayloadRecipientListRecipientEdgeArgs =
  {
    orderBy?: InputMaybe<Array<RecipientListRecipientsOrderBy>>
  }

/** The output of our update `Recipient` mutation. */
export type UpdateRecipientPayload = {
  __typename: 'UpdateRecipientPayload'
  /** Reads a single `Address` that is related to this `Recipient`. */
  addressByAdresnimistokod?: Maybe<Address>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `Recipient` that was updated by this mutation. */
  recipient?: Maybe<Recipient>
  /** An edge for our `Recipient`. May be used by Relay 1. */
  recipientEdge?: Maybe<RecipientsEdge>
}

/** The output of our update `Recipient` mutation. */
export type UpdateRecipientPayloadRecipientEdgeArgs = {
  orderBy?: InputMaybe<Array<RecipientsOrderBy>>
}

/** All input for the `updateSenderAddressById` mutation. */
export type UpdateSenderAddressByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `SenderAddress` being updated. */
  senderAddressPatch: SenderAddressPatch
}

/** All input for the `updateSenderAddress` mutation. */
export type UpdateSenderAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `SenderAddress` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `SenderAddress` being updated. */
  senderAddressPatch: SenderAddressPatch
}

/** The output of our update `SenderAddress` mutation. */
export type UpdateSenderAddressPayload = {
  __typename: 'UpdateSenderAddressPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `SenderAddress` that was updated by this mutation. */
  senderAddress?: Maybe<SenderAddress>
  /** An edge for our `SenderAddress`. May be used by Relay 1. */
  senderAddressEdge?: Maybe<SenderAddressesEdge>
}

/** The output of our update `SenderAddress` mutation. */
export type UpdateSenderAddressPayloadSenderAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<SenderAddressesOrderBy>>
}

/** All input for the `updateUnitRentByCadastralAreaCode` mutation. */
export type UpdateUnitRentByCadastralAreaCodeInput = {
  cadastralAreaCode: Scalars['String']
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** An object where the defined keys will be set on the `UnitRent` being updated. */
  unitRentPatch: UnitRentPatch
}

/** All input for the `updateUnitRentById` mutation. */
export type UpdateUnitRentByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `UnitRent` being updated. */
  unitRentPatch: UnitRentPatch
}

/** All input for the `updateUnitRent` mutation. */
export type UpdateUnitRentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `UnitRent` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `UnitRent` being updated. */
  unitRentPatch: UnitRentPatch
}

/** The output of our update `UnitRent` mutation. */
export type UpdateUnitRentPayload = {
  __typename: 'UpdateUnitRentPayload'
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `UnitRent` that was updated by this mutation. */
  unitRent?: Maybe<UnitRent>
  /** An edge for our `UnitRent`. May be used by Relay 1. */
  unitRentEdge?: Maybe<UnitRentsEdge>
}

/** The output of our update `UnitRent` mutation. */
export type UpdateUnitRentPayloadUnitRentEdgeArgs = {
  orderBy?: InputMaybe<Array<UnitRentsOrderBy>>
}

/** All input for the `updateUserActivityLogById` mutation. */
export type UpdateUserActivityLogByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
  /** An object where the defined keys will be set on the `UserActivityLog` being updated. */
  userActivityLogPatch: UserActivityLogPatch
}

/** All input for the `updateUserActivityLog` mutation. */
export type UpdateUserActivityLogInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>
  /** The globally unique `ID` which will identify a single `UserActivityLog` to be updated. */
  nodeId: Scalars['ID']
  /** An object where the defined keys will be set on the `UserActivityLog` being updated. */
  userActivityLogPatch: UserActivityLogPatch
}

/** The output of our update `UserActivityLog` mutation. */
export type UpdateUserActivityLogPayload = {
  __typename: 'UpdateUserActivityLogPayload'
  /** Reads a single `AuctionListing` that is related to this `UserActivityLog`. */
  auctionListingByAuctionListingId?: Maybe<AuctionListing>
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>
  /** The `UserActivityLog` that was updated by this mutation. */
  userActivityLog?: Maybe<UserActivityLog>
  /** An edge for our `UserActivityLog`. May be used by Relay 1. */
  userActivityLogEdge?: Maybe<UserActivityLogsEdge>
}

/** The output of our update `UserActivityLog` mutation. */
export type UpdateUserActivityLogPayloadUserActivityLogEdgeArgs = {
  orderBy?: InputMaybe<Array<UserActivityLogsOrderBy>>
}

export enum UserActivityActionType {
  SeenDetail = 'SEEN_DETAIL',
  SeenOverview = 'SEEN_OVERVIEW',
  SeenPreview = 'SEEN_PREVIEW',
}

/** A filter to be used against UserActivityActionType fields. All fields are combined with a logical ‘and.’ */
export type UserActivityActionTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserActivityActionType>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserActivityActionType>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserActivityActionType>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserActivityActionType>
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserActivityActionType>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserActivityActionType>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserActivityActionType>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserActivityActionType>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserActivityActionType>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserActivityActionType>>
}

export enum UserActivityEntityType {
  Area = 'AREA',
  Auction = 'AUCTION',
  Building = 'BUILDING',
  Proceeding = 'PROCEEDING',
  Unit = 'UNIT',
}

/** A filter to be used against UserActivityEntityType fields. All fields are combined with a logical ‘and.’ */
export type UserActivityEntityTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserActivityEntityType>
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserActivityEntityType>
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserActivityEntityType>
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserActivityEntityType>
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserActivityEntityType>>
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserActivityEntityType>
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserActivityEntityType>
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserActivityEntityType>
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserActivityEntityType>
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserActivityEntityType>>
}

export type UserActivityLog = Node & {
  __typename: 'UserActivityLog'
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  actionSource?: Maybe<Scalars['String']>
  actionType: UserActivityActionType
  /** Reads a single `AuctionListing` that is related to this `UserActivityLog`. */
  auctionListingByAuctionListingId?: Maybe<AuctionListing>
  auctionListingId?: Maybe<Scalars['UUID']>
  createdAt: Scalars['Datetime']
  editedAt: Scalars['Datetime']
  entityId: Scalars['String']
  entityType: UserActivityEntityType
  id: Scalars['UUID']
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']
}

/**
 * A condition to be used against `UserActivityLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserActivityLogCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `actionSource` field. */
  actionSource?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `actionType` field. */
  actionType?: InputMaybe<UserActivityActionType>
  /** Checks for equality with the object’s `auctionListingId` field. */
  auctionListingId?: InputMaybe<Scalars['UUID']>
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `editedAt` field. */
  editedAt?: InputMaybe<Scalars['Datetime']>
  /** Checks for equality with the object’s `entityId` field. */
  entityId?: InputMaybe<Scalars['String']>
  /** Checks for equality with the object’s `entityType` field. */
  entityType?: InputMaybe<UserActivityEntityType>
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>
}

/** A filter to be used against `UserActivityLog` object types. All fields are combined with a logical ‘and.’ */
export type UserActivityLogFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `accountUserId` field. */
  accountUserId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `actionSource` field. */
  actionSource?: InputMaybe<StringFilter>
  /** Filter by the object’s `actionType` field. */
  actionType?: InputMaybe<UserActivityActionTypeFilter>
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserActivityLogFilter>>
  /** Filter by the object’s `auctionListingId` field. */
  auctionListingId?: InputMaybe<UuidFilter>
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `editedAt` field. */
  editedAt?: InputMaybe<DatetimeFilter>
  /** Filter by the object’s `entityId` field. */
  entityId?: InputMaybe<StringFilter>
  /** Filter by the object’s `entityType` field. */
  entityType?: InputMaybe<UserActivityEntityTypeFilter>
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>
  /** Negates the expression. */
  not?: InputMaybe<UserActivityLogFilter>
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserActivityLogFilter>>
}

/** An input for mutations affecting `UserActivityLog` */
export type UserActivityLogInput = {
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  actionSource?: InputMaybe<Scalars['String']>
  actionType: UserActivityActionType
  auctionListingId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  entityId: Scalars['String']
  entityType: UserActivityEntityType
  id?: InputMaybe<Scalars['UUID']>
}

/** Represents an update to a `UserActivityLog`. Fields that are set will be updated. */
export type UserActivityLogPatch = {
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  actionSource?: InputMaybe<Scalars['String']>
  actionType?: InputMaybe<UserActivityActionType>
  auctionListingId?: InputMaybe<Scalars['UUID']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  entityId?: InputMaybe<Scalars['String']>
  entityType?: InputMaybe<UserActivityEntityType>
  id?: InputMaybe<Scalars['UUID']>
}

/** A connection to a list of `UserActivityLog` values. */
export type UserActivityLogsConnection = {
  __typename: 'UserActivityLogsConnection'
  /** A list of edges which contains the `UserActivityLog` and cursor to aid in pagination. */
  edges: Array<UserActivityLogsEdge>
  /** A list of `UserActivityLog` objects. */
  nodes: Array<Maybe<UserActivityLog>>
  /** Information to aid in pagination. */
  pageInfo: PageInfo
  /** The count of *all* `UserActivityLog` you could get from the connection. */
  totalCount: Scalars['Int']
}

/** A `UserActivityLog` edge in the connection. */
export type UserActivityLogsEdge = {
  __typename: 'UserActivityLogsEdge'
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>
  /** The `UserActivityLog` at the end of the edge. */
  node?: Maybe<UserActivityLog>
}

/** Methods to use when ordering `UserActivityLog`. */
export enum UserActivityLogsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AccountUserIdAsc = 'ACCOUNT_USER_ID_ASC',
  AccountUserIdDesc = 'ACCOUNT_USER_ID_DESC',
  ActionSourceAsc = 'ACTION_SOURCE_ASC',
  ActionSourceDesc = 'ACTION_SOURCE_DESC',
  ActionTypeAsc = 'ACTION_TYPE_ASC',
  ActionTypeDesc = 'ACTION_TYPE_DESC',
  AuctionListingIdAsc = 'AUCTION_LISTING_ID_ASC',
  AuctionListingIdDesc = 'AUCTION_LISTING_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EditedAtAsc = 'EDITED_AT_ASC',
  EditedAtDesc = 'EDITED_AT_DESC',
  EntityIdAsc = 'ENTITY_ID_ASC',
  EntityIdDesc = 'ENTITY_ID_DESC',
  EntityTypeAsc = 'ENTITY_TYPE_ASC',
  EntityTypeDesc = 'ENTITY_TYPE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type EditLabelMutationVariables = Exact<{
  id: Scalars['UUID']
  colorKey?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  iconKey?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
}>

export type EditLabelMutation = { __typename: 'Mutation' } & {
  updateLabelById?: Maybe<
    { __typename: 'UpdateLabelPayload' } & Pick<
      UpdateLabelPayload,
      'clientMutationId'
    > & {
        label?: Maybe<{ __typename: 'Label' }>
        query?: Maybe<
          { __typename: 'Query' } & {
            allLabels?: Maybe<{ __typename: 'LabelsConnection' }>
          }
        >
      }
  >
}

export type AuctionDetailDrawerQueryVariables = Exact<{
  id: Scalars['UUID']
  accountUserId: Scalars['UUID']
  accountId: Scalars['UUID']
  labelIds: Array<Scalars['UUID']> | Scalars['UUID']
}>

export type AuctionDetailDrawerQuery = { __typename: 'Query' } & {
  auctionListingById?: Maybe<
    { __typename: 'AuctionListing' } & Pick<
      AuctionListing,
      | 'createdAt'
      | 'auctionDecreeUrl'
      | 'description'
      | 'detailUrl'
      | 'auctionedOn'
      | 'endDate'
      | 'id'
      | 'lat'
      | 'long'
      | 'photoUrl'
      | 'price'
      | 'startDate'
      | 'state'
      | 'title'
      | 'type'
      | 'updatedAt'
    > & {
        labels: { __typename: 'LabelConnectionsConnection' } & {
          nodes: Array<
            Maybe<
              { __typename: 'LabelConnection' } & Pick<
                LabelConnection,
                'id'
              > & {
                  labelByLabelId?: Maybe<
                    { __typename: 'Label' } & Pick<
                      Label,
                      'colorKey' | 'iconKey' | 'description' | 'id' | 'name'
                    >
                  >
                }
            >
          >
        }
        userActivityLogsByAuctionListingId: {
          __typename: 'UserActivityLogsConnection'
        } & {
          nodes: Array<
            Maybe<
              { __typename: 'UserActivityLog' } & Pick<
                UserActivityLog,
                'editedAt' | 'id' | 'nodeId'
              >
            >
          >
        }
        linkedProperties: { __typename: 'AuctionPropertiesConnection' } & {
          nodes: Array<
            Maybe<
              { __typename: 'AuctionProperty' } & Pick<
                AuctionProperty,
                'propertyId'
              >
            >
          >
        }
      }
  >
}

export type AuctionLinkedPropertyQueryVariables = Exact<{
  accountId: Scalars['UUID']
  auctionId: Scalars['UUID']
}>

export type AuctionLinkedPropertyQuery = { __typename: 'Query' } & {
  allAuctionProperties?: Maybe<
    { __typename: 'AuctionPropertiesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'AuctionProperty' } & Pick<
            AuctionProperty,
            | 'id'
            | 'auctionId'
            | 'createdAt'
            | 'propertyId'
            | 'propertyName'
            | 'propertyType'
          >
        >
      >
    }
  >
}

export type CreateAuctionPropertyMutationVariables = Exact<{
  auctionProperty: AuctionPropertyInput
}>

export type CreateAuctionPropertyMutation = { __typename: 'Mutation' } & {
  createAuctionProperty?: Maybe<
    { __typename: 'CreateAuctionPropertyPayload' } & {
      auctionProperty?: Maybe<
        { __typename: 'AuctionProperty' } & Pick<
          AuctionProperty,
          'id' | 'propertyId' | 'propertyName' | 'propertyType' | 'createdAt'
        >
      >
      query?: Maybe<
        { __typename: 'Query' } & {
          allAuctionProperties?: Maybe<
            { __typename: 'AuctionPropertiesConnection' } & {
              nodes: Array<Maybe<{ __typename: 'AuctionProperty' }>>
            }
          >
        }
      >
    }
  >
}

export type DeleteAuctionPropertyMutationVariables = Exact<{
  id: Scalars['UUID']
}>

export type DeleteAuctionPropertyMutation = { __typename: 'Mutation' } & {
  deleteAuctionPropertyById?: Maybe<
    { __typename: 'DeleteAuctionPropertyPayload' } & Pick<
      DeleteAuctionPropertyPayload,
      'clientMutationId'
    > & {
        query?: Maybe<
          { __typename: 'Query' } & {
            allAuctionProperties?: Maybe<
              { __typename: 'AuctionPropertiesConnection' } & {
                nodes: Array<Maybe<{ __typename: 'AuctionProperty' }>>
              }
            >
          }
        >
      }
  >
}

export type AllAuctionLabelsQueryVariables = Exact<{
  accountId: Scalars['UUID']
}>

export type AllAuctionLabelsQuery = { __typename: 'Query' } & {
  allLabels?: Maybe<
    { __typename: 'LabelsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Label' } & Pick<Label, 'name' | 'id'> & {
              labelConnectionsByLabelId: {
                __typename: 'LabelConnectionsConnection'
              } & Pick<LabelConnectionsConnection, 'totalCount'>
            }
        >
      >
    }
  >
}

export type AuctionMonitoringTabQueryVariables = Exact<{
  filter?: InputMaybe<AuctionListingFilter>
  accountUserId: Scalars['UUID']
  accountId: Scalars['UUID']
  labelIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>
  exportData?: InputMaybe<Scalars['Boolean']>
}>

export type AuctionMonitoringTabQuery = { __typename: 'Query' } & {
  allAuctionListings?: Maybe<
    { __typename: 'AuctionListingsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'AuctionListing' } & Pick<
            AuctionListing,
            | 'id'
            | 'title'
            | 'type'
            | 'auctionNumber'
            | 'detailUrl'
            | 'state'
            | 'price'
            | 'startDate'
            | 'endDate'
            | 'auctionedOn'
            | 'auctionDecreeUrl'
            | 'lat'
            | 'long'
            | 'createdAt'
            | 'photoUrl'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
              activityLogs: { __typename: 'UserActivityLogsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'UserActivityLog' } & Pick<
                      UserActivityLog,
                      'editedAt' | 'id' | 'nodeId' | 'actionType'
                    >
                  >
                >
              }
              linkedProperties: {
                __typename: 'AuctionPropertiesConnection'
              } & Pick<AuctionPropertiesConnection, 'totalCount'> & {
                  nodes?: Array<
                    Maybe<
                      { __typename: 'AuctionProperty' } & Pick<
                        AuctionProperty,
                        | 'id'
                        | 'auctionId'
                        | 'createdAt'
                        | 'propertyId'
                        | 'propertyName'
                        | 'propertyType'
                      >
                    >
                  >
                }
            }
        >
      >
    }
  >
}

export type FirstBpejByCodeQueryVariables = Exact<{
  kod: Scalars['String']
}>

export type FirstBpejByCodeQuery = { __typename: 'Query' } & {
  allBpejs?: Maybe<
    { __typename: 'BpejsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Bpej' } & Pick<
            Bpej,
            'cena' | 'platnostOd' | 'platnostDo' | 'popis'
          >
        >
      >
    }
  >
}

export type CreateBuybackCalculationMutationVariables = Exact<{
  buybackCalculation: BuybackCalculationInput
}>

export type CreateBuybackCalculationMutation = { __typename: 'Mutation' } & {
  createBuybackCalculation?: Maybe<
    { __typename: 'CreateBuybackCalculationPayload' } & {
      buybackCalculation?: Maybe<
        { __typename: 'BuybackCalculation' } & Pick<
          BuybackCalculation,
          'id' | 'accountId'
        >
      >
      query?: Maybe<
        { __typename: 'Query' } & {
          allBuybackCalculations?: Maybe<{
            __typename: 'BuybackCalculationsConnection'
          }>
        }
      >
    }
  >
}

export type AllBuybackCalculationsQueryVariables = Exact<{
  accountId: Scalars['UUID']
}>

export type AllBuybackCalculationsQuery = { __typename: 'Query' } & {
  allBuybackCalculations?: Maybe<
    { __typename: 'BuybackCalculationsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'BuybackCalculation' } & Pick<
            BuybackCalculation,
            | 'id'
            | 'accountId'
            | 'propertyId'
            | 'propertyType'
            | 'propertyName'
            | 'title'
            | 'description'
            | 'createdAt'
            | 'formData'
          >
        >
      >
    }
  >
}

export type CadastreMapAuctionQueryVariables = Exact<{
  filter: AuctionListingFilter
  accountUserId: Scalars['UUID']
}>

export type CadastreMapAuctionQuery = { __typename: 'Query' } & {
  allAuctionListings?: Maybe<
    { __typename: 'AuctionListingsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'AuctionListing' } & Pick<
            AuctionListing,
            | 'id'
            | 'title'
            | 'type'
            | 'state'
            | 'price'
            | 'startDate'
            | 'endDate'
            | 'updatedAt'
            | 'auctionedOn'
            | 'lat'
            | 'long'
            | 'createdAt'
          > & {
              activityLogs: { __typename: 'UserActivityLogsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'UserActivityLog' } & Pick<
                      UserActivityLog,
                      'editedAt' | 'id' | 'nodeId' | 'actionType'
                    >
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type AuctionListingsStatsQueryVariables = Exact<{
  now: Scalars['Datetime']
  newTreshold: Scalars['Datetime']
}>

export type AuctionListingsStatsQuery = { __typename: 'Query' } & {
  new?: Maybe<
    { __typename: 'AuctionListingsConnection' } & Pick<
      AuctionListingsConnection,
      'totalCount'
    >
  >
  upcoming?: Maybe<
    { __typename: 'AuctionListingsConnection' } & Pick<
      AuctionListingsConnection,
      'totalCount'
    >
  >
}

export type RecipientListByIdQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type RecipientListByIdQuery = { __typename: 'Query' } & {
  recipientListById?: Maybe<
    { __typename: 'RecipientList' } & Pick<RecipientList, 'nazev'> & {
        recipientListRecipientsByRecipientListId: {
          __typename: 'RecipientListRecipientsConnection'
        } & {
          nodes: Array<
            Maybe<
              { __typename: 'RecipientListRecipient' } & Pick<
                RecipientListRecipient,
                'id' | 'propertyName' | 'propertyType'
              > & {
                  recipientByRecipientId?: Maybe<
                    { __typename: 'Recipient' } & Pick<
                      Recipient,
                      | 'id'
                      | 'krestnijmeno'
                      | 'osloveni'
                      | 'pohlavi'
                      | 'nazev'
                      | 'prijmeni'
                      | 'titulpred'
                      | 'titulza'
                    > & {
                        addressByAdresnimistokod?: Maybe<
                          { __typename: 'Address' } & Pick<
                            Address,
                            | 'castobce'
                            | 'cislodomovni'
                            | 'cisloorientacni'
                            | 'cisloorientacnipismeno'
                            | 'kraj'
                            | 'obec'
                            | 'okres'
                            | 'psc'
                            | 'typbudovy'
                            | 'ulice'
                          >
                        >
                      }
                  >
                }
            >
          >
        }
      }
  >
}

export type CreateMonitoringCeeMutationVariables = Exact<{
  input: CreateMonitoringCeeInput
}>

export type CreateMonitoringCeeMutation = { __typename: 'Mutation' } & {
  createMonitoringCee?: Maybe<
    { __typename: 'CreateMonitoringCeePayload' } & {
      monitoringCee?: Maybe<
        { __typename: 'MonitoringCee' } & Pick<MonitoringCee, 'id'>
      >
      query?: Maybe<
        { __typename: 'Query' } & {
          allMonitoringCees?: Maybe<{ __typename: 'MonitoringCeesConnection' }>
        }
      >
    }
  >
}

export type DeleteMonitoringCeeMutationVariables = Exact<{
  input: DeleteMonitoringCeeByIdInput
}>

export type DeleteMonitoringCeeMutation = { __typename: 'Mutation' } & {
  deleteMonitoringCeeById?: Maybe<
    { __typename: 'DeleteMonitoringCeePayload' } & Pick<
      DeleteMonitoringCeePayload,
      'deletedMonitoringCeeId'
    >
  >
}

export type CeeMonitoringTableQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['UUID']>
  filter?: InputMaybe<MonitoringCeeFilter>
}>

export type CeeMonitoringTableQuery = { __typename: 'Query' } & {
  allMonitoringCees?: Maybe<
    { __typename: 'MonitoringCeesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'MonitoringCee' } & Pick<
            MonitoringCee,
            | 'id'
            | 'accountId'
            | 'accountUserId'
            | 'createdAt'
            | 'editedAt'
            | 'birthDate'
            | 'executionCount'
            | 'firstname'
            | 'ico'
            | 'lastname'
            | 'note'
            | 'rc'
            | 'errorState'
            | 'found'
            | 'checkFrequency'
            | 'lastCheck'
            | 'validatedCode'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
              monitoringCuzkRcsByMonitoringCeeId: {
                __typename: 'MonitoringCuzkRcsConnection'
              } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'MonitoringCuzkRc' } & Pick<
                      MonitoringCuzkRc,
                      | 'found'
                      | 'checkFrequency'
                      | 'lastCheck'
                      | 'id'
                      | 'cuzkOsId'
                    >
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type CuzkOByIdQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type CuzkOByIdQuery = { __typename: 'Query' } & {
  cuzkOById?: Maybe<
    { __typename: 'CuzkO' } & Pick<
      CuzkO,
      | 'id'
      | 'castobcenazev'
      | 'cislodomovni'
      | 'cisloorientacni'
      | 'charostype'
      | 'doplnekico'
      | 'ico'
      | 'jmeno'
      | 'lastCheck'
      | 'mestskacastnazev'
      | 'mestskyobvodnazev'
      | 'nazev'
      | 'obecnazev'
      | 'okresnazev'
      | 'prijmeni'
      | 'psc'
      | 'rc'
      | 'rczkracene'
      | 'statnazev'
      | 'titulpred'
      | 'titulza'
      | 'typcpce'
      | 'ulice'
      | 'vlastniktyp'
      | 'partner1'
      | 'partner2'
    >
  >
}

export type CeeMonitorTableExpandedRowQueryVariables = Exact<{
  monitoringCeeId: Scalars['UUID']
}>

export type CeeMonitorTableExpandedRowQuery = { __typename: 'Query' } & {
  allCeeExecutions?: Maybe<
    { __typename: 'CeeExecutionsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'CeeExecution' } & Pick<
            CeeExecution,
            | 'address'
            | 'birthDate'
            | 'ceeEvent'
            | 'detailCode'
            | 'executionDate'
            | 'updateDate'
            | 'fullname'
            | 'ico'
            | 'id'
            | 'identificationCode'
            | 'rc'
            | 'spzn'
            | 'createdAt'
          > & {
              ceeOfficeByExecutorCode?: Maybe<
                { __typename: 'CeeOffice' } & Pick<
                  CeeOffice,
                  | 'address'
                  | 'area'
                  | 'databox'
                  | 'dic'
                  | 'email'
                  | 'ico'
                  | 'name'
                  | 'note'
                  | 'phone'
                  | 'web'
                  | 'executorCode'
                >
              >
              ceeDetails: { __typename: 'CeeExecutionDetailsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'CeeExecutionDetail' } & Pick<
                      CeeExecutionDetail,
                      | 'nodeId'
                      | 'castka'
                      | 'createdAt'
                      | 'datum'
                      | 'exekutorskyUrad'
                      | 'id'
                      | 'nepenezitaPovinost'
                      | 'povinnaOsoba'
                      | 'pravidelnaSplatka'
                      | 'soud'
                      | 'spznExekutora'
                      | 'spznSoudu'
                      | 'titul'
                    >
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type CreateRecipientListMutationVariables = Exact<{
  input: CreateRecipientListInput
}>

export type CreateRecipientListMutation = { __typename: 'Mutation' } & {
  createRecipientList?: Maybe<
    { __typename: 'CreateRecipientListPayload' } & {
      recipientList?: Maybe<
        { __typename: 'RecipientList' } & Pick<RecipientList, 'id'>
      >
    }
  >
}

export type UpdateInitialRecipientListMutationVariables = Exact<{
  id: Scalars['UUID']
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  description?: InputMaybe<Scalars['String']>
  nazev?: InputMaybe<Scalars['String']>
  senderAddressId?: InputMaybe<Scalars['UUID']>
  temporaryRecipientsJson?: InputMaybe<Scalars['String']>
}>

export type UpdateInitialRecipientListMutation = { __typename: 'Mutation' } & {
  updateRecipientListById?: Maybe<
    { __typename: 'UpdateRecipientListPayload' } & {
      recipientList?: Maybe<
        { __typename: 'RecipientList' } & Pick<RecipientList, 'id'>
      >
    }
  >
}

export type AllSenderAddressesQueryVariables = Exact<{
  accountId: Scalars['UUID']
}>

export type AllSenderAddressesQuery = { __typename: 'Query' } & {
  allSenderAddresses?: Maybe<
    { __typename: 'SenderAddressesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'SenderAddress' } & Pick<
            SenderAddress,
            | 'senderName'
            | 'city'
            | 'houseNumber'
            | 'id'
            | 'orientationNumber'
            | 'street'
            | 'zipCode'
            | 'templateName'
          >
        >
      >
    }
  >
}

export type CreateSenderAddressMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  city: Scalars['String']
  houseNumber?: InputMaybe<Scalars['String']>
  orientationNumber?: InputMaybe<Scalars['String']>
  senderName: Scalars['String']
  street: Scalars['String']
  zipCode: Scalars['String']
  isTemplate?: InputMaybe<Scalars['Boolean']>
  templateName?: InputMaybe<Scalars['String']>
}>

export type CreateSenderAddressMutation = { __typename: 'Mutation' } & {
  createSenderAddress?: Maybe<
    { __typename: 'CreateSenderAddressPayload' } & {
      senderAddress?: Maybe<
        { __typename: 'SenderAddress' } & Pick<SenderAddress, 'id'>
      >
    }
  >
}

export type CuzkDocumentCollectionTableQueryVariables = Exact<{
  accountId: Scalars['UUID']
  oneDayAgo?: InputMaybe<Scalars['Datetime']>
  idFilter?: InputMaybe<UuidFilter>
}>

export type CuzkDocumentCollectionTableQuery = { __typename: 'Query' } & {
  allCuzkDocumentCollections?: Maybe<
    { __typename: 'CuzkDocumentCollectionsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'CuzkDocumentCollection' } & Pick<
            CuzkDocumentCollection,
            | 'id'
            | 'cuzkCollectionId'
            | 'cuzkDocumentId'
            | 'accountId'
            | 'accountUserId'
            | 'casoveraziko'
            | 'cena'
            | 'createdAt'
            | 'datumpozadavku'
            | 'datumspusteni'
            | 'datumvytvoreni'
            | 'elznacka'
            | 'format'
            | 'nazev'
            | 'pocetjednotek'
            | 'pocetstran'
            | 'rizeni'
            | 'stav'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type CuzkEpoDetailQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type CuzkEpoDetailQuery = { __typename: 'Query' } & {
  cuzkEpoById?: Maybe<
    { __typename: 'CuzkEpo' } & Pick<
      CuzkEpo,
      | 'createdAt'
      | 'nazev'
      | 'pocetLv'
      | 'rcIco'
      | 'typ'
      | 'format'
      | 'adresnimistokod'
    >
  >
}

export type CuzkEpoTableQueryVariables = Exact<{
  accountId: Scalars['UUID']
  oneDayAgo?: InputMaybe<Scalars['Datetime']>
  idFilter?: InputMaybe<UuidFilter>
}>

export type CuzkEpoTableQuery = { __typename: 'Query' } & {
  allCuzkEpos?: Maybe<
    { __typename: 'CuzkEposConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'CuzkEpo' } & Pick<
            CuzkEpo,
            | 'cena'
            | 'createdAt'
            | 'datumpozadavku'
            | 'datumspusteni'
            | 'datumvytvoreni'
            | 'elznacka'
            | 'format'
            | 'id'
            | 'cuzkCollectionId'
            | 'nazev'
            | 'pocetjednotek'
            | 'pocetstran'
            | 'pocetLv'
            | 'rcIco'
            | 'stav'
            | 'typ'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type BpejByCodeQueryVariables = Exact<{
  in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>

export type BpejByCodeQuery = { __typename: 'Query' } & {
  allBpejs?: Maybe<
    { __typename: 'BpejsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Bpej' } & Pick<
            Bpej,
            'id' | 'cena' | 'popis' | 'platnostOd' | 'platnostDo' | 'kod'
          >
        >
      >
    }
  >
}

export type CeeOfficeByNameQueryVariables = Exact<{
  startsWith: Scalars['String']
}>

export type CeeOfficeByNameQuery = { __typename: 'Query' } & {
  allCeeOffices?: Maybe<
    { __typename: 'CeeOfficesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'CeeOffice' } & Pick<
            CeeOffice,
            | 'id'
            | 'address'
            | 'area'
            | 'databox'
            | 'dic'
            | 'email'
            | 'ico'
            | 'name'
            | 'note'
            | 'phone'
            | 'web'
            | 'executorCode'
          >
        >
      >
    }
  >
}

export type CuzkLvTableQueryVariables = Exact<{
  accountId: Scalars['UUID']
  oneDayAgo?: InputMaybe<Scalars['Datetime']>
  idFilter?: InputMaybe<UuidFilter>
}>

export type CuzkLvTableQuery = { __typename: 'Query' } & {
  allCuzkLvs?: Maybe<
    { __typename: 'CuzkLvsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'CuzkLv' } & Pick<
            CuzkLv,
            | 'id'
            | 'cena'
            | 'createdAt'
            | 'datumpozadavku'
            | 'datumspusteni'
            | 'datumvytvoreni'
            | 'elznacka'
            | 'format'
            | 'lv'
            | 'katastralniUzemiKod'
            | 'katastralniUzemiNazev'
            | 'obec'
            | 'datumK'
            | 'cuzkCollectionId'
            | 'pocetjednotek'
            | 'pocetstran'
            | 'stav'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type AllLabelsQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['UUID']>
}>

export type AllLabelsQuery = { __typename: 'Query' } & {
  allLabels?: Maybe<
    { __typename: 'LabelsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Label' } & Pick<
            Label,
            'name' | 'description' | 'id' | 'colorKey' | 'iconKey' | 'createdAt'
          >
        >
      >
    }
  >
}

export type CreateLabelMutationVariables = Exact<{
  input: CreateLabelInput
}>

export type CreateLabelMutation = { __typename: 'Mutation' } & {
  createLabel?: Maybe<
    { __typename: 'CreateLabelPayload' } & Pick<
      CreateLabelPayload,
      'clientMutationId'
    > & {
        label?: Maybe<
          { __typename: 'Label' } & Pick<Label, 'id' | 'name' | 'description'>
        >
      }
  >
}

export type CreateMonitoringCuzkRcMutationVariables = Exact<{
  input: CreateMonitoringCuzkRcInput
}>

export type CreateMonitoringCuzkRcMutation = { __typename: 'Mutation' } & {
  createMonitoringCuzkRc?: Maybe<
    { __typename: 'CreateMonitoringCuzkRcPayload' } & {
      monitoringCuzkRc?: Maybe<
        { __typename: 'MonitoringCuzkRc' } & Pick<MonitoringCuzkRc, 'id'>
      >
    }
  >
}

export type CreateMonitoringCuzkRcLabelMutationVariables = Exact<{
  input: CreateLabelMonitoringCuzkRcInput
}>

export type CreateMonitoringCuzkRcLabelMutation = { __typename: 'Mutation' } & {
  createLabelMonitoringCuzkRc?: Maybe<
    { __typename: 'CreateLabelMonitoringCuzkRcPayload' } & Pick<
      CreateLabelMonitoringCuzkRcPayload,
      'clientMutationId'
    >
  >
}

export type DeleteMonitoringCuzkRcLabelMutationVariables = Exact<{
  input: DeleteLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcIdInput
}>

export type DeleteMonitoringCuzkRcLabelMutation = { __typename: 'Mutation' } & {
  deleteLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcId?: Maybe<
    { __typename: 'DeleteLabelMonitoringCuzkRcPayload' } & Pick<
      DeleteLabelMonitoringCuzkRcPayload,
      'clientMutationId'
    >
  >
}

export type DeleteMonitoringCuzkRcMutationVariables = Exact<{
  input: DeleteMonitoringCuzkRcByIdInput
}>

export type DeleteMonitoringCuzkRcMutation = { __typename: 'Mutation' } & {
  deleteMonitoringCuzkRcById?: Maybe<
    { __typename: 'DeleteMonitoringCuzkRcPayload' } & Pick<
      DeleteMonitoringCuzkRcPayload,
      'clientMutationId'
    >
  >
}

export type AllMonitoringCuzkRcsQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['UUID']>
  filter?: InputMaybe<MonitoringCuzkRcFilter>
}>

export type AllMonitoringCuzkRcsQuery = { __typename: 'Query' } & {
  allMonitoringCuzkRcs?: Maybe<
    { __typename: 'MonitoringCuzkRcsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'MonitoringCuzkRc' } & Pick<
            MonitoringCuzkRc,
            | 'id'
            | 'found'
            | 'editedAt'
            | 'firstname'
            | 'lastname'
            | 'birthDate'
            | 'description'
            | 'cuzkOsId'
            | 'createdAt'
            | 'checkFrequency'
            | 'accountUserId'
            | 'accountId'
            | 'lastCheck'
            | 'validatedCode'
            | 'ico'
            | 'rc'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
              cuzkOByCuzkOsId?: Maybe<
                { __typename: 'CuzkO' } & Pick<
                  CuzkO,
                  | 'id'
                  | 'castobcenazev'
                  | 'cislodomovni'
                  | 'cisloorientacni'
                  | 'charostype'
                  | 'doplnekico'
                  | 'ico'
                  | 'jmeno'
                  | 'lastCheck'
                  | 'mestskacastnazev'
                  | 'mestskyobvodnazev'
                  | 'nazev'
                  | 'obecnazev'
                  | 'okresnazev'
                  | 'prijmeni'
                  | 'psc'
                  | 'rc'
                  | 'rczkracene'
                  | 'statnazev'
                  | 'titulpred'
                  | 'titulza'
                  | 'typcpce'
                  | 'ulice'
                  | 'vlastniktyp'
                  | 'partner1'
                  | 'partner2'
                >
              >
            }
        >
      >
    }
  >
}

export type CuzkMonitorRcTableExpandedRowQueryVariables = Exact<{
  partnerId?: InputMaybe<Scalars['UUID']>
}>

export type CuzkMonitorRcTableExpandedRowQuery = { __typename: 'Query' } & {
  allCuzkOs?: Maybe<
    { __typename: 'CuzkOsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'CuzkO' } & Pick<
            CuzkO,
            | 'id'
            | 'castobcenazev'
            | 'cislodomovni'
            | 'cisloorientacni'
            | 'charostype'
            | 'doplnekico'
            | 'ico'
            | 'jmeno'
            | 'lastCheck'
            | 'mestskacastnazev'
            | 'mestskyobvodnazev'
            | 'nazev'
            | 'obecnazev'
            | 'okresnazev'
            | 'prijmeni'
            | 'psc'
            | 'rc'
            | 'rczkracene'
            | 'statnazev'
            | 'titulpred'
            | 'titulza'
            | 'typcpce'
            | 'ulice'
            | 'vlastniktyp'
            | 'partner1'
            | 'partner2'
          > & {
              cuzkOByPartner1?: Maybe<
                { __typename: 'CuzkO' } & Pick<
                  CuzkO,
                  | 'id'
                  | 'castobcenazev'
                  | 'cislodomovni'
                  | 'cisloorientacni'
                  | 'charostype'
                  | 'doplnekico'
                  | 'ico'
                  | 'jmeno'
                  | 'lastCheck'
                  | 'mestskacastnazev'
                  | 'mestskyobvodnazev'
                  | 'nazev'
                  | 'obecnazev'
                  | 'okresnazev'
                  | 'prijmeni'
                  | 'psc'
                  | 'rc'
                  | 'rczkracene'
                  | 'statnazev'
                  | 'titulpred'
                  | 'titulza'
                  | 'typcpce'
                  | 'ulice'
                  | 'vlastniktyp'
                  | 'partner1'
                  | 'partner2'
                >
              >
              cuzkOByPartner2?: Maybe<
                { __typename: 'CuzkO' } & Pick<
                  CuzkO,
                  | 'id'
                  | 'castobcenazev'
                  | 'cislodomovni'
                  | 'cisloorientacni'
                  | 'charostype'
                  | 'doplnekico'
                  | 'ico'
                  | 'jmeno'
                  | 'lastCheck'
                  | 'mestskacastnazev'
                  | 'mestskyobvodnazev'
                  | 'nazev'
                  | 'obecnazev'
                  | 'okresnazev'
                  | 'prijmeni'
                  | 'psc'
                  | 'rc'
                  | 'rczkracene'
                  | 'statnazev'
                  | 'titulpred'
                  | 'titulza'
                  | 'typcpce'
                  | 'ulice'
                  | 'vlastniktyp'
                  | 'partner1'
                  | 'partner2'
                >
              >
            }
        >
      >
    }
  >
}

export type DataBoxDetailQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type DataBoxDetailQuery = { __typename: 'Query' } & {
  databoxById?: Maybe<
    { __typename: 'Databox' } & Pick<
      Databox,
      | 'fulladdress'
      | 'databoxid'
      | 'firstname'
      | 'fullname'
      | 'adresnimistokod'
      | 'birthname'
      | 'businessname'
      | 'ico'
      | 'idovm'
      | 'ismaster'
      | 'masterid'
      | 'lastname'
      | 'middlename'
      | 'ovm'
      | 'pdz'
      | 'subtype'
      | 'type'
    >
  >
}

export type SubDataBoxDetailQueryVariables = Exact<{
  masterid?: InputMaybe<Scalars['String']>
}>

export type SubDataBoxDetailQuery = { __typename: 'Query' } & {
  allDataboxes?: Maybe<
    { __typename: 'DataboxesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Databox' } & Pick<
            Databox,
            | 'id'
            | 'fulladdress'
            | 'databoxid'
            | 'firstname'
            | 'fullname'
            | 'adresnimistokod'
            | 'birthname'
            | 'businessname'
            | 'ico'
            | 'idovm'
            | 'lastname'
            | 'middlename'
            | 'ovm'
            | 'pdz'
            | 'subtype'
            | 'type'
          >
        >
      >
    }
  >
}

export type DataBoxSearchBarQueryVariables = Exact<{
  filter?: InputMaybe<DataboxFilter>
  first?: InputMaybe<Scalars['Int']>
}>

export type DataBoxSearchBarQuery = { __typename: 'Query' } & {
  allDataboxes?: Maybe<
    { __typename: 'DataboxesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Databox' } & Pick<
            Databox,
            | 'fulladdress'
            | 'databoxid'
            | 'firstname'
            | 'fullname'
            | 'adresnimistokod'
            | 'birthname'
            | 'businessname'
            | 'ico'
            | 'idovm'
            | 'ismaster'
            | 'masterid'
            | 'lastname'
            | 'middlename'
            | 'ovm'
            | 'pdz'
            | 'subtype'
            | 'type'
            | 'id'
          >
        >
      >
    }
  >
}

export type KuWorkplaceByKodQueryVariables = Exact<{
  kod: Scalars['String']
}>

export type KuWorkplaceByKodQuery = { __typename: 'Query' } & {
  kuWorkplaceByKod?: Maybe<
    { __typename: 'KuWorkplace' } & Pick<
      KuWorkplace,
      | 'castObce'
      | 'cisloDomovni'
      | 'cisloOrientacni'
      | 'email'
      | 'ico'
      | 'mestskaCast'
      | 'nazev'
      | 'nazevUlice'
      | 'nazevZkraceny'
      | 'obec'
      | 'okres'
      | 'psc'
      | 'telefon'
      | 'zkratka'
      | 'web'
    >
  >
}

export type LabelOverviewQueryVariables = Exact<{
  labelId: Scalars['UUID']
}>

export type LabelOverviewQuery = { __typename: 'Query' } & {
  labelById?: Maybe<
    { __typename: 'Label' } & Pick<
      Label,
      'id' | 'iconKey' | 'colorKey' | 'description' | 'createdAt' | 'name'
    > & {
        labelConnectionsByLabelId: {
          __typename: 'LabelConnectionsConnection'
        } & Pick<LabelConnectionsConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename: 'LabelConnection' } & Pick<
                  LabelConnection,
                  | 'cuzkDocumentCollectionId'
                  | 'cuzkLvId'
                  | 'cuzkEpoId'
                  | 'cuzkEpoLienId'
                  | 'monitId'
                  | 'marketplaceOfferId'
                  | 'monitoringCeeId'
                  | 'monitoringCuzkRcId'
                  | 'postserviceListId'
                  | 'propertyLabelId'
                  | 'auctionListingId'
                >
              >
            >
          }
      }
  >
}

export type DeleteLabelMutationVariables = Exact<{
  id: Scalars['UUID']
}>

export type DeleteLabelMutation = { __typename: 'Mutation' } & {
  deleteLabelById?: Maybe<
    { __typename: 'DeleteLabelPayload' } & {
      label?: Maybe<{ __typename: 'Label' } & Pick<Label, 'name'>>
      query?: Maybe<
        { __typename: 'Query' } & {
          allLabels?: Maybe<{ __typename: 'LabelsConnection' }>
        }
      >
    }
  >
}

export type LabelTableQueryVariables = Exact<{
  accountId: Scalars['UUID']
}>

export type LabelTableQuery = { __typename: 'Query' } & {
  allLabels?: Maybe<
    { __typename: 'LabelsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Label' } & Pick<
            Label,
            | 'name'
            | 'id'
            | 'iconKey'
            | 'editedAt'
            | 'description'
            | 'createdAt'
            | 'colorKey'
          > & {
              labelConnectionsByLabelId: {
                __typename: 'LabelConnectionsConnection'
              } & Pick<LabelConnectionsConnection, 'totalCount'>
            }
        >
      >
    }
  >
}

export type KuWorkplaceByAreaCodeQueryVariables = Exact<{
  kuKod?: InputMaybe<Scalars['String']>
}>

export type KuWorkplaceByAreaCodeQuery = { __typename: 'Query' } & {
  allKuAreas?: Maybe<
    { __typename: 'KuAreasConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'KuArea' } & {
            kuWorkplaceByPraresKod?: Maybe<
              { __typename: 'KuWorkplace' } & Pick<
                KuWorkplace,
                | 'castObce'
                | 'cisloDomovni'
                | 'cisloOrientacni'
                | 'email'
                | 'ico'
                | 'mestskaCast'
                | 'nazev'
                | 'nazevUlice'
                | 'nazevZkraceny'
                | 'obec'
                | 'okres'
                | 'psc'
                | 'telefon'
                | 'zkratka'
                | 'web'
                | 'kod'
              >
            >
          }
        >
      >
    }
  >
}

export type CreateMarketplaceOfferMutationVariables = Exact<{
  id: Scalars['UUID']
  offerType: Scalars['String']
  title: Scalars['String']
  description?: InputMaybe<Scalars['String']>
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  contactDescription?: InputMaybe<Scalars['String']>
  contactEmail: Scalars['String']
  contactName: Scalars['String']
  contactPhone: Scalars['String']
  expirationDate: Scalars['Datetime']
  images?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >
  interestAmount: Scalars['BigFloat']
  investmentAmount: Scalars['BigFloat']
  monthlyPayment: Scalars['BigFloat']
  offerLocation: Scalars['String']
  propertyValue: Scalars['BigFloat']
}>

export type CreateMarketplaceOfferMutation = { __typename: 'Mutation' } & {
  createMarketplaceOffer?: Maybe<
    { __typename: 'CreateMarketplaceOfferPayload' } & Pick<
      CreateMarketplaceOfferPayload,
      'clientMutationId'
    >
  >
}

export type MunicipalOfficeNameByAdresnimistokodQueryVariables = Exact<{
  adresnimistokod: Scalars['String']
}>

export type MunicipalOfficeNameByAdresnimistokodQuery = {
  __typename: 'Query'
} & {
  municipalOfficeByAdresnimistokod?: Maybe<
    { __typename: 'MunicipalOffice' } & Pick<
      MunicipalOffice,
      'adresnimistokod' | 'officeName'
    >
  >
}

export type UpdatePostserviceRecipientMutationVariables = Exact<{
  id: Scalars['UUID']
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
  city: Scalars['String']
  companyName?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  firstname: Scalars['String']
  gender?: InputMaybe<Scalars['String']>
  houseNumber: Scalars['String']
  lastname: Scalars['String']
  callName?: InputMaybe<Scalars['String']>
  orientationNumber?: InputMaybe<Scalars['String']>
  street: Scalars['String']
  zipCode: Scalars['String']
  addressId?: InputMaybe<Scalars['String']>
  variable1?: InputMaybe<Scalars['String']>
  variable2?: InputMaybe<Scalars['String']>
  variable3?: InputMaybe<Scalars['String']>
  variable4?: InputMaybe<Scalars['String']>
  variable5?: InputMaybe<Scalars['String']>
  variable7?: InputMaybe<Scalars['String']>
  variable6?: InputMaybe<Scalars['String']>
  variable8?: InputMaybe<Scalars['String']>
  variable9?: InputMaybe<Scalars['String']>
  variable10?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyType?: InputMaybe<Scalars['String']>
  propertyLv?: InputMaybe<Scalars['String']>
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  propertyCadastralName?: InputMaybe<Scalars['String']>
  propertyCity?: InputMaybe<Scalars['String']>
  propertyAddress?: InputMaybe<Scalars['String']>
  propertyAreaNumber?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
}>

export type UpdatePostserviceRecipientMutation = { __typename: 'Mutation' } & {
  updatePostserviceRecipientById?: Maybe<
    { __typename: 'UpdatePostserviceRecipientPayload' } & {
      postserviceRecipient?: Maybe<
        { __typename: 'PostserviceRecipient' } & Pick<
          PostserviceRecipient,
          'id'
        >
      >
    }
  >
}

export type CreatePostserviceRecipientMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  postserviceListId: Scalars['UUID']
  companyName?: InputMaybe<Scalars['String']>
  uniquePersonKey?: InputMaybe<Scalars['String']>
  firstname: Scalars['String']
  lastname: Scalars['String']
  callName?: InputMaybe<Scalars['String']>
  gender?: InputMaybe<Scalars['String']>
  street: Scalars['String']
  houseNumber: Scalars['String']
  orientationNumber?: InputMaybe<Scalars['String']>
  city: Scalars['String']
  addressId?: InputMaybe<Scalars['String']>
  zipCode: Scalars['String']
  country: Scalars['String']
  variable1?: InputMaybe<Scalars['String']>
  variable2?: InputMaybe<Scalars['String']>
  variable3?: InputMaybe<Scalars['String']>
  variable4?: InputMaybe<Scalars['String']>
  variable5?: InputMaybe<Scalars['String']>
  variable7?: InputMaybe<Scalars['String']>
  variable6?: InputMaybe<Scalars['String']>
  variable8?: InputMaybe<Scalars['String']>
  variable9?: InputMaybe<Scalars['String']>
  variable10?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyType?: InputMaybe<Scalars['String']>
  propertyLv?: InputMaybe<Scalars['String']>
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  propertyCadastralName?: InputMaybe<Scalars['String']>
  propertyCity?: InputMaybe<Scalars['String']>
  propertyAddress?: InputMaybe<Scalars['String']>
  propertyAreaNumber?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
}>

export type CreatePostserviceRecipientMutation = { __typename: 'Mutation' } & {
  createPostserviceRecipient?: Maybe<
    { __typename: 'CreatePostserviceRecipientPayload' } & {
      postserviceRecipient?: Maybe<
        { __typename: 'PostserviceRecipient' } & Pick<
          PostserviceRecipient,
          'id'
        > & {
            postserviceListByPostserviceListId?: Maybe<
              { __typename: 'PostserviceList' } & Pick<PostserviceList, 'id'>
            >
          }
      >
    }
  >
}

export type CreatePostserviceListMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  listName: Scalars['String']
  description?: InputMaybe<Scalars['String']>
}>

export type CreatePostserviceListMutation = { __typename: 'Mutation' } & {
  createPostserviceList?: Maybe<
    { __typename: 'CreatePostserviceListPayload' } & {
      postserviceList?: Maybe<
        { __typename: 'PostserviceList' } & Pick<PostserviceList, 'id'>
      >
    }
  >
}

export type EditPostserviceListMutationVariables = Exact<{
  listName: Scalars['String']
  description?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}>

export type EditPostserviceListMutation = { __typename: 'Mutation' } & {
  updatePostserviceListById?: Maybe<
    { __typename: 'UpdatePostserviceListPayload' } & Pick<
      UpdatePostserviceListPayload,
      'clientMutationId'
    >
  >
}

export type PostserviceRecipientsByListIdQueryVariables = Exact<{
  postserviceListId: Scalars['UUID']
}>

export type PostserviceRecipientsByListIdQuery = { __typename: 'Query' } & {
  recipients?: Maybe<
    { __typename: 'PostserviceRecipientsConnection' } & Pick<
      PostserviceRecipientsConnection,
      'totalCount'
    > & {
        nodes: Array<
          Maybe<
            { __typename: 'PostserviceRecipient' } & Pick<
              PostserviceRecipient,
              | 'accountId'
              | 'accountUserId'
              | 'city'
              | 'companyName'
              | 'country'
              | 'gender'
              | 'houseNumber'
              | 'id'
              | 'firstname'
              | 'lastname'
              | 'callName'
              | 'orientationNumber'
              | 'postserviceListId'
              | 'addressId'
              | 'uniquePersonKey'
              | 'street'
              | 'variable1'
              | 'variable10'
              | 'variable2'
              | 'variable3'
              | 'variable4'
              | 'variable5'
              | 'variable6'
              | 'variable7'
              | 'variable8'
              | 'variable9'
              | 'zipCode'
              | 'propertyId'
              | 'propertyType'
              | 'propertyLv'
              | 'propertyCadastralCode'
              | 'propertyCadastralName'
              | 'propertyCity'
              | 'propertyAddress'
              | 'propertyAreaNumber'
              | 'propertyName'
            >
          >
        >
      }
  >
}

export type PostserviceTemplateByIdQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type PostserviceTemplateByIdQuery = { __typename: 'Query' } & {
  template?: Maybe<
    { __typename: 'PostserviceTemplate' } & Pick<
      PostserviceTemplate,
      'id' | 'name' | 'content' | 'description'
    >
  >
}

export type DeletePostserviceRecipientByIdMutationVariables = Exact<{
  id: Scalars['UUID']
}>

export type DeletePostserviceRecipientByIdMutation = {
  __typename: 'Mutation'
} & {
  deletePostserviceRecipientById?: Maybe<
    { __typename: 'DeletePostserviceRecipientPayload' } & {
      postserviceListByPostserviceListId?: Maybe<
        { __typename: 'PostserviceList' } & Pick<PostserviceList, 'id'>
      >
    }
  >
}

export type PostServiceRecipientListTableQueryVariables = Exact<{
  accountId: Scalars['UUID']
  idFilter?: InputMaybe<UuidFilter>
}>

export type PostServiceRecipientListTableQuery = { __typename: 'Query' } & {
  allPostserviceLists?: Maybe<
    { __typename: 'PostserviceListsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PostserviceList' } & Pick<
            PostserviceList,
            'createdAt' | 'description' | 'id' | 'listName'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
              recipients: {
                __typename: 'PostserviceRecipientsConnection'
              } & Pick<PostserviceRecipientsConnection, 'totalCount'>
              letters: {
                __typename: 'PostserviceSentLettersConnection'
              } & Pick<PostserviceSentLettersConnection, 'totalCount'>
            }
        >
      >
    }
  >
}

export type PostserviceListNameQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type PostserviceListNameQuery = { __typename: 'Query' } & {
  postserviceListById?: Maybe<
    { __typename: 'PostserviceList' } & Pick<PostserviceList, 'listName'>
  >
}

export type DeletePostServiceRecipientListMutationVariables = Exact<{
  id: Scalars['UUID']
  deletedAt?: InputMaybe<Scalars['Datetime']>
}>

export type DeletePostServiceRecipientListMutation = {
  __typename: 'Mutation'
} & {
  updatePostserviceListById?: Maybe<
    { __typename: 'UpdatePostserviceListPayload' } & {
      postserviceList?: Maybe<
        { __typename: 'PostserviceList' } & Pick<PostserviceList, 'id'>
      >
    }
  >
}

export type PostserviceRecipientTableQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type PostserviceRecipientTableQuery = { __typename: 'Query' } & {
  postserviceListById?: Maybe<
    { __typename: 'PostserviceList' } & Pick<
      PostserviceList,
      'id' | 'listName'
    > & {
        postserviceRecipientsByPostserviceListId: {
          __typename: 'PostserviceRecipientsConnection'
        } & {
          nodes: Array<
            Maybe<
              { __typename: 'PostserviceRecipient' } & Pick<
                PostserviceRecipient,
                | 'id'
                | 'city'
                | 'companyName'
                | 'country'
                | 'createdAt'
                | 'firstname'
                | 'callName'
                | 'gender'
                | 'addressId'
                | 'houseNumber'
                | 'lastname'
                | 'orientationNumber'
                | 'street'
                | 'variable1'
                | 'variable10'
                | 'variable2'
                | 'variable3'
                | 'variable4'
                | 'variable5'
                | 'variable6'
                | 'variable7'
                | 'variable8'
                | 'variable9'
                | 'zipCode'
                | 'propertyId'
                | 'propertyType'
                | 'propertyLv'
                | 'propertyCadastralCode'
                | 'propertyCadastralName'
                | 'propertyCity'
                | 'propertyAddress'
                | 'propertyAreaNumber'
                | 'propertyName'
              >
            >
          >
        }
      }
  >
}

export type CreatePostserviceTemplateMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  content: Scalars['String']
  description: Scalars['String']
  name: Scalars['String']
}>

export type CreatePostserviceTemplateMutation = { __typename: 'Mutation' } & {
  createPostserviceTemplate?: Maybe<
    { __typename: 'CreatePostserviceTemplatePayload' } & {
      postserviceTemplate?: Maybe<
        { __typename: 'PostserviceTemplate' } & Pick<PostserviceTemplate, 'id'>
      >
    }
  >
}

export type CreatePostserviceSentLetterMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  content: Scalars['String']
  originalTemplateId?: InputMaybe<Scalars['UUID']>
  originalListId: Scalars['UUID']
  name?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  senderAddressId: Scalars['UUID']
}>

export type CreatePostserviceSentLetterMutation = { __typename: 'Mutation' } & {
  createPostserviceSentLetter?: Maybe<
    { __typename: 'CreatePostserviceSentLetterPayload' } & {
      postserviceSentLetter?: Maybe<
        { __typename: 'PostserviceSentLetter' } & Pick<
          PostserviceSentLetter,
          'id'
        >
      >
    }
  >
}

export type CreatePostserviceSentRecipientMutationVariables = Exact<{
  originalRecipientId?: InputMaybe<Scalars['UUID']>
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  sentLetterId?: InputMaybe<Scalars['UUID']>
  city: Scalars['String']
  companyName?: InputMaybe<Scalars['String']>
  country: Scalars['String']
  firstname: Scalars['String']
  gender?: InputMaybe<Scalars['String']>
  houseNumber: Scalars['String']
  lastname: Scalars['String']
  callName?: InputMaybe<Scalars['String']>
  orientationNumber?: InputMaybe<Scalars['String']>
  street: Scalars['String']
  uniquePersonKey?: InputMaybe<Scalars['String']>
  addressId?: InputMaybe<Scalars['String']>
  variable1?: InputMaybe<Scalars['String']>
  variable2?: InputMaybe<Scalars['String']>
  variable3?: InputMaybe<Scalars['String']>
  variable4?: InputMaybe<Scalars['String']>
  variable5?: InputMaybe<Scalars['String']>
  variable7?: InputMaybe<Scalars['String']>
  variable6?: InputMaybe<Scalars['String']>
  variable8?: InputMaybe<Scalars['String']>
  variable9?: InputMaybe<Scalars['String']>
  variable10?: InputMaybe<Scalars['String']>
  zipCode: Scalars['String']
  propertyId?: InputMaybe<Scalars['UUID']>
  propertyType?: InputMaybe<Scalars['String']>
  propertyLv?: InputMaybe<Scalars['String']>
  propertyCadastralCode?: InputMaybe<Scalars['String']>
  propertyCadastralName?: InputMaybe<Scalars['String']>
  propertyCity?: InputMaybe<Scalars['String']>
  propertyAddress?: InputMaybe<Scalars['String']>
  propertyAreaNumber?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
}>

export type CreatePostserviceSentRecipientMutation = {
  __typename: 'Mutation'
} & {
  createPostserviceSentRecipient?: Maybe<
    { __typename: 'CreatePostserviceSentRecipientPayload' } & Pick<
      CreatePostserviceSentRecipientPayload,
      'clientMutationId'
    >
  >
}

export type SentLetterPreviewQueryVariables = Exact<{
  letterId: Scalars['UUID']
  recipientId: Scalars['UUID']
}>

export type SentLetterPreviewQuery = { __typename: 'Query' } & {
  postserviceSentLetterById?: Maybe<
    { __typename: 'PostserviceSentLetter' } & Pick<
      PostserviceSentLetter,
      'postserviceType' | 'name' | 'description' | 'sentAt' | 'content'
    > & {
        postserviceSentRecipientsBySentLetterId: {
          __typename: 'PostserviceSentRecipientsConnection'
        } & {
          nodes: Array<
            Maybe<
              { __typename: 'PostserviceSentRecipient' } & Pick<
                PostserviceSentRecipient,
                | 'callName'
                | 'city'
                | 'companyName'
                | 'country'
                | 'createdAt'
                | 'firstname'
                | 'gender'
                | 'houseNumber'
                | 'lastname'
                | 'id'
                | 'orientationNumber'
                | 'originalRecipientId'
                | 'postserviceTrackingNumber'
                | 'street'
                | 'uniquePersonKey'
                | 'variable1'
                | 'variable10'
                | 'variable2'
                | 'variable3'
                | 'variable4'
                | 'variable5'
                | 'variable6'
                | 'variable7'
                | 'variable8'
                | 'variable9'
                | 'zipCode'
                | 'propertyId'
                | 'propertyType'
                | 'propertyLv'
                | 'propertyCadastralCode'
                | 'propertyCadastralName'
                | 'propertyCity'
                | 'propertyAddress'
                | 'propertyAreaNumber'
                | 'propertyName'
              >
            >
          >
        }
      }
  >
}

export type PostServiceSentTableQueryVariables = Exact<{
  accountId: Scalars['UUID']
  idFilter?: InputMaybe<UuidFilter>
}>

export type PostServiceSentTableQuery = { __typename: 'Query' } & {
  allRecipientLists?: Maybe<
    { __typename: 'RecipientListsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'RecipientList' } & Pick<
            RecipientList,
            | 'createdAt'
            | 'description'
            | 'dispatchDate'
            | 'letterText'
            | 'nazev'
            | 'id'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
              recipients: {
                __typename: 'RecipientListRecipientsConnection'
              } & Pick<RecipientListRecipientsConnection, 'totalCount'>
              senderAddress?: Maybe<
                { __typename: 'SenderAddress' } & Pick<
                  SenderAddress,
                  | 'city'
                  | 'houseNumber'
                  | 'id'
                  | 'orientationNumber'
                  | 'senderName'
                  | 'street'
                  | 'zipCode'
                >
              >
            }
        >
      >
    }
  >
}

export type PostserviceSentLettersQueryVariables = Exact<{
  accountId: Scalars['UUID']
  originalListId?: InputMaybe<UuidFilter>
}>

export type PostserviceSentLettersQuery = { __typename: 'Query' } & {
  allPostserviceSentLetters?: Maybe<
    { __typename: 'PostserviceSentLettersConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PostserviceSentLetter' } & Pick<
            PostserviceSentLetter,
            | 'content'
            | 'createdAt'
            | 'id'
            | 'name'
            | 'description'
            | 'sentAt'
            | 'postserviceType'
          > & {
              senderAddress?: Maybe<
                { __typename: 'SenderAddress' } & Pick<
                  SenderAddress,
                  | 'senderName'
                  | 'street'
                  | 'zipCode'
                  | 'orientationNumber'
                  | 'houseNumber'
                  | 'city'
                >
              >
              template?: Maybe<
                { __typename: 'PostserviceTemplate' } & Pick<
                  PostserviceTemplate,
                  'name' | 'id'
                >
              >
              recipients: {
                __typename: 'PostserviceSentRecipientsConnection'
              } & Pick<PostserviceSentRecipientsConnection, 'totalCount'>
            }
        >
      >
    }
  >
}

export type DeletePostserviceSentLetterByIdMutationVariables = Exact<{
  id: Scalars['UUID']
  deletedAt: Scalars['Datetime']
}>

export type DeletePostserviceSentLetterByIdMutation = {
  __typename: 'Mutation'
} & {
  updatePostserviceSentLetterById?: Maybe<
    { __typename: 'UpdatePostserviceSentLetterPayload' } & Pick<
      UpdatePostserviceSentLetterPayload,
      'clientMutationId'
    >
  >
}

export type DeleteRecipientListMutationVariables = Exact<{
  deletedAt?: InputMaybe<Scalars['Datetime']>
  id: Scalars['UUID']
}>

export type DeleteRecipientListMutation = { __typename: 'Mutation' } & {
  updateRecipientListById?: Maybe<
    { __typename: 'UpdateRecipientListPayload' } & Pick<
      UpdateRecipientListPayload,
      'clientMutationId'
    >
  >
}

export type PostServiceSentRecipientsQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type PostServiceSentRecipientsQuery = { __typename: 'Query' } & {
  recipientListById?: Maybe<
    { __typename: 'RecipientList' } & Pick<RecipientList, 'letterText'> & {
        recipientListRecipientsByRecipientListId: {
          __typename: 'RecipientListRecipientsConnection'
        } & {
          nodes: Array<
            Maybe<
              { __typename: 'RecipientListRecipient' } & Pick<
                RecipientListRecipient,
                'id' | 'propertyName' | 'propertyType' | 'propertyId'
              > & {
                  recipient?: Maybe<
                    { __typename: 'Recipient' } & Pick<
                      Recipient,
                      | 'id'
                      | 'krestnijmeno'
                      | 'osloveni'
                      | 'pohlavi'
                      | 'nazev'
                      | 'prijmeni'
                      | 'titulpred'
                      | 'titulza'
                    > & {
                        address?: Maybe<
                          { __typename: 'Address' } & Pick<
                            Address,
                            | 'id'
                            | 'budovaregestaid'
                            | 'castobce'
                            | 'cislodomovni'
                            | 'cisloorientacni'
                            | 'cisloorientacnipismeno'
                            | 'kraj'
                            | 'obec'
                            | 'okres'
                            | 'psc'
                            | 'typbudovy'
                            | 'ulice'
                            | 'radnice'
                          >
                        >
                      }
                  >
                }
            >
          >
        }
      }
  >
}

export type PostserviceSentLetterByIdQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type PostserviceSentLetterByIdQuery = { __typename: 'Query' } & {
  postserviceSentLetterById?: Maybe<
    { __typename: 'PostserviceSentLetter' } & Pick<
      PostserviceSentLetter,
      'content' | 'sentAt'
    > & {
        recipients: { __typename: 'PostserviceSentRecipientsConnection' } & {
          nodes: Array<
            Maybe<
              { __typename: 'PostserviceSentRecipient' } & Pick<
                PostserviceSentRecipient,
                | 'id'
                | 'companyName'
                | 'firstname'
                | 'lastname'
                | 'callName'
                | 'gender'
                | 'postserviceTrackingNumber'
                | 'postserviceId'
                | 'street'
                | 'orientationNumber'
                | 'houseNumber'
                | 'city'
                | 'zipCode'
                | 'country'
                | 'addressId'
                | 'variable1'
                | 'variable2'
                | 'variable3'
                | 'variable5'
                | 'variable4'
                | 'variable6'
                | 'variable7'
                | 'variable8'
                | 'variable9'
                | 'variable10'
                | 'propertyId'
                | 'propertyType'
                | 'propertyLv'
                | 'propertyCadastralCode'
                | 'propertyCadastralName'
                | 'propertyCity'
                | 'propertyAddress'
                | 'propertyAreaNumber'
                | 'propertyName'
              >
            >
          >
        }
      }
  >
}

export type PostServiceTableQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type PostServiceTableQuery = { __typename: 'Query' } & {
  recipientListById?: Maybe<
    { __typename: 'RecipientList' } & Pick<
      RecipientList,
      'temporaryRecipientsJson' | 'nazev' | 'createdAt' | 'id'
    >
  >
}

export type AllPostserviceTemplatesQueryVariables = Exact<{
  accountId: Scalars['UUID']
}>

export type AllPostserviceTemplatesQuery = { __typename: 'Query' } & {
  allPostserviceTemplates?: Maybe<
    { __typename: 'PostserviceTemplatesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PostserviceTemplate' } & Pick<
            PostserviceTemplate,
            'content' | 'description' | 'id' | 'name'
          >
        >
      >
    }
  >
}

export type PostserviceTemplateTableQueryVariables = Exact<{
  accountId: Scalars['UUID']
}>

export type PostserviceTemplateTableQuery = { __typename: 'Query' } & {
  allPostserviceTemplates?: Maybe<
    { __typename: 'PostserviceTemplatesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PostserviceTemplate' } & Pick<
            PostserviceTemplate,
            'id' | 'createdAt' | 'description' | 'content' | 'name'
          >
        >
      >
    }
  >
}

export type DeletePostserviceTemplateMutationVariables = Exact<{
  deletedAt?: InputMaybe<Scalars['Datetime']>
  id: Scalars['UUID']
}>

export type DeletePostserviceTemplateMutation = { __typename: 'Mutation' } & {
  updatePostserviceTemplateById?: Maybe<
    { __typename: 'UpdatePostserviceTemplatePayload' } & Pick<
      UpdatePostserviceTemplatePayload,
      'clientMutationId'
    >
  >
}

export type UpdatePostserviceTemplateMutationVariables = Exact<{
  id: Scalars['UUID']
  content: Scalars['String']
  editedAt?: InputMaybe<Scalars['Datetime']>
  name?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
}>

export type UpdatePostserviceTemplateMutation = { __typename: 'Mutation' } & {
  updatePostserviceTemplateById?: Maybe<
    { __typename: 'UpdatePostserviceTemplatePayload' } & Pick<
      UpdatePostserviceTemplatePayload,
      'clientMutationId'
    >
  >
}

export type PriceEstimateLayoutQueryVariables = Exact<{
  accountId: Scalars['UUID']
  propertyId: Scalars['UUID']
}>

export type PriceEstimateLayoutQuery = { __typename: 'Query' } & {
  allMonits?: Maybe<
    { __typename: 'MonitsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Monit' } & Pick<
            Monit,
            | 'cenaM2Nab'
            | 'cenaM2Real'
            | 'cenaNab'
            | 'cenaReal'
            | 'decompNab'
            | 'decompReal'
            | 'timeSeriesGraph'
            | 'estimateToDate'
            | 'createdAt'
            | 'id'
            | 'modelVersion'
            | 'note'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type PriceEstimatePdfQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type PriceEstimatePdfQuery = { __typename: 'Query' } & {
  monitById?: Maybe<
    { __typename: 'Monit' } & Pick<
      Monit,
      | 'id'
      | 'requestData'
      | 'publicNote'
      | 'risyData'
      | 'lvData'
      | 'propertyId'
      | 'propertyType'
      | 'modelVersion'
      | 'title'
      | 'lat'
      | 'lon'
      | 'polygon'
      | 'createdAt'
      | 'cenaReal'
      | 'cenaNab'
      | 'cenaM2Real'
      | 'cenaM2Nab'
      | 'estimateToDate'
      | 'decompReal'
      | 'decompNab'
      | 'timeSeriesGraph'
      | 'graphImageString'
    >
  >
}

export type PriceEstimateSelectBoxQueryVariables = Exact<{
  accountId: Scalars['UUID']
  propertyId: Scalars['UUID']
}>

export type PriceEstimateSelectBoxQuery = { __typename: 'Query' } & {
  allMonits?: Maybe<
    { __typename: 'MonitsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Monit' } & Pick<
            Monit,
            'id' | 'estimateToDate' | 'requestData' | 'cenaReal' | 'note'
          >
        >
      >
    }
  >
}

export type PriceEstimateTableQueryVariables = Exact<{
  accountId: Scalars['UUID']
  filter?: InputMaybe<MonitFilter>
}>

export type PriceEstimateTableQuery = { __typename: 'Query' } & {
  allMonits?: Maybe<
    { __typename: 'MonitsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Monit' } & Pick<
            Monit,
            | 'id'
            | 'title'
            | 'propertyType'
            | 'estimateToDate'
            | 'createdAt'
            | 'cenaReal'
            | 'cenaNab'
            | 'cenaM2Real'
            | 'cenaM2Nab'
            | 'propertyId'
            | 'note'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type ProceedingDetailDocumentCollectionTableQueryVariables = Exact<{
  accountId: Scalars['UUID']
  rizeni: Scalars['String']
}>

export type ProceedingDetailDocumentCollectionTableQuery = {
  __typename: 'Query'
} & {
  allCuzkDocumentCollections?: Maybe<
    { __typename: 'CuzkDocumentCollectionsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'CuzkDocumentCollection' } & Pick<
            CuzkDocumentCollection,
            | 'id'
            | 'cuzkCollectionId'
            | 'cuzkDocumentId'
            | 'accountId'
            | 'accountUserId'
            | 'casoveraziko'
            | 'cena'
            | 'createdAt'
            | 'datumpozadavku'
            | 'datumspusteni'
            | 'datumvytvoreni'
            | 'elznacka'
            | 'format'
            | 'nazev'
            | 'pocetjednotek'
            | 'pocetstran'
            | 'rizeni'
            | 'stav'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type AllCeeOfficeQueryVariables = Exact<{ [key: string]: never }>

export type AllCeeOfficeQuery = { __typename: 'Query' } & {
  allCeeOffices?: Maybe<
    { __typename: 'CeeOfficesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'CeeOffice' } & Pick<
            CeeOffice,
            | 'id'
            | 'address'
            | 'area'
            | 'databox'
            | 'dic'
            | 'email'
            | 'ico'
            | 'name'
            | 'note'
            | 'phone'
            | 'web'
            | 'executorCode'
          >
        >
      >
    }
  >
}

export type ProceedingSearchBarQueryVariables = Exact<{ [key: string]: never }>

export type ProceedingSearchBarQuery = { __typename: 'Query' } & {
  allKuWorkplaces?: Maybe<
    { __typename: 'KuWorkplacesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'KuWorkplace' } & Pick<
            KuWorkplace,
            'nazevZkraceny' | 'kod'
          >
        >
      >
    }
  >
}

export type PropertyDetailAuctionQueryVariables = Exact<{
  accountUserId: Scalars['UUID']
  accountId: Scalars['UUID']
  propertyId: Scalars['UUID']
  labelIds: Array<Scalars['UUID']> | Scalars['UUID']
}>

export type PropertyDetailAuctionQuery = { __typename: 'Query' } & {
  allAuctionProperties?: Maybe<
    { __typename: 'AuctionPropertiesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'AuctionProperty' } & {
            auctionListingByAuctionId?: Maybe<
              { __typename: 'AuctionListing' } & Pick<
                AuctionListing,
                | 'id'
                | 'title'
                | 'type'
                | 'auctionNumber'
                | 'detailUrl'
                | 'state'
                | 'price'
                | 'startDate'
                | 'endDate'
                | 'auctionedOn'
                | 'auctionDecreeUrl'
                | 'lat'
                | 'long'
                | 'createdAt'
                | 'photoUrl'
              > & {
                  labels: { __typename: 'LabelConnectionsConnection' } & {
                    nodes: Array<
                      Maybe<
                        { __typename: 'LabelConnection' } & Pick<
                          LabelConnection,
                          'id'
                        > & {
                            labelByLabelId?: Maybe<
                              { __typename: 'Label' } & Pick<
                                Label,
                                | 'colorKey'
                                | 'iconKey'
                                | 'description'
                                | 'id'
                                | 'name'
                              >
                            >
                          }
                      >
                    >
                  }
                  activityLogs: { __typename: 'UserActivityLogsConnection' } & {
                    nodes: Array<
                      Maybe<
                        { __typename: 'UserActivityLog' } & Pick<
                          UserActivityLog,
                          'editedAt' | 'id' | 'nodeId' | 'actionType'
                        >
                      >
                    >
                  }
                  linkedProperties: {
                    __typename: 'AuctionPropertiesConnection'
                  } & Pick<AuctionPropertiesConnection, 'totalCount'>
                }
            >
          }
        >
      >
    }
  >
}

export type PropertyDetailAuctionCheckQueryVariables = Exact<{
  propertyId: Scalars['UUID']
  accountId: Scalars['UUID']
}>

export type PropertyDetailAuctionCheckQuery = { __typename: 'Query' } & {
  allAuctionProperties?: Maybe<
    { __typename: 'AuctionPropertiesConnection' } & Pick<
      AuctionPropertiesConnection,
      'totalCount'
    >
  >
}

export type UnitRentByCadastralAreaCodeQueryVariables = Exact<{
  cadastralAreaCode: Scalars['String']
}>

export type UnitRentByCadastralAreaCodeQuery = { __typename: 'Query' } & {
  unitRentByCadastralAreaCode?: Maybe<
    { __typename: 'UnitRent' } & Pick<
      UnitRent,
      | 'cadastralAreaName'
      | 'cityName'
      | 'vk1DataCoverage'
      | 'vk1LowerInterval'
      | 'vk1Maximum'
      | 'vk1Median'
      | 'vk1Minimum'
      | 'vk1NewBuilding'
      | 'vk1Reference'
      | 'vk1UpperInterval'
      | 'vk2DataCoverage'
      | 'vk2LowerInterval'
      | 'vk2Maximum'
      | 'vk2Median'
      | 'vk2Minimum'
      | 'vk2NewBuilding'
      | 'vk2Reference'
      | 'vk2UpperInterval'
      | 'vk3DataCoverage'
      | 'vk3LowerInterval'
      | 'vk3Maximum'
      | 'vk3Median'
      | 'vk3Minimum'
      | 'vk3NewBuilding'
      | 'vk3Reference'
      | 'vk3UpperInterval'
      | 'vk4DataCoverage'
      | 'vk4LowerInterval'
      | 'vk4Maximum'
      | 'vk4Median'
      | 'vk4Minimum'
      | 'vk4Reference'
      | 'vk4NewBuilding'
      | 'vk4UpperInterval'
    >
  >
}

export type PropertyBuybackCalculationsQueryVariables = Exact<{
  propertyId: Scalars['UUID']
  accountId: Scalars['UUID']
}>

export type PropertyBuybackCalculationsQuery = { __typename: 'Query' } & {
  allBuybackCalculations?: Maybe<
    { __typename: 'BuybackCalculationsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'BuybackCalculation' } & Pick<
            BuybackCalculation,
            | 'id'
            | 'accountId'
            | 'calculatorVersion'
            | 'title'
            | 'description'
            | 'createdAt'
            | 'formData'
          >
        >
      >
    }
  >
}

export type DeleteBuybackCalculationMutationVariables = Exact<{
  deletedAt: Scalars['Datetime']
  id: Scalars['UUID']
}>

export type DeleteBuybackCalculationMutation = { __typename: 'Mutation' } & {
  updateBuybackCalculationById?: Maybe<
    { __typename: 'UpdateBuybackCalculationPayload' } & Pick<
      UpdateBuybackCalculationPayload,
      'clientMutationId'
    > & {
        buybackCalculation?: Maybe<
          { __typename: 'BuybackCalculation' } & Pick<BuybackCalculation, 'id'>
        >
        query?: Maybe<
          { __typename: 'Query' } & {
            allBuybackCalculations?: Maybe<{
              __typename: 'BuybackCalculationsConnection'
            }>
          }
        >
      }
  >
}

export type UpdateBuybackCalculationMutationVariables = Exact<{
  payload: BuybackCalculationPatch
  id: Scalars['UUID']
}>

export type UpdateBuybackCalculationMutation = { __typename: 'Mutation' } & {
  updateBuybackCalculationById?: Maybe<
    { __typename: 'UpdateBuybackCalculationPayload' } & Pick<
      UpdateBuybackCalculationPayload,
      'clientMutationId'
    > & {
        buybackCalculation?: Maybe<
          { __typename: 'BuybackCalculation' } & Pick<BuybackCalculation, 'id'>
        >
        query?: Maybe<
          { __typename: 'Query' } & {
            allBuybackCalculations?: Maybe<{
              __typename: 'BuybackCalculationsConnection'
            }>
          }
        >
      }
  >
}

export type CreatePropertyDetailLabelMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  propertyCadastralCode: Scalars['String']
  propertyCadastralName: Scalars['String']
  propertyId: Scalars['UUID']
  propertyLv: Scalars['String']
  propertyName: Scalars['String']
  propertyType: Scalars['String']
}>

export type CreatePropertyDetailLabelMutation = { __typename: 'Mutation' } & {
  createPropertyLabel?: Maybe<
    { __typename: 'CreatePropertyLabelPayload' } & {
      propertyLabel?: Maybe<
        { __typename: 'PropertyLabel' } & Pick<PropertyLabel, 'id'>
      >
    }
  >
}

export type PropertyDetailLastNoteQueryVariables = Exact<{
  propertyLv: Scalars['String']
  propertyCadastralCode: Scalars['String']
  accountId: Scalars['UUID']
}>

export type PropertyDetailLastNoteQuery = { __typename: 'Query' } & {
  allPropertyNotes?: Maybe<
    { __typename: 'PropertyNotesConnection' } & Pick<
      PropertyNotesConnection,
      'totalCount'
    > & {
        nodes: Array<
          Maybe<
            { __typename: 'PropertyNote' } & Pick<
              PropertyNote,
              | 'accountId'
              | 'accountUserId'
              | 'propertyName'
              | 'propertyType'
              | 'propertyId'
              | 'note'
              | 'id'
              | 'links'
              | 'iconKey'
              | 'editedAt'
              | 'createdAt'
              | 'colorKey'
            >
          >
        >
      }
  >
}

export type PropertyDetailAllCuzkLvsQueryVariables = Exact<{
  lv: Scalars['String']
  katastralniUzemiKod: Scalars['String']
  accountId: Scalars['UUID']
}>

export type PropertyDetailAllCuzkLvsQuery = { __typename: 'Query' } & {
  allCuzkLvs?: Maybe<
    { __typename: 'CuzkLvsConnection' } & Pick<
      CuzkLvsConnection,
      'totalCount'
    > & { nodes: Array<Maybe<{ __typename: 'CuzkLv' } & Pick<CuzkLv, 'id'>>> }
  >
}

export type CreatePropertyNoteMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  note: Scalars['String']
  propertyCadastralCode: Scalars['String']
  propertyId: Scalars['UUID']
  propertyLv: Scalars['String']
  propertyType?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
  links?: InputMaybe<Scalars['JSON']>
  colorKey?: InputMaybe<Scalars['String']>
  iconKey?: InputMaybe<Scalars['String']>
}>

export type CreatePropertyNoteMutation = { __typename: 'Mutation' } & {
  createPropertyNote?: Maybe<
    { __typename: 'CreatePropertyNotePayload' } & {
      propertyNote?: Maybe<
        { __typename: 'PropertyNote' } & Pick<PropertyNote, 'id'>
      >
      query?: Maybe<
        { __typename: 'Query' } & {
          allPropertyNotes?: Maybe<
            { __typename: 'PropertyNotesConnection' } & Pick<
              PropertyNotesConnection,
              'totalCount'
            >
          >
        }
      >
    }
  >
}

export type DeletePropertyNoteByIdMutationVariables = Exact<{
  id: Scalars['UUID']
}>

export type DeletePropertyNoteByIdMutation = { __typename: 'Mutation' } & {
  deletePropertyNoteById?: Maybe<
    { __typename: 'DeletePropertyNotePayload' } & {
      propertyNote?: Maybe<
        { __typename: 'PropertyNote' } & Pick<PropertyNote, 'id'>
      >
    }
  >
}

export type UpdatePropertyNoteByIdMutationVariables = Exact<{
  id: Scalars['UUID']
  colorKey?: InputMaybe<Scalars['String']>
  editedAt?: InputMaybe<Scalars['Datetime']>
  iconKey?: InputMaybe<Scalars['String']>
  links?: InputMaybe<Scalars['JSON']>
  note?: InputMaybe<Scalars['String']>
}>

export type UpdatePropertyNoteByIdMutation = { __typename: 'Mutation' } & {
  updatePropertyNoteById?: Maybe<
    { __typename: 'UpdatePropertyNotePayload' } & {
      propertyNote?: Maybe<
        { __typename: 'PropertyNote' } & Pick<PropertyNote, 'id'>
      >
    }
  >
}

export type PropertyDetailNoteTimelineQueryVariables = Exact<{
  propertyLv: Scalars['String']
  propertyCadastralCode: Scalars['String']
  accountId: Scalars['UUID']
}>

export type PropertyDetailNoteTimelineQuery = { __typename: 'Query' } & {
  allPropertyNotes?: Maybe<
    { __typename: 'PropertyNotesConnection' } & Pick<
      PropertyNotesConnection,
      'totalCount'
    > & {
        nodes: Array<
          Maybe<
            { __typename: 'PropertyNote' } & Pick<
              PropertyNote,
              | 'accountId'
              | 'accountUserId'
              | 'propertyType'
              | 'propertyName'
              | 'propertyLv'
              | 'propertyId'
              | 'note'
              | 'propertyCadastralCode'
              | 'id'
              | 'links'
              | 'iconKey'
              | 'editedAt'
              | 'deletedAt'
              | 'createdAt'
              | 'colorKey'
            >
          >
        >
      }
  >
}

export type GeneralPropertyLabelsQueryVariables = Exact<{
  propertyIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>
  accountId: Scalars['UUID']
}>

export type GeneralPropertyLabelsQuery = { __typename: 'Query' } & {
  allPropertyLabels?: Maybe<
    { __typename: 'PropertyLabelsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PropertyLabel' } & Pick<
            PropertyLabel,
            | 'id'
            | 'propertyId'
            | 'propertyLv'
            | 'propertyName'
            | 'propertyType'
            | 'propertyCadastralName'
            | 'propertyCadastralCode'
            | 'createdAt'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type PropertyDetailsLabelsQueryVariables = Exact<{
  propertyIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>
  propertyType: Scalars['String']
  accountId: Scalars['UUID']
}>

export type PropertyDetailsLabelsQuery = { __typename: 'Query' } & {
  allPropertyLabels?: Maybe<
    { __typename: 'PropertyLabelsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PropertyLabel' } & Pick<
            PropertyLabel,
            | 'id'
            | 'propertyId'
            | 'propertyLv'
            | 'propertyName'
            | 'propertyType'
            | 'propertyCadastralName'
            | 'propertyCadastralCode'
            | 'createdAt'
          > & {
              labels: { __typename: 'LabelConnectionsConnection' } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'LabelConnection' } & Pick<
                      LabelConnection,
                      'id'
                    > & {
                        labelByLabelId?: Maybe<
                          { __typename: 'Label' } & Pick<
                            Label,
                            | 'colorKey'
                            | 'iconKey'
                            | 'description'
                            | 'id'
                            | 'name'
                          >
                        >
                      }
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type ProceedingIdsWithDocumentQueryVariables = Exact<{
  accountId: Scalars['UUID']
  proceedings?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>

export type ProceedingIdsWithDocumentQuery = { __typename: 'Query' } & {
  allCuzkDocumentCollections?: Maybe<
    { __typename: 'CuzkDocumentCollectionsConnection' } & Pick<
      CuzkDocumentCollectionsConnection,
      'totalCount'
    > & {
        nodes: Array<
          Maybe<
            { __typename: 'CuzkDocumentCollection' } & Pick<
              CuzkDocumentCollection,
              'rizeni'
            >
          >
        >
      }
  >
}

export type PropertyLabelTableQueryVariables = Exact<{
  labelId: Scalars['UUID']
}>

export type PropertyLabelTableQuery = { __typename: 'Query' } & {
  allLabelConnections?: Maybe<
    { __typename: 'LabelConnectionsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'LabelConnection' } & {
            propertyLabelByPropertyLabelId?: Maybe<
              { __typename: 'PropertyLabel' } & Pick<
                PropertyLabel,
                | 'propertyType'
                | 'propertyName'
                | 'propertyLv'
                | 'propertyId'
                | 'propertyCadastralName'
                | 'propertyCadastralCode'
                | 'id'
                | 'createdAt'
              > & {
                  labels: { __typename: 'LabelConnectionsConnection' } & {
                    nodes: Array<
                      Maybe<
                        { __typename: 'LabelConnection' } & Pick<
                          LabelConnection,
                          'id'
                        > & {
                            labelByLabelId?: Maybe<
                              { __typename: 'Label' } & Pick<
                                Label,
                                | 'colorKey'
                                | 'iconKey'
                                | 'description'
                                | 'id'
                                | 'name'
                              >
                            >
                          }
                      >
                    >
                  }
                }
            >
          }
        >
      >
    }
  >
}

export type PropertyListDetailQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type PropertyListDetailQuery = { __typename: 'Query' } & {
  propertyListById?: Maybe<
    { __typename: 'PropertyList' } & Pick<
      PropertyList,
      | 'id'
      | 'name'
      | 'description'
      | 'count'
      | 'whereClause'
      | 'propertyType'
      | 'createdAt'
    >
  >
}

export type CreatePropertyListMutationVariables = Exact<{
  name: Scalars['String']
  description?: InputMaybe<Scalars['String']>
  whereClause: Scalars['String']
  count: Scalars['Int']
  propertyType: Scalars['String']
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
}>

export type CreatePropertyListMutation = { __typename: 'Mutation' } & {
  createPropertyList?: Maybe<
    { __typename: 'CreatePropertyListPayload' } & Pick<
      CreatePropertyListPayload,
      'clientMutationId'
    > & {
        propertyList?: Maybe<
          { __typename: 'PropertyList' } & Pick<PropertyList, 'id' | 'name'>
        >
      }
  >
}

export type DeletePropertyListMutationVariables = Exact<{
  id: Scalars['UUID']
  deletedAt: Scalars['Datetime']
}>

export type DeletePropertyListMutation = { __typename: 'Mutation' } & {
  updatePropertyListById?: Maybe<
    { __typename: 'UpdatePropertyListPayload' } & {
      propertyList?: Maybe<
        { __typename: 'PropertyList' } & Pick<PropertyList, 'id'>
      >
    }
  >
}

export type EditPropertyListMutationVariables = Exact<{
  id: Scalars['UUID']
  name: Scalars['String']
  description?: InputMaybe<Scalars['String']>
}>

export type EditPropertyListMutation = { __typename: 'Mutation' } & {
  updatePropertyListById?: Maybe<
    { __typename: 'UpdatePropertyListPayload' } & {
      propertyList?: Maybe<
        { __typename: 'PropertyList' } & Pick<
          PropertyList,
          'id' | 'name' | 'description'
        >
      >
    }
  >
}

export type PropertyListsQueryVariables = Exact<{
  accountId: Scalars['UUID']
}>

export type PropertyListsQuery = { __typename: 'Query' } & {
  allPropertyLists?: Maybe<
    { __typename: 'PropertyListsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PropertyList' } & Pick<
            PropertyList,
            | 'id'
            | 'name'
            | 'description'
            | 'count'
            | 'propertyType'
            | 'createdAt'
          >
        >
      >
    }
  >
}

export type PropertyNotesByPropertyIdsQueryVariables = Exact<{
  propertyIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>
  accountId: Scalars['UUID']
}>

export type PropertyNotesByPropertyIdsQuery = { __typename: 'Query' } & {
  allPropertyNotes?: Maybe<
    { __typename: 'PropertyNotesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PropertyNote' } & Pick<
            PropertyNote,
            | 'iconKey'
            | 'note'
            | 'colorKey'
            | 'propertyId'
            | 'propertyLv'
            | 'propertyCadastralCode'
            | 'propertyType'
          >
        >
      >
    }
  >
}

export type PropertyNoteTableQueryVariables = Exact<{
  accountId: Scalars['UUID']
}>

export type PropertyNoteTableQuery = { __typename: 'Query' } & {
  allPropertyNotes?: Maybe<
    { __typename: 'PropertyNotesConnection' } & Pick<
      PropertyNotesConnection,
      'totalCount'
    > & {
        nodes: Array<
          Maybe<
            { __typename: 'PropertyNote' } & Pick<
              PropertyNote,
              | 'accountId'
              | 'accountUserId'
              | 'propertyType'
              | 'propertyName'
              | 'propertyLv'
              | 'propertyId'
              | 'note'
              | 'propertyCadastralCode'
              | 'id'
              | 'links'
              | 'iconKey'
              | 'editedAt'
              | 'deletedAt'
              | 'createdAt'
              | 'colorKey'
            >
          >
        >
      }
  >
}

export type SearchCadastralAreaQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>
}>

export type SearchCadastralAreaQuery = { __typename: 'Query' } & {
  allKuAreas?: Maybe<
    { __typename: 'KuAreasConnection' } & Pick<
      KuAreasConnection,
      'totalCount'
    > & {
        nodes: Array<
          Maybe<
            { __typename: 'KuArea' } & Pick<
              KuArea,
              'kuKod' | 'kuNazev' | 'obecNazev'
            >
          >
        >
      }
  >
}

export type RecipientsByUniquePersonKeysQueryVariables = Exact<{
  uniquePersonKeys?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
  accountId: Scalars['UUID']
}>

export type RecipientsByUniquePersonKeysQuery = { __typename: 'Query' } & {
  allPostserviceRecipients?: Maybe<
    { __typename: 'PostserviceRecipientsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PostserviceRecipient' } & Pick<
            PostserviceRecipient,
            'id' | 'uniquePersonKey'
          > & {
              postserviceListByPostserviceListId?: Maybe<
                { __typename: 'PostserviceList' } & Pick<
                  PostserviceList,
                  'id' | 'listName' | 'description'
                > & {
                    labels: { __typename: 'LabelConnectionsConnection' } & {
                      nodes: Array<
                        Maybe<
                          { __typename: 'LabelConnection' } & Pick<
                            LabelConnection,
                            'id'
                          > & {
                              labelByLabelId?: Maybe<
                                { __typename: 'Label' } & Pick<
                                  Label,
                                  | 'colorKey'
                                  | 'iconKey'
                                  | 'description'
                                  | 'id'
                                  | 'name'
                                >
                              >
                            }
                        >
                      >
                    }
                  }
              >
            }
        >
      >
    }
  >
  allPostserviceSentRecipients?: Maybe<
    { __typename: 'PostserviceSentRecipientsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PostserviceSentRecipient' } & Pick<
            PostserviceSentRecipient,
            | 'id'
            | 'postserviceId'
            | 'uniquePersonKey'
            | 'postserviceTrackingNumber'
          > & {
              postserviceSentLetterBySentLetterId?: Maybe<
                { __typename: 'PostserviceSentLetter' } & Pick<
                  PostserviceSentLetter,
                  | 'name'
                  | 'id'
                  | 'description'
                  | 'sentAt'
                  | 'deletedAt'
                  | 'postserviceType'
                >
              >
            }
        >
      >
    }
  >
}

export type CreateLabelConnectionMutationVariables = Exact<{
  labelId: Scalars['UUID']
  monitoringCuzkRcId?: InputMaybe<Scalars['UUID']>
  recipientListId?: InputMaybe<Scalars['UUID']>
  monitoringCeeId?: InputMaybe<Scalars['UUID']>
  monitId?: InputMaybe<Scalars['UUID']>
  marketplaceOfferId?: InputMaybe<Scalars['UUID']>
  cuzkEpoLienId?: InputMaybe<Scalars['UUID']>
  cuzkLvId?: InputMaybe<Scalars['UUID']>
  cuzkEpoId?: InputMaybe<Scalars['UUID']>
  cuzkDocumentCollectionId?: InputMaybe<Scalars['UUID']>
  postserviceListId?: InputMaybe<Scalars['UUID']>
  propertyLabelId?: InputMaybe<Scalars['UUID']>
  auctionListingId?: InputMaybe<Scalars['UUID']>
}>

export type CreateLabelConnectionMutation = { __typename: 'Mutation' } & {
  createLabelConnection?: Maybe<
    { __typename: 'CreateLabelConnectionPayload' } & Pick<
      CreateLabelConnectionPayload,
      'clientMutationId'
    > & {
        labelConnection?: Maybe<
          { __typename: 'LabelConnection' } & Pick<LabelConnection, 'id'>
        >
        query?: Maybe<
          { __typename: 'Query' } & {
            allLabelConnections?: Maybe<{
              __typename: 'LabelConnectionsConnection'
            }>
            allMonitoringCuzkRcs?: Maybe<{
              __typename: 'MonitoringCuzkRcsConnection'
            }>
            allCuzkEpoLiens?: Maybe<{ __typename: 'CuzkEpoLiensConnection' }>
            allCuzkLvs?: Maybe<{ __typename: 'CuzkLvsConnection' }>
            allCuzkEpos?: Maybe<{ __typename: 'CuzkEposConnection' }>
            allCuzkDocumentCollections?: Maybe<{
              __typename: 'CuzkDocumentCollectionsConnection'
            }>
            allMarketplaceOffers?: Maybe<{
              __typename: 'MarketplaceOffersConnection'
            }>
            allMonits?: Maybe<{ __typename: 'MonitsConnection' }>
            allMonitoringCees?: Maybe<{
              __typename: 'MonitoringCeesConnection'
            }>
            allRecipientLists?: Maybe<{
              __typename: 'RecipientListsConnection'
            }>
            allPostserviceLists?: Maybe<{
              __typename: 'PostserviceListsConnection'
            }>
            allPropertyLabels?: Maybe<{
              __typename: 'PropertyLabelsConnection'
            }>
            allAuctionListings?: Maybe<{
              __typename: 'AuctionListingsConnection'
            }>
          }
        >
      }
  >
}

export type DeleteLabelConnectionMutationVariables = Exact<{
  id: Scalars['UUID']
}>

export type DeleteLabelConnectionMutation = { __typename: 'Mutation' } & {
  deleteLabelConnectionById?: Maybe<
    { __typename: 'DeleteLabelConnectionPayload' } & Pick<
      DeleteLabelConnectionPayload,
      'clientMutationId'
    > & {
        labelConnection?: Maybe<
          { __typename: 'LabelConnection' } & Pick<LabelConnection, 'id'>
        >
      }
  >
}

export type AllUserActivityLogsQueryVariables = Exact<{
  accountUserId?: InputMaybe<Scalars['UUID']>
  entityIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>

export type AllUserActivityLogsQuery = { __typename: 'Query' } & {
  allUserActivityLogs?: Maybe<
    { __typename: 'UserActivityLogsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'UserActivityLog' } & Pick<
            UserActivityLog,
            'id' | 'actionType' | 'editedAt' | 'entityId' | 'entityType'
          >
        >
      >
    }
  >
}

export type CreateUserActivityLogMutationVariables = Exact<{
  entityType: UserActivityEntityType
  actionType: UserActivityActionType
  actionSource?: InputMaybe<Scalars['String']>
  accountUserId: Scalars['UUID']
  accountId: Scalars['UUID']
  entityId: Scalars['String']
  auctionListingId?: InputMaybe<Scalars['UUID']>
}>

export type CreateUserActivityLogMutation = { __typename: 'Mutation' } & {
  createUserActivityLog?: Maybe<
    { __typename: 'CreateUserActivityLogPayload' } & Pick<
      CreateUserActivityLogPayload,
      'clientMutationId'
    > & {
        query?: Maybe<
          { __typename: 'Query' } & {
            allUserActivityLogs?: Maybe<
              { __typename: 'UserActivityLogsConnection' } & {
                nodes: Array<Maybe<{ __typename: 'UserActivityLog' }>>
              }
            >
          }
        >
      }
  >
}

export type UpdateUserActivityLogMutationVariables = Exact<{
  nodeId: Scalars['ID']
  actionType: UserActivityActionType
  editedAt: Scalars['Datetime']
  auctionListingId?: InputMaybe<Scalars['UUID']>
}>

export type UpdateUserActivityLogMutation = { __typename: 'Mutation' } & {
  updateUserActivityLog?: Maybe<
    { __typename: 'UpdateUserActivityLogPayload' } & Pick<
      UpdateUserActivityLogPayload,
      'clientMutationId'
    > & {
        userActivityLog?: Maybe<
          { __typename: 'UserActivityLog' } & Pick<UserActivityLog, 'id'>
        >
      }
  >
}

export type UserActivityLogByEntityIdQueryVariables = Exact<{
  accountUserId: Scalars['UUID']
  entityId: Scalars['String']
}>

export type UserActivityLogByEntityIdQuery = { __typename: 'Query' } & {
  allUserActivityLogs?: Maybe<
    { __typename: 'UserActivityLogsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'UserActivityLog' } & Pick<
            UserActivityLog,
            | 'id'
            | 'actionType'
            | 'editedAt'
            | 'entityId'
            | 'entityType'
            | 'nodeId'
          >
        >
      >
    }
  >
}

export type CuzkOFragmentFragment = { __typename: 'CuzkO' } & Pick<
  CuzkO,
  | 'id'
  | 'castobcenazev'
  | 'cislodomovni'
  | 'cisloorientacni'
  | 'charostype'
  | 'doplnekico'
  | 'ico'
  | 'jmeno'
  | 'lastCheck'
  | 'mestskacastnazev'
  | 'mestskyobvodnazev'
  | 'nazev'
  | 'obecnazev'
  | 'okresnazev'
  | 'prijmeni'
  | 'psc'
  | 'rc'
  | 'rczkracene'
  | 'statnazev'
  | 'titulpred'
  | 'titulza'
  | 'typcpce'
  | 'ulice'
  | 'vlastniktyp'
  | 'partner1'
  | 'partner2'
>

export type LabelConnectionFragmentFragment = {
  __typename: 'LabelConnectionsConnection'
} & {
  nodes: Array<
    Maybe<
      { __typename: 'LabelConnection' } & Pick<LabelConnection, 'id'> & {
          labelByLabelId?: Maybe<
            { __typename: 'Label' } & Pick<
              Label,
              'colorKey' | 'iconKey' | 'description' | 'id' | 'name'
            >
          >
        }
    >
  >
}

export type RecipientFragment = { __typename: 'PostserviceRecipient' } & Pick<
  PostserviceRecipient,
  | 'accountId'
  | 'accountUserId'
  | 'city'
  | 'companyName'
  | 'country'
  | 'gender'
  | 'houseNumber'
  | 'id'
  | 'firstname'
  | 'lastname'
  | 'callName'
  | 'orientationNumber'
  | 'postserviceListId'
  | 'addressId'
  | 'uniquePersonKey'
  | 'street'
  | 'variable1'
  | 'variable10'
  | 'variable2'
  | 'variable3'
  | 'variable4'
  | 'variable5'
  | 'variable6'
  | 'variable7'
  | 'variable8'
  | 'variable9'
  | 'zipCode'
  | 'propertyId'
  | 'propertyType'
  | 'propertyLv'
  | 'propertyCadastralCode'
  | 'propertyCadastralName'
  | 'propertyCity'
  | 'propertyAddress'
  | 'propertyAreaNumber'
  | 'propertyName'
>

export type RecipientListFragmentFragment = {
  __typename: 'RecipientList'
} & Pick<RecipientList, 'nazev'> & {
    recipientListRecipientsByRecipientListId: {
      __typename: 'RecipientListRecipientsConnection'
    } & {
      nodes: Array<
        Maybe<
          { __typename: 'RecipientListRecipient' } & Pick<
            RecipientListRecipient,
            'id' | 'propertyName' | 'propertyType'
          > & {
              recipientByRecipientId?: Maybe<
                { __typename: 'Recipient' } & Pick<
                  Recipient,
                  | 'id'
                  | 'krestnijmeno'
                  | 'osloveni'
                  | 'pohlavi'
                  | 'nazev'
                  | 'prijmeni'
                  | 'titulpred'
                  | 'titulza'
                > & {
                    addressByAdresnimistokod?: Maybe<
                      { __typename: 'Address' } & Pick<
                        Address,
                        | 'castobce'
                        | 'cislodomovni'
                        | 'cisloorientacni'
                        | 'cisloorientacnipismeno'
                        | 'kraj'
                        | 'obec'
                        | 'okres'
                        | 'psc'
                        | 'typbudovy'
                        | 'ulice'
                      >
                    >
                  }
              >
            }
        >
      >
    }
  }

export type AuctionListingsByFilterQueryVariables = Exact<{
  filter: AuctionListingFilter
}>

export type AuctionListingsByFilterQuery = { __typename: 'Query' } & {
  allAuctionListings?: Maybe<
    { __typename: 'AuctionListingsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'AuctionListing' } & Pick<
            AuctionListing,
            | 'id'
            | 'title'
            | 'description'
            | 'type'
            | 'auctionNumber'
            | 'slug'
            | 'detailUrl'
            | 'state'
            | 'price'
            | 'startDate'
            | 'endDate'
            | 'auctionedOn'
            | 'auctionDecreeUrl'
            | 'sourceHostname'
            | 'lat'
            | 'long'
            | 'ku'
            | 'obec'
            | 'createdAt'
          >
        >
      >
    }
  >
}

export type CreateAuctionMutationVariables = Exact<{
  input: AuctionListingInput
}>

export type CreateAuctionMutation = { __typename: 'Mutation' } & {
  createAuctionListing?: Maybe<
    { __typename: 'CreateAuctionListingPayload' } & {
      auctionListing?: Maybe<
        { __typename: 'AuctionListing' } & Pick<AuctionListing, 'id' | 'slug'>
      >
    }
  >
}

export type UpdateAuctionByIdMutationVariables = Exact<{
  input: UpdateAuctionListingByIdInput
}>

export type UpdateAuctionByIdMutation = { __typename: 'Mutation' } & {
  updateAuctionListingById?: Maybe<
    { __typename: 'UpdateAuctionListingPayload' } & {
      auctionListing?: Maybe<{ __typename: 'AuctionListing' }>
    }
  >
}

export type BuybackByIdQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type BuybackByIdQuery = { __typename: 'Query' } & {
  buybackCalculationById?: Maybe<
    { __typename: 'BuybackCalculation' } & Pick<
      BuybackCalculation,
      | 'id'
      | 'title'
      | 'propertyName'
      | 'lv'
      | 'propertyId'
      | 'accountId'
      | 'accountUserId'
      | 'createdAt'
      | 'formData'
    >
  >
}

export type CeeCronQueryVariables = Exact<{
  day: Scalars['Datetime']
  week: Scalars['Datetime']
  month: Scalars['Datetime']
}>

export type CeeCronQuery = { __typename: 'Query' } & {
  allMonitoringCees?: Maybe<
    { __typename: 'MonitoringCeesConnection' } & Pick<
      MonitoringCeesConnection,
      'totalCount'
    > & {
        nodes: Array<
          Maybe<
            { __typename: 'MonitoringCee' } & Pick<
              MonitoringCee,
              | 'id'
              | 'checkFrequency'
              | 'accountUserId'
              | 'accountId'
              | 'lastCheck'
              | 'rc'
              | 'ico'
              | 'firstname'
              | 'lastname'
              | 'birthDate'
            >
          >
        >
      }
  >
}

export type CeeStatisticsQueryVariables = Exact<{ [key: string]: never }>

export type CeeStatisticsQuery = { __typename: 'Query' } & {
  allMonitoringCees?: Maybe<
    { __typename: 'MonitoringCeesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'MonitoringCee' } & Pick<
            MonitoringCee,
            | 'id'
            | 'createdAt'
            | 'firstname'
            | 'executionCount'
            | 'lastname'
            | 'rc'
            | 'ico'
            | 'lastCheck'
            | 'accountId'
            | 'birthDate'
            | 'accountUserId'
          > & {
              ceeExecutionsByMonitoringCeeId: {
                __typename: 'CeeExecutionsConnection'
              } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'CeeExecution' } & {
                      ceeExecutionDetailsByCeeExecutionId: {
                        __typename: 'CeeExecutionDetailsConnection'
                      } & {
                        nodes: Array<
                          Maybe<
                            { __typename: 'CeeExecutionDetail' } & Pick<
                              CeeExecutionDetail,
                              | 'createdAt'
                              | 'accountId'
                              | 'accountUserId'
                              | 'detailCode'
                              | 'id'
                            >
                          >
                        >
                      }
                    }
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type SelectedMonitoringCeeIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>
}>

export type SelectedMonitoringCeeIdsQuery = { __typename: 'Query' } & {
  allMonitoringCees?: Maybe<
    { __typename: 'MonitoringCeesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'MonitoringCee' } & Pick<
            MonitoringCee,
            | 'accountId'
            | 'accountUserId'
            | 'birthDate'
            | 'checkFrequency'
            | 'editedAt'
            | 'createdAt'
            | 'executionCount'
            | 'firstname'
            | 'lastname'
            | 'found'
            | 'ico'
            | 'id'
            | 'lastCheck'
            | 'note'
            | 'rc'
            | 'validatedCode'
          >
        >
      >
    }
  >
}

export type CuzkDocumentCollectionsQueryVariables = Exact<{
  cuzkDocumentId: Scalars['String']
  accountId: Scalars['UUID']
}>

export type CuzkDocumentCollectionsQuery = { __typename: 'Query' } & {
  allCuzkDocumentCollections?: Maybe<
    { __typename: 'CuzkDocumentCollectionsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'CuzkDocumentCollection' } & Pick<
            CuzkDocumentCollection,
            | 'accountId'
            | 'casoveraziko'
            | 'cena'
            | 'createdAt'
            | 'datumpozadavku'
            | 'datumspusteni'
            | 'datumvytvoreni'
            | 'elznacka'
            | 'format'
            | 'id'
            | 'cuzkCollectionId'
            | 'cuzkDocumentId'
            | 'nazev'
            | 'pocetjednotek'
            | 'pocetstran'
            | 'rizeni'
            | 'stav'
          >
        >
      >
    }
  >
}

export type NajdiOsCronQueryVariables = Exact<{
  day: Scalars['Datetime']
  week: Scalars['Datetime']
  month: Scalars['Datetime']
}>

export type NajdiOsCronQuery = { __typename: 'Query' } & {
  allMonitoringCuzkRcs?: Maybe<
    { __typename: 'MonitoringCuzkRcsConnection' } & Pick<
      MonitoringCuzkRcsConnection,
      'totalCount'
    > & {
        nodes: Array<
          Maybe<
            { __typename: 'MonitoringCuzkRc' } & Pick<
              MonitoringCuzkRc,
              | 'id'
              | 'checkFrequency'
              | 'accountUserId'
              | 'accountId'
              | 'lastCheck'
              | 'rc'
              | 'ico'
              | 'firstname'
              | 'lastname'
              | 'birthDate'
            >
          >
        >
      }
  >
}

export type SelectedMonitoringCuzkRcsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>
}>

export type SelectedMonitoringCuzkRcsQuery = { __typename: 'Query' } & {
  allMonitoringCuzkRcs?: Maybe<
    { __typename: 'MonitoringCuzkRcsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'MonitoringCuzkRc' } & Pick<
            MonitoringCuzkRc,
            | 'accountId'
            | 'accountUserId'
            | 'checkFrequency'
            | 'cuzkOsId'
            | 'description'
            | 'editedAt'
            | 'found'
            | 'id'
            | 'lastCheck'
            | 'rc'
            | 'ico'
            | 'firstname'
            | 'lastname'
            | 'birthDate'
          >
        >
      >
    }
  >
}

export type MyOffersAccessesQueryVariables = Exact<{
  accountId: Scalars['UUID']
}>

export type MyOffersAccessesQuery = { __typename: 'Query' } & {
  allMarketplaceOffers?: Maybe<
    { __typename: 'MarketplaceOffersConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'MarketplaceOffer' } & Pick<
            MarketplaceOffer,
            | 'accountId'
            | 'description'
            | 'expirationDate'
            | 'id'
            | 'images'
            | 'interestAmount'
            | 'investmentAmount'
            | 'monthlyPayment'
            | 'offerLocation'
            | 'offerType'
            | 'propertyValue'
            | 'title'
            | 'state'
          > & {
              marketplaceOfferAccessesByOfferId: {
                __typename: 'MarketplaceOfferAccessesConnection'
              } & {
                nodes: Array<
                  Maybe<
                    { __typename: 'MarketplaceOfferAccess' } & Pick<
                      MarketplaceOfferAccess,
                      'isOwner' | 'createdAt'
                    > & {
                        marketplaceOfferByOfferId?: Maybe<
                          { __typename: 'MarketplaceOffer' } & Pick<
                            MarketplaceOffer,
                            | 'contactPhone'
                            | 'contactName'
                            | 'contactEmail'
                            | 'contactDescription'
                          >
                        >
                      }
                  >
                >
              }
            }
        >
      >
    }
  >
}

export type MarketplaceOwnerByIdQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type MarketplaceOwnerByIdQuery = { __typename: 'Query' } & {
  marketplaceOfferById?: Maybe<
    { __typename: 'MarketplaceOffer' } & Pick<MarketplaceOffer, 'accountId'>
  >
}

export type MarketplaceStatisticsQueryVariables = Exact<{
  [key: string]: never
}>

export type MarketplaceStatisticsQuery = { __typename: 'Query' } & {
  allMarketplaceOfferAccesses?: Maybe<
    { __typename: 'MarketplaceOfferAccessesConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'MarketplaceOfferAccess' } & Pick<
            MarketplaceOfferAccess,
            'id' | 'accountId' | 'accountUserId' | 'createdAt'
          > & {
              marketplaceOfferByOfferId?: Maybe<
                { __typename: 'MarketplaceOffer' } & Pick<
                  MarketplaceOffer,
                  'accountId' | 'contactName' | 'offerType' | 'title'
                >
              >
            }
        >
      >
    }
  >
}

export type MarketplaceExpireItemQueryVariables = Exact<{
  lessThan: Scalars['Datetime']
}>

export type MarketplaceExpireItemQuery = { __typename: 'Query' } & {
  allMarketplaceOffers?: Maybe<
    { __typename: 'MarketplaceOffersConnection' } & {
      nodes: Array<
        Maybe<{ __typename: 'MarketplaceOffer' } & Pick<MarketplaceOffer, 'id'>>
      >
    }
  >
}

export type MonitStatisticsQueryVariables = Exact<{ [key: string]: never }>

export type MonitStatisticsQuery = { __typename: 'Query' } & {
  allMonits?: Maybe<
    { __typename: 'MonitsConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'Monit' } & Pick<
            Monit,
            | 'accountId'
            | 'accountUserId'
            | 'createdAt'
            | 'estimateToDate'
            | 'title'
            | 'cenaM2Nab'
            | 'cenaM2Real'
            | 'cenaNab'
            | 'cenaReal'
            | 'id'
            | 'propertyId'
            | 'propertyType'
          >
        >
      >
    }
  >
}

export type PostServiceDispatchQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type PostServiceDispatchQuery = { __typename: 'Query' } & {
  recipientListById?: Maybe<
    { __typename: 'RecipientList' } & Pick<
      RecipientList,
      'id' | 'dispatchDate' | 'letterText' | 'accountId'
    > & {
        senderAddressBySenderAddressId?: Maybe<
          { __typename: 'SenderAddress' } & Pick<
            SenderAddress,
            | 'city'
            | 'houseNumber'
            | 'id'
            | 'orientationNumber'
            | 'senderName'
            | 'street'
            | 'zipCode'
          >
        >
        recipientListRecipientsByRecipientListId: {
          __typename: 'RecipientListRecipientsConnection'
        } & Pick<RecipientListRecipientsConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename: 'RecipientListRecipient' } & Pick<
                  RecipientListRecipient,
                  'id' | 'propertyName' | 'propertyType'
                > & {
                    recipientByRecipientId?: Maybe<
                      { __typename: 'Recipient' } & Pick<
                        Recipient,
                        | 'fyzickaosoba'
                        | 'id'
                        | 'krestnijmeno'
                        | 'nazev'
                        | 'osloveni'
                        | 'pohlavi'
                        | 'prijmeni'
                        | 'titulpred'
                        | 'titulza'
                      > & {
                          addressByAdresnimistokod?: Maybe<
                            { __typename: 'Address' } & Pick<
                              Address,
                              | 'castobce'
                              | 'cislodomovni'
                              | 'cisloorientacni'
                              | 'cisloorientacnipismeno'
                              | 'kraj'
                              | 'obec'
                              | 'okres'
                              | 'psc'
                              | 'radnice'
                              | 'typbudovy'
                              | 'ulice'
                            >
                          >
                        }
                    >
                  }
              >
            >
          }
      }
  >
}

export type SentLetterByIdQueryVariables = Exact<{
  letterId: Scalars['UUID']
}>

export type SentLetterByIdQuery = { __typename: 'Query' } & {
  postserviceSentLetterById?: Maybe<
    { __typename: 'PostserviceSentLetter' } & Pick<
      PostserviceSentLetter,
      'accountId' | 'sentAt' | 'content' | 'id'
    > & {
        sender?: Maybe<
          { __typename: 'SenderAddress' } & Pick<
            SenderAddress,
            | 'city'
            | 'houseNumber'
            | 'id'
            | 'orientationNumber'
            | 'senderName'
            | 'street'
            | 'zipCode'
          >
        >
        recipients: {
          __typename: 'PostserviceSentRecipientsConnection'
        } & Pick<PostserviceSentRecipientsConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename: 'PostserviceSentRecipient' } & Pick<
                  PostserviceSentRecipient,
                  | 'callName'
                  | 'city'
                  | 'companyName'
                  | 'country'
                  | 'firstname'
                  | 'gender'
                  | 'houseNumber'
                  | 'id'
                  | 'lastname'
                  | 'orientationNumber'
                  | 'street'
                  | 'variable1'
                  | 'variable10'
                  | 'variable2'
                  | 'variable3'
                  | 'variable4'
                  | 'variable5'
                  | 'variable6'
                  | 'variable7'
                  | 'variable8'
                  | 'variable9'
                  | 'zipCode'
                  | 'propertyId'
                  | 'propertyType'
                  | 'propertyLv'
                  | 'propertyCadastralCode'
                  | 'propertyCadastralName'
                  | 'propertyCity'
                  | 'propertyAddress'
                  | 'propertyAreaNumber'
                  | 'propertyName'
                >
              >
            >
          }
      }
  >
}

export type PostServiceStatisticsQueryVariables = Exact<{
  [key: string]: never
}>

export type PostServiceStatisticsQuery = { __typename: 'Query' } & {
  allPostserviceSentLetters?: Maybe<
    { __typename: 'PostserviceSentLettersConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'PostserviceSentLetter' } & Pick<
            PostserviceSentLetter,
            | 'accountId'
            | 'accountUserId'
            | 'createdAt'
            | 'id'
            | 'description'
            | 'name'
          > & { dispatchDate: PostserviceSentLetter['sentAt'] } & {
              senderAddress?: Maybe<
                { __typename: 'SenderAddress' } & Pick<
                  SenderAddress,
                  'senderName' | 'city'
                >
              >
              recipients: {
                __typename: 'PostserviceSentRecipientsConnection'
              } & Pick<PostserviceSentRecipientsConnection, 'totalCount'>
            }
        >
      >
    }
  >
}

export type UnitRentByCadastralCodeQueryVariables = Exact<{
  cadastralAreaCode: Scalars['String']
}>

export type UnitRentByCadastralCodeQuery = { __typename: 'Query' } & {
  unitRentByCadastralAreaCode?: Maybe<
    { __typename: 'UnitRent' } & Pick<
      UnitRent,
      | 'cadastralAreaCode'
      | 'cadastralAreaName'
      | 'cityName'
      | 'vk1DataCoverage'
      | 'vk1LowerInterval'
      | 'vk1UpperInterval'
      | 'vk1Minimum'
      | 'vk1Maximum'
      | 'vk1Median'
      | 'vk1Reference'
      | 'vk1NewBuilding'
      | 'vk2DataCoverage'
      | 'vk2LowerInterval'
      | 'vk2UpperInterval'
      | 'vk2Minimum'
      | 'vk2Maximum'
      | 'vk2Median'
      | 'vk2Reference'
      | 'vk2NewBuilding'
      | 'vk3DataCoverage'
      | 'vk3LowerInterval'
      | 'vk3UpperInterval'
      | 'vk3Minimum'
      | 'vk3Maximum'
      | 'vk3Median'
      | 'vk3Reference'
      | 'vk3NewBuilding'
      | 'vk4DataCoverage'
      | 'vk4LowerInterval'
      | 'vk4UpperInterval'
      | 'vk4Minimum'
      | 'vk4Maximum'
      | 'vk4Median'
      | 'vk4Reference'
      | 'vk4NewBuilding'
    >
  >
}

export type CreateAddressMutationMutationVariables = Exact<{
  budovaregestaid?: InputMaybe<Scalars['UUID']>
  castobce?: InputMaybe<Scalars['String']>
  cislodomovni?: InputMaybe<Scalars['Int']>
  cisloorientacni?: InputMaybe<Scalars['Int']>
  cisloorientacnipismeno?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['Datetime']>
  kod?: InputMaybe<Scalars['String']>
  kraj?: InputMaybe<Scalars['String']>
  obec?: InputMaybe<Scalars['String']>
  okres?: InputMaybe<Scalars['String']>
  psc?: InputMaybe<Scalars['String']>
  radnice?: InputMaybe<Scalars['String']>
  typbudovy?: InputMaybe<Scalars['String']>
  ulice?: InputMaybe<Scalars['String']>
}>

export type CreateAddressMutationMutation = { __typename: 'Mutation' } & {
  createAddress?: Maybe<
    { __typename: 'CreateAddressPayload' } & {
      address?: Maybe<{ __typename: 'Address' } & Pick<Address, 'id'>>
    }
  >
}

export type CreateCeeExecutionMutationVariables = Exact<{
  address?: InputMaybe<Scalars['String']>
  birthDate?: InputMaybe<Scalars['Date']>
  ceeEvent?: InputMaybe<Scalars['String']>
  detailCode?: InputMaybe<Scalars['String']>
  executionDate?: InputMaybe<Scalars['Date']>
  executorCode?: InputMaybe<Scalars['String']>
  executorName?: InputMaybe<Scalars['String']>
  fullname?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  rc?: InputMaybe<Scalars['String']>
  spzn?: InputMaybe<Scalars['String']>
  updateDate?: InputMaybe<Scalars['Date']>
  monitoringCeeId: Scalars['UUID']
  identificationCode?: InputMaybe<Scalars['String']>
}>

export type CreateCeeExecutionMutation = { __typename: 'Mutation' } & {
  createCeeExecution?: Maybe<
    { __typename: 'CreateCeeExecutionPayload' } & {
      ceeExecution?: Maybe<
        { __typename: 'CeeExecution' } & Pick<CeeExecution, 'id'>
      >
    }
  >
}

export type CreateDataBoxMutationVariables = Exact<{
  adresnimistokod?: InputMaybe<Scalars['String']>
  birthname?: InputMaybe<Scalars['String']>
  businessname?: InputMaybe<Scalars['String']>
  databoxid: Scalars['String']
  type?: InputMaybe<Scalars['String']>
  subtype?: InputMaybe<Scalars['String']>
  pdz?: InputMaybe<Scalars['Boolean']>
  ovm?: InputMaybe<Scalars['Boolean']>
  masterid?: InputMaybe<Scalars['String']>
  lastname?: InputMaybe<Scalars['String']>
  middlename?: InputMaybe<Scalars['String']>
  ismaster?: InputMaybe<Scalars['Boolean']>
  idovm?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  fulladdress?: InputMaybe<Scalars['String']>
  firstname?: InputMaybe<Scalars['String']>
}>

export type CreateDataBoxMutation = { __typename: 'Mutation' } & {
  createDatabox?: Maybe<
    { __typename: 'CreateDataboxPayload' } & {
      databox?: Maybe<{ __typename: 'Databox' } & Pick<Databox, 'id'>>
    }
  >
}

export type CreateCeeExecutionDetailMutationVariables = Exact<{
  castka?: InputMaybe<Scalars['String']>
  ceeExecutionId?: InputMaybe<Scalars['UUID']>
  datum?: InputMaybe<Scalars['String']>
  detailCode?: InputMaybe<Scalars['String']>
  exekutorskyUrad?: InputMaybe<Scalars['String']>
  ico?: InputMaybe<Scalars['String']>
  nepenezitaPovinost?: InputMaybe<Scalars['String']>
  povinnaOsoba?: InputMaybe<Scalars['String']>
  pravidelnaSplatka?: InputMaybe<Scalars['String']>
  rc?: InputMaybe<Scalars['String']>
  soud?: InputMaybe<Scalars['String']>
  spznExekutora?: InputMaybe<Scalars['String']>
  spznSoudu?: InputMaybe<Scalars['String']>
  titul?: InputMaybe<Scalars['String']>
  accountId?: InputMaybe<Scalars['UUID']>
  accountUserId?: InputMaybe<Scalars['UUID']>
}>

export type CreateCeeExecutionDetailMutation = { __typename: 'Mutation' } & {
  createCeeExecutionDetail?: Maybe<
    { __typename: 'CreateCeeExecutionDetailPayload' } & {
      ceeExecutionDetail?: Maybe<
        { __typename: 'CeeExecutionDetail' } & Pick<CeeExecutionDetail, 'id'>
      >
    }
  >
}

export type CreateDocumentCollectionMutationVariables = Exact<{
  format: Scalars['String']
  nazev: Scalars['String']
  rizeni: Scalars['String']
  stav: Scalars['String']
  accountUserId: Scalars['UUID']
  accountId: Scalars['UUID']
  cuzkDocumentId: Scalars['String']
  cuzkCollectionId: Scalars['String']
  datumspusteni: Scalars['Datetime']
  datumpozadavku: Scalars['Datetime']
}>

export type CreateDocumentCollectionMutation = { __typename: 'Mutation' } & {
  createCuzkDocumentCollection?: Maybe<
    { __typename: 'CreateCuzkDocumentCollectionPayload' } & {
      cuzkDocumentCollection?: Maybe<
        { __typename: 'CuzkDocumentCollection' } & Pick<
          CuzkDocumentCollection,
          'id'
        >
      >
    }
  >
}

export type CreateEpoLienMutationVariables = Exact<{
  input: CreateCuzkEpoLienInput
}>

export type CreateEpoLienMutation = { __typename: 'Mutation' } & {
  createCuzkEpoLien?: Maybe<
    { __typename: 'CreateCuzkEpoLienPayload' } & {
      cuzkEpoLien?: Maybe<
        { __typename: 'CuzkEpoLien' } & Pick<CuzkEpoLien, 'id'>
      >
    }
  >
}

export type CreateEpoMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  cuzkCollectionId: Scalars['String']
  datumpozadavku: Scalars['Datetime']
  datumspusteni: Scalars['Datetime']
  format: Scalars['String']
  nazev: Scalars['String']
  rcIco: Scalars['String']
  stav: Scalars['String']
  typ: Scalars['String']
}>

export type CreateEpoMutation = { __typename: 'Mutation' } & {
  createCuzkEpo?: Maybe<
    { __typename: 'CreateCuzkEpoPayload' } & {
      cuzkEpo?: Maybe<{ __typename: 'CuzkEpo' } & Pick<CuzkEpo, 'id'>>
    }
  >
}

export type CreateEpoRestrictionCheckMutationVariables = Exact<{
  cuzkEpoRestrictionCheck: CuzkEpoRestrictionCheckInput
}>

export type CreateEpoRestrictionCheckMutation = { __typename: 'Mutation' } & {
  createCuzkEpoRestrictionCheck?: Maybe<
    { __typename: 'CreateCuzkEpoRestrictionCheckPayload' } & {
      cuzkEpoRestrictionCheck?: Maybe<
        { __typename: 'CuzkEpoRestrictionCheck' } & Pick<
          CuzkEpoRestrictionCheck,
          'id'
        >
      >
    }
  >
}

export type CreateLvMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  cuzkCollectionId: Scalars['String']
  datumK?: InputMaybe<Scalars['Date']>
  datumpozadavku: Scalars['Datetime']
  datumspusteni: Scalars['Datetime']
  format: Scalars['String']
  katastralniUzemiKod: Scalars['String']
  katastralniUzemiNazev?: InputMaybe<Scalars['String']>
  obec?: InputMaybe<Scalars['String']>
  lv: Scalars['String']
  stav: Scalars['String']
}>

export type CreateLvMutation = { __typename: 'Mutation' } & {
  createCuzkLv?: Maybe<
    { __typename: 'CreateCuzkLvPayload' } & {
      cuzkLv?: Maybe<{ __typename: 'CuzkLv' } & Pick<CuzkLv, 'id'>>
    }
  >
}

export type CreateMarketplaceOfferAccessMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  offerId: Scalars['UUID']
}>

export type CreateMarketplaceOfferAccessMutation = {
  __typename: 'Mutation'
} & {
  createMarketplaceOfferAccess?: Maybe<
    { __typename: 'CreateMarketplaceOfferAccessPayload' } & {
      marketplaceOfferByOfferId?: Maybe<
        { __typename: 'MarketplaceOffer' } & Pick<MarketplaceOffer, 'id'>
      >
    }
  >
}

export type MyMutationMutationVariables = Exact<{
  estimateToDate: Scalars['Date']
  accountId: Scalars['UUID']
  accountUserId?: InputMaybe<Scalars['UUID']>
  propertyId: Scalars['UUID']
  cenaM2Nab?: InputMaybe<Scalars['BigFloat']>
  cenaM2Real?: InputMaybe<Scalars['BigFloat']>
  cenaNab?: InputMaybe<Scalars['BigFloat']>
  cenaReal?: InputMaybe<Scalars['BigFloat']>
  decompNab?: InputMaybe<Scalars['String']>
  decompReal?: InputMaybe<Scalars['String']>
  graphImageString?: InputMaybe<Scalars['String']>
  timeSeriesGraph?: InputMaybe<Scalars['String']>
  kodObce?: InputMaybe<Scalars['Int']>
  lat: Scalars['BigFloat']
  lon: Scalars['BigFloat']
  modelVersion?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  publicNote?: InputMaybe<Scalars['String']>
  propertyType: Scalars['Int']
  requestData: Scalars['String']
  lvData?: InputMaybe<Scalars['String']>
  risyData?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  polygon?: InputMaybe<Scalars['String']>
}>

export type MyMutationMutation = { __typename: 'Mutation' } & {
  createMonit?: Maybe<
    { __typename: 'CreateMonitPayload' } & {
      monit?: Maybe<{ __typename: 'Monit' } & Pick<Monit, 'id'>>
    }
  >
}

export type CreateRecipientListOnServerMutationVariables = Exact<{
  accountId: Scalars['UUID']
  accountUserId: Scalars['UUID']
  nazev: Scalars['String']
  temporaryRecipientsJson?: InputMaybe<Scalars['String']>
}>

export type CreateRecipientListOnServerMutation = { __typename: 'Mutation' } & {
  createRecipientList?: Maybe<
    { __typename: 'CreateRecipientListPayload' } & {
      recipientList?: Maybe<
        { __typename: 'RecipientList' } & Pick<RecipientList, 'id'>
      >
    }
  >
}

export type CreateRecipientListRecipientMutationVariables = Exact<{
  recipientId: Scalars['UUID']
  recipientListId: Scalars['UUID']
  propertyType?: InputMaybe<Scalars['String']>
  propertyName?: InputMaybe<Scalars['String']>
  propertyId?: InputMaybe<Scalars['UUID']>
}>

export type CreateRecipientListRecipientMutation = {
  __typename: 'Mutation'
} & {
  createRecipientListRecipient?: Maybe<
    { __typename: 'CreateRecipientListRecipientPayload' } & {
      recipientListRecipient?: Maybe<
        { __typename: 'RecipientListRecipient' } & Pick<
          RecipientListRecipient,
          'id'
        >
      >
    }
  >
}

export type CreateRecipientMutationMutationVariables = Exact<{
  adresnimistokod?: InputMaybe<Scalars['String']>
  createdAt1?: InputMaybe<Scalars['Datetime']>
  fyzickaosoba?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['UUID']>
  krestnijmeno?: InputMaybe<Scalars['String']>
  nazev?: InputMaybe<Scalars['String']>
  osloveni?: InputMaybe<Scalars['String']>
  pohlavi?: InputMaybe<Scalars['String']>
  prijmeni?: InputMaybe<Scalars['String']>
  titulpred?: InputMaybe<Scalars['String']>
  titulza?: InputMaybe<Scalars['String']>
}>

export type CreateRecipientMutationMutation = { __typename: 'Mutation' } & {
  createRecipient?: Maybe<
    { __typename: 'CreateRecipientPayload' } & {
      recipient?: Maybe<{ __typename: 'Recipient' } & Pick<Recipient, 'id'>>
    }
  >
}

export type DeleteDocumentCollectionMutationMutationVariables = Exact<{
  id: Scalars['UUID']
}>

export type DeleteDocumentCollectionMutationMutation = {
  __typename: 'Mutation'
} & {
  deleteCuzkDocumentCollectionById?: Maybe<
    { __typename: 'DeleteCuzkDocumentCollectionPayload' } & Pick<
      DeleteCuzkDocumentCollectionPayload,
      'deletedCuzkDocumentCollectionId'
    >
  >
}

export type DeleteEpoMutationMutationVariables = Exact<{
  id: Scalars['UUID']
}>

export type DeleteEpoMutationMutation = { __typename: 'Mutation' } & {
  deleteCuzkEpoById?: Maybe<
    { __typename: 'DeleteCuzkEpoPayload' } & Pick<
      DeleteCuzkEpoPayload,
      'deletedCuzkEpoId'
    >
  >
}

export type DeleteLvMutationMutationVariables = Exact<{
  id: Scalars['UUID']
}>

export type DeleteLvMutationMutation = { __typename: 'Mutation' } & {
  deleteCuzkLvById?: Maybe<
    { __typename: 'DeleteCuzkLvPayload' } & Pick<
      DeleteCuzkLvPayload,
      'deletedCuzkLvId'
    >
  >
}

export type UpdateMarketplaceOfferMutationVariables = Exact<{
  id: Scalars['UUID']
}>

export type UpdateMarketplaceOfferMutation = { __typename: 'Mutation' } & {
  updateMarketplaceOfferById?: Maybe<
    { __typename: 'UpdateMarketplaceOfferPayload' } & {
      marketplaceOffer?: Maybe<
        { __typename: 'MarketplaceOffer' } & Pick<MarketplaceOffer, 'id'>
      >
    }
  >
}

export type EpoRestrictionCheckByCodesQueryVariables = Exact<{
  cuzkEpoId: Scalars['UUID']
  codes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>
}>

export type EpoRestrictionCheckByCodesQuery = { __typename: 'Query' } & {
  cuzkEpoById?: Maybe<
    { __typename: 'CuzkEpo' } & {
      cuzkEpoRestrictionChecksByCuzkEpoId: {
        __typename: 'CuzkEpoRestrictionChecksConnection'
      } & {
        nodes: Array<
          Maybe<
            { __typename: 'CuzkEpoRestrictionCheck' } & Pick<
              CuzkEpoRestrictionCheck,
              'id' | 'katastralniPracovisteKod'
            > & {
                cuzkEpoLiensByRestrictionCheckId: {
                  __typename: 'CuzkEpoLiensConnection'
                } & Pick<CuzkEpoLiensConnection, 'totalCount'>
              }
          >
        >
      }
    }
  >
}

export type EpoRestrictionCheckInProgressQueryVariables = Exact<{
  accountId: Scalars['UUID']
  cuzkEpoId: Scalars['UUID']
}>

export type EpoRestrictionCheckInProgressQuery = { __typename: 'Query' } & {
  allCuzkEpoRestrictionChecks?: Maybe<
    { __typename: 'CuzkEpoRestrictionChecksConnection' } & {
      nodes: Array<
        Maybe<
          { __typename: 'CuzkEpoRestrictionCheck' } & Pick<
            CuzkEpoRestrictionCheck,
            | 'katastralniPracovisteNazev'
            | 'katastralniUradNazev'
            | 'katastralniPracovisteKod'
            | 'katastralniUradKod'
            | 'lvKeKontrolePocet'
            | 'boughtAt'
            | 'checkedBy'
            | 'state'
            | 'id'
          > & {
              cuzkEpoLiensByRestrictionCheckId: {
                __typename: 'CuzkEpoLiensConnection'
              } & Pick<CuzkEpoLiensConnection, 'totalCount'>
            }
        >
      >
    }
  >
}

export type ReadEpoRestrictionCheckQueryVariables = Exact<{
  id: Scalars['UUID']
}>

export type ReadEpoRestrictionCheckQuery = { __typename: 'Query' } & {
  cuzkEpoById?: Maybe<
    { __typename: 'CuzkEpo' } & Pick<CuzkEpo, 'pocetLv'> & {
        cuzkEpoRestrictionChecksByCuzkEpoId: {
          __typename: 'CuzkEpoRestrictionChecksConnection'
        } & Pick<CuzkEpoRestrictionChecksConnection, 'totalCount'> & {
            nodes: Array<
              Maybe<
                { __typename: 'CuzkEpoRestrictionCheck' } & Pick<
                  CuzkEpoRestrictionCheck,
                  | 'boughtAt'
                  | 'id'
                  | 'katastralniPracovisteKod'
                  | 'katastralniPracovisteNazev'
                  | 'katastralniUradKod'
                  | 'katastralniUradNazev'
                  | 'lvKeKontrolePocet'
                  | 'state'
                >
              >
            >
          }
      }
  >
}

export type CuzkEpoByIdQueryVariables = Exact<{
  accountId: Scalars['UUID']
  cuzkEpoId: Scalars['UUID']
}>

export type CuzkEpoByIdQuery = { __typename: 'Query' } & {
  allCuzkEpoRestrictionChecks?: Maybe<
    { __typename: 'CuzkEpoRestrictionChecksConnection' } & Pick<
      CuzkEpoRestrictionChecksConnection,
      'totalCount'
    > & {
        nodes: Array<
          Maybe<
            { __typename: 'CuzkEpoRestrictionCheck' } & Pick<
              CuzkEpoRestrictionCheck,
              'katastralniPracovisteNazev' | 'katastralniUradNazev'
            > & {
                cuzkEpoLiensByRestrictionCheckId: {
                  __typename: 'CuzkEpoLiensConnection'
                } & Pick<CuzkEpoLiensConnection, 'totalCount'> & {
                    nodes: Array<
                      Maybe<
                        { __typename: 'CuzkEpoLien' } & Pick<
                          CuzkEpoLien,
                          | 'katastralniUzemiNazev'
                          | 'obec'
                          | 'okres'
                          | 'parcelyPocet'
                          | 'predkupniPravo'
                          | 'restrictionCheckId'
                          | 'rizeni'
                          | 'vlastniciPocet'
                          | 'zastavyNedobrovolne'
                          | 'lv'
                          | 'katastralniUzemiKod'
                          | 'jednotkyPocet'
                          | 'insolvence'
                          | 'id'
                          | 'exekuce'
                          | 'budovyPocet'
                        >
                      >
                    >
                  }
              }
          >
        >
      }
  >
  cuzkEpoById?: Maybe<
    { __typename: 'CuzkEpo' } & Pick<CuzkEpo, 'pocetLv'> & {
        cuzkEpoRestrictionChecksByCuzkEpoId: {
          __typename: 'CuzkEpoRestrictionChecksConnection'
        } & Pick<CuzkEpoRestrictionChecksConnection, 'totalCount'>
      }
  >
}

export type UpdateDocumentCollectionMutationVariables = Exact<{
  id: Scalars['UUID']
  stav?: InputMaybe<Scalars['String']>
  pocetstran?: InputMaybe<Scalars['Int']>
  pocetjednotek?: InputMaybe<Scalars['Int']>
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  casoveraziko?: InputMaybe<Scalars['String']>
  cena?: InputMaybe<Scalars['BigFloat']>
  elznacka?: InputMaybe<Scalars['String']>
}>

export type UpdateDocumentCollectionMutation = { __typename: 'Mutation' } & {
  updateCuzkDocumentCollectionById?: Maybe<
    { __typename: 'UpdateCuzkDocumentCollectionPayload' } & {
      cuzkDocumentCollection?: Maybe<
        { __typename: 'CuzkDocumentCollection' } & Pick<
          CuzkDocumentCollection,
          'id'
        >
      >
    }
  >
}

export type UpdateCuzkEpoMutationVariables = Exact<{
  id: Scalars['UUID']
  stav?: InputMaybe<Scalars['String']>
  pocetstran?: InputMaybe<Scalars['Int']>
  pocetjednotek?: InputMaybe<Scalars['Int']>
  pocetLv?: InputMaybe<Scalars['Int']>
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  cena?: InputMaybe<Scalars['BigFloat']>
  elznacka?: InputMaybe<Scalars['String']>
  adresnimistokod?: InputMaybe<Scalars['String']>
}>

export type UpdateCuzkEpoMutation = { __typename: 'Mutation' } & {
  updateCuzkEpoById?: Maybe<
    { __typename: 'UpdateCuzkEpoPayload' } & {
      cuzkEpo?: Maybe<{ __typename: 'CuzkEpo' } & Pick<CuzkEpo, 'id'>>
    }
  >
}

export type UpdateEpoRestrictionCheckByIdMutationVariables = Exact<{
  id: Scalars['UUID']
  boughtAt?: InputMaybe<Scalars['Datetime']>
  checkedAt?: InputMaybe<Scalars['Datetime']>
  boughtBy?: InputMaybe<Scalars['UUID']>
  checkedBy?: InputMaybe<Scalars['UUID']>
  state?: InputMaybe<RestrictionCheckState>
}>

export type UpdateEpoRestrictionCheckByIdMutation = {
  __typename: 'Mutation'
} & {
  updateCuzkEpoRestrictionCheckById?: Maybe<
    { __typename: 'UpdateCuzkEpoRestrictionCheckPayload' } & Pick<
      UpdateCuzkEpoRestrictionCheckPayload,
      'clientMutationId'
    >
  >
}

export type UpdateEpoRestrictionCheckMutationVariables = Exact<{
  nodeId: Scalars['ID']
  boughtAt?: InputMaybe<Scalars['Datetime']>
  boughtBy?: InputMaybe<Scalars['UUID']>
  checkedAt?: InputMaybe<Scalars['Datetime']>
  checkedBy?: InputMaybe<Scalars['UUID']>
  state?: InputMaybe<RestrictionCheckState>
}>

export type UpdateEpoRestrictionCheckMutation = { __typename: 'Mutation' } & {
  updateCuzkEpoRestrictionCheck?: Maybe<
    { __typename: 'UpdateCuzkEpoRestrictionCheckPayload' } & Pick<
      UpdateCuzkEpoRestrictionCheckPayload,
      'clientMutationId'
    >
  >
}

export type UpdateCuzkLvMutationVariables = Exact<{
  id: Scalars['UUID']
  stav?: InputMaybe<Scalars['String']>
  pocetstran?: InputMaybe<Scalars['Int']>
  pocetjednotek?: InputMaybe<Scalars['Int']>
  datumvytvoreni?: InputMaybe<Scalars['Datetime']>
  cena?: InputMaybe<Scalars['BigFloat']>
  elznacka?: InputMaybe<Scalars['String']>
}>

export type UpdateCuzkLvMutation = { __typename: 'Mutation' } & {
  updateCuzkLvById?: Maybe<
    { __typename: 'UpdateCuzkLvPayload' } & {
      cuzkLv?: Maybe<{ __typename: 'CuzkLv' } & Pick<CuzkLv, 'id'>>
    }
  >
}

export type UpdateMonitoringCeeMutationVariables = Exact<{
  lastCheck?: InputMaybe<Scalars['Datetime']>
  checkFrequency?: InputMaybe<Scalars['Int']>
  found?: InputMaybe<Scalars['Boolean']>
  birthDate?: InputMaybe<Scalars['Date']>
  firstname?: InputMaybe<Scalars['String']>
  lastname?: InputMaybe<Scalars['String']>
  executionCount?: InputMaybe<Scalars['Int']>
  errorState?: InputMaybe<Scalars['Boolean']>
  id: Scalars['UUID']
}>

export type UpdateMonitoringCeeMutation = { __typename: 'Mutation' } & {
  updateMonitoringCeeById?: Maybe<
    { __typename: 'UpdateMonitoringCeePayload' } & {
      monitoringCee?: Maybe<
        { __typename: 'MonitoringCee' } & Pick<MonitoringCee, 'id'>
      >
    }
  >
}

export type UpdateRecipientListByIdMutationVariables = Exact<{
  letterText?: InputMaybe<Scalars['String']>
  id: Scalars['UUID']
}>

export type UpdateRecipientListByIdMutation = { __typename: 'Mutation' } & {
  updateRecipientListById?: Maybe<
    { __typename: 'UpdateRecipientListPayload' } & {
      recipientList?: Maybe<
        { __typename: 'RecipientList' } & Pick<RecipientList, 'id'>
      >
    }
  >
}

export type UpdaterecipientListRecipientMutationVariables = Exact<{
  id: Scalars['UUID']
  postserviceId: Scalars['String']
}>

export type UpdaterecipientListRecipientMutation = {
  __typename: 'Mutation'
} & {
  updateRecipientListRecipientById?: Maybe<
    { __typename: 'UpdateRecipientListRecipientPayload' } & Pick<
      UpdateRecipientListRecipientPayload,
      'clientMutationId'
    >
  >
}

export type UpdateRecipientListMutationVariables = Exact<{
  id: Scalars['UUID']
  dispatchDate?: InputMaybe<Scalars['Datetime']>
}>

export type UpdateRecipientListMutation = { __typename: 'Mutation' } & {
  updateRecipientListById?: Maybe<
    { __typename: 'UpdateRecipientListPayload' } & Pick<
      UpdateRecipientListPayload,
      'clientMutationId'
    >
  >
}

export type UpdatePostServiceSentLetterMutationVariables = Exact<{
  letterId: Scalars['UUID']
  sentAt?: InputMaybe<Scalars['Datetime']>
  sentByUserId?: InputMaybe<Scalars['UUID']>
  postserviceType?: InputMaybe<PostserviceLetterType>
}>

export type UpdatePostServiceSentLetterMutation = { __typename: 'Mutation' } & {
  updatePostserviceSentLetterById?: Maybe<
    { __typename: 'UpdatePostserviceSentLetterPayload' } & Pick<
      UpdatePostserviceSentLetterPayload,
      'clientMutationId'
    >
  >
}

export type UpdatePostserviceSentRecipientByIdMutationVariables = Exact<{
  id: Scalars['UUID']
  postserviceId?: InputMaybe<Scalars['String']>
  postserviceTrackingNumber?: InputMaybe<Scalars['String']>
}>

export type UpdatePostserviceSentRecipientByIdMutation = {
  __typename: 'Mutation'
} & {
  updatePostserviceSentRecipientById?: Maybe<
    { __typename: 'UpdatePostserviceSentRecipientPayload' } & Pick<
      UpdatePostserviceSentRecipientPayload,
      'clientMutationId'
    >
  >
}

import { IntrospectionQuery } from 'graphql'
export default {
  __schema: {
    queryType: {
      name: 'Query',
    },
    mutationType: {
      name: 'Mutation',
    },
    subscriptionType: null,
    types: [
      {
        kind: 'OBJECT',
        name: 'Address',
        fields: [
          {
            name: 'budovaregestaid',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'castobce',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cislodomovni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cisloorientacni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cisloorientacnipismeno',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'kod',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kraj',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'obec',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'okres',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'psc',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'radnice',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'recipientsByAdresnimistokod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'RecipientsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'typbudovy',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ulice',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'AddressesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'AddressesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'Address',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'AddressesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'AuctionListing',
        fields: [
          {
            name: 'auctionDecreeText',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'auctionDecreeUrl',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'auctionNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'auctionPropertiesByAuctionId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'AuctionPropertiesConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'auctionedOn',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'detailUrl',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'endDate',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'ku',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'labelConnectionsByAuctionListingId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'lat',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'long',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'obec',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'photoUrl',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'price',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'ruianId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'slug',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'sourceHostname',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'startDate',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'state',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'title',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'type',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'updatedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'userActivityLogsByAuctionListingId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'UserActivityLogsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'AuctionListingsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'AuctionListingsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'AuctionListing',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'AuctionListingsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'AuctionPropertiesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'AuctionPropertiesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'AuctionProperty',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'AuctionPropertiesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'AuctionProperty',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'AuctionProperty',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'auctionId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'auctionListingByAuctionId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'Bpej',
        fields: [
          {
            name: 'cena',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'kod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'platnostDo',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'platnostOd',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'popis',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'BpejsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'BpejsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'Bpej',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'BpejsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'Bpej',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'BuybackCalculation',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cadastralCode',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'calculatorVersion',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'deletedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'formData',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'lv',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'priceEstimateId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'title',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'updatedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'BuybackCalculationsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'BuybackCalculationsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'BuybackCalculation',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'BuybackCalculationsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'BuybackCalculation',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CeeExecution',
        fields: [
          {
            name: 'address',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'birthDate',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ceeEvent',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ceeExecutionDetailsByCeeExecutionId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'CeeExecutionDetailsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'ceeOfficeByExecutorCode',
            type: {
              kind: 'OBJECT',
              name: 'CeeOffice',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'detailCode',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'executionDate',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'executorCode',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'executorName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'fullname',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ico',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'identificationCode',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'rc',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'spzn',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'updateDate',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'CeeExecutionDetail',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'castka',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ceeExecutionByCeeExecutionId',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecution',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeExecutionId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'datum',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'detailCode',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'exekutorskyUrad',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ico',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nepenezitaPovinost',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'povinnaOsoba',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'pravidelnaSplatka',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'rc',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'soud',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'spznExekutora',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'spznSoudu',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'titul',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'CeeExecutionDetailsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CeeExecutionDetailsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'CeeExecutionDetail',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CeeExecutionDetailsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionDetail',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CeeExecutionsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CeeExecutionsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'CeeExecution',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CeeExecutionsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecution',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CeeOffice',
        fields: [
          {
            name: 'address',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'area',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ceeExecutionsByExecutorCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'CeeExecutionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'databox',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'dic',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'email',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'executorCode',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ico',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'note',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'phone',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'web',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'CeeOfficesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CeeOfficesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'CeeOffice',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CeeOfficesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'CeeOffice',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateAddressPayload',
        fields: [
          {
            name: 'address',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'addressEdge',
            type: {
              kind: 'OBJECT',
              name: 'AddressesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateAuctionListingPayload',
        fields: [
          {
            name: 'auctionListing',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionListingEdge',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListingsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateAuctionPropertyPayload',
        fields: [
          {
            name: 'auctionListingByAuctionId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionProperty',
            type: {
              kind: 'OBJECT',
              name: 'AuctionProperty',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionPropertyEdge',
            type: {
              kind: 'OBJECT',
              name: 'AuctionPropertiesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateBpejPayload',
        fields: [
          {
            name: 'bpej',
            type: {
              kind: 'OBJECT',
              name: 'Bpej',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'bpejEdge',
            type: {
              kind: 'OBJECT',
              name: 'BpejsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateBuybackCalculationPayload',
        fields: [
          {
            name: 'buybackCalculation',
            type: {
              kind: 'OBJECT',
              name: 'BuybackCalculation',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'buybackCalculationEdge',
            type: {
              kind: 'OBJECT',
              name: 'BuybackCalculationsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateCeeExecutionDetailPayload',
        fields: [
          {
            name: 'ceeExecutionByCeeExecutionId',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecution',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeExecutionDetail',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionDetail',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeExecutionDetailEdge',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionDetailsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateCeeExecutionPayload',
        fields: [
          {
            name: 'ceeExecution',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecution',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeExecutionEdge',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'ceeOfficeByExecutorCode',
            type: {
              kind: 'OBJECT',
              name: 'CeeOffice',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateCeeOfficePayload',
        fields: [
          {
            name: 'ceeOffice',
            type: {
              kind: 'OBJECT',
              name: 'CeeOffice',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeOfficeEdge',
            type: {
              kind: 'OBJECT',
              name: 'CeeOfficesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateCuzkDocumentCollectionPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollection',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollection',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollectionEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollectionsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateCuzkEpoLienPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpoLien',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLien',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoLienEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLiensEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkEpoRestrictionCheckByRestrictionCheckId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionCheck',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateCuzkEpoPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpo',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEposEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateCuzkEpoRestrictionCheckPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpoByCuzkEpoId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoRestrictionCheck',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionCheck',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoRestrictionCheckEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionChecksEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateCuzkLvPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkLv',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLv',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkLvEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLvsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateCuzkOPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkO',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOByPartner1',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOByPartner2',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkOsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateDataboxPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'databox',
            type: {
              kind: 'OBJECT',
              name: 'Databox',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'databoxEdge',
            type: {
              kind: 'OBJECT',
              name: 'DataboxesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateKuAreaPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuArea',
            type: {
              kind: 'OBJECT',
              name: 'KuArea',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'kuAreaEdge',
            type: {
              kind: 'OBJECT',
              name: 'KuAreasEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'kuWorkplaceByPraresKod',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateKuWorkplacePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuWorkplace',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'kuWorkplaceByNadrizPrac',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'kuWorkplaceEdge',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplacesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateLabelConnectionPayload',
        fields: [
          {
            name: 'auctionListingByAuctionListingId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollectionByCuzkDocumentCollectionId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollection',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoByCuzkEpoId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoLienByCuzkEpoLienId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLien',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkLvByCuzkLvId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLv',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelByLabelId',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelConnection',
            type: {
              kind: 'OBJECT',
              name: 'LabelConnection',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelConnectionEdge',
            type: {
              kind: 'OBJECT',
              name: 'LabelConnectionsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'marketplaceOfferByMarketplaceOfferId',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitByMonitId',
            type: {
              kind: 'OBJECT',
              name: 'Monit',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcByMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceListByPostserviceListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyLabelByPropertyLabelId',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabel',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListByRecipientListId',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateLabelMonitoringCuzkRcPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'labelByLabelId',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelMonitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'LabelMonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelMonitoringCuzkRcEdge',
            type: {
              kind: 'OBJECT',
              name: 'LabelMonitoringCuzkRcsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'monitoringCuzkRcByMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateLabelPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'label',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelEdge',
            type: {
              kind: 'OBJECT',
              name: 'LabelsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateMarketplaceOfferAccessPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'marketplaceOfferAccess',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOfferAccess',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'marketplaceOfferAccessEdge',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOfferAccessesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'marketplaceOfferByOfferId',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateMarketplaceOfferPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'marketplaceOffer',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'marketplaceOfferEdge',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffersEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateMonitPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monit',
            type: {
              kind: 'OBJECT',
              name: 'Monit',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitEdge',
            type: {
              kind: 'OBJECT',
              name: 'MonitsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateMonitoringCeePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCee',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeEdge',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCeesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateMonitoringCuzkRcPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkOByCuzkOsId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcEdge',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRcsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateMunicipalOfficePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'municipalOffice',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOffice',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'municipalOfficeEdge',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOfficesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreatePostserviceListPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceList',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceListEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceListsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreatePostserviceRecipientPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceListByPostserviceListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceRecipient',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceRecipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreatePostserviceSentLetterPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceListByOriginalListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentLetter',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLetter',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentLetterEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLettersEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceTemplateByOriginalTemplateId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplate',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddressBySenderAddressId',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreatePostserviceSentRecipientPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceRecipientByOriginalRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentLetterBySentLetterId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLetter',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentRecipient',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentRecipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentRecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreatePostserviceTemplatePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceTemplate',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplate',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceTemplateEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplatesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreatePropertyLabelPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyLabel',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabel',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyLabelEdge',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabelsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreatePropertyListPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyList',
            type: {
              kind: 'OBJECT',
              name: 'PropertyList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyListEdge',
            type: {
              kind: 'OBJECT',
              name: 'PropertyListsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreatePropertyNotePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyNote',
            type: {
              kind: 'OBJECT',
              name: 'PropertyNote',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyNoteEdge',
            type: {
              kind: 'OBJECT',
              name: 'PropertyNotesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateRecipientListPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientList',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListEdge',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'senderAddressBySenderAddressId',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateRecipientListRecipientPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientByRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'Recipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListByRecipientListId',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListRecipient',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListRecipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateRecipientPayload',
        fields: [
          {
            name: 'addressByAdresnimistokod',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipient',
            type: {
              kind: 'OBJECT',
              name: 'Recipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'RecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateSenderAddressPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddress',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddressEdge',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddressesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateUnitRentPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'unitRent',
            type: {
              kind: 'OBJECT',
              name: 'UnitRent',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'unitRentEdge',
            type: {
              kind: 'OBJECT',
              name: 'UnitRentsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CreateUserActivityLogPayload',
        fields: [
          {
            name: 'auctionListingByAuctionListingId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'userActivityLog',
            type: {
              kind: 'OBJECT',
              name: 'UserActivityLog',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'userActivityLogEdge',
            type: {
              kind: 'OBJECT',
              name: 'UserActivityLogsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkDocumentCollection',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'casoveraziko',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cena',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cuzkCollectionId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cuzkDocumentId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'datumpozadavku',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'datumspusteni',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'datumvytvoreni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'elznacka',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'format',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelConnectionsByCuzkDocumentCollectionId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'nazev',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'pocetjednotek',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'pocetstran',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'rizeni',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'stav',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkDocumentCollectionsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CuzkDocumentCollectionsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'CuzkDocumentCollection',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkDocumentCollectionsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollection',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkEpo',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'adresnimistokod',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cena',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cuzkCollectionId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cuzkEpoRestrictionChecksByCuzkEpoId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'CuzkEpoRestrictionChecksConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'datumpozadavku',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'datumspusteni',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'datumvytvoreni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'elznacka',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'format',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelConnectionsByCuzkEpoId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'nazev',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'pocetLv',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'pocetjednotek',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'pocetstran',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'rcIco',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'stav',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'typ',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkEpoLien',
        fields: [
          {
            name: 'budovyPocet',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cuzkEpoRestrictionCheckByRestrictionCheckId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionCheck',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'exekuce',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'insolvence',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'jednotkyPocet',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'katastralniUzemiKod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'katastralniUzemiNazev',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelConnectionsByCuzkEpoLienId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'lv',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'obec',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'okres',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'parcelyPocet',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'predkupniPravo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'restrictionCheckId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'rizeni',
            type: {
              kind: 'LIST',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'vlastniciPocet',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'zastavyNedobrovolne',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkEpoLiensConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CuzkEpoLiensEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'CuzkEpoLien',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkEpoLiensEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLien',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkEpoRestrictionCheck',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'boughtAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'boughtBy',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'checkedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'checkedBy',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpoByCuzkEpoId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cuzkEpoLiensByRestrictionCheckId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'CuzkEpoLiensConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'katastralniPracovisteKod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'katastralniPracovisteNazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'katastralniUradKod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'katastralniUradNazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'lvKeKontrolePocet',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'state',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkEpoRestrictionChecksConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CuzkEpoRestrictionChecksEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'CuzkEpoRestrictionCheck',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkEpoRestrictionChecksEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionCheck',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkEposConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CuzkEposEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'CuzkEpo',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkEposEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkLv',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cena',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cuzkCollectionId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'datumK',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'datumpozadavku',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'datumspusteni',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'datumvytvoreni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'elznacka',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'format',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'katastralniUzemiKod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'katastralniUzemiNazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'labelConnectionsByCuzkLvId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'lv',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'obec',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'pocetjednotek',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'pocetstran',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'stav',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkLvsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CuzkLvsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'CuzkLv',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkLvsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLv',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkO',
        fields: [
          {
            name: 'castobcenazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'charostype',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cislodomovni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cisloorientacni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cuzkOByPartner1',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOByPartner2',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOsByPartner1',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'CuzkOsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkOsByPartner2',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'CuzkOsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'doplnekico',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ico',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'idOs',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'jmeno',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'lastCheck',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'mestskacastnazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'mestskyobvodnazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcsByCuzkOsId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'MonitoringCuzkRcsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'nazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'obecnazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'okresnazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'partner1',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'partner2',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'prijmeni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'psc',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'rc',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'rczkracene',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'statnazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'titulpred',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'titulza',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'typcpce',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ulice',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'updatedAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'vlastniktyp',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkOsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'CuzkOsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'CuzkO',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'CuzkOsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Databox',
        fields: [
          {
            name: 'adresnimistokod',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'birthname',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'businessname',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdat',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'databoxid',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'firstname',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'fulladdress',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'fullname',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ico',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'idovm',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ismaster',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'lastname',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'masterid',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'middlename',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'ovm',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'pdz',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'subtype',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'type',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'updatedat',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'DataboxesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'DataboxesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'Databox',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DataboxesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'Databox',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteAddressPayload',
        fields: [
          {
            name: 'address',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'addressEdge',
            type: {
              kind: 'OBJECT',
              name: 'AddressesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedAddressId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteAuctionListingPayload',
        fields: [
          {
            name: 'auctionListing',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionListingEdge',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListingsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedAuctionListingId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteAuctionPropertyPayload',
        fields: [
          {
            name: 'auctionListingByAuctionId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionProperty',
            type: {
              kind: 'OBJECT',
              name: 'AuctionProperty',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionPropertyEdge',
            type: {
              kind: 'OBJECT',
              name: 'AuctionPropertiesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedAuctionPropertyId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteBpejPayload',
        fields: [
          {
            name: 'bpej',
            type: {
              kind: 'OBJECT',
              name: 'Bpej',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'bpejEdge',
            type: {
              kind: 'OBJECT',
              name: 'BpejsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedBpejId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteBuybackCalculationPayload',
        fields: [
          {
            name: 'buybackCalculation',
            type: {
              kind: 'OBJECT',
              name: 'BuybackCalculation',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'buybackCalculationEdge',
            type: {
              kind: 'OBJECT',
              name: 'BuybackCalculationsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedBuybackCalculationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteCeeExecutionDetailPayload',
        fields: [
          {
            name: 'ceeExecutionByCeeExecutionId',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecution',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeExecutionDetail',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionDetail',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeExecutionDetailEdge',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionDetailsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedCeeExecutionDetailId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteCeeExecutionPayload',
        fields: [
          {
            name: 'ceeExecution',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecution',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeExecutionEdge',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'ceeOfficeByExecutorCode',
            type: {
              kind: 'OBJECT',
              name: 'CeeOffice',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedCeeExecutionId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteCeeOfficePayload',
        fields: [
          {
            name: 'ceeOffice',
            type: {
              kind: 'OBJECT',
              name: 'CeeOffice',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeOfficeEdge',
            type: {
              kind: 'OBJECT',
              name: 'CeeOfficesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedCeeOfficeId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteCuzkDocumentCollectionPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollection',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollection',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollectionEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollectionsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'deletedCuzkDocumentCollectionId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteCuzkEpoLienPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpoLien',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLien',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoLienEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLiensEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkEpoRestrictionCheckByRestrictionCheckId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionCheck',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'deletedCuzkEpoLienId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteCuzkEpoPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpo',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEposEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'deletedCuzkEpoId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteCuzkEpoRestrictionCheckPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpoByCuzkEpoId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoRestrictionCheck',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionCheck',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoRestrictionCheckEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionChecksEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'deletedCuzkEpoRestrictionCheckId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteCuzkLvPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkLv',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLv',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkLvEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLvsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'deletedCuzkLvId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteCuzkOPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkO',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOByPartner1',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOByPartner2',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkOsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'deletedCuzkOId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteDataboxPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'databox',
            type: {
              kind: 'OBJECT',
              name: 'Databox',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'databoxEdge',
            type: {
              kind: 'OBJECT',
              name: 'DataboxesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'deletedDataboxId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteKuAreaPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedKuAreaId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuArea',
            type: {
              kind: 'OBJECT',
              name: 'KuArea',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'kuAreaEdge',
            type: {
              kind: 'OBJECT',
              name: 'KuAreasEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'kuWorkplaceByPraresKod',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteKuWorkplacePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedKuWorkplaceId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuWorkplace',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'kuWorkplaceByNadrizPrac',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'kuWorkplaceEdge',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplacesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteLabelConnectionPayload',
        fields: [
          {
            name: 'auctionListingByAuctionListingId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollectionByCuzkDocumentCollectionId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollection',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoByCuzkEpoId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoLienByCuzkEpoLienId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLien',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkLvByCuzkLvId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLv',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'deletedLabelConnectionId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'labelByLabelId',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelConnection',
            type: {
              kind: 'OBJECT',
              name: 'LabelConnection',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelConnectionEdge',
            type: {
              kind: 'OBJECT',
              name: 'LabelConnectionsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'marketplaceOfferByMarketplaceOfferId',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitByMonitId',
            type: {
              kind: 'OBJECT',
              name: 'Monit',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcByMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceListByPostserviceListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyLabelByPropertyLabelId',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabel',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListByRecipientListId',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteLabelMonitoringCuzkRcPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedLabelMonitoringCuzkRcId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'labelByLabelId',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelMonitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'LabelMonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelMonitoringCuzkRcEdge',
            type: {
              kind: 'OBJECT',
              name: 'LabelMonitoringCuzkRcsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'monitoringCuzkRcByMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteLabelPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedLabelId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'label',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelEdge',
            type: {
              kind: 'OBJECT',
              name: 'LabelsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteMarketplaceOfferAccessPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedMarketplaceOfferAccessId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'marketplaceOfferAccess',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOfferAccess',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'marketplaceOfferAccessEdge',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOfferAccessesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'marketplaceOfferByOfferId',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteMarketplaceOfferPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedMarketplaceOfferId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'marketplaceOffer',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'marketplaceOfferEdge',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffersEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteMonitPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedMonitId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monit',
            type: {
              kind: 'OBJECT',
              name: 'Monit',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitEdge',
            type: {
              kind: 'OBJECT',
              name: 'MonitsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteMonitoringCeePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedMonitoringCeeId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCee',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeEdge',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCeesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteMonitoringCuzkRcPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkOByCuzkOsId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'deletedMonitoringCuzkRcId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcEdge',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRcsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteMunicipalOfficePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedMunicipalOfficeId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'municipalOffice',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOffice',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'municipalOfficeEdge',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOfficesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeletePostserviceListPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedPostserviceListId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceList',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceListEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceListsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeletePostserviceRecipientPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedPostserviceRecipientId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceListByPostserviceListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceRecipient',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceRecipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeletePostserviceSentLetterPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedPostserviceSentLetterId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceListByOriginalListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentLetter',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLetter',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentLetterEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLettersEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceTemplateByOriginalTemplateId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplate',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddressBySenderAddressId',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeletePostserviceSentRecipientPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedPostserviceSentRecipientId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceRecipientByOriginalRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentLetterBySentLetterId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLetter',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentRecipient',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentRecipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentRecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeletePostserviceTemplatePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedPostserviceTemplateId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceTemplate',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplate',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceTemplateEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplatesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeletePropertyLabelPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedPropertyLabelId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyLabel',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabel',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyLabelEdge',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabelsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeletePropertyListPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedPropertyListId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyList',
            type: {
              kind: 'OBJECT',
              name: 'PropertyList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyListEdge',
            type: {
              kind: 'OBJECT',
              name: 'PropertyListsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeletePropertyNotePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedPropertyNoteId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyNote',
            type: {
              kind: 'OBJECT',
              name: 'PropertyNote',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyNoteEdge',
            type: {
              kind: 'OBJECT',
              name: 'PropertyNotesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteRecipientListPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedRecipientListId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientList',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListEdge',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'senderAddressBySenderAddressId',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteRecipientListRecipientPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedRecipientListRecipientId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientByRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'Recipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListByRecipientListId',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListRecipient',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListRecipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteRecipientPayload',
        fields: [
          {
            name: 'addressByAdresnimistokod',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedRecipientId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipient',
            type: {
              kind: 'OBJECT',
              name: 'Recipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'RecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteSenderAddressPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedSenderAddressId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddress',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddressEdge',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddressesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteUnitRentPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedUnitRentId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'unitRent',
            type: {
              kind: 'OBJECT',
              name: 'UnitRent',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'unitRentEdge',
            type: {
              kind: 'OBJECT',
              name: 'UnitRentsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'DeleteUserActivityLogPayload',
        fields: [
          {
            name: 'auctionListingByAuctionListingId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedUserActivityLogId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'userActivityLog',
            type: {
              kind: 'OBJECT',
              name: 'UserActivityLog',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'userActivityLogEdge',
            type: {
              kind: 'OBJECT',
              name: 'UserActivityLogsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'FilmInStockPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'pFilmCounts',
            type: {
              kind: 'LIST',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'FilmNotInStockPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'pFilmCounts',
            type: {
              kind: 'LIST',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'GetCustomerBalancePayload',
        fields: [
          {
            name: 'bigFloat',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'InventoryHeldByCustomerPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'integer',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'InventoryInStockPayload',
        fields: [
          {
            name: 'boolean',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'KuArea',
        fields: [
          {
            name: 'areaId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'ciselnaRada',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'krajKod',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuKod',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuNazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuPrac',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuWorkplaceByPraresKod',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'mapa',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nuts4',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'obecKod',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'obecNazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'okresKod',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'platnostDo',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'platnostOd',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'poznamka',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'praresKod',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'KuAreasConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'KuAreasEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'KuArea',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'KuAreasEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'KuArea',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'KuWorkplace',
        fields: [
          {
            name: 'castObce',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cisloDomovni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cisloOrientacni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'email',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'fax',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ico',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'kod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'kodProVs',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuAreasByPraresKod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'KuAreasConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'kuWorkplaceByNadrizPrac',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'kuWorkplacesByNadrizPrac',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'KuWorkplacesConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'mestskaCast',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nadrizPrac',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nazevUlice',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nazevZkraceny',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'obec',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'okres',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'platnostDo',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'platnostOd',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'psc',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'stat',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'telefon',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'typAdresy',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'typPrac',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'web',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'zkratka',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'KuWorkplacesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'KuWorkplacesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'KuWorkplace',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'KuWorkplacesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Label',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'colorKey',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'editedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'iconKey',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelConnectionsByLabelId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'labelMonitoringCuzkRcsByLabelId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelMonitoringCuzkRcsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'name',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'LabelConnection',
        fields: [
          {
            name: 'auctionListingByAuctionListingId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionListingId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollectionByCuzkDocumentCollectionId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollection',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollectionId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpoByCuzkEpoId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpoLienByCuzkEpoLienId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLien',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoLienId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkLvByCuzkLvId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLv',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkLvId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelByLabelId',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'marketplaceOfferByMarketplaceOfferId',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'marketplaceOfferId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitByMonitId',
            type: {
              kind: 'OBJECT',
              name: 'Monit',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcByMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'postserviceListByPostserviceListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceListId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyLabelByPropertyLabelId',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabel',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyLabelId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'recipientListByRecipientListId',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'LabelConnectionsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'LabelConnectionsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'LabelConnection',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'LabelConnectionsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'LabelConnection',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'LabelMonitoringCuzkRc',
        fields: [
          {
            name: 'labelByLabelId',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcByMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'updatedAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'LabelMonitoringCuzkRcsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'LabelMonitoringCuzkRcsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'LabelMonitoringCuzkRc',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'LabelMonitoringCuzkRcsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'LabelMonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'LabelsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'LabelsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'Label',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'LabelsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MarketplaceOffer',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'contactDescription',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'contactEmail',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'contactName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'contactPhone',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'expirationDate',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'images',
            type: {
              kind: 'LIST',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'interestAmount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'investmentAmount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelConnectionsByMarketplaceOfferId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'ltv',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'marketplaceOfferAccessesByOfferId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'MarketplaceOfferAccessesConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'monthlyPayment',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'offerLocation',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'offerType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyValue',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'state',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'title',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'MarketplaceOfferAccess',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'isOwner',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'marketplaceOfferByOfferId',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'offerId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'MarketplaceOfferAccessesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'MarketplaceOfferAccessesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'MarketplaceOfferAccess',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MarketplaceOfferAccessesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOfferAccess',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MarketplaceOffersConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'MarketplaceOffersEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'MarketplaceOffer',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MarketplaceOffersEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Monit',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cenaM2Nab',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cenaM2Real',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cenaNab',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cenaReal',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'decompNab',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'decompReal',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'estimateToDate',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'graphImageString',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'kodObce',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'labelConnectionsByMonitId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'lat',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'lon',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'lvData',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'modelVersion',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'note',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'polygon',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'publicNote',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'requestData',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'risyData',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'timeSeriesGraph',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'title',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'MonitoringCee',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'birthDate',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ceeExecutionsByMonitoringCeeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'CeeExecutionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'checkFrequency',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'editedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'errorState',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'executionCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'firstname',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'found',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ico',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelConnectionsByMonitoringCeeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'lastCheck',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'lastname',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoring',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcsByMonitoringCeeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'MonitoringCuzkRcsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'note',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'rc',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'validatedCode',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'MonitoringCeesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'MonitoringCeesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'MonitoringCee',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MonitoringCeesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MonitoringCuzkRc',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'birthDate',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'checkFrequency',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkOByCuzkOsId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOsId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'editedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'firstname',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'found',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ico',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelConnectionsByMonitoringCuzkRcId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'labelMonitoringCuzkRcsByMonitoringCuzkRcId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelMonitoringCuzkRcsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'lastCheck',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'lastname',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'rc',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'validatedCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'MonitoringCuzkRcsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'MonitoringCuzkRcsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'MonitoringCuzkRc',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MonitoringCuzkRcsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MonitsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'MonitsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'Monit',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MonitsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'Monit',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MunicipalOffice',
        fields: [
          {
            name: 'adresnimistokod',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cityName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cityPartName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'houseNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'ico',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'officeName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'orientationNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'streetName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'zipCode',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'MunicipalOfficesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'MunicipalOfficesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'MunicipalOffice',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'MunicipalOfficesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOffice',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Mutation',
        fields: [
          {
            name: 'createAddress',
            type: {
              kind: 'OBJECT',
              name: 'CreateAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createAuctionListing',
            type: {
              kind: 'OBJECT',
              name: 'CreateAuctionListingPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createAuctionProperty',
            type: {
              kind: 'OBJECT',
              name: 'CreateAuctionPropertyPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createBpej',
            type: {
              kind: 'OBJECT',
              name: 'CreateBpejPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createBuybackCalculation',
            type: {
              kind: 'OBJECT',
              name: 'CreateBuybackCalculationPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createCeeExecution',
            type: {
              kind: 'OBJECT',
              name: 'CreateCeeExecutionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createCeeExecutionDetail',
            type: {
              kind: 'OBJECT',
              name: 'CreateCeeExecutionDetailPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createCeeOffice',
            type: {
              kind: 'OBJECT',
              name: 'CreateCeeOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createCuzkDocumentCollection',
            type: {
              kind: 'OBJECT',
              name: 'CreateCuzkDocumentCollectionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createCuzkEpo',
            type: {
              kind: 'OBJECT',
              name: 'CreateCuzkEpoPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createCuzkEpoLien',
            type: {
              kind: 'OBJECT',
              name: 'CreateCuzkEpoLienPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createCuzkEpoRestrictionCheck',
            type: {
              kind: 'OBJECT',
              name: 'CreateCuzkEpoRestrictionCheckPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createCuzkLv',
            type: {
              kind: 'OBJECT',
              name: 'CreateCuzkLvPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createCuzkO',
            type: {
              kind: 'OBJECT',
              name: 'CreateCuzkOPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createDatabox',
            type: {
              kind: 'OBJECT',
              name: 'CreateDataboxPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createKuArea',
            type: {
              kind: 'OBJECT',
              name: 'CreateKuAreaPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createKuWorkplace',
            type: {
              kind: 'OBJECT',
              name: 'CreateKuWorkplacePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createLabel',
            type: {
              kind: 'OBJECT',
              name: 'CreateLabelPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createLabelConnection',
            type: {
              kind: 'OBJECT',
              name: 'CreateLabelConnectionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createLabelMonitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'CreateLabelMonitoringCuzkRcPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createMarketplaceOffer',
            type: {
              kind: 'OBJECT',
              name: 'CreateMarketplaceOfferPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createMarketplaceOfferAccess',
            type: {
              kind: 'OBJECT',
              name: 'CreateMarketplaceOfferAccessPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createMonit',
            type: {
              kind: 'OBJECT',
              name: 'CreateMonitPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createMonitoringCee',
            type: {
              kind: 'OBJECT',
              name: 'CreateMonitoringCeePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createMonitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'CreateMonitoringCuzkRcPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createMunicipalOffice',
            type: {
              kind: 'OBJECT',
              name: 'CreateMunicipalOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createPostserviceList',
            type: {
              kind: 'OBJECT',
              name: 'CreatePostserviceListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createPostserviceRecipient',
            type: {
              kind: 'OBJECT',
              name: 'CreatePostserviceRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createPostserviceSentLetter',
            type: {
              kind: 'OBJECT',
              name: 'CreatePostserviceSentLetterPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createPostserviceSentRecipient',
            type: {
              kind: 'OBJECT',
              name: 'CreatePostserviceSentRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createPostserviceTemplate',
            type: {
              kind: 'OBJECT',
              name: 'CreatePostserviceTemplatePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createPropertyLabel',
            type: {
              kind: 'OBJECT',
              name: 'CreatePropertyLabelPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createPropertyList',
            type: {
              kind: 'OBJECT',
              name: 'CreatePropertyListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createPropertyNote',
            type: {
              kind: 'OBJECT',
              name: 'CreatePropertyNotePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createRecipient',
            type: {
              kind: 'OBJECT',
              name: 'CreateRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createRecipientList',
            type: {
              kind: 'OBJECT',
              name: 'CreateRecipientListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createRecipientListRecipient',
            type: {
              kind: 'OBJECT',
              name: 'CreateRecipientListRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createSenderAddress',
            type: {
              kind: 'OBJECT',
              name: 'CreateSenderAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createUnitRent',
            type: {
              kind: 'OBJECT',
              name: 'CreateUnitRentPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'createUserActivityLog',
            type: {
              kind: 'OBJECT',
              name: 'CreateUserActivityLogPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteAddress',
            type: {
              kind: 'OBJECT',
              name: 'DeleteAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteAddressById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteAddressByKod',
            type: {
              kind: 'OBJECT',
              name: 'DeleteAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteAuctionListing',
            type: {
              kind: 'OBJECT',
              name: 'DeleteAuctionListingPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteAuctionListingById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteAuctionListingPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteAuctionProperty',
            type: {
              kind: 'OBJECT',
              name: 'DeleteAuctionPropertyPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteAuctionPropertyById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteAuctionPropertyPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteBpej',
            type: {
              kind: 'OBJECT',
              name: 'DeleteBpejPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteBpejById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteBpejPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteBuybackCalculation',
            type: {
              kind: 'OBJECT',
              name: 'DeleteBuybackCalculationPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteBuybackCalculationById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteBuybackCalculationPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCeeExecution',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCeeExecutionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCeeExecutionById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCeeExecutionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCeeExecutionDetail',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCeeExecutionDetailPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCeeExecutionDetailById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCeeExecutionDetailPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCeeOffice',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCeeOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCeeOfficeById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCeeOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkDocumentCollection',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkDocumentCollectionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkDocumentCollectionById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkDocumentCollectionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkEpo',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkEpoPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkEpoById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkEpoPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkEpoLien',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkEpoLienPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkEpoLienById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkEpoLienPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkEpoRestrictionCheck',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkEpoRestrictionCheckPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkEpoRestrictionCheckById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkEpoRestrictionCheckPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkLv',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkLvPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkLvById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkLvPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkO',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkOPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteCuzkOById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteCuzkOPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteDatabox',
            type: {
              kind: 'OBJECT',
              name: 'DeleteDataboxPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteDataboxByDataboxid',
            type: {
              kind: 'OBJECT',
              name: 'DeleteDataboxPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteDataboxById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteDataboxPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteKuArea',
            type: {
              kind: 'OBJECT',
              name: 'DeleteKuAreaPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteKuAreaByAreaId',
            type: {
              kind: 'OBJECT',
              name: 'DeleteKuAreaPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteKuWorkplace',
            type: {
              kind: 'OBJECT',
              name: 'DeleteKuWorkplacePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteKuWorkplaceById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteKuWorkplacePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteKuWorkplaceByKod',
            type: {
              kind: 'OBJECT',
              name: 'DeleteKuWorkplacePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteLabel',
            type: {
              kind: 'OBJECT',
              name: 'DeleteLabelPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteLabelById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteLabelPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteLabelConnection',
            type: {
              kind: 'OBJECT',
              name: 'DeleteLabelConnectionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteLabelConnectionById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteLabelConnectionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteLabelMonitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'DeleteLabelMonitoringCuzkRcPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'DeleteLabelMonitoringCuzkRcPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMarketplaceOffer',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMarketplaceOfferPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMarketplaceOfferAccess',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMarketplaceOfferAccessPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMarketplaceOfferAccessById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMarketplaceOfferAccessPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMarketplaceOfferById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMarketplaceOfferPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMonit',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMonitPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMonitById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMonitPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMonitoringCee',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMonitoringCeePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMonitoringCeeById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMonitoringCeePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMonitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMonitoringCuzkRcPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMonitoringCuzkRcById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMonitoringCuzkRcPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMunicipalOffice',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMunicipalOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMunicipalOfficeByAdresnimistokod',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMunicipalOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteMunicipalOfficeById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteMunicipalOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePostserviceList',
            type: {
              kind: 'OBJECT',
              name: 'DeletePostserviceListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePostserviceListById',
            type: {
              kind: 'OBJECT',
              name: 'DeletePostserviceListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePostserviceRecipient',
            type: {
              kind: 'OBJECT',
              name: 'DeletePostserviceRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePostserviceRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'DeletePostserviceRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePostserviceSentLetter',
            type: {
              kind: 'OBJECT',
              name: 'DeletePostserviceSentLetterPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePostserviceSentLetterById',
            type: {
              kind: 'OBJECT',
              name: 'DeletePostserviceSentLetterPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePostserviceSentRecipient',
            type: {
              kind: 'OBJECT',
              name: 'DeletePostserviceSentRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePostserviceSentRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'DeletePostserviceSentRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePostserviceTemplate',
            type: {
              kind: 'OBJECT',
              name: 'DeletePostserviceTemplatePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePostserviceTemplateById',
            type: {
              kind: 'OBJECT',
              name: 'DeletePostserviceTemplatePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePropertyLabel',
            type: {
              kind: 'OBJECT',
              name: 'DeletePropertyLabelPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePropertyLabelById',
            type: {
              kind: 'OBJECT',
              name: 'DeletePropertyLabelPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePropertyList',
            type: {
              kind: 'OBJECT',
              name: 'DeletePropertyListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePropertyListById',
            type: {
              kind: 'OBJECT',
              name: 'DeletePropertyListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePropertyNote',
            type: {
              kind: 'OBJECT',
              name: 'DeletePropertyNotePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deletePropertyNoteById',
            type: {
              kind: 'OBJECT',
              name: 'DeletePropertyNotePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteRecipient',
            type: {
              kind: 'OBJECT',
              name: 'DeleteRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteRecipientList',
            type: {
              kind: 'OBJECT',
              name: 'DeleteRecipientListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteRecipientListById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteRecipientListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteRecipientListRecipient',
            type: {
              kind: 'OBJECT',
              name: 'DeleteRecipientListRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteRecipientListRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteRecipientListRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteRecipientListRecipientByRecipientListIdAndRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'DeleteRecipientListRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteSenderAddress',
            type: {
              kind: 'OBJECT',
              name: 'DeleteSenderAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteSenderAddressById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteSenderAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteUnitRent',
            type: {
              kind: 'OBJECT',
              name: 'DeleteUnitRentPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteUnitRentByCadastralAreaCode',
            type: {
              kind: 'OBJECT',
              name: 'DeleteUnitRentPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteUnitRentById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteUnitRentPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteUserActivityLog',
            type: {
              kind: 'OBJECT',
              name: 'DeleteUserActivityLogPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'deleteUserActivityLogById',
            type: {
              kind: 'OBJECT',
              name: 'DeleteUserActivityLogPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'filmInStock',
            type: {
              kind: 'OBJECT',
              name: 'FilmInStockPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'filmNotInStock',
            type: {
              kind: 'OBJECT',
              name: 'FilmNotInStockPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'getCustomerBalance',
            type: {
              kind: 'OBJECT',
              name: 'GetCustomerBalancePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'inventoryHeldByCustomer',
            type: {
              kind: 'OBJECT',
              name: 'InventoryHeldByCustomerPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'inventoryInStock',
            type: {
              kind: 'OBJECT',
              name: 'InventoryInStockPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateAddress',
            type: {
              kind: 'OBJECT',
              name: 'UpdateAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateAddressById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateAddressByKod',
            type: {
              kind: 'OBJECT',
              name: 'UpdateAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateAuctionListing',
            type: {
              kind: 'OBJECT',
              name: 'UpdateAuctionListingPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateAuctionListingById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateAuctionListingPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateAuctionProperty',
            type: {
              kind: 'OBJECT',
              name: 'UpdateAuctionPropertyPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateAuctionPropertyById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateAuctionPropertyPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateBpej',
            type: {
              kind: 'OBJECT',
              name: 'UpdateBpejPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateBpejById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateBpejPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateBuybackCalculation',
            type: {
              kind: 'OBJECT',
              name: 'UpdateBuybackCalculationPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateBuybackCalculationById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateBuybackCalculationPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCeeExecution',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCeeExecutionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCeeExecutionById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCeeExecutionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCeeExecutionDetail',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCeeExecutionDetailPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCeeExecutionDetailById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCeeExecutionDetailPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCeeOffice',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCeeOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCeeOfficeById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCeeOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkDocumentCollection',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkDocumentCollectionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkDocumentCollectionById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkDocumentCollectionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkEpo',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkEpoPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkEpoById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkEpoPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkEpoLien',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkEpoLienPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkEpoLienById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkEpoLienPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkEpoRestrictionCheck',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkEpoRestrictionCheckPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkEpoRestrictionCheckById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkEpoRestrictionCheckPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkLv',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkLvPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkLvById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkLvPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkO',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkOPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateCuzkOById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateCuzkOPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateDatabox',
            type: {
              kind: 'OBJECT',
              name: 'UpdateDataboxPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateDataboxByDataboxid',
            type: {
              kind: 'OBJECT',
              name: 'UpdateDataboxPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateDataboxById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateDataboxPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateKuArea',
            type: {
              kind: 'OBJECT',
              name: 'UpdateKuAreaPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateKuAreaByAreaId',
            type: {
              kind: 'OBJECT',
              name: 'UpdateKuAreaPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateKuWorkplace',
            type: {
              kind: 'OBJECT',
              name: 'UpdateKuWorkplacePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateKuWorkplaceById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateKuWorkplacePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateKuWorkplaceByKod',
            type: {
              kind: 'OBJECT',
              name: 'UpdateKuWorkplacePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateLabel',
            type: {
              kind: 'OBJECT',
              name: 'UpdateLabelPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateLabelById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateLabelPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateLabelConnection',
            type: {
              kind: 'OBJECT',
              name: 'UpdateLabelConnectionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateLabelConnectionById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateLabelConnectionPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateLabelMonitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'UpdateLabelMonitoringCuzkRcPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'UpdateLabelMonitoringCuzkRcPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMarketplaceOffer',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMarketplaceOfferPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMarketplaceOfferAccess',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMarketplaceOfferAccessPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMarketplaceOfferAccessById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMarketplaceOfferAccessPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMarketplaceOfferById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMarketplaceOfferPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMonit',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMonitPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMonitById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMonitPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMonitoringCee',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMonitoringCeePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMonitoringCeeById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMonitoringCeePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMonitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMonitoringCuzkRcPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMonitoringCuzkRcById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMonitoringCuzkRcPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMunicipalOffice',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMunicipalOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMunicipalOfficeByAdresnimistokod',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMunicipalOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateMunicipalOfficeById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateMunicipalOfficePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePostserviceList',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePostserviceListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePostserviceListById',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePostserviceListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePostserviceRecipient',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePostserviceRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePostserviceRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePostserviceRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePostserviceSentLetter',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePostserviceSentLetterPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePostserviceSentLetterById',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePostserviceSentLetterPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePostserviceSentRecipient',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePostserviceSentRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePostserviceSentRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePostserviceSentRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePostserviceTemplate',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePostserviceTemplatePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePostserviceTemplateById',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePostserviceTemplatePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePropertyLabel',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePropertyLabelPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePropertyLabelById',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePropertyLabelPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePropertyList',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePropertyListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePropertyListById',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePropertyListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePropertyNote',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePropertyNotePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updatePropertyNoteById',
            type: {
              kind: 'OBJECT',
              name: 'UpdatePropertyNotePayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateRecipient',
            type: {
              kind: 'OBJECT',
              name: 'UpdateRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateRecipientList',
            type: {
              kind: 'OBJECT',
              name: 'UpdateRecipientListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateRecipientListById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateRecipientListPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateRecipientListRecipient',
            type: {
              kind: 'OBJECT',
              name: 'UpdateRecipientListRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateRecipientListRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateRecipientListRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateRecipientListRecipientByRecipientListIdAndRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'UpdateRecipientListRecipientPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateSenderAddress',
            type: {
              kind: 'OBJECT',
              name: 'UpdateSenderAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateSenderAddressById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateSenderAddressPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateUnitRent',
            type: {
              kind: 'OBJECT',
              name: 'UpdateUnitRentPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateUnitRentByCadastralAreaCode',
            type: {
              kind: 'OBJECT',
              name: 'UpdateUnitRentPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateUnitRentById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateUnitRentPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateUserActivityLog',
            type: {
              kind: 'OBJECT',
              name: 'UpdateUserActivityLogPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'updateUserActivityLogById',
            type: {
              kind: 'OBJECT',
              name: 'UpdateUserActivityLogPayload',
              ofType: null,
            },
            args: [
              {
                name: 'input',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'INTERFACE',
        name: 'Node',
        fields: [
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
        possibleTypes: [
          {
            kind: 'OBJECT',
            name: 'Address',
          },
          {
            kind: 'OBJECT',
            name: 'AuctionListing',
          },
          {
            kind: 'OBJECT',
            name: 'AuctionProperty',
          },
          {
            kind: 'OBJECT',
            name: 'Bpej',
          },
          {
            kind: 'OBJECT',
            name: 'BuybackCalculation',
          },
          {
            kind: 'OBJECT',
            name: 'CeeExecution',
          },
          {
            kind: 'OBJECT',
            name: 'CeeExecutionDetail',
          },
          {
            kind: 'OBJECT',
            name: 'CeeOffice',
          },
          {
            kind: 'OBJECT',
            name: 'CuzkDocumentCollection',
          },
          {
            kind: 'OBJECT',
            name: 'CuzkEpo',
          },
          {
            kind: 'OBJECT',
            name: 'CuzkEpoLien',
          },
          {
            kind: 'OBJECT',
            name: 'CuzkEpoRestrictionCheck',
          },
          {
            kind: 'OBJECT',
            name: 'CuzkLv',
          },
          {
            kind: 'OBJECT',
            name: 'CuzkO',
          },
          {
            kind: 'OBJECT',
            name: 'Databox',
          },
          {
            kind: 'OBJECT',
            name: 'KuArea',
          },
          {
            kind: 'OBJECT',
            name: 'KuWorkplace',
          },
          {
            kind: 'OBJECT',
            name: 'Label',
          },
          {
            kind: 'OBJECT',
            name: 'LabelConnection',
          },
          {
            kind: 'OBJECT',
            name: 'LabelMonitoringCuzkRc',
          },
          {
            kind: 'OBJECT',
            name: 'MarketplaceOffer',
          },
          {
            kind: 'OBJECT',
            name: 'MarketplaceOfferAccess',
          },
          {
            kind: 'OBJECT',
            name: 'Monit',
          },
          {
            kind: 'OBJECT',
            name: 'MonitoringCee',
          },
          {
            kind: 'OBJECT',
            name: 'MonitoringCuzkRc',
          },
          {
            kind: 'OBJECT',
            name: 'MunicipalOffice',
          },
          {
            kind: 'OBJECT',
            name: 'PostserviceList',
          },
          {
            kind: 'OBJECT',
            name: 'PostserviceRecipient',
          },
          {
            kind: 'OBJECT',
            name: 'PostserviceSentLetter',
          },
          {
            kind: 'OBJECT',
            name: 'PostserviceSentRecipient',
          },
          {
            kind: 'OBJECT',
            name: 'PostserviceTemplate',
          },
          {
            kind: 'OBJECT',
            name: 'PropertyLabel',
          },
          {
            kind: 'OBJECT',
            name: 'PropertyList',
          },
          {
            kind: 'OBJECT',
            name: 'PropertyNote',
          },
          {
            kind: 'OBJECT',
            name: 'Query',
          },
          {
            kind: 'OBJECT',
            name: 'Recipient',
          },
          {
            kind: 'OBJECT',
            name: 'RecipientList',
          },
          {
            kind: 'OBJECT',
            name: 'RecipientListRecipient',
          },
          {
            kind: 'OBJECT',
            name: 'SenderAddress',
          },
          {
            kind: 'OBJECT',
            name: 'UnitRent',
          },
          {
            kind: 'OBJECT',
            name: 'UserActivityLog',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'PageInfo',
        fields: [
          {
            name: 'endCursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'hasNextPage',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'hasPreviousPage',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'startCursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceList',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'deletedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelConnectionsByPostserviceListId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'listName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'postserviceRecipientsByPostserviceListId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PostserviceRecipientsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceSentLettersByOriginalListId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PostserviceSentLettersConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceListsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'PostserviceListsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'PostserviceList',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceListsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceRecipient',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'addressId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'callName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'city',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'companyName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'country',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'firstname',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'gender',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'houseNumber',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'lastname',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'orientationNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceListByPostserviceListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceListId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'postserviceSentRecipientsByOriginalRecipientId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PostserviceSentRecipientsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'propertyAddress',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyAreaNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyCadastralCode',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyCadastralName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyCity',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyLv',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyType',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'street',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'uniquePersonKey',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable1',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable2',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable3',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable4',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable5',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable6',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable7',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable8',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable9',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable10',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'zipCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceRecipientsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'PostserviceRecipientsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'PostserviceRecipient',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceRecipientsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipient',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceSentLetter',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'content',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'deletedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'originalListId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'originalTemplateId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceListByOriginalListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentRecipientsBySentLetterId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PostserviceSentRecipientsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceTemplateByOriginalTemplateId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplate',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceType',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'senderAddressBySenderAddressId',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddressId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'sentAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'sentByUserId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceSentLettersConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'PostserviceSentLettersEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'PostserviceSentLetter',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceSentLettersEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLetter',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceSentRecipient',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'addressId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'callName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'city',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'companyName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'country',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'deletedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'firstname',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'gender',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'houseNumber',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'lastname',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'orientationNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'originalRecipientId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceRecipientByOriginalRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentLetterBySentLetterId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLetter',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceTrackingNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyAddress',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyAreaNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyCadastralCode',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyCadastralName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyCity',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyLv',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyType',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'sentLetterId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'street',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'uniquePersonKey',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable1',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable2',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable3',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable4',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable5',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable6',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable7',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable8',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable9',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'variable10',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'zipCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceSentRecipientsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'PostserviceSentRecipientsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'PostserviceSentRecipient',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceSentRecipientsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentRecipient',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceTemplate',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'content',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'deletedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'editedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'postserviceSentLettersByOriginalTemplateId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PostserviceSentLettersConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceTemplatesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'PostserviceTemplatesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'PostserviceTemplate',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PostserviceTemplatesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplate',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PropertyLabel',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'deletedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelConnectionsByPropertyLabelId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyCadastralCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyCadastralName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyLv',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'PropertyLabelsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'PropertyLabelsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'PropertyLabel',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PropertyLabelsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabel',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PropertyList',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'count',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'deletedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'name',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'whereClause',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'PropertyListsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'PropertyListsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'PropertyList',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PropertyListsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'PropertyList',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PropertyNote',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'colorKey',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'deletedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'editedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'iconKey',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'links',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'note',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyCadastralCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyLv',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'propertyName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyType',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'PropertyNotesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'PropertyNotesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'PropertyNote',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'PropertyNotesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'PropertyNote',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'Query',
        fields: [
          {
            name: '_groupConcat',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [
              {
                name: 'arg0',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'arg1',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
            ],
          },
          {
            name: 'address',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'addressById',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'addressByKod',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [
              {
                name: 'kod',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'allAddresses',
            type: {
              kind: 'OBJECT',
              name: 'AddressesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allAuctionListings',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListingsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allAuctionProperties',
            type: {
              kind: 'OBJECT',
              name: 'AuctionPropertiesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allBpejs',
            type: {
              kind: 'OBJECT',
              name: 'BpejsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allBuybackCalculations',
            type: {
              kind: 'OBJECT',
              name: 'BuybackCalculationsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allCeeExecutionDetails',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionDetailsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allCeeExecutions',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allCeeOffices',
            type: {
              kind: 'OBJECT',
              name: 'CeeOfficesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allCuzkDocumentCollections',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollectionsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allCuzkEpoLiens',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLiensConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allCuzkEpoRestrictionChecks',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionChecksConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allCuzkEpos',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEposConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allCuzkLvs',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLvsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allCuzkOs',
            type: {
              kind: 'OBJECT',
              name: 'CuzkOsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allDataboxes',
            type: {
              kind: 'OBJECT',
              name: 'DataboxesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allKuAreas',
            type: {
              kind: 'OBJECT',
              name: 'KuAreasConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allKuWorkplaces',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplacesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allLabelConnections',
            type: {
              kind: 'OBJECT',
              name: 'LabelConnectionsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allLabelMonitoringCuzkRcs',
            type: {
              kind: 'OBJECT',
              name: 'LabelMonitoringCuzkRcsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allLabels',
            type: {
              kind: 'OBJECT',
              name: 'LabelsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allMarketplaceOfferAccesses',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOfferAccessesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allMarketplaceOffers',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffersConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allMonitoringCees',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCeesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allMonitoringCuzkRcs',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRcsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allMonits',
            type: {
              kind: 'OBJECT',
              name: 'MonitsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allMunicipalOffices',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOfficesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allPostserviceLists',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceListsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allPostserviceRecipients',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipientsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allPostserviceSentLetters',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLettersConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allPostserviceSentRecipients',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentRecipientsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allPostserviceTemplates',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplatesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allPropertyLabels',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabelsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allPropertyLists',
            type: {
              kind: 'OBJECT',
              name: 'PropertyListsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allPropertyNotes',
            type: {
              kind: 'OBJECT',
              name: 'PropertyNotesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allRecipientListRecipients',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipientsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allRecipientLists',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allRecipients',
            type: {
              kind: 'OBJECT',
              name: 'RecipientsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allSenderAddresses',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddressesConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allUnitRents',
            type: {
              kind: 'OBJECT',
              name: 'UnitRentsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'allUserActivityLogs',
            type: {
              kind: 'OBJECT',
              name: 'UserActivityLogsConnection',
              ofType: null,
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'auctionListing',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'auctionListingById',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'auctionProperty',
            type: {
              kind: 'OBJECT',
              name: 'AuctionProperty',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'auctionPropertyById',
            type: {
              kind: 'OBJECT',
              name: 'AuctionProperty',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'bpej',
            type: {
              kind: 'OBJECT',
              name: 'Bpej',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'bpejById',
            type: {
              kind: 'OBJECT',
              name: 'Bpej',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'buybackCalculation',
            type: {
              kind: 'OBJECT',
              name: 'BuybackCalculation',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'buybackCalculationById',
            type: {
              kind: 'OBJECT',
              name: 'BuybackCalculation',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'ceeExecution',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecution',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'ceeExecutionById',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecution',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'ceeExecutionDetail',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionDetail',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'ceeExecutionDetailById',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionDetail',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'ceeOffice',
            type: {
              kind: 'OBJECT',
              name: 'CeeOffice',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'ceeOfficeById',
            type: {
              kind: 'OBJECT',
              name: 'CeeOffice',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkDocumentCollection',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollection',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkDocumentCollectionById',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollection',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkEpo',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkEpoById',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkEpoLien',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLien',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkEpoLienById',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLien',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkEpoRestrictionCheck',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionCheck',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkEpoRestrictionCheckById',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionCheck',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkLv',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLv',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkLvById',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLv',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkO',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkOById',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'databox',
            type: {
              kind: 'OBJECT',
              name: 'Databox',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'databoxByDataboxid',
            type: {
              kind: 'OBJECT',
              name: 'Databox',
              ofType: null,
            },
            args: [
              {
                name: 'databoxid',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'databoxById',
            type: {
              kind: 'OBJECT',
              name: 'Databox',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'kuArea',
            type: {
              kind: 'OBJECT',
              name: 'KuArea',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'kuAreaByAreaId',
            type: {
              kind: 'OBJECT',
              name: 'KuArea',
              ofType: null,
            },
            args: [
              {
                name: 'areaId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'kuWorkplace',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'kuWorkplaceById',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'kuWorkplaceByKod',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [
              {
                name: 'kod',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'label',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'labelById',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'labelConnection',
            type: {
              kind: 'OBJECT',
              name: 'LabelConnection',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'labelConnectionById',
            type: {
              kind: 'OBJECT',
              name: 'LabelConnection',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'labelMonitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'LabelMonitoringCuzkRc',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'labelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'LabelMonitoringCuzkRc',
              ofType: null,
            },
            args: [
              {
                name: 'labelId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
              {
                name: 'monitoringCuzkRcId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'lastDay',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [
              {
                name: 'arg0',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'marketplaceOffer',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'marketplaceOfferAccess',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOfferAccess',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'marketplaceOfferAccessById',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOfferAccess',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'marketplaceOfferById',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'monit',
            type: {
              kind: 'OBJECT',
              name: 'Monit',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'monitById',
            type: {
              kind: 'OBJECT',
              name: 'Monit',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'monitoringCee',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'monitoringCeeById',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'monitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'monitoringCuzkRcById',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'municipalOffice',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOffice',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'municipalOfficeByAdresnimistokod',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOffice',
              ofType: null,
            },
            args: [
              {
                name: 'adresnimistokod',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'municipalOfficeById',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOffice',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'node',
            type: {
              kind: 'INTERFACE',
              name: 'Node',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'postserviceList',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceListById',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceRecipient',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipient',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipient',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceSentLetter',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLetter',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceSentLetterById',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLetter',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceSentRecipient',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentRecipient',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceSentRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentRecipient',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceTemplate',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplate',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceTemplateById',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplate',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'propertyLabel',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabel',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'propertyLabelById',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabel',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'propertyList',
            type: {
              kind: 'OBJECT',
              name: 'PropertyList',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'propertyListById',
            type: {
              kind: 'OBJECT',
              name: 'PropertyList',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'propertyNote',
            type: {
              kind: 'OBJECT',
              name: 'PropertyNote',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'propertyNoteById',
            type: {
              kind: 'OBJECT',
              name: 'PropertyNote',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'Query',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'recipient',
            type: {
              kind: 'OBJECT',
              name: 'Recipient',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'recipientById',
            type: {
              kind: 'OBJECT',
              name: 'Recipient',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'recipientList',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'recipientListById',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'recipientListRecipient',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipient',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'recipientListRecipientById',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipient',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'recipientListRecipientByRecipientListIdAndRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipient',
              ofType: null,
            },
            args: [
              {
                name: 'recipientId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
              {
                name: 'recipientListId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'senderAddress',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'senderAddressById',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'unitRent',
            type: {
              kind: 'OBJECT',
              name: 'UnitRent',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'unitRentByCadastralAreaCode',
            type: {
              kind: 'OBJECT',
              name: 'UnitRent',
              ofType: null,
            },
            args: [
              {
                name: 'cadastralAreaCode',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'unitRentById',
            type: {
              kind: 'OBJECT',
              name: 'UnitRent',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'userActivityLog',
            type: {
              kind: 'OBJECT',
              name: 'UserActivityLog',
              ofType: null,
            },
            args: [
              {
                name: 'nodeId',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
          {
            name: 'userActivityLogById',
            type: {
              kind: 'OBJECT',
              name: 'UserActivityLog',
              ofType: null,
            },
            args: [
              {
                name: 'id',
                type: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'SCALAR',
                    name: 'Any',
                  },
                },
              },
            ],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'Recipient',
        fields: [
          {
            name: 'addressByAdresnimistokod',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'adresnimistokod',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'fyzickaosoba',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'krestnijmeno',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nazev',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'osloveni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'pohlavi',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'prijmeni',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'recipientListRecipientsByRecipientId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'RecipientListRecipientsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'titulpred',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'titulza',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'RecipientList',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'deletedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'description',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'dispatchDate',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'labelConnectionsByRecipientListId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'LabelConnectionsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'letterText',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nazev',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'recipientListRecipientsByRecipientListId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'RecipientListRecipientsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'senderAddressBySenderAddressId',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddressId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'temporaryRecipientsJson',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'RecipientListRecipient',
        fields: [
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'postserviceId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyType',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'recipientByRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'Recipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'recipientListByRecipientListId',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'updatedAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'RecipientListRecipientsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'RecipientListRecipientsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'RecipientListRecipient',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RecipientListRecipientsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipient',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RecipientListsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'RecipientListsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'RecipientList',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RecipientListsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RecipientsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'RecipientsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'Recipient',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'RecipientsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'Recipient',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'SenderAddress',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'city',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'houseNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'isTemplate',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'orientationNumber',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceSentLettersBySenderAddressId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PostserviceSentLettersConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'recipientListsBySenderAddressId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'RecipientListsConnection',
                ofType: null,
              },
            },
            args: [
              {
                name: 'after',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'before',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'condition',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'filter',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'first',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'last',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'offset',
                type: {
                  kind: 'SCALAR',
                  name: 'Any',
                },
              },
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'senderName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'street',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'templateName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'zipCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'SenderAddressesConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'SenderAddressesEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'SenderAddress',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'SenderAddressesEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UnitRent',
        fields: [
          {
            name: 'cadastralAreaCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'cadastralAreaName',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cityName',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'regionCode',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'vk1DataCoverage',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk1LowerInterval',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk1Maximum',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk1Median',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk1Minimum',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk1NewBuilding',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk1Reference',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk1UpperInterval',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk2DataCoverage',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk2LowerInterval',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk2Maximum',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk2Median',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk2Minimum',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk2NewBuilding',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk2Reference',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk2UpperInterval',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk3DataCoverage',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk3LowerInterval',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk3Maximum',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk3Median',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk3Minimum',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk3NewBuilding',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk3Reference',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk3UpperInterval',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk4DataCoverage',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk4LowerInterval',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk4Maximum',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk4Median',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk4Minimum',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk4NewBuilding',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk4Reference',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'vk4UpperInterval',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'UnitRentsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'UnitRentsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'UnitRent',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UnitRentsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'UnitRent',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateAddressPayload',
        fields: [
          {
            name: 'address',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'addressEdge',
            type: {
              kind: 'OBJECT',
              name: 'AddressesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateAuctionListingPayload',
        fields: [
          {
            name: 'auctionListing',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionListingEdge',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListingsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateAuctionPropertyPayload',
        fields: [
          {
            name: 'auctionListingByAuctionId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionProperty',
            type: {
              kind: 'OBJECT',
              name: 'AuctionProperty',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionPropertyEdge',
            type: {
              kind: 'OBJECT',
              name: 'AuctionPropertiesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateBpejPayload',
        fields: [
          {
            name: 'bpej',
            type: {
              kind: 'OBJECT',
              name: 'Bpej',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'bpejEdge',
            type: {
              kind: 'OBJECT',
              name: 'BpejsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateBuybackCalculationPayload',
        fields: [
          {
            name: 'buybackCalculation',
            type: {
              kind: 'OBJECT',
              name: 'BuybackCalculation',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'buybackCalculationEdge',
            type: {
              kind: 'OBJECT',
              name: 'BuybackCalculationsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateCeeExecutionDetailPayload',
        fields: [
          {
            name: 'ceeExecutionByCeeExecutionId',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecution',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeExecutionDetail',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionDetail',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeExecutionDetailEdge',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionDetailsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateCeeExecutionPayload',
        fields: [
          {
            name: 'ceeExecution',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecution',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeExecutionEdge',
            type: {
              kind: 'OBJECT',
              name: 'CeeExecutionsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'ceeOfficeByExecutorCode',
            type: {
              kind: 'OBJECT',
              name: 'CeeOffice',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateCeeOfficePayload',
        fields: [
          {
            name: 'ceeOffice',
            type: {
              kind: 'OBJECT',
              name: 'CeeOffice',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'ceeOfficeEdge',
            type: {
              kind: 'OBJECT',
              name: 'CeeOfficesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateCuzkDocumentCollectionPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollection',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollection',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollectionEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollectionsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateCuzkEpoLienPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpoLien',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLien',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoLienEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLiensEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'cuzkEpoRestrictionCheckByRestrictionCheckId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionCheck',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateCuzkEpoPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpo',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEposEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateCuzkEpoRestrictionCheckPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkEpoByCuzkEpoId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoRestrictionCheck',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionCheck',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoRestrictionCheckEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoRestrictionChecksEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateCuzkLvPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkLv',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLv',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkLvEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLvsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateCuzkOPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkO',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOByPartner1',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOByPartner2',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkOEdge',
            type: {
              kind: 'OBJECT',
              name: 'CuzkOsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateDataboxPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'databox',
            type: {
              kind: 'OBJECT',
              name: 'Databox',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'databoxEdge',
            type: {
              kind: 'OBJECT',
              name: 'DataboxesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateKuAreaPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuArea',
            type: {
              kind: 'OBJECT',
              name: 'KuArea',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'kuAreaEdge',
            type: {
              kind: 'OBJECT',
              name: 'KuAreasEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'kuWorkplaceByPraresKod',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateKuWorkplacePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'kuWorkplace',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'kuWorkplaceByNadrizPrac',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplace',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'kuWorkplaceEdge',
            type: {
              kind: 'OBJECT',
              name: 'KuWorkplacesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateLabelConnectionPayload',
        fields: [
          {
            name: 'auctionListingByAuctionListingId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkDocumentCollectionByCuzkDocumentCollectionId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkDocumentCollection',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoByCuzkEpoId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpo',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkEpoLienByCuzkEpoLienId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkEpoLien',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'cuzkLvByCuzkLvId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkLv',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelByLabelId',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelConnection',
            type: {
              kind: 'OBJECT',
              name: 'LabelConnection',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelConnectionEdge',
            type: {
              kind: 'OBJECT',
              name: 'LabelConnectionsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'marketplaceOfferByMarketplaceOfferId',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitByMonitId',
            type: {
              kind: 'OBJECT',
              name: 'Monit',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcByMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceListByPostserviceListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyLabelByPropertyLabelId',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabel',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListByRecipientListId',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateLabelMonitoringCuzkRcPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'labelByLabelId',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelMonitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'LabelMonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelMonitoringCuzkRcEdge',
            type: {
              kind: 'OBJECT',
              name: 'LabelMonitoringCuzkRcsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'monitoringCuzkRcByMonitoringCuzkRcId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateLabelPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'label',
            type: {
              kind: 'OBJECT',
              name: 'Label',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'labelEdge',
            type: {
              kind: 'OBJECT',
              name: 'LabelsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateMarketplaceOfferAccessPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'marketplaceOfferAccess',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOfferAccess',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'marketplaceOfferAccessEdge',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOfferAccessesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'marketplaceOfferByOfferId',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateMarketplaceOfferPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'marketplaceOffer',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffer',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'marketplaceOfferEdge',
            type: {
              kind: 'OBJECT',
              name: 'MarketplaceOffersEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateMonitPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monit',
            type: {
              kind: 'OBJECT',
              name: 'Monit',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitEdge',
            type: {
              kind: 'OBJECT',
              name: 'MonitsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateMonitoringCeePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'monitoringCee',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeEdge',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCeesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateMonitoringCuzkRcPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'cuzkOByCuzkOsId',
            type: {
              kind: 'OBJECT',
              name: 'CuzkO',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCeeByMonitoringCeeId',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCee',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRc',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRc',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'monitoringCuzkRcEdge',
            type: {
              kind: 'OBJECT',
              name: 'MonitoringCuzkRcsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateMunicipalOfficePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'municipalOffice',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOffice',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'municipalOfficeEdge',
            type: {
              kind: 'OBJECT',
              name: 'MunicipalOfficesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdatePostserviceListPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceList',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceListEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceListsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdatePostserviceRecipientPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceListByPostserviceListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceRecipient',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceRecipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdatePostserviceSentLetterPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceListByOriginalListId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentLetter',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLetter',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentLetterEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLettersEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'postserviceTemplateByOriginalTemplateId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplate',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddressBySenderAddressId',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdatePostserviceSentRecipientPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceRecipientByOriginalRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentLetterBySentLetterId',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentLetter',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentRecipient',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceSentRecipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceSentRecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdatePostserviceTemplatePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'postserviceTemplate',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplate',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'postserviceTemplateEdge',
            type: {
              kind: 'OBJECT',
              name: 'PostserviceTemplatesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdatePropertyLabelPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyLabel',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabel',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyLabelEdge',
            type: {
              kind: 'OBJECT',
              name: 'PropertyLabelsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdatePropertyListPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyList',
            type: {
              kind: 'OBJECT',
              name: 'PropertyList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyListEdge',
            type: {
              kind: 'OBJECT',
              name: 'PropertyListsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdatePropertyNotePayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'propertyNote',
            type: {
              kind: 'OBJECT',
              name: 'PropertyNote',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'propertyNoteEdge',
            type: {
              kind: 'OBJECT',
              name: 'PropertyNotesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateRecipientListPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientList',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListEdge',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
          {
            name: 'senderAddressBySenderAddressId',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateRecipientListRecipientPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientByRecipientId',
            type: {
              kind: 'OBJECT',
              name: 'Recipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListByRecipientListId',
            type: {
              kind: 'OBJECT',
              name: 'RecipientList',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListRecipient',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientListRecipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'RecipientListRecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateRecipientPayload',
        fields: [
          {
            name: 'addressByAdresnimistokod',
            type: {
              kind: 'OBJECT',
              name: 'Address',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipient',
            type: {
              kind: 'OBJECT',
              name: 'Recipient',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'recipientEdge',
            type: {
              kind: 'OBJECT',
              name: 'RecipientsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateSenderAddressPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddress',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddress',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'senderAddressEdge',
            type: {
              kind: 'OBJECT',
              name: 'SenderAddressesEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateUnitRentPayload',
        fields: [
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'unitRent',
            type: {
              kind: 'OBJECT',
              name: 'UnitRent',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'unitRentEdge',
            type: {
              kind: 'OBJECT',
              name: 'UnitRentsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UpdateUserActivityLogPayload',
        fields: [
          {
            name: 'auctionListingByAuctionListingId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'clientMutationId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'query',
            type: {
              kind: 'OBJECT',
              name: 'Query',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'userActivityLog',
            type: {
              kind: 'OBJECT',
              name: 'UserActivityLog',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'userActivityLogEdge',
            type: {
              kind: 'OBJECT',
              name: 'UserActivityLogsEdge',
              ofType: null,
            },
            args: [
              {
                name: 'orderBy',
                type: {
                  kind: 'LIST',
                  ofType: {
                    kind: 'NON_NULL',
                    ofType: {
                      kind: 'SCALAR',
                      name: 'Any',
                    },
                  },
                },
              },
            ],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UserActivityLog',
        fields: [
          {
            name: 'accountId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'accountUserId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'actionSource',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'actionType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'auctionListingByAuctionListingId',
            type: {
              kind: 'OBJECT',
              name: 'AuctionListing',
              ofType: null,
            },
            args: [],
          },
          {
            name: 'auctionListingId',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'createdAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'editedAt',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'entityId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'entityType',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'id',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
          {
            name: 'nodeId',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [
          {
            kind: 'INTERFACE',
            name: 'Node',
          },
        ],
      },
      {
        kind: 'OBJECT',
        name: 'UserActivityLogsConnection',
        fields: [
          {
            name: 'edges',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'NON_NULL',
                  ofType: {
                    kind: 'OBJECT',
                    name: 'UserActivityLogsEdge',
                    ofType: null,
                  },
                },
              },
            },
            args: [],
          },
          {
            name: 'nodes',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'LIST',
                ofType: {
                  kind: 'OBJECT',
                  name: 'UserActivityLog',
                  ofType: null,
                },
              },
            },
            args: [],
          },
          {
            name: 'pageInfo',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'OBJECT',
                name: 'PageInfo',
                ofType: null,
              },
            },
            args: [],
          },
          {
            name: 'totalCount',
            type: {
              kind: 'NON_NULL',
              ofType: {
                kind: 'SCALAR',
                name: 'Any',
              },
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'OBJECT',
        name: 'UserActivityLogsEdge',
        fields: [
          {
            name: 'cursor',
            type: {
              kind: 'SCALAR',
              name: 'Any',
            },
            args: [],
          },
          {
            name: 'node',
            type: {
              kind: 'OBJECT',
              name: 'UserActivityLog',
              ofType: null,
            },
            args: [],
          },
        ],
        interfaces: [],
      },
      {
        kind: 'SCALAR',
        name: 'Any',
      },
    ],
    directives: [],
  },
} as unknown as IntrospectionQuery
export const CuzkOFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CuzkOFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'CuzkO' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'castobcenazev' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cislodomovni' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cisloorientacni' } },
          { kind: 'Field', name: { kind: 'Name', value: 'charostype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'doplnekico' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jmeno' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastCheck' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mestskacastnazev' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mestskyobvodnazev' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nazev' } },
          { kind: 'Field', name: { kind: 'Name', value: 'obecnazev' } },
          { kind: 'Field', name: { kind: 'Name', value: 'okresnazev' } },
          { kind: 'Field', name: { kind: 'Name', value: 'prijmeni' } },
          { kind: 'Field', name: { kind: 'Name', value: 'psc' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rc' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rczkracene' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statnazev' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titulpred' } },
          { kind: 'Field', name: { kind: 'Name', value: 'titulza' } },
          { kind: 'Field', name: { kind: 'Name', value: 'typcpce' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ulice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vlastniktyp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partner1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partner2' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode
export const LabelConnectionFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LabelConnectionFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LabelConnectionsConnection' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nodes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelByLabelId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colorKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iconKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode
export const RecipientFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Recipient' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'PostserviceRecipient' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accountUserId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'houseNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
          { kind: 'Field', name: { kind: 'Name', value: 'callName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orientationNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'postserviceListId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uniquePersonKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variable1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variable10' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variable2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variable3' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variable4' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variable5' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variable6' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variable7' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variable8' } },
          { kind: 'Field', name: { kind: 'Name', value: 'variable9' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyLv' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'propertyCadastralCode' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'propertyCadastralName' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyCity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyAddress' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'propertyAreaNumber' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'propertyName' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode
export const RecipientListFragmentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RecipientListFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'RecipientList' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'nazev' } },
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'recipientListRecipientsByRecipientListId',
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recipientByRecipientId' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'krestnijmeno' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'osloveni' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pohlavi' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nazev' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prijmeni' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'titulpred' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'titulza' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'addressByAdresnimistokod',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'castobce' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'cislodomovni',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'cisloorientacni',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'cisloorientacnipismeno',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'kraj' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'obec' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'okres' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'psc' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'typbudovy' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'ulice' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode
export const EditLabelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'editLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'colorKey' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'description' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'iconKey' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLabelById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'labelPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'colorKey' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'colorKey' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'description' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'description' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'iconKey' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'iconKey' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'name' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'name' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'label' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allLabels' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useEditLabelMutation() {
  return Urql.useMutation<EditLabelMutation, EditLabelMutationVariables>(
    EditLabelDocument
  )
}
export const AuctionDetailDrawerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'auctionDetailDrawer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'labelIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UUID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'auctionListingById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'auctionDecreeUrl' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'detailUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'auctionedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                { kind: 'Field', name: { kind: 'Name', value: 'photoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'labels' },
                  name: {
                    kind: 'Name',
                    value: 'labelConnectionsByAuctionListingId',
                  },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'labelId' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'in' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'labelIds' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'LabelConnectionFragment',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'userActivityLogsByAuctionListingId',
                  },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'condition' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'editedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodeId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'linkedProperties' },
                  name: { kind: 'Name', value: 'auctionPropertiesByAuctionId' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'condition' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useAuctionDetailDrawerQuery(
  options: Omit<Urql.UseQueryArgs<AuctionDetailDrawerQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    AuctionDetailDrawerQuery,
    AuctionDetailDrawerQueryVariables
  >({ query: AuctionDetailDrawerDocument, ...options })
}
export const AuctionLinkedPropertyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'auctionLinkedProperty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'auctionId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allAuctionProperties' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'auctionId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'auctionId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auctionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useAuctionLinkedPropertyQuery(
  options: Omit<Urql.UseQueryArgs<AuctionLinkedPropertyQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    AuctionLinkedPropertyQuery,
    AuctionLinkedPropertyQueryVariables
  >({ query: AuctionLinkedPropertyDocument, ...options })
}
export const CreateAuctionPropertyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAuctionProperty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'auctionProperty' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AuctionPropertyInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAuctionProperty' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'auctionProperty' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'auctionProperty' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'auctionProperty' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allAuctionProperties' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateAuctionPropertyMutation() {
  return Urql.useMutation<
    CreateAuctionPropertyMutation,
    CreateAuctionPropertyMutationVariables
  >(CreateAuctionPropertyDocument)
}
export const DeleteAuctionPropertyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteAuctionProperty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAuctionPropertyById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allAuctionProperties' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteAuctionPropertyMutation() {
  return Urql.useMutation<
    DeleteAuctionPropertyMutation,
    DeleteAuctionPropertyMutationVariables
  >(DeleteAuctionPropertyDocument)
}
export const AllAuctionLabelsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allAuctionLabels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allLabels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByLabelId',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: {
                                    kind: 'Name',
                                    value: 'auctionListingId',
                                  },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'isNull' },
                                        value: {
                                          kind: 'BooleanValue',
                                          value: false,
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useAllAuctionLabelsQuery(
  options: Omit<Urql.UseQueryArgs<AllAuctionLabelsQueryVariables>, 'query'>
) {
  return Urql.useQuery<AllAuctionLabelsQuery, AllAuctionLabelsQueryVariables>({
    query: AllAuctionLabelsDocument,
    ...options,
  })
}
export const AuctionMonitoringTabDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'auctionMonitoringTab' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'AuctionListingFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'labelIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UUID' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'exportData' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
          defaultValue: { kind: 'BooleanValue', value: false },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allAuctionListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auctionNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'detailUrl' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auctionedOn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auctionDecreeUrl' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photoUrl' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByAuctionListingId',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'labelId' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'in' },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'labelIds',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'skip' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'exportData' },
                                },
                              },
                            ],
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'activityLogs' },
                        name: {
                          kind: 'Name',
                          value: 'userActivityLogsByAuctionListingId',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: {
                                    kind: 'Name',
                                    value: 'accountUserId',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'accountUserId',
                                    },
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '1' },
                          },
                        ],
                        directives: [
                          {
                            kind: 'Directive',
                            name: { kind: 'Name', value: 'skip' },
                            arguments: [
                              {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'if' },
                                value: {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'exportData' },
                                },
                              },
                            ],
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'editedAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodeId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'actionType' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'linkedProperties' },
                        name: {
                          kind: 'Name',
                          value: 'auctionPropertiesByAuctionId',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'accountId' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'accountId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'exportData',
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'auctionId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'propertyId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'propertyName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'propertyType',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useAuctionMonitoringTabQuery(
  options: Omit<Urql.UseQueryArgs<AuctionMonitoringTabQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    AuctionMonitoringTabQuery,
    AuctionMonitoringTabQueryVariables
  >({ query: AuctionMonitoringTabDocument, ...options })
}
export const FirstBpejByCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'firstBpejByCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kod' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allBpejs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'kod' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'kod' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cena' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'platnostOd' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'platnostDo' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'popis' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useFirstBpejByCodeQuery(
  options: Omit<Urql.UseQueryArgs<FirstBpejByCodeQueryVariables>, 'query'>
) {
  return Urql.useQuery<FirstBpejByCodeQuery, FirstBpejByCodeQueryVariables>({
    query: FirstBpejByCodeDocument,
    ...options,
  })
}
export const CreateBuybackCalculationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createBuybackCalculation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'buybackCalculation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BuybackCalculationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBuybackCalculation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'buybackCalculation' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'buybackCalculation' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buybackCalculation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allBuybackCalculations' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateBuybackCalculationMutation() {
  return Urql.useMutation<
    CreateBuybackCalculationMutation,
    CreateBuybackCalculationMutationVariables
  >(CreateBuybackCalculationDocument)
}
export const AllBuybackCalculationsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allBuybackCalculations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allBuybackCalculations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: { kind: 'NullValue' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formData' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useAllBuybackCalculationsQuery(
  options: Omit<
    Urql.UseQueryArgs<AllBuybackCalculationsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    AllBuybackCalculationsQuery,
    AllBuybackCalculationsQueryVariables
  >({ query: AllBuybackCalculationsDocument, ...options })
}
export const CadastreMapAuctionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cadastreMapAuction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AuctionListingFilter' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allAuctionListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auctionedOn' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'activityLogs' },
                        name: {
                          kind: 'Name',
                          value: 'userActivityLogsByAuctionListingId',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: {
                                    kind: 'Name',
                                    value: 'accountUserId',
                                  },
                                  value: {
                                    kind: 'Variable',
                                    name: {
                                      kind: 'Name',
                                      value: 'accountUserId',
                                    },
                                  },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '1' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'editedAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodeId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'actionType' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCadastreMapAuctionQuery(
  options: Omit<Urql.UseQueryArgs<CadastreMapAuctionQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    CadastreMapAuctionQuery,
    CadastreMapAuctionQueryVariables
  >({ query: CadastreMapAuctionDocument, ...options })
}
export const AuctionListingsStatsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'auctionListingsStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'now' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newTreshold' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'new' },
            name: { kind: 'Name', value: 'allAuctionListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'createdAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'newTreshold' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'upcoming' },
            name: { kind: 'Name', value: 'allAuctionListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'startDate' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'greaterThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'now' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useAuctionListingsStatsQuery(
  options: Omit<Urql.UseQueryArgs<AuctionListingsStatsQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    AuctionListingsStatsQuery,
    AuctionListingsStatsQueryVariables
  >({ query: AuctionListingsStatsDocument, ...options })
}
export const RecipientListByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'recipientListById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'RecipientListFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...RecipientListFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useRecipientListByIdQuery(
  options: Omit<Urql.UseQueryArgs<RecipientListByIdQueryVariables>, 'query'>
) {
  return Urql.useQuery<RecipientListByIdQuery, RecipientListByIdQueryVariables>(
    { query: RecipientListByIdDocument, ...options }
  )
}
export const CreateMonitoringCeeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMonitoringCee' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateMonitoringCeeInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMonitoringCee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'monitoringCee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allMonitoringCees' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateMonitoringCeeMutation() {
  return Urql.useMutation<
    CreateMonitoringCeeMutation,
    CreateMonitoringCeeMutationVariables
  >(CreateMonitoringCeeDocument)
}
export const DeleteMonitoringCeeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteMonitoringCee' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteMonitoringCeeByIdInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMonitoringCeeById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deletedMonitoringCeeId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteMonitoringCeeMutation() {
  return Urql.useMutation<
    DeleteMonitoringCeeMutation,
    DeleteMonitoringCeeMutationVariables
  >(DeleteMonitoringCeeDocument)
}
export const CeeMonitoringTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ceeMonitoringTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MonitoringCeeFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonitoringCees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'editedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'birthDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'executionCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rc' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errorState' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'found' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkFrequency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'validatedCode' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByMonitoringCeeId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'monitoringCuzkRcsByMonitoringCeeId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'found' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'checkFrequency',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastCheck' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'cuzkOsId' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useCeeMonitoringTableQuery(
  options?: Omit<Urql.UseQueryArgs<CeeMonitoringTableQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    CeeMonitoringTableQuery,
    CeeMonitoringTableQueryVariables
  >({ query: CeeMonitoringTableDocument, ...options })
}
export const CuzkOByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cuzkOById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cuzkOById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CuzkOFragment' },
                },
              ],
            },
          },
        ],
      },
    },
    ...CuzkOFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useCuzkOByIdQuery(
  options: Omit<Urql.UseQueryArgs<CuzkOByIdQueryVariables>, 'query'>
) {
  return Urql.useQuery<CuzkOByIdQuery, CuzkOByIdQueryVariables>({
    query: CuzkOByIdDocument,
    ...options,
  })
}
export const CeeMonitorTableExpandedRowDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ceeMonitorTableExpandedRow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'monitoringCeeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCeeExecutions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'monitoringCeeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'monitoringCeeId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'EXECUTION_DATE_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'birthDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ceeEvent' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'detailCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'executionDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateDate' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'ceeOfficeByExecutorCode',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'area' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'databox' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'dic' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ico' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'note' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'web' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'executorCode' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'ceeDetails' },
                        name: {
                          kind: 'Name',
                          value: 'ceeExecutionDetailsByCeeExecutionId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodeId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'castka' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'datum' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'exekutorskyUrad',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'nepenezitaPovinost',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'povinnaOsoba',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'pravidelnaSplatka',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'soud' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'spznExekutora',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'spznSoudu' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'titul' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullname' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identificationCode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'spzn' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateDate' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCeeMonitorTableExpandedRowQuery(
  options: Omit<
    Urql.UseQueryArgs<CeeMonitorTableExpandedRowQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    CeeMonitorTableExpandedRowQuery,
    CeeMonitorTableExpandedRowQueryVariables
  >({ query: CeeMonitorTableExpandedRowDocument, ...options })
}
export const CreateRecipientListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createRecipientList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateRecipientListInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRecipientList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipientList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateRecipientListMutation() {
  return Urql.useMutation<
    CreateRecipientListMutation,
    CreateRecipientListMutationVariables
  >(CreateRecipientListDocument)
}
export const UpdateInitialRecipientListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateInitialRecipientList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'description' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nazev' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'senderAddressId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'temporaryRecipientsJson' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRecipientListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'recipientListPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'description' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'description' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'nazev' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'nazev' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'senderAddressId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'senderAddressId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'temporaryRecipientsJson',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'temporaryRecipientsJson',
                              },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipientList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateInitialRecipientListMutation() {
  return Urql.useMutation<
    UpdateInitialRecipientListMutation,
    UpdateInitialRecipientListMutationVariables
  >(UpdateInitialRecipientListDocument)
}
export const AllSenderAddressesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allSenderAddresses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allSenderAddresses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isTemplate' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'senderName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'houseNumber' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orientationNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'street' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zipCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'templateName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useAllSenderAddressesQuery(
  options: Omit<Urql.UseQueryArgs<AllSenderAddressesQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    AllSenderAddressesQuery,
    AllSenderAddressesQueryVariables
  >({ query: AllSenderAddressesDocument, ...options })
}
export const CreateSenderAddressDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createSenderAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'houseNumber' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orientationNumber' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'senderName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'street' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'zipCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'isTemplate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'templateName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSenderAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'senderAddress' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'city' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'city' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'street' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'street' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'houseNumber' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'houseNumber' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'orientationNumber' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'orientationNumber',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'zipCode' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'senderName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'senderName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isTemplate' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'isTemplate' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'templateName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'templateName' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'senderAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateSenderAddressMutation() {
  return Urql.useMutation<
    CreateSenderAddressMutation,
    CreateSenderAddressMutationVariables
  >(CreateSenderAddressDocument)
}
export const CuzkDocumentCollectionTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cuzkDocumentCollectionTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'oneDayAgo' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'idFilter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UUIDFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCuzkDocumentCollections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'not' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'and' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'stav' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'equalTo',
                                            },
                                            value: {
                                              kind: 'StringValue',
                                              value: 'zpracován',
                                              block: false,
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'datumpozadavku',
                                      },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'lessThan',
                                            },
                                            value: {
                                              kind: 'Variable',
                                              name: {
                                                kind: 'Name',
                                                value: 'oneDayAgo',
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'idFilter' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkCollectionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkDocumentId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'casoveraziko' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cena' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumpozadavku' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumspusteni' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumvytvoreni' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'elznacka' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'format' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nazev' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetjednotek' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetstran' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rizeni' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'stav' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByCuzkDocumentCollectionId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useCuzkDocumentCollectionTableQuery(
  options: Omit<
    Urql.UseQueryArgs<CuzkDocumentCollectionTableQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    CuzkDocumentCollectionTableQuery,
    CuzkDocumentCollectionTableQueryVariables
  >({ query: CuzkDocumentCollectionTableDocument, ...options })
}
export const CuzkEpoDetailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cuzkEpoDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cuzkEpoById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nazev' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pocetLv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rcIco' } },
                { kind: 'Field', name: { kind: 'Name', value: 'typ' } },
                { kind: 'Field', name: { kind: 'Name', value: 'format' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adresnimistokod' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCuzkEpoDetailQuery(
  options: Omit<Urql.UseQueryArgs<CuzkEpoDetailQueryVariables>, 'query'>
) {
  return Urql.useQuery<CuzkEpoDetailQuery, CuzkEpoDetailQueryVariables>({
    query: CuzkEpoDetailDocument,
    ...options,
  })
}
export const CuzkEpoTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cuzkEpoTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'oneDayAgo' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'idFilter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UUIDFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCuzkEpos' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'not' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'and' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'stav' },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'equalTo',
                                            },
                                            value: {
                                              kind: 'StringValue',
                                              value: 'zpracován',
                                              block: false,
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'datumpozadavku',
                                      },
                                      value: {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'lessThan',
                                            },
                                            value: {
                                              kind: 'Variable',
                                              name: {
                                                kind: 'Name',
                                                value: 'oneDayAgo',
                                              },
                                            },
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'idFilter' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cena' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumpozadavku' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumspusteni' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumvytvoreni' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'elznacka' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'format' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkCollectionId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nazev' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetjednotek' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetstran' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetLv' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rcIco' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stav' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'typ' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByCuzkEpoId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useCuzkEpoTableQuery(
  options: Omit<Urql.UseQueryArgs<CuzkEpoTableQueryVariables>, 'query'>
) {
  return Urql.useQuery<CuzkEpoTableQuery, CuzkEpoTableQueryVariables>({
    query: CuzkEpoTableDocument,
    ...options,
  })
}
export const BpejByCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'bpejByCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'in' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allBpejs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'kod' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'in' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cena' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'popis' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'platnostOd' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'platnostDo' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'kod' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useBpejByCodeQuery(
  options?: Omit<Urql.UseQueryArgs<BpejByCodeQueryVariables>, 'query'>
) {
  return Urql.useQuery<BpejByCodeQuery, BpejByCodeQueryVariables>({
    query: BpejByCodeDocument,
    ...options,
  })
}
export const CeeOfficeByNameDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ceeOfficeByName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'startsWith' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCeeOffices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'startsWith' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'startsWith' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'databox' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'dic' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'web' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'executorCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCeeOfficeByNameQuery(
  options: Omit<Urql.UseQueryArgs<CeeOfficeByNameQueryVariables>, 'query'>
) {
  return Urql.useQuery<CeeOfficeByNameQuery, CeeOfficeByNameQueryVariables>({
    query: CeeOfficeByNameDocument,
    ...options,
  })
}
export const CuzkLvTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cuzkLvTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'oneDayAgo' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'idFilter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UUIDFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCuzkLvs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'not' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'and' },
                                      value: {
                                        kind: 'ListValue',
                                        values: [
                                          {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'stav',
                                                },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'equalTo',
                                                      },
                                                      value: {
                                                        kind: 'StringValue',
                                                        value: 'zpracován',
                                                        block: false,
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                          {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'datumpozadavku',
                                                },
                                                value: {
                                                  kind: 'ObjectValue',
                                                  fields: [
                                                    {
                                                      kind: 'ObjectField',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'lessThan',
                                                      },
                                                      value: {
                                                        kind: 'Variable',
                                                        name: {
                                                          kind: 'Name',
                                                          value: 'oneDayAgo',
                                                        },
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    },
                                  ],
                                },
                              },
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'id' },
                                value: {
                                  kind: 'Variable',
                                  name: { kind: 'Name', value: 'idFilter' },
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cena' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumpozadavku' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumspusteni' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumvytvoreni' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'elznacka' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'format' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lv' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'katastralniUzemiKod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'katastralniUzemiNazev' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'obec' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumK' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkCollectionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetjednotek' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetstran' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'stav' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByCuzkLvId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useCuzkLvTableQuery(
  options: Omit<Urql.UseQueryArgs<CuzkLvTableQueryVariables>, 'query'>
) {
  return Urql.useQuery<CuzkLvTableQuery, CuzkLvTableQueryVariables>({
    query: CuzkLvTableDocument,
    ...options,
  })
}
export const AllLabelsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allLabels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allLabels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colorKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iconKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useAllLabelsQuery(
  options?: Omit<Urql.UseQueryArgs<AllLabelsQueryVariables>, 'query'>
) {
  return Urql.useQuery<AllLabelsQuery, AllLabelsQueryVariables>({
    query: AllLabelsDocument,
    ...options,
  })
}
export const CreateLabelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateLabelInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'label' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateLabelMutation() {
  return Urql.useMutation<CreateLabelMutation, CreateLabelMutationVariables>(
    CreateLabelDocument
  )
}
export const CreateMonitoringCuzkRcDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMonitoringCuzkRc' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateMonitoringCuzkRcInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMonitoringCuzkRc' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'monitoringCuzkRc' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateMonitoringCuzkRcMutation() {
  return Urql.useMutation<
    CreateMonitoringCuzkRcMutation,
    CreateMonitoringCuzkRcMutationVariables
  >(CreateMonitoringCuzkRcDocument)
}
export const CreateMonitoringCuzkRcLabelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMonitoringCuzkRcLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateLabelMonitoringCuzkRcInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLabelMonitoringCuzkRc' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateMonitoringCuzkRcLabelMutation() {
  return Urql.useMutation<
    CreateMonitoringCuzkRcLabelMutation,
    CreateMonitoringCuzkRcLabelMutationVariables
  >(CreateMonitoringCuzkRcLabelDocument)
}
export const DeleteMonitoringCuzkRcLabelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteMonitoringCuzkRcLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value:
                  'DeleteLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcIdInput',
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value:
                'deleteLabelMonitoringCuzkRcByLabelIdAndMonitoringCuzkRcId',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteMonitoringCuzkRcLabelMutation() {
  return Urql.useMutation<
    DeleteMonitoringCuzkRcLabelMutation,
    DeleteMonitoringCuzkRcLabelMutationVariables
  >(DeleteMonitoringCuzkRcLabelDocument)
}
export const DeleteMonitoringCuzkRcDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteMonitoringCuzkRc' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DeleteMonitoringCuzkRcByIdInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMonitoringCuzkRcById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteMonitoringCuzkRcMutation() {
  return Urql.useMutation<
    DeleteMonitoringCuzkRcMutation,
    DeleteMonitoringCuzkRcMutationVariables
  >(DeleteMonitoringCuzkRcDocument)
}
export const AllMonitoringCuzkRcsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allMonitoringCuzkRcs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MonitoringCuzkRcFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonitoringCuzkRcs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'found' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'editedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'birthDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkOsId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkFrequency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'validatedCode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rc' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByMonitoringCuzkRcId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkOByCuzkOsId' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'CuzkOFragment' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
    ...CuzkOFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useAllMonitoringCuzkRcsQuery(
  options?: Omit<Urql.UseQueryArgs<AllMonitoringCuzkRcsQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    AllMonitoringCuzkRcsQuery,
    AllMonitoringCuzkRcsQueryVariables
  >({ query: AllMonitoringCuzkRcsDocument, ...options })
}
export const CuzkMonitorRcTableExpandedRowDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cuzkMonitorRcTableExpandedRow' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'partnerId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCuzkOs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'partner1' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'equalTo' },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'partnerId',
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'partner2' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'equalTo' },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'partnerId',
                                        },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CuzkOFragment' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkOByPartner1' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'CuzkOFragment' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkOByPartner2' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'CuzkOFragment' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...CuzkOFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useCuzkMonitorRcTableExpandedRowQuery(
  options?: Omit<
    Urql.UseQueryArgs<CuzkMonitorRcTableExpandedRowQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    CuzkMonitorRcTableExpandedRowQuery,
    CuzkMonitorRcTableExpandedRowQueryVariables
  >({ query: CuzkMonitorRcTableExpandedRowDocument, ...options })
}
export const DataBoxDetailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dataBoxDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'databoxById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fulladdress' } },
                { kind: 'Field', name: { kind: 'Name', value: 'databoxid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullname' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adresnimistokod' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'birthname' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessname' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                { kind: 'Field', name: { kind: 'Name', value: 'idovm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ismaster' } },
                { kind: 'Field', name: { kind: 'Name', value: 'masterid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastname' } },
                { kind: 'Field', name: { kind: 'Name', value: 'middlename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ovm' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdz' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDataBoxDetailQuery(
  options: Omit<Urql.UseQueryArgs<DataBoxDetailQueryVariables>, 'query'>
) {
  return Urql.useQuery<DataBoxDetailQuery, DataBoxDetailQueryVariables>({
    query: DataBoxDetailDocument,
    ...options,
  })
}
export const SubDataBoxDetailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'subDataBoxDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'masterid' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allDataboxes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'masterid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'masterid' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fulladdress' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'databoxid' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adresnimistokod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'birthname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessname' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'idovm' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'middlename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ovm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pdz' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subtype' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useSubDataBoxDetailQuery(
  options?: Omit<Urql.UseQueryArgs<SubDataBoxDetailQueryVariables>, 'query'>
) {
  return Urql.useQuery<SubDataBoxDetailQuery, SubDataBoxDetailQueryVariables>({
    query: SubDataBoxDetailDocument,
    ...options,
  })
}
export const DataBoxSearchBarDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'dataBoxSearchBar' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'DataboxFilter' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allDataboxes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fulladdress' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'databoxid' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adresnimistokod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'birthname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessname' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'idovm' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ismaster' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'masterid' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'middlename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'ovm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pdz' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subtype' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDataBoxSearchBarQuery(
  options?: Omit<Urql.UseQueryArgs<DataBoxSearchBarQueryVariables>, 'query'>
) {
  return Urql.useQuery<DataBoxSearchBarQuery, DataBoxSearchBarQueryVariables>({
    query: DataBoxSearchBarDocument,
    ...options,
  })
}
export const KuWorkplaceByKodDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'kuWorkplaceByKod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kod' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'kuWorkplaceByKod' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kod' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'kod' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'castObce' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cisloDomovni' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cisloOrientacni' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mestskaCast' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nazev' } },
                { kind: 'Field', name: { kind: 'Name', value: 'nazevUlice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nazevZkraceny' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'obec' } },
                { kind: 'Field', name: { kind: 'Name', value: 'okres' } },
                { kind: 'Field', name: { kind: 'Name', value: 'psc' } },
                { kind: 'Field', name: { kind: 'Name', value: 'telefon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zkratka' } },
                { kind: 'Field', name: { kind: 'Name', value: 'web' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useKuWorkplaceByKodQuery(
  options: Omit<Urql.UseQueryArgs<KuWorkplaceByKodQueryVariables>, 'query'>
) {
  return Urql.useQuery<KuWorkplaceByKodQuery, KuWorkplaceByKodQueryVariables>({
    query: KuWorkplaceByKodDocument,
    ...options,
  })
}
export const LabelOverviewDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'labelOverview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'labelId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'labelById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'labelId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelConnectionsByLabelId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cuzkDocumentCollectionId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cuzkLvId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cuzkEpoId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cuzkEpoLienId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'monitId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'marketplaceOfferId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'monitoringCeeId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'monitoringCuzkRcId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'postserviceListId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyLabelId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'auctionListingId' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colorKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useLabelOverviewQuery(
  options: Omit<Urql.UseQueryArgs<LabelOverviewQueryVariables>, 'query'>
) {
  return Urql.useQuery<LabelOverviewQuery, LabelOverviewQueryVariables>({
    query: LabelOverviewDocument,
    ...options,
  })
}
export const DeleteLabelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteLabelById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'label' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allLabels' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteLabelMutation() {
  return Urql.useMutation<DeleteLabelMutation, DeleteLabelMutationVariables>(
    DeleteLabelDocument
  )
}
export const LabelTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'labelTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allLabels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByLabelId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iconKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'editedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colorKey' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useLabelTableQuery(
  options: Omit<Urql.UseQueryArgs<LabelTableQueryVariables>, 'query'>
) {
  return Urql.useQuery<LabelTableQuery, LabelTableQueryVariables>({
    query: LabelTableDocument,
    ...options,
  })
}
export const KuWorkplaceByAreaCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'kuWorkplaceByAreaCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'kuKod' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allKuAreas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'kuKod' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'kuKod' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'kuWorkplaceByPraresKod' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'castObce' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cisloDomovni' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cisloOrientacni' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ico' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mestskaCast' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nazev' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nazevUlice' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nazevZkraceny' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'obec' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'okres' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'psc' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'telefon' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'zkratka' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'web' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kod' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useKuWorkplaceByAreaCodeQuery(
  options?: Omit<
    Urql.UseQueryArgs<KuWorkplaceByAreaCodeQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    KuWorkplaceByAreaCodeQuery,
    KuWorkplaceByAreaCodeQueryVariables
  >({ query: KuWorkplaceByAreaCodeDocument, ...options })
}
export const CreateMarketplaceOfferDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMarketplaceOffer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'offerType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'title' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'description' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contactDescription' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contactEmail' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contactName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'contactPhone' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'expirationDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'images' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'interestAmount' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigFloat' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'investmentAmount' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigFloat' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'monthlyPayment' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigFloat' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'offerLocation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyValue' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigFloat' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMarketplaceOffer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'marketplaceOffer' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'id' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'offerType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offerType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'offerLocation' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offerLocation' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'expirationDate' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'expirationDate' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'interestAmount' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'interestAmount' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'monthlyPayment' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'monthlyPayment' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyValue' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyValue' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'investmentAmount' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'investmentAmount' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'contactName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'contactName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'contactEmail' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'contactEmail' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'contactPhone' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'contactPhone' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'contactDescription' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'contactDescription',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'description' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'description' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'images' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'images' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'title' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'title' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'state' },
                            value: { kind: 'EnumValue', value: 'ACTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateMarketplaceOfferMutation() {
  return Urql.useMutation<
    CreateMarketplaceOfferMutation,
    CreateMarketplaceOfferMutationVariables
  >(CreateMarketplaceOfferDocument)
}
export const MunicipalOfficeNameByAdresnimistokodDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'municipalOfficeNameByAdresnimistokod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'adresnimistokod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipalOfficeByAdresnimistokod' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'adresnimistokod' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'adresnimistokod' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adresnimistokod' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'officeName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useMunicipalOfficeNameByAdresnimistokodQuery(
  options: Omit<
    Urql.UseQueryArgs<MunicipalOfficeNameByAdresnimistokodQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    MunicipalOfficeNameByAdresnimistokodQuery,
    MunicipalOfficeNameByAdresnimistokodQueryVariables
  >({ query: MunicipalOfficeNameByAdresnimistokodDocument, ...options })
}
export const UpdatePostserviceRecipientDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePostserviceRecipient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'companyName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'country' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'firstname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'gender' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'houseNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'callName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orientationNumber' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'street' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'zipCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'addressId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable1' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable2' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable3' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable4' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable5' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable7' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable6' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable8' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable9' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable10' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyType' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyLv' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralCode' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCity' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyAddress' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyAreaNumber' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePostserviceRecipientById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {
                        kind: 'Name',
                        value: 'postserviceRecipientPatch',
                      },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lastname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'firstname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'callName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'callName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'houseNumber' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'houseNumber' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'street' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'street' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'zipCode' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'city' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'city' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'country' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'country' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'companyName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'gender' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'gender' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'orientationNumber' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'orientationNumber',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'addressId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'addressId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable10' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable10' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable9' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable9' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable8' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable8' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable7' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable7' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable6' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable6' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable5' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable5' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable4' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable4' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable3' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable3' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable2' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable2' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable1' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable1' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyLv' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyLv' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'propertyCadastralCode',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralCode',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'propertyCadastralName',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralName',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyCity' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyCity' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyAddress' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyAddress' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyAreaNumber' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyAreaNumber',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'postserviceRecipient' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdatePostserviceRecipientMutation() {
  return Urql.useMutation<
    UpdatePostserviceRecipientMutation,
    UpdatePostserviceRecipientMutationVariables
  >(UpdatePostserviceRecipientDocument)
}
export const CreatePostserviceRecipientDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPostserviceRecipient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'postserviceListId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'companyName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'uniquePersonKey' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'firstname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'callName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'gender' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'street' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'houseNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orientationNumber' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'addressId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'zipCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'country' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable1' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable2' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable3' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable4' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable5' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable7' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable6' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable8' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable9' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable10' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyType' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyLv' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralCode' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCity' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyAddress' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyAreaNumber' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPostserviceRecipient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'postserviceRecipient' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'postserviceListId' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'postserviceListId',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'companyName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uniquePersonKey' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'uniquePersonKey' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'firstname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lastname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'callName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'callName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'gender' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'gender' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'street' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'street' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'houseNumber' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'houseNumber' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'orientationNumber' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'orientationNumber',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'zipCode' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'city' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'city' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'addressId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'addressId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'country' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'country' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable10' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable10' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable9' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable9' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable8' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable8' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable7' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable7' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable6' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable6' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable5' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable5' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable4' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable4' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable3' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable3' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable2' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable2' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable1' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable1' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyLv' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyLv' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'propertyCadastralCode',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralCode',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'propertyCadastralName',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralName',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyCity' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyCity' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyAddress' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyAddress' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyAreaNumber' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyAreaNumber',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'postserviceRecipient' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'postserviceListByPostserviceListId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreatePostserviceRecipientMutation() {
  return Urql.useMutation<
    CreatePostserviceRecipientMutation,
    CreatePostserviceRecipientMutationVariables
  >(CreatePostserviceRecipientDocument)
}
export const CreatePostserviceListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPostserviceList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'listName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'description' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPostserviceList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'postserviceList' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'listName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'listName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'description' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'description' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'postserviceList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreatePostserviceListMutation() {
  return Urql.useMutation<
    CreatePostserviceListMutation,
    CreatePostserviceListMutationVariables
  >(CreatePostserviceListDocument)
}
export const EditPostserviceListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'editPostserviceList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'listName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'description' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePostserviceListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'postserviceListPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'description' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'description' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'listName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'listName' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useEditPostserviceListMutation() {
  return Urql.useMutation<
    EditPostserviceListMutation,
    EditPostserviceListMutationVariables
  >(EditPostserviceListDocument)
}
export const PostserviceRecipientsByListIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postserviceRecipientsByListId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'postserviceListId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'recipients' },
            name: { kind: 'Name', value: 'allPostserviceRecipients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'postserviceListId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'postserviceListId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'Recipient' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
    ...RecipientFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function usePostserviceRecipientsByListIdQuery(
  options: Omit<
    Urql.UseQueryArgs<PostserviceRecipientsByListIdQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PostserviceRecipientsByListIdQuery,
    PostserviceRecipientsByListIdQueryVariables
  >({ query: PostserviceRecipientsByListIdDocument, ...options })
}
export const PostserviceTemplateByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postserviceTemplateById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'template' },
            name: { kind: 'Name', value: 'postserviceTemplateById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePostserviceTemplateByIdQuery(
  options: Omit<
    Urql.UseQueryArgs<PostserviceTemplateByIdQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PostserviceTemplateByIdQuery,
    PostserviceTemplateByIdQueryVariables
  >({ query: PostserviceTemplateByIdDocument, ...options })
}
export const DeletePostserviceRecipientByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deletePostserviceRecipientById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePostserviceRecipientById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'postserviceListByPostserviceListId',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeletePostserviceRecipientByIdMutation() {
  return Urql.useMutation<
    DeletePostserviceRecipientByIdMutation,
    DeletePostserviceRecipientByIdMutationVariables
  >(DeletePostserviceRecipientByIdDocument)
}
export const PostServiceRecipientListTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postServiceRecipientListTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'idFilter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UUIDFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPostserviceLists' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'idFilter' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'listName' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByPostserviceListId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'recipients' },
                        name: {
                          kind: 'Name',
                          value: 'postserviceRecipientsByPostserviceListId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'letters' },
                        name: {
                          kind: 'Name',
                          value: 'postserviceSentLettersByOriginalListId',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'deletedAt' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'isNull' },
                                        value: {
                                          kind: 'BooleanValue',
                                          value: true,
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function usePostServiceRecipientListTableQuery(
  options: Omit<
    Urql.UseQueryArgs<PostServiceRecipientListTableQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PostServiceRecipientListTableQuery,
    PostServiceRecipientListTableQueryVariables
  >({ query: PostServiceRecipientListTableDocument, ...options })
}
export const PostserviceListNameDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postserviceListName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postserviceListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'listName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePostserviceListNameQuery(
  options: Omit<Urql.UseQueryArgs<PostserviceListNameQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    PostserviceListNameQuery,
    PostserviceListNameQueryVariables
  >({ query: PostserviceListNameDocument, ...options })
}
export const DeletePostServiceRecipientListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deletePostServiceRecipientList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'deletedAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePostserviceListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'postserviceListPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'deletedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'deletedAt' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'postserviceList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeletePostServiceRecipientListMutation() {
  return Urql.useMutation<
    DeletePostServiceRecipientListMutation,
    DeletePostServiceRecipientListMutationVariables
  >(DeletePostServiceRecipientListDocument)
}
export const PostserviceRecipientTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postserviceRecipientTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postserviceListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listName' } },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'postserviceRecipientsByPostserviceListId',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'country' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gender' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addressId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'houseNumber' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'orientationNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'street' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable1' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable10' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable2' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable3' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable4' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable5' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable6' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable7' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable8' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable9' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyLv' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralCode',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyCity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyAddress' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyAreaNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePostserviceRecipientTableQuery(
  options: Omit<
    Urql.UseQueryArgs<PostserviceRecipientTableQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PostserviceRecipientTableQuery,
    PostserviceRecipientTableQueryVariables
  >({ query: PostserviceRecipientTableDocument, ...options })
}
export const CreatePostserviceTemplateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPostserviceTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'content' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'description' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPostserviceTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'postserviceTemplate' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'name' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'name' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'description' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'description' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'content' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'content' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'postserviceTemplate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreatePostserviceTemplateMutation() {
  return Urql.useMutation<
    CreatePostserviceTemplateMutation,
    CreatePostserviceTemplateMutationVariables
  >(CreatePostserviceTemplateDocument)
}
export const CreatePostserviceSentLetterDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPostserviceSentLetter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'content' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'originalTemplateId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'originalListId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'description' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'senderAddressId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPostserviceSentLetter' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'postserviceSentLetter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'content' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'content' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'senderAddressId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'senderAddressId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'originalTemplateId' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'originalTemplateId',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'originalListId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'originalListId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'name' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'name' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'description' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'description' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'postserviceSentLetter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreatePostserviceSentLetterMutation() {
  return Urql.useMutation<
    CreatePostserviceSentLetterMutation,
    CreatePostserviceSentLetterMutationVariables
  >(CreatePostserviceSentLetterDocument)
}
export const CreatePostserviceSentRecipientDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPostserviceSentRecipient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'originalRecipientId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sentLetterId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'companyName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'country' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'firstname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'gender' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'houseNumber' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastname' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'callName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orientationNumber' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'street' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'uniquePersonKey' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'addressId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable1' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable2' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable3' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable4' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable5' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable7' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable6' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable8' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable9' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'variable10' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'zipCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyType' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyLv' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralCode' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCity' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyAddress' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyAreaNumber' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPostserviceSentRecipient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'postserviceSentRecipient' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'originalRecipientId',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'originalRecipientId',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'sentLetterId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'sentLetterId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lastname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'firstname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'callName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'callName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'houseNumber' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'houseNumber' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'orientationNumber' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'orientationNumber',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'street' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'street' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'zipCode' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'city' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'city' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'country' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'country' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'companyName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'gender' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'gender' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'uniquePersonKey' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'uniquePersonKey' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'addressId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'addressId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable10' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable10' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable9' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable9' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable8' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable8' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable7' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable7' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable6' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable6' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable5' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable5' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable4' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable4' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable3' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable3' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable2' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable2' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'variable1' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'variable1' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyLv' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyLv' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'propertyCadastralCode',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralCode',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'propertyCadastralName',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralName',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyCity' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyCity' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyAddress' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyAddress' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyAreaNumber' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyAreaNumber',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreatePostserviceSentRecipientMutation() {
  return Urql.useMutation<
    CreatePostserviceSentRecipientMutation,
    CreatePostserviceSentRecipientMutationVariables
  >(CreatePostserviceSentRecipientDocument)
}
export const SentLetterPreviewDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sentLetterPreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'letterId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipientId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postserviceSentLetterById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'letterId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'postserviceSentRecipientsBySentLetterId',
                  },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'condition' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'recipientId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'country' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gender' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'houseNumber' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'orientationNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'originalRecipientId',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'postserviceTrackingNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'street' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uniquePersonKey' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable1' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable10' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable2' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable3' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable4' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable5' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable6' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable7' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable8' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable9' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyLv' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralCode',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyCity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyAddress' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyAreaNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'postserviceType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useSentLetterPreviewQuery(
  options: Omit<Urql.UseQueryArgs<SentLetterPreviewQueryVariables>, 'query'>
) {
  return Urql.useQuery<SentLetterPreviewQuery, SentLetterPreviewQueryVariables>(
    { query: SentLetterPreviewDocument, ...options }
  )
}
export const PostServiceSentTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postServiceSentTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'idFilter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UUIDFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allRecipientLists' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'letterText' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'idFilter' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dispatchDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'letterText' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nazev' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByRecipientListId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'recipients' },
                        name: {
                          kind: 'Name',
                          value: 'recipientListRecipientsByRecipientListId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'senderAddress' },
                        name: {
                          kind: 'Name',
                          value: 'senderAddressBySenderAddressId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'houseNumber' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'orientationNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'senderName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'street' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function usePostServiceSentTableQuery(
  options: Omit<Urql.UseQueryArgs<PostServiceSentTableQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    PostServiceSentTableQuery,
    PostServiceSentTableQueryVariables
  >({ query: PostServiceSentTableDocument, ...options })
}
export const PostserviceSentLettersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postserviceSentLetters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'originalListId' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'UUIDFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPostserviceSentLetters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'originalListId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'originalListId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'senderAddress' },
                        name: {
                          kind: 'Name',
                          value: 'senderAddressBySenderAddressId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'senderName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'street' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'orientationNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'houseNumber' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sentAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postserviceType' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'template' },
                        name: {
                          kind: 'Name',
                          value: 'postserviceTemplateByOriginalTemplateId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'recipients' },
                        name: {
                          kind: 'Name',
                          value: 'postserviceSentRecipientsBySentLetterId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePostserviceSentLettersQuery(
  options: Omit<
    Urql.UseQueryArgs<PostserviceSentLettersQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PostserviceSentLettersQuery,
    PostserviceSentLettersQueryVariables
  >({ query: PostserviceSentLettersDocument, ...options })
}
export const DeletePostserviceSentLetterByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deletePostserviceSentLetterById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'deletedAt' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePostserviceSentLetterById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {
                        kind: 'Name',
                        value: 'postserviceSentLetterPatch',
                      },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'deletedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'deletedAt' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeletePostserviceSentLetterByIdMutation() {
  return Urql.useMutation<
    DeletePostserviceSentLetterByIdMutation,
    DeletePostserviceSentLetterByIdMutationVariables
  >(DeletePostserviceSentLetterByIdDocument)
}
export const DeleteRecipientListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteRecipientList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'deletedAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRecipientListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'recipientListPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'deletedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'deletedAt' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteRecipientListMutation() {
  return Urql.useMutation<
    DeleteRecipientListMutation,
    DeleteRecipientListMutationVariables
  >(DeleteRecipientListDocument)
}
export const PostServiceSentRecipientsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postServiceSentRecipients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'letterText' } },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'recipientListRecipientsByRecipientListId',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'recipient' },
                              name: {
                                kind: 'Name',
                                value: 'recipientByRecipientId',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'krestnijmeno',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'osloveni' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pohlavi' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nazev' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'prijmeni' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'titulpred' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'titulza' },
                                  },
                                  {
                                    kind: 'Field',
                                    alias: { kind: 'Name', value: 'address' },
                                    name: {
                                      kind: 'Name',
                                      value: 'addressByAdresnimistokod',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'budovaregestaid',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'castobce',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cislodomovni',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cisloorientacni',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cisloorientacnipismeno',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'kraj' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'obec' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'okres',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'psc' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'typbudovy',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'ulice',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'radnice',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePostServiceSentRecipientsQuery(
  options: Omit<
    Urql.UseQueryArgs<PostServiceSentRecipientsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PostServiceSentRecipientsQuery,
    PostServiceSentRecipientsQueryVariables
  >({ query: PostServiceSentRecipientsDocument, ...options })
}
export const PostserviceSentLetterByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postserviceSentLetterById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postserviceSentLetterById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'recipients' },
                  name: {
                    kind: 'Name',
                    value: 'postserviceSentRecipientsBySentLetterId',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gender' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'postserviceTrackingNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'postserviceId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'street' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'orientationNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'houseNumber' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'country' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'addressId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable1' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable2' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable3' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable5' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable4' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable6' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable7' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable8' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable9' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable10' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyLv' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralCode',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyCity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyAddress' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyAreaNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePostserviceSentLetterByIdQuery(
  options: Omit<
    Urql.UseQueryArgs<PostserviceSentLetterByIdQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PostserviceSentLetterByIdQuery,
    PostserviceSentLetterByIdQueryVariables
  >({ query: PostserviceSentLetterByIdDocument, ...options })
}
export const PostServiceTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postServiceTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'temporaryRecipientsJson' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'nazev' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePostServiceTableQuery(
  options: Omit<Urql.UseQueryArgs<PostServiceTableQueryVariables>, 'query'>
) {
  return Urql.useQuery<PostServiceTableQuery, PostServiceTableQueryVariables>({
    query: PostServiceTableDocument,
    ...options,
  })
}
export const AllPostserviceTemplatesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allPostserviceTemplates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPostserviceTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useAllPostserviceTemplatesQuery(
  options: Omit<
    Urql.UseQueryArgs<AllPostserviceTemplatesQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    AllPostserviceTemplatesQuery,
    AllPostserviceTemplatesQueryVariables
  >({ query: AllPostserviceTemplatesDocument, ...options })
}
export const PostserviceTemplateTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postserviceTemplateTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPostserviceTemplates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePostserviceTemplateTableQuery(
  options: Omit<
    Urql.UseQueryArgs<PostserviceTemplateTableQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PostserviceTemplateTableQuery,
    PostserviceTemplateTableQueryVariables
  >({ query: PostserviceTemplateTableDocument, ...options })
}
export const DeletePostserviceTemplateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deletePostserviceTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'deletedAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePostserviceTemplateById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'postserviceTemplatePatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'deletedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'deletedAt' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeletePostserviceTemplateMutation() {
  return Urql.useMutation<
    DeletePostserviceTemplateMutation,
    DeletePostserviceTemplateMutationVariables
  >(DeletePostserviceTemplateDocument)
}
export const UpdatePostserviceTemplateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePostserviceTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'content' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'editedAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'description' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePostserviceTemplateById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'postserviceTemplatePatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'content' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'content' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'editedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'editedAt' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'name' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'name' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'description' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'description' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdatePostserviceTemplateMutation() {
  return Urql.useMutation<
    UpdatePostserviceTemplateMutation,
    UpdatePostserviceTemplateMutationVariables
  >(UpdatePostserviceTemplateDocument)
}
export const PriceEstimateLayoutDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'priceEstimateLayout' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaM2Nab' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaM2Real' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaNab' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaReal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decompNab' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decompReal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeSeriesGraph' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimateToDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'modelVersion' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByMonitId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function usePriceEstimateLayoutQuery(
  options: Omit<Urql.UseQueryArgs<PriceEstimateLayoutQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    PriceEstimateLayoutQuery,
    PriceEstimateLayoutQueryVariables
  >({ query: PriceEstimateLayoutDocument, ...options })
}
export const PriceEstimatePdfDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'priceEstimatePdf' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'monitById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publicNote' } },
                { kind: 'Field', name: { kind: 'Name', value: 'risyData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lvData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyType' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'modelVersion' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'polygon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cenaReal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cenaNab' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cenaM2Real' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cenaM2Nab' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'estimateToDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'decompReal' } },
                { kind: 'Field', name: { kind: 'Name', value: 'decompNab' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeSeriesGraph' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'graphImageString' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePriceEstimatePdfQuery(
  options: Omit<Urql.UseQueryArgs<PriceEstimatePdfQueryVariables>, 'query'>
) {
  return Urql.useQuery<PriceEstimatePdfQuery, PriceEstimatePdfQueryVariables>({
    query: PriceEstimatePdfDocument,
    ...options,
  })
}
export const PriceEstimateSelectBoxDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'priceEstimateSelectBox' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimateToDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestData' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaReal' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePriceEstimateSelectBoxQuery(
  options: Omit<
    Urql.UseQueryArgs<PriceEstimateSelectBoxQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PriceEstimateSelectBoxQuery,
    PriceEstimateSelectBoxQueryVariables
  >({ query: PriceEstimateSelectBoxDocument, ...options })
}
export const PriceEstimateTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'priceEstimateTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MonitFilter' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonits' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimateToDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaReal' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaNab' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaM2Real' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaM2Nab' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByMonitId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function usePriceEstimateTableQuery(
  options: Omit<Urql.UseQueryArgs<PriceEstimateTableQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    PriceEstimateTableQuery,
    PriceEstimateTableQueryVariables
  >({ query: PriceEstimateTableDocument, ...options })
}
export const ProceedingDetailDocumentCollectionTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'proceedingDetailDocumentCollectionTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'rizeni' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCuzkDocumentCollections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'rizeni' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'rizeni' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkCollectionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkDocumentId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'casoveraziko' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cena' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumpozadavku' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumspusteni' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumvytvoreni' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'elznacka' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'format' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nazev' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetjednotek' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetstran' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rizeni' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'stav' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByCuzkDocumentCollectionId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useProceedingDetailDocumentCollectionTableQuery(
  options: Omit<
    Urql.UseQueryArgs<ProceedingDetailDocumentCollectionTableQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    ProceedingDetailDocumentCollectionTableQuery,
    ProceedingDetailDocumentCollectionTableQueryVariables
  >({ query: ProceedingDetailDocumentCollectionTableDocument, ...options })
}
export const AllCeeOfficeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allCeeOffice' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCeeOffices' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'databox' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'dic' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'web' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'executorCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useAllCeeOfficeQuery(
  options?: Omit<Urql.UseQueryArgs<AllCeeOfficeQueryVariables>, 'query'>
) {
  return Urql.useQuery<AllCeeOfficeQuery, AllCeeOfficeQueryVariables>({
    query: AllCeeOfficeDocument,
    ...options,
  })
}
export const ProceedingSearchBarDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'proceedingSearchBar' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allKuWorkplaces' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'typPrac' },
                      value: { kind: 'IntValue', value: '2' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'NAZEV_ZKRACENY_ASC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nazevZkraceny' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'kod' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useProceedingSearchBarQuery(
  options?: Omit<Urql.UseQueryArgs<ProceedingSearchBarQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    ProceedingSearchBarQuery,
    ProceedingSearchBarQueryVariables
  >({ query: ProceedingSearchBarDocument, ...options })
}
export const PropertyDetailAuctionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyDetailAuction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'labelIds' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'UUID' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allAuctionProperties' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'auctionListingByAuctionId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'auctionNumber' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'detailUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'price' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'auctionedOn' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'auctionDecreeUrl' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lat' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'long' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photoUrl' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'labels' },
                              name: {
                                kind: 'Name',
                                value: 'labelConnectionsByAuctionListingId',
                              },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'filter' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'labelId',
                                        },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: {
                                                kind: 'Name',
                                                value: 'in',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'labelIds',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'LabelConnectionFragment',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'activityLogs' },
                              name: {
                                kind: 'Name',
                                value: 'userActivityLogsByAuctionListingId',
                              },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'condition' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'accountUserId',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'accountUserId',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'first' },
                                  value: { kind: 'IntValue', value: '1' },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'editedAt',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'nodeId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'actionType',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              alias: {
                                kind: 'Name',
                                value: 'linkedProperties',
                              },
                              name: {
                                kind: 'Name',
                                value: 'auctionPropertiesByAuctionId',
                              },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'condition' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'accountId',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'accountId',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'totalCount' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function usePropertyDetailAuctionQuery(
  options: Omit<Urql.UseQueryArgs<PropertyDetailAuctionQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    PropertyDetailAuctionQuery,
    PropertyDetailAuctionQueryVariables
  >({ query: PropertyDetailAuctionDocument, ...options })
}
export const PropertyDetailAuctionCheckDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyDetailAuctionCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allAuctionProperties' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePropertyDetailAuctionCheckQuery(
  options: Omit<
    Urql.UseQueryArgs<PropertyDetailAuctionCheckQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PropertyDetailAuctionCheckQuery,
    PropertyDetailAuctionCheckQueryVariables
  >({ query: PropertyDetailAuctionCheckDocument, ...options })
}
export const UnitRentByCadastralAreaCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'unitRentByCadastralAreaCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cadastralAreaCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unitRentByCadastralAreaCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cadastralAreaCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cadastralAreaCode' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cadastralAreaName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk1DataCoverage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk1LowerInterval' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vk1Maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk1Median' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk1Minimum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk1NewBuilding' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk1Reference' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk1UpperInterval' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk2DataCoverage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk2LowerInterval' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vk2Maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk2Median' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk2Minimum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk2NewBuilding' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk2Reference' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk2UpperInterval' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk3DataCoverage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk3LowerInterval' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vk3Maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk3Median' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk3Minimum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk3NewBuilding' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk3Reference' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk3UpperInterval' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk4DataCoverage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk4LowerInterval' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vk4Maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk4Median' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk4Minimum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk4Reference' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk4NewBuilding' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk4UpperInterval' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUnitRentByCadastralAreaCodeQuery(
  options: Omit<
    Urql.UseQueryArgs<UnitRentByCadastralAreaCodeQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    UnitRentByCadastralAreaCodeQuery,
    UnitRentByCadastralAreaCodeQueryVariables
  >({ query: UnitRentByCadastralAreaCodeDocument, ...options })
}
export const PropertyBuybackCalculationsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyBuybackCalculations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allBuybackCalculations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: { kind: 'NullValue' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'calculatorVersion' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'formData' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePropertyBuybackCalculationsQuery(
  options: Omit<
    Urql.UseQueryArgs<PropertyBuybackCalculationsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PropertyBuybackCalculationsQuery,
    PropertyBuybackCalculationsQueryVariables
  >({ query: PropertyBuybackCalculationsDocument, ...options })
}
export const DeleteBuybackCalculationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteBuybackCalculation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'deletedAt' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBuybackCalculationById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'buybackCalculationPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'deletedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'deletedAt' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buybackCalculation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allBuybackCalculations' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteBuybackCalculationMutation() {
  return Urql.useMutation<
    DeleteBuybackCalculationMutation,
    DeleteBuybackCalculationMutationVariables
  >(DeleteBuybackCalculationDocument)
}
export const UpdateBuybackCalculationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateBuybackCalculation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'payload' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BuybackCalculationPatch' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBuybackCalculationById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'buybackCalculationPatch' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'payload' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'buybackCalculation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allBuybackCalculations' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateBuybackCalculationMutation() {
  return Urql.useMutation<
    UpdateBuybackCalculationMutation,
    UpdateBuybackCalculationMutationVariables
  >(UpdateBuybackCalculationDocument)
}
export const CreatePropertyDetailLabelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPropertyDetailLabel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyLv' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPropertyLabel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyLabel' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyLv' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyLv' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'propertyCadastralCode',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralCode',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'propertyCadastralName',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralName',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyLabel' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreatePropertyDetailLabelMutation() {
  return Urql.useMutation<
    CreatePropertyDetailLabelMutation,
    CreatePropertyDetailLabelMutationVariables
  >(CreatePropertyDetailLabelDocument)
}
export const PropertyDetailLastNoteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyDetailLastNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyLv' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPropertyNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyLv' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'propertyLv' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyCadastralCode' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'propertyCadastralCode' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'links' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iconKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'editedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colorKey' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePropertyDetailLastNoteQuery(
  options: Omit<
    Urql.UseQueryArgs<PropertyDetailLastNoteQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PropertyDetailLastNoteQuery,
    PropertyDetailLastNoteQueryVariables
  >({ query: PropertyDetailLastNoteDocument, ...options })
}
export const PropertyDetailAllCuzkLvsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyDetailAllCuzkLvs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lv' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'katastralniUzemiKod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCuzkLvs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lv' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'lv' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'katastralniUzemiKod' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'katastralniUzemiKod' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePropertyDetailAllCuzkLvsQuery(
  options: Omit<
    Urql.UseQueryArgs<PropertyDetailAllCuzkLvsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PropertyDetailAllCuzkLvsQuery,
    PropertyDetailAllCuzkLvsQueryVariables
  >({ query: PropertyDetailAllCuzkLvsDocument, ...options })
}
export const CreatePropertyNoteDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPropertyNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyLv' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyType' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'links' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'colorKey' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'iconKey' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPropertyNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyNote' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyLv' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyLv' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'propertyCadastralCode',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralCode',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'note' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'note' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'links' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'links' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'iconKey' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'iconKey' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'colorKey' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'colorKey' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyNote' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allPropertyNotes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreatePropertyNoteMutation() {
  return Urql.useMutation<
    CreatePropertyNoteMutation,
    CreatePropertyNoteMutationVariables
  >(CreatePropertyNoteDocument)
}
export const DeletePropertyNoteByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deletePropertyNoteById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePropertyNoteById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyNote' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeletePropertyNoteByIdMutation() {
  return Urql.useMutation<
    DeletePropertyNoteByIdMutation,
    DeletePropertyNoteByIdMutationVariables
  >(DeletePropertyNoteByIdDocument)
}
export const UpdatePropertyNoteByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePropertyNoteById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'colorKey' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'editedAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'iconKey' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'links' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePropertyNoteById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyNotePatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'colorKey' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'colorKey' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'editedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'editedAt' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'iconKey' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'iconKey' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'links' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'links' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'note' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'note' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyNote' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdatePropertyNoteByIdMutation() {
  return Urql.useMutation<
    UpdatePropertyNoteByIdMutation,
    UpdatePropertyNoteByIdMutationVariables
  >(UpdatePropertyNoteByIdDocument)
}
export const PropertyDetailNoteTimelineDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyDetailNoteTimeline' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyLv' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyCadastralCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPropertyNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyLv' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'propertyLv' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyCadastralCode' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'propertyCadastralCode' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_ASC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyLv' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyCadastralCode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'links' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iconKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'editedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colorKey' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePropertyDetailNoteTimelineQuery(
  options: Omit<
    Urql.UseQueryArgs<PropertyDetailNoteTimelineQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PropertyDetailNoteTimelineQuery,
    PropertyDetailNoteTimelineQueryVariables
  >({ query: PropertyDetailNoteTimelineDocument, ...options })
}
export const GeneralPropertyLabelsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'generalPropertyLabels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UUID' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPropertyLabels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyIds' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyLv' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyCadastralName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyCadastralCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByPropertyLabelId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useGeneralPropertyLabelsQuery(
  options: Omit<Urql.UseQueryArgs<GeneralPropertyLabelsQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    GeneralPropertyLabelsQuery,
    GeneralPropertyLabelsQueryVariables
  >({ query: GeneralPropertyLabelsDocument, ...options })
}
export const PropertyDetailsLabelsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyDetailsLabels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UUID' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPropertyLabels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyIds' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyLv' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyCadastralName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyCadastralCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'labels' },
                        name: {
                          kind: 'Name',
                          value: 'labelConnectionsByPropertyLabelId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'LabelConnectionFragment',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function usePropertyDetailsLabelsQuery(
  options: Omit<Urql.UseQueryArgs<PropertyDetailsLabelsQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    PropertyDetailsLabelsQuery,
    PropertyDetailsLabelsQueryVariables
  >({ query: PropertyDetailsLabelsDocument, ...options })
}
export const ProceedingIdsWithDocumentDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'proceedingIdsWithDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'proceedings' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCuzkDocumentCollections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'rizeni' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'proceedings' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rizeni' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useProceedingIdsWithDocumentQuery(
  options: Omit<
    Urql.UseQueryArgs<ProceedingIdsWithDocumentQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    ProceedingIdsWithDocumentQuery,
    ProceedingIdsWithDocumentQueryVariables
  >({ query: ProceedingIdsWithDocumentDocument, ...options })
}
export const PropertyLabelTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyLabelTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'labelId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allLabelConnections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'labelId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'labelId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyLabelId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'propertyLabelByPropertyLabelId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyLv' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralCode',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'labels' },
                              name: {
                                kind: 'Name',
                                value: 'labelConnectionsByPropertyLabelId',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'LabelConnectionFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function usePropertyLabelTableQuery(
  options: Omit<Urql.UseQueryArgs<PropertyLabelTableQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    PropertyLabelTableQuery,
    PropertyLabelTableQueryVariables
  >({ query: PropertyLabelTableDocument, ...options })
}
export const PropertyListDetailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyListDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'propertyListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'whereClause' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyType' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePropertyListDetailQuery(
  options: Omit<Urql.UseQueryArgs<PropertyListDetailQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    PropertyListDetailQuery,
    PropertyListDetailQueryVariables
  >({ query: PropertyListDetailDocument, ...options })
}
export const CreatePropertyListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPropertyList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'description' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'whereClause' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'count' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPropertyList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyList' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'name' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'name' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'description' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'description' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'whereClause' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'whereClause' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'count' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'count' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreatePropertyListMutation() {
  return Urql.useMutation<
    CreatePropertyListMutation,
    CreatePropertyListMutationVariables
  >(CreatePropertyListDocument)
}
export const DeletePropertyListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deletePropertyList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'deletedAt' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePropertyListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyListPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'deletedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'deletedAt' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeletePropertyListMutation() {
  return Urql.useMutation<
    DeletePropertyListMutation,
    DeletePropertyListMutationVariables
  >(DeletePropertyListDocument)
}
export const EditPropertyListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'editPropertyList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'description' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePropertyListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyListPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'name' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'name' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'description' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'description' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useEditPropertyListMutation() {
  return Urql.useMutation<
    EditPropertyListMutation,
    EditPropertyListMutationVariables
  >(EditPropertyListDocument)
}
export const PropertyListsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyLists' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPropertyLists' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: { kind: 'NullValue' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePropertyListsQuery(
  options: Omit<Urql.UseQueryArgs<PropertyListsQueryVariables>, 'query'>
) {
  return Urql.useQuery<PropertyListsQuery, PropertyListsQueryVariables>({
    query: PropertyListsDocument,
    ...options,
  })
}
export const PropertyNotesByPropertyIdsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyNotesByPropertyIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UUID' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPropertyNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'propertyId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyIds' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'and' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'deletedAt' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'isNull' },
                                  value: { kind: 'BooleanValue', value: true },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_ASC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iconKey' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colorKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyLv' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyCadastralCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePropertyNotesByPropertyIdsQuery(
  options: Omit<
    Urql.UseQueryArgs<PropertyNotesByPropertyIdsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PropertyNotesByPropertyIdsQuery,
    PropertyNotesByPropertyIdsQueryVariables
  >({ query: PropertyNotesByPropertyIdsDocument, ...options })
}
export const PropertyNoteTableDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyNoteTable' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPropertyNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'deletedAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyLv' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyCadastralCode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'links' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iconKey' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'editedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deletedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'colorKey' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePropertyNoteTableQuery(
  options: Omit<Urql.UseQueryArgs<PropertyNoteTableQueryVariables>, 'query'>
) {
  return Urql.useQuery<PropertyNoteTableQuery, PropertyNoteTableQueryVariables>(
    { query: PropertyNoteTableDocument, ...options }
  )
}
export const SearchCadastralAreaDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchCadastralArea' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'query' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allKuAreas' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'kuKod' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'startsWith',
                                      },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'query' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'kuNazev' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'startsWithInsensitive',
                                      },
                                      value: {
                                        kind: 'Variable',
                                        name: { kind: 'Name', value: 'query' },
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '10' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'kuKod' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'kuNazev' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'obecNazev' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useSearchCadastralAreaQuery(
  options?: Omit<Urql.UseQueryArgs<SearchCadastralAreaQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    SearchCadastralAreaQuery,
    SearchCadastralAreaQueryVariables
  >({ query: SearchCadastralAreaDocument, ...options })
}
export const RecipientsByUniquePersonKeysDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'recipientsByUniquePersonKeys' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'uniquePersonKeys' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPostserviceRecipients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uniquePersonKey' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'uniquePersonKeys' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uniquePersonKey' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'postserviceListByPostserviceListId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'listName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'labels' },
                              name: {
                                kind: 'Name',
                                value: 'labelConnectionsByPostserviceListId',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'LabelConnectionFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPostserviceSentRecipients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'uniquePersonKey' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'uniquePersonKeys' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'postserviceId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uniquePersonKey' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'postserviceTrackingNumber',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'postserviceSentLetterBySentLetterId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sentAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'deletedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'postserviceType' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...LabelConnectionFragmentFragmentDoc.definitions,
  ],
} as unknown as DocumentNode

export function useRecipientsByUniquePersonKeysQuery(
  options: Omit<
    Urql.UseQueryArgs<RecipientsByUniquePersonKeysQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    RecipientsByUniquePersonKeysQuery,
    RecipientsByUniquePersonKeysQueryVariables
  >({ query: RecipientsByUniquePersonKeysDocument, ...options })
}
export const CreateLabelConnectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createLabelConnection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'labelId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'monitoringCuzkRcId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipientListId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'monitoringCeeId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'monitId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'marketplaceOfferId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkEpoLienId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkLvId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkEpoId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkDocumentCollectionId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'postserviceListId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyLabelId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'auctionListingId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createLabelConnection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'labelConnection' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'labelId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'labelId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'monitoringCuzkRcId' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'monitoringCuzkRcId',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cuzkEpoLienId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cuzkEpoLienId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cuzkLvId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cuzkLvId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cuzkEpoId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cuzkEpoId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'cuzkDocumentCollectionId',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'cuzkDocumentCollectionId',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'marketplaceOfferId' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'marketplaceOfferId',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'monitId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'monitId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'monitoringCeeId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'monitoringCeeId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'recipientListId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'recipientListId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'postserviceListId' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'postserviceListId',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyLabelId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyLabelId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'auctionListingId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'auctionListingId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allLabelConnections' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allMonitoringCuzkRcs' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allCuzkEpoLiens' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allCuzkLvs' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allCuzkEpos' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'allCuzkDocumentCollections',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allMarketplaceOffers' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allMonits' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allMonitoringCees' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allRecipientLists' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allPostserviceLists' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allPropertyLabels' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allAuctionListings' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateLabelConnectionMutation() {
  return Urql.useMutation<
    CreateLabelConnectionMutation,
    CreateLabelConnectionMutationVariables
  >(CreateLabelConnectionDocument)
}
export const DeleteLabelConnectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteLabelConnection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteLabelConnectionById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'labelConnection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteLabelConnectionMutation() {
  return Urql.useMutation<
    DeleteLabelConnectionMutation,
    DeleteLabelConnectionMutationVariables
  >(DeleteLabelConnectionDocument)
}
export const AllUserActivityLogsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allUserActivityLogs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entityIds' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allUserActivityLogs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountUserId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entityId' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'entityIds' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actionType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'editedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useAllUserActivityLogsQuery(
  options?: Omit<Urql.UseQueryArgs<AllUserActivityLogsQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    AllUserActivityLogsQuery,
    AllUserActivityLogsQueryVariables
  >({ query: AllUserActivityLogsDocument, ...options })
}
export const CreateUserActivityLogDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createUserActivityLog' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entityType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserActivityEntityType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'actionType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserActivityActionType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'actionSource' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entityId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'auctionListingId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUserActivityLog' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userActivityLog' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'entityId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'entityId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'entityType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'entityType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'actionType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'actionType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'actionSource' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'actionSource' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'auctionListingId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'auctionListingId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'query' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allUserActivityLogs' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '0' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateUserActivityLogMutation() {
  return Urql.useMutation<
    CreateUserActivityLogMutation,
    CreateUserActivityLogMutationVariables
  >(CreateUserActivityLogDocument)
}
export const UpdateUserActivityLogDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserActivityLog' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nodeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'actionType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserActivityActionType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'editedAt' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'auctionListingId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserActivityLog' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'nodeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'nodeId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userActivityLogPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'actionType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'actionType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'auctionListingId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'auctionListingId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'editedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'editedAt' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userActivityLog' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateUserActivityLogMutation() {
  return Urql.useMutation<
    UpdateUserActivityLogMutation,
    UpdateUserActivityLogMutationVariables
  >(UpdateUserActivityLogDocument)
}
export const UserActivityLogByEntityIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'userActivityLogByEntityId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'entityId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allUserActivityLogs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountUserId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'entityId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'entityId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actionType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'editedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodeId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUserActivityLogByEntityIdQuery(
  options: Omit<
    Urql.UseQueryArgs<UserActivityLogByEntityIdQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    UserActivityLogByEntityIdQuery,
    UserActivityLogByEntityIdQueryVariables
  >({ query: UserActivityLogByEntityIdDocument, ...options })
}
export const AuctionListingsByFilterDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'auctionListingsByFilter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'filter' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AuctionListingFilter' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allAuctionListings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'filter' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auctionNumber' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'detailUrl' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auctionedOn' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'auctionDecreeUrl' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sourceHostname' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'long' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ku' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'obec' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useAuctionListingsByFilterQuery(
  options: Omit<
    Urql.UseQueryArgs<AuctionListingsByFilterQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    AuctionListingsByFilterQuery,
    AuctionListingsByFilterQueryVariables
  >({ query: AuctionListingsByFilterDocument, ...options })
}
export const CreateAuctionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAuction' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AuctionListingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAuctionListing' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'auctionListing' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'input' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'auctionListing' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateAuctionMutation() {
  return Urql.useMutation<
    CreateAuctionMutation,
    CreateAuctionMutationVariables
  >(CreateAuctionDocument)
}
export const UpdateAuctionByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAuctionById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAuctionListingByIdInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAuctionListingById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'auctionListing' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateAuctionByIdMutation() {
  return Urql.useMutation<
    UpdateAuctionByIdMutation,
    UpdateAuctionByIdMutationVariables
  >(UpdateAuctionByIdDocument)
}
export const BuybackByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BuybackById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buybackCalculationById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lv' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountUserId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'formData' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useBuybackByIdQuery(
  options: Omit<Urql.UseQueryArgs<BuybackByIdQueryVariables>, 'query'>
) {
  return Urql.useQuery<BuybackByIdQuery, BuybackByIdQueryVariables>({
    query: BuybackByIdDocument,
    ...options,
  })
}
export const CeeCronDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ceeCron' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'day' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'week' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'month' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonitoringCees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '20' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'LAST_CHECK_DESC' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'and' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastCheck',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThan',
                                                },
                                                value: {
                                                  kind: 'Variable',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'day',
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'checkFrequency',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThanOrEqualTo',
                                                },
                                                value: {
                                                  kind: 'IntValue',
                                                  value: '1',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'and' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastCheck',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThan',
                                                },
                                                value: {
                                                  kind: 'Variable',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'week',
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'checkFrequency',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThanOrEqualTo',
                                                },
                                                value: {
                                                  kind: 'IntValue',
                                                  value: '7',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'checkFrequency',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'greaterThan',
                                                },
                                                value: {
                                                  kind: 'IntValue',
                                                  value: '1',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'and' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastCheck',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThan',
                                                },
                                                value: {
                                                  kind: 'Variable',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'month',
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'checkFrequency',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThanOrEqualTo',
                                                },
                                                value: {
                                                  kind: 'IntValue',
                                                  value: '30',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'checkFrequency',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'greaterThan',
                                                },
                                                value: {
                                                  kind: 'IntValue',
                                                  value: '7',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'lastCheck' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'isNull' },
                                      value: {
                                        kind: 'BooleanValue',
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'checkFrequency' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'found' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'distinctFrom' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'errorState' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'distinctFrom' },
                            value: { kind: 'BooleanValue', value: true },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkFrequency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastCheck' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'birthDate' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCeeCronQuery(
  options: Omit<Urql.UseQueryArgs<CeeCronQueryVariables>, 'query'>
) {
  return Urql.useQuery<CeeCronQuery, CeeCronQueryVariables>({
    query: CeeCronDocument,
    ...options,
  })
}
export const CeeStatisticsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ceeStatistics' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonitoringCees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'executionCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastCheck' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'birthDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'ceeExecutionsByMonitoringCeeId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'ceeExecutionDetailsByCeeExecutionId',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'nodes',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'createdAt',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'accountId',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'accountUserId',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'detailCode',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCeeStatisticsQuery(
  options?: Omit<Urql.UseQueryArgs<CeeStatisticsQueryVariables>, 'query'>
) {
  return Urql.useQuery<CeeStatisticsQuery, CeeStatisticsQueryVariables>({
    query: CeeStatisticsDocument,
    ...options,
  })
}
export const SelectedMonitoringCeeIdsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'selectedMonitoringCeeIds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UUID' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonitoringCees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'ids' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'birthDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkFrequency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'editedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'executionCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'found' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastCheck' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'note' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rc' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'validatedCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useSelectedMonitoringCeeIdsQuery(
  options?: Omit<
    Urql.UseQueryArgs<SelectedMonitoringCeeIdsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    SelectedMonitoringCeeIdsQuery,
    SelectedMonitoringCeeIdsQueryVariables
  >({ query: SelectedMonitoringCeeIdsDocument, ...options })
}
export const CuzkDocumentCollectionsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cuzkDocumentCollections' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkDocumentId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCuzkDocumentCollections' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cuzkDocumentId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuzkDocumentId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'casoveraziko' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'cena' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumpozadavku' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumspusteni' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'datumvytvoreni' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'elznacka' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'format' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkCollectionId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkDocumentId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nazev' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetjednotek' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pocetstran' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rizeni' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'stav' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCuzkDocumentCollectionsQuery(
  options: Omit<
    Urql.UseQueryArgs<CuzkDocumentCollectionsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    CuzkDocumentCollectionsQuery,
    CuzkDocumentCollectionsQueryVariables
  >({ query: CuzkDocumentCollectionsDocument, ...options })
}
export const NajdiOsCronDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'najdiOsCron' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'day' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'week' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'month' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonitoringCuzkRcs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '100' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'LAST_CHECK_DESC' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'or' },
                      value: {
                        kind: 'ListValue',
                        values: [
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'and' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastCheck',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThan',
                                                },
                                                value: {
                                                  kind: 'Variable',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'day',
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'checkFrequency',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThanOrEqualTo',
                                                },
                                                value: {
                                                  kind: 'IntValue',
                                                  value: '1',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'and' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastCheck',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThan',
                                                },
                                                value: {
                                                  kind: 'Variable',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'week',
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'checkFrequency',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThanOrEqualTo',
                                                },
                                                value: {
                                                  kind: 'IntValue',
                                                  value: '7',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'checkFrequency',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'greaterThan',
                                                },
                                                value: {
                                                  kind: 'IntValue',
                                                  value: '1',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'and' },
                                value: {
                                  kind: 'ListValue',
                                  values: [
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastCheck',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThan',
                                                },
                                                value: {
                                                  kind: 'Variable',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'month',
                                                  },
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'checkFrequency',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lessThanOrEqualTo',
                                                },
                                                value: {
                                                  kind: 'IntValue',
                                                  value: '30',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      kind: 'ObjectValue',
                                      fields: [
                                        {
                                          kind: 'ObjectField',
                                          name: {
                                            kind: 'Name',
                                            value: 'checkFrequency',
                                          },
                                          value: {
                                            kind: 'ObjectValue',
                                            fields: [
                                              {
                                                kind: 'ObjectField',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'greaterThan',
                                                },
                                                value: {
                                                  kind: 'IntValue',
                                                  value: '7',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                          {
                            kind: 'ObjectValue',
                            fields: [
                              {
                                kind: 'ObjectField',
                                name: { kind: 'Name', value: 'lastCheck' },
                                value: {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'isNull' },
                                      value: {
                                        kind: 'BooleanValue',
                                        value: true,
                                      },
                                    },
                                  ],
                                },
                              },
                            ],
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'checkFrequency' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkFrequency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastCheck' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'birthDate' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useNajdiOsCronQuery(
  options: Omit<Urql.UseQueryArgs<NajdiOsCronQueryVariables>, 'query'>
) {
  return Urql.useQuery<NajdiOsCronQuery, NajdiOsCronQueryVariables>({
    query: NajdiOsCronDocument,
    ...options,
  })
}
export const SelectedMonitoringCuzkRcsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'selectedMonitoringCuzkRcs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'UUID' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonitoringCuzkRcs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'ids' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkFrequency' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cuzkOsId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'editedAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'found' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastCheck' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'rc' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ico' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastname' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'birthDate' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useSelectedMonitoringCuzkRcsQuery(
  options?: Omit<
    Urql.UseQueryArgs<SelectedMonitoringCuzkRcsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    SelectedMonitoringCuzkRcsQuery,
    SelectedMonitoringCuzkRcsQueryVariables
  >({ query: SelectedMonitoringCuzkRcsDocument, ...options })
}
export const MyOffersAccessesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'myOffersAccesses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMarketplaceOffers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'marketplaceOfferAccessesByOfferId',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'accountId' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'accountId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isOwner' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'marketplaceOfferByOfferId',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'contactPhone',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'contactName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'contactEmail',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'contactDescription',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expirationDate' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'images' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'interestAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'investmentAmount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'monthlyPayment' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'offerLocation' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'offerType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyValue' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useMyOffersAccessesQuery(
  options: Omit<Urql.UseQueryArgs<MyOffersAccessesQueryVariables>, 'query'>
) {
  return Urql.useQuery<MyOffersAccessesQuery, MyOffersAccessesQueryVariables>({
    query: MyOffersAccessesDocument,
    ...options,
  })
}
export const MarketplaceOwnerByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'marketplaceOwnerById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'marketplaceOfferById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useMarketplaceOwnerByIdQuery(
  options: Omit<Urql.UseQueryArgs<MarketplaceOwnerByIdQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    MarketplaceOwnerByIdQuery,
    MarketplaceOwnerByIdQueryVariables
  >({ query: MarketplaceOwnerByIdDocument, ...options })
}
export const MarketplaceStatisticsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'marketplaceStatistics' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMarketplaceOfferAccesses' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'marketplaceOfferByOfferId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contactName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'offerType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useMarketplaceStatisticsQuery(
  options?: Omit<
    Urql.UseQueryArgs<MarketplaceStatisticsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    MarketplaceStatisticsQuery,
    MarketplaceStatisticsQueryVariables
  >({ query: MarketplaceStatisticsDocument, ...options })
}
export const MarketplaceExpireItemDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'marketplaceExpireItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lessThan' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMarketplaceOffers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'expirationDate' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lessThan' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lessThan' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'equalTo' },
                            value: { kind: 'EnumValue', value: 'ACTIVE' },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useMarketplaceExpireItemQuery(
  options: Omit<Urql.UseQueryArgs<MarketplaceExpireItemQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    MarketplaceExpireItemQuery,
    MarketplaceExpireItemQueryVariables
  >({ query: MarketplaceExpireItemDocument, ...options })
}
export const MonitStatisticsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'monitStatistics' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allMonits' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'estimateToDate' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaM2Nab' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaM2Real' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaNab' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cenaReal' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useMonitStatisticsQuery(
  options?: Omit<Urql.UseQueryArgs<MonitStatisticsQueryVariables>, 'query'>
) {
  return Urql.useQuery<MonitStatisticsQuery, MonitStatisticsQueryVariables>({
    query: MonitStatisticsDocument,
    ...options,
  })
}
export const PostServiceDispatchDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postServiceDispatch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recipientListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'dispatchDate' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'letterText' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'senderAddressBySenderAddressId',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'houseNumber' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orientationNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'senderName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'street' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zipCode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'recipientListRecipientsByRecipientListId',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'recipientByRecipientId',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'fyzickaosoba',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'krestnijmeno',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nazev' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'osloveni' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pohlavi' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'prijmeni' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'titulpred' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'titulza' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'addressByAdresnimistokod',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'castobce',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cislodomovni',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cisloorientacni',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'cisloorientacnipismeno',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'kraj' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'obec' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'okres',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'psc' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'radnice',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'typbudovy',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'ulice',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePostServiceDispatchQuery(
  options: Omit<Urql.UseQueryArgs<PostServiceDispatchQueryVariables>, 'query'>
) {
  return Urql.useQuery<
    PostServiceDispatchQuery,
    PostServiceDispatchQueryVariables
  >({ query: PostServiceDispatchDocument, ...options })
}
export const SentLetterByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sentLetterById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'letterId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postserviceSentLetterById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'letterId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accountId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'sender' },
                  name: {
                    kind: 'Name',
                    value: 'senderAddressBySenderAddressId',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'houseNumber' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orientationNumber' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'senderName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'street' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'zipCode' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'recipients' },
                  name: {
                    kind: 'Name',
                    value: 'postserviceSentRecipientsBySentLetterId',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'callName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'country' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'gender' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'houseNumber' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'orientationNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'street' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable1' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable10' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable2' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable3' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable4' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable5' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable6' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable7' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable8' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'variable9' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'zipCode' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyLv' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralCode',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyCadastralName',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyCity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyAddress' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'propertyAreaNumber',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useSentLetterByIdQuery(
  options: Omit<Urql.UseQueryArgs<SentLetterByIdQueryVariables>, 'query'>
) {
  return Urql.useQuery<SentLetterByIdQuery, SentLetterByIdQueryVariables>({
    query: SentLetterByIdDocument,
    ...options,
  })
}
export const PostServiceStatisticsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'postServiceStatistics' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPostserviceSentLetters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sentAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountUserId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'dispatchDate' },
                        name: { kind: 'Name', value: 'sentAt' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'description' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'senderAddress' },
                        name: {
                          kind: 'Name',
                          value: 'senderAddressBySenderAddressId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'senderName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'city' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'recipients' },
                        name: {
                          kind: 'Name',
                          value: 'postserviceSentRecipientsBySentLetterId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function usePostServiceStatisticsQuery(
  options?: Omit<
    Urql.UseQueryArgs<PostServiceStatisticsQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    PostServiceStatisticsQuery,
    PostServiceStatisticsQueryVariables
  >({ query: PostServiceStatisticsDocument, ...options })
}
export const UnitRentByCadastralCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'unitRentByCadastralCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cadastralAreaCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unitRentByCadastralAreaCode' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cadastralAreaCode' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cadastralAreaCode' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cadastralAreaCode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cadastralAreaName' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk1DataCoverage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk1LowerInterval' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk1UpperInterval' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vk1Minimum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk1Maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk1Median' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk1Reference' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk1NewBuilding' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk2DataCoverage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk2LowerInterval' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk2UpperInterval' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vk2Minimum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk2Maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk2Median' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk2Reference' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk2NewBuilding' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk3DataCoverage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk3LowerInterval' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk3UpperInterval' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vk3Minimum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk3Maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk3Median' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk3Reference' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk3NewBuilding' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk4DataCoverage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk4LowerInterval' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk4UpperInterval' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'vk4Minimum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk4Maximum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vk4Median' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk4Reference' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vk4NewBuilding' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUnitRentByCadastralCodeQuery(
  options: Omit<
    Urql.UseQueryArgs<UnitRentByCadastralCodeQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    UnitRentByCadastralCodeQuery,
    UnitRentByCadastralCodeQueryVariables
  >({ query: UnitRentByCadastralCodeDocument, ...options })
}
export const CreateAddressMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAddressMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'budovaregestaid' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'castobce' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cislodomovni' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cisloorientacni' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cisloorientacnipismeno' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'createdAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kod' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kraj' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'obec' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'okres' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'psc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'radnice' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'typbudovy' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ulice' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAddress' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'address' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ulice' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'ulice' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'typbudovy' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'typbudovy' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'radnice' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'radnice' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'psc' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'psc' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'okres' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'okres' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'obec' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'obec' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'kraj' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'kraj' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'kod' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'kod' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'createdAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'cisloorientacnipismeno',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'cisloorientacnipismeno',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cisloorientacni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cisloorientacni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cislodomovni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cislodomovni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'castobce' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'castobce' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'budovaregestaid' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'budovaregestaid' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateAddressMutationMutation() {
  return Urql.useMutation<
    CreateAddressMutationMutation,
    CreateAddressMutationMutationVariables
  >(CreateAddressMutationDocument)
}
export const CreateCeeExecutionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCeeExecution' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'address' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'birthDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ceeEvent' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'detailCode' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'executionDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'executorCode' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'executorName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fullname' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ico' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'spzn' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'updateDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'monitoringCeeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'identificationCode' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCeeExecution' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ceeExecution' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'birthDate' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'birthDate' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ceeEvent' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'ceeEvent' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fullname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'fullname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ico' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'ico' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'identificationCode' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'identificationCode',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'rc' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'rc' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'spzn' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'spzn' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'updateDate' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'updateDate' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'detailCode' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'detailCode' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'executionDate' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'executionDate' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'executorName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'executorName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'executorCode' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'executorCode' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'address' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'address' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'monitoringCeeId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'monitoringCeeId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ceeExecution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateCeeExecutionMutation() {
  return Urql.useMutation<
    CreateCeeExecutionMutation,
    CreateCeeExecutionMutationVariables
  >(CreateCeeExecutionDocument)
}
export const CreateDataBoxDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createDataBox' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'adresnimistokod' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'birthname' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'businessname' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'databoxid' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'subtype' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pdz' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ovm' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'masterid' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastname' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'middlename' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ismaster' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'idovm' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ico' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fulladdress' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'firstname' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDatabox' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'databox' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'databoxid' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'databoxid' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'adresnimistokod' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'adresnimistokod' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'birthname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'birthname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'businessname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'businessname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'firstname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fulladdress' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'fulladdress' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ico' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'ico' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ismaster' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'ismaster' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'idovm' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'idovm' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lastname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'masterid' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'masterid' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'middlename' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'middlename' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'pdz' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'pdz' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ovm' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'ovm' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'subtype' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'subtype' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'type' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'type' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'databox' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateDataBoxMutation() {
  return Urql.useMutation<
    CreateDataBoxMutation,
    CreateDataBoxMutationVariables
  >(CreateDataBoxDocument)
}
export const CreateCeeExecutionDetailDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCeeExecutionDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'castka' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ceeExecutionId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datum' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'detailCode' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'exekutorskyUrad' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ico' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nepenezitaPovinost' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'povinnaOsoba' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pravidelnaSplatka' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rc' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'soud' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'spznExekutora' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'spznSoudu' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'titul' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCeeExecutionDetail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ceeExecutionDetail' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'rc' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'rc' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ico' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'ico' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'soud' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'soud' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'titul' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'titul' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datum' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datum' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'castka' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'castka' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'spznSoudu' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'spznSoudu' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'detailCode' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'detailCode' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'povinnaOsoba' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'povinnaOsoba' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'spznExekutora' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'spznExekutora' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'ceeExecutionId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'ceeExecutionId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'exekutorskyUrad' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'exekutorskyUrad' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'nepenezitaPovinost' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'nepenezitaPovinost',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'pravidelnaSplatka' },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'pravidelnaSplatka',
                              },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'ceeExecutionDetail' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateCeeExecutionDetailMutation() {
  return Urql.useMutation<
    CreateCeeExecutionDetailMutation,
    CreateCeeExecutionDetailMutationVariables
  >(CreateCeeExecutionDetailDocument)
}
export const CreateDocumentCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createDocumentCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'format' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nazev' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'rizeni' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stav' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkDocumentId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkCollectionId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datumspusteni' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datumpozadavku' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCuzkDocumentCollection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cuzkDocumentCollection' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cuzkDocumentId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cuzkDocumentId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cuzkCollectionId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cuzkCollectionId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'rizeni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'rizeni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'nazev' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'nazev' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datumpozadavku' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datumpozadavku' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datumspusteni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datumspusteni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'stav' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'stav' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'format' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'format' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cuzkDocumentCollection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateDocumentCollectionMutation() {
  return Urql.useMutation<
    CreateDocumentCollectionMutation,
    CreateDocumentCollectionMutationVariables
  >(CreateDocumentCollectionDocument)
}
export const CreateEpoLienDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEpoLien' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateCuzkEpoLienInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCuzkEpoLien' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cuzkEpoLien' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateEpoLienMutation() {
  return Urql.useMutation<
    CreateEpoLienMutation,
    CreateEpoLienMutationVariables
  >(CreateEpoLienDocument)
}
export const CreateEpoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEpo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkCollectionId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datumpozadavku' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datumspusteni' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'format' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nazev' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'rcIco' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stav' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'typ' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCuzkEpo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cuzkEpo' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'rcIco' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'rcIco' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'nazev' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'nazev' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'typ' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'typ' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datumpozadavku' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datumpozadavku' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datumspusteni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datumspusteni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'stav' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'stav' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'format' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'format' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cuzkCollectionId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cuzkCollectionId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cuzkEpo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateEpoMutation() {
  return Urql.useMutation<CreateEpoMutation, CreateEpoMutationVariables>(
    CreateEpoDocument
  )
}
export const CreateEpoRestrictionCheckDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEpoRestrictionCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkEpoRestrictionCheck' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CuzkEpoRestrictionCheckInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCuzkEpoRestrictionCheck' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cuzkEpoRestrictionCheck' },
                      value: {
                        kind: 'Variable',
                        name: {
                          kind: 'Name',
                          value: 'cuzkEpoRestrictionCheck',
                        },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cuzkEpoRestrictionCheck' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateEpoRestrictionCheckMutation() {
  return Urql.useMutation<
    CreateEpoRestrictionCheckMutation,
    CreateEpoRestrictionCheckMutationVariables
  >(CreateEpoRestrictionCheckDocument)
}
export const CreateLvDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createLv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkCollectionId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datumK' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datumpozadavku' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datumspusteni' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Datetime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'format' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'katastralniUzemiKod' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'katastralniUzemiNazev' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'obec' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lv' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stav' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCuzkLv' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cuzkLv' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'katastralniUzemiKod',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'katastralniUzemiKod',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'stav' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'stav' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'format' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'format' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cuzkCollectionId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cuzkCollectionId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datumpozadavku' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datumpozadavku' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datumspusteni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datumspusteni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datumK' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datumK' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'katastralniUzemiNazev',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'katastralniUzemiNazev',
                              },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'obec' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'obec' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lv' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lv' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cuzkLv' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateLvMutation() {
  return Urql.useMutation<CreateLvMutation, CreateLvMutationVariables>(
    CreateLvDocument
  )
}
export const CreateMarketplaceOfferAccessDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMarketplaceOfferAccess' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'offerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMarketplaceOfferAccess' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'marketplaceOfferAccess' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'offerId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offerId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'marketplaceOfferByOfferId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateMarketplaceOfferAccessMutation() {
  return Urql.useMutation<
    CreateMarketplaceOfferAccessMutation,
    CreateMarketplaceOfferAccessMutationVariables
  >(CreateMarketplaceOfferAccessDocument)
}
export const MyMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MyMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'estimateToDate' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cenaM2Nab' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BigFloat' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cenaM2Real' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BigFloat' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cenaNab' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BigFloat' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cenaReal' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BigFloat' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'decompNab' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'decompReal' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'graphImageString' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'timeSeriesGraph' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'kodObce' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lat' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigFloat' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lon' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BigFloat' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'modelVersion' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'publicNote' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyType' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'requestData' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lvData' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'risyData' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'title' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'polygon' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMonit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'monit' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'estimateToDate' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'estimateToDate' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lat' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lat' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lon' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lon' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'requestData' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'requestData' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lvData' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lvData' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'risyData' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'risyData' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cenaM2Nab' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cenaM2Nab' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cenaM2Real' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cenaM2Real' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cenaNab' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cenaNab' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cenaReal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cenaReal' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'decompNab' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'decompNab' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'decompReal' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'decompReal' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'timeSeriesGraph' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'timeSeriesGraph' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'graphImageString' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'graphImageString' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'kodObce' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'kodObce' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'modelVersion' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'modelVersion' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'note' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'note' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'publicNote' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'publicNote' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'title' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'title' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'polygon' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'polygon' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'monit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useMyMutationMutation() {
  return Urql.useMutation<MyMutationMutation, MyMutationMutationVariables>(
    MyMutationDocument
  )
}
export const CreateRecipientListOnServerDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createRecipientListOnServer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountUserId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nazev' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'temporaryRecipientsJson' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRecipientList' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'recipientList' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'accountUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'accountUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'nazev' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'nazev' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'temporaryRecipientsJson',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'temporaryRecipientsJson',
                              },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipientList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateRecipientListOnServerMutation() {
  return Urql.useMutation<
    CreateRecipientListOnServerMutation,
    CreateRecipientListOnServerMutationVariables
  >(CreateRecipientListOnServerDocument)
}
export const CreateRecipientListRecipientDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createRecipientListRecipient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipientId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipientListId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyType' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyName' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'propertyId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRecipientListRecipient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'recipientListRecipient' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'recipientListId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'recipientListId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'recipientId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'recipientId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyType' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyName' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyName' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'propertyId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'propertyId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipientListRecipient' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateRecipientListRecipientMutation() {
  return Urql.useMutation<
    CreateRecipientListRecipientMutation,
    CreateRecipientListRecipientMutationVariables
  >(CreateRecipientListRecipientDocument)
}
export const CreateRecipientMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createRecipientMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'adresnimistokod' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'createdAt1' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fyzickaosoba' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'krestnijmeno' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nazev' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'osloveni' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pohlavi' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'prijmeni' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'titulpred' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'titulza' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRecipient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'recipient' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'adresnimistokod' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'adresnimistokod' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'createdAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'createdAt1' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'fyzickaosoba' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'fyzickaosoba' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'krestnijmeno' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'krestnijmeno' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'nazev' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'nazev' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'osloveni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'osloveni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'pohlavi' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'pohlavi' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'prijmeni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'prijmeni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'titulpred' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'titulpred' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'titulza' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'titulza' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'id' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'id' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipient' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCreateRecipientMutationMutation() {
  return Urql.useMutation<
    CreateRecipientMutationMutation,
    CreateRecipientMutationMutationVariables
  >(CreateRecipientMutationDocument)
}
export const DeleteDocumentCollectionMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteDocumentCollectionMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCuzkDocumentCollectionById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'deletedCuzkDocumentCollectionId',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteDocumentCollectionMutationMutation() {
  return Urql.useMutation<
    DeleteDocumentCollectionMutationMutation,
    DeleteDocumentCollectionMutationMutationVariables
  >(DeleteDocumentCollectionMutationDocument)
}
export const DeleteEpoMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteEpoMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCuzkEpoById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deletedCuzkEpoId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteEpoMutationMutation() {
  return Urql.useMutation<
    DeleteEpoMutationMutation,
    DeleteEpoMutationMutationVariables
  >(DeleteEpoMutationDocument)
}
export const DeleteLvMutationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteLvMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteCuzkLvById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deletedCuzkLvId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useDeleteLvMutationMutation() {
  return Urql.useMutation<
    DeleteLvMutationMutation,
    DeleteLvMutationMutationVariables
  >(DeleteLvMutationDocument)
}
export const UpdateMarketplaceOfferDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateMarketplaceOffer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMarketplaceOfferById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'marketplaceOfferPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'state' },
                            value: { kind: 'EnumValue', value: 'EXPIRED' },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'marketplaceOffer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateMarketplaceOfferMutation() {
  return Urql.useMutation<
    UpdateMarketplaceOfferMutation,
    UpdateMarketplaceOfferMutationVariables
  >(UpdateMarketplaceOfferDocument)
}
export const EpoRestrictionCheckByCodesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'epoRestrictionCheckByCodes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkEpoId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'codes' },
          },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'String' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cuzkEpoById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cuzkEpoId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'cuzkEpoRestrictionChecksByCuzkEpoId',
                  },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'katastralniPracovisteKod',
                            },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'in' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'codes' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'katastralniPracovisteKod',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'cuzkEpoLiensByRestrictionCheckId',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'totalCount' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useEpoRestrictionCheckByCodesQuery(
  options: Omit<
    Urql.UseQueryArgs<EpoRestrictionCheckByCodesQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    EpoRestrictionCheckByCodesQuery,
    EpoRestrictionCheckByCodesQueryVariables
  >({ query: EpoRestrictionCheckByCodesDocument, ...options })
}
export const EpoRestrictionCheckInProgressDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'epoRestrictionCheckInProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkEpoId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCuzkEpoRestrictionChecks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'in' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'EnumValue', value: 'CHECKED' },
                                { kind: 'EnumValue', value: 'PROCESSING' },
                                { kind: 'EnumValue', value: 'CREATED' },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cuzkEpoId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuzkEpoId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'cuzkEpoLiensByRestrictionCheckId',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'or' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'exekuce',
                                            },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'equalTo',
                                                  },
                                                  value: {
                                                    kind: 'BooleanValue',
                                                    value: true,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'insolvence',
                                            },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'equalTo',
                                                  },
                                                  value: {
                                                    kind: 'BooleanValue',
                                                    value: true,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'predkupniPravo',
                                            },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'equalTo',
                                                  },
                                                  value: {
                                                    kind: 'BooleanValue',
                                                    value: true,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'zastavyNedobrovolne',
                                            },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'equalTo',
                                                  },
                                                  value: {
                                                    kind: 'BooleanValue',
                                                    value: true,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'katastralniPracovisteNazev',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'katastralniUradNazev' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'katastralniPracovisteKod',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'katastralniUradKod' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lvKeKontrolePocet' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'boughtAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkedBy' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useEpoRestrictionCheckInProgressQuery(
  options: Omit<
    Urql.UseQueryArgs<EpoRestrictionCheckInProgressQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    EpoRestrictionCheckInProgressQuery,
    EpoRestrictionCheckInProgressQueryVariables
  >({ query: EpoRestrictionCheckInProgressDocument, ...options })
}
export const ReadEpoRestrictionCheckDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'readEpoRestrictionCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cuzkEpoById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'cuzkEpoRestrictionChecksByCuzkEpoId',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'boughtAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'katastralniPracovisteKod',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'katastralniPracovisteNazev',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'katastralniUradKod',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'katastralniUradNazev',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'lvKeKontrolePocet',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pocetLv' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useReadEpoRestrictionCheckQuery(
  options: Omit<
    Urql.UseQueryArgs<ReadEpoRestrictionCheckQueryVariables>,
    'query'
  >
) {
  return Urql.useQuery<
    ReadEpoRestrictionCheckQuery,
    ReadEpoRestrictionCheckQueryVariables
  >({ query: ReadEpoRestrictionCheckDocument, ...options })
}
export const CuzkEpoByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'cuzkEpoById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cuzkEpoId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCuzkEpoRestrictionChecks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'boughtAt' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'isNull' },
                            value: { kind: 'BooleanValue', value: false },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cuzkEpoId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'cuzkEpoId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: { kind: 'EnumValue', value: 'CHECKED' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'katastralniPracovisteNazev',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'katastralniUradNazev' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'cuzkEpoLiensByRestrictionCheckId',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'filter' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'or' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'exekuce',
                                            },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'equalTo',
                                                  },
                                                  value: {
                                                    kind: 'BooleanValue',
                                                    value: true,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'insolvence',
                                            },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'equalTo',
                                                  },
                                                  value: {
                                                    kind: 'BooleanValue',
                                                    value: true,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'predkupniPravo',
                                            },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'equalTo',
                                                  },
                                                  value: {
                                                    kind: 'BooleanValue',
                                                    value: true,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'zastavyNedobrovolne',
                                            },
                                            value: {
                                              kind: 'ObjectValue',
                                              fields: [
                                                {
                                                  kind: 'ObjectField',
                                                  name: {
                                                    kind: 'Name',
                                                    value: 'equalTo',
                                                  },
                                                  value: {
                                                    kind: 'BooleanValue',
                                                    value: true,
                                                  },
                                                },
                                              ],
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'katastralniUzemiNazev',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'obec' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'okres' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'parcelyPocet',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'predkupniPravo',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'restrictionCheckId',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rizeni' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'vlastniciPocet',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'zastavyNedobrovolne',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lv' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'katastralniUzemiKod',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'jednotkyPocet',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'insolvence' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'exekuce' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'budovyPocet',
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cuzkEpoById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cuzkEpoId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pocetLv' } },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'cuzkEpoRestrictionChecksByCuzkEpoId',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useCuzkEpoByIdQuery(
  options: Omit<Urql.UseQueryArgs<CuzkEpoByIdQueryVariables>, 'query'>
) {
  return Urql.useQuery<CuzkEpoByIdQuery, CuzkEpoByIdQueryVariables>({
    query: CuzkEpoByIdDocument,
    ...options,
  })
}
export const UpdateDocumentCollectionDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDocumentCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stav' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pocetstran' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pocetjednotek' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datumvytvoreni' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'casoveraziko' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cena' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BigFloat' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'elznacka' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCuzkDocumentCollectionById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {
                        kind: 'Name',
                        value: 'cuzkDocumentCollectionPatch',
                      },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'stav' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'stav' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'pocetstran' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'pocetstran' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'pocetjednotek' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'pocetjednotek' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datumvytvoreni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datumvytvoreni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'casoveraziko' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'casoveraziko' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cena' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cena' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'elznacka' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'elznacka' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cuzkDocumentCollection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateDocumentCollectionMutation() {
  return Urql.useMutation<
    UpdateDocumentCollectionMutation,
    UpdateDocumentCollectionMutationVariables
  >(UpdateDocumentCollectionDocument)
}
export const UpdateCuzkEpoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCuzkEpo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stav' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pocetstran' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pocetjednotek' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pocetLv' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datumvytvoreni' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cena' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BigFloat' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'elznacka' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'adresnimistokod' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCuzkEpoById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cuzkEpoPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'stav' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'stav' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'pocetstran' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'pocetstran' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'pocetjednotek' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'pocetjednotek' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'pocetLv' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'pocetLv' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datumvytvoreni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datumvytvoreni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cena' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cena' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'elznacka' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'elznacka' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'adresnimistokod' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'adresnimistokod' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cuzkEpo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateCuzkEpoMutation() {
  return Urql.useMutation<
    UpdateCuzkEpoMutation,
    UpdateCuzkEpoMutationVariables
  >(UpdateCuzkEpoDocument)
}
export const UpdateEpoRestrictionCheckByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateEpoRestrictionCheckById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boughtAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkedAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boughtBy' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkedBy' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'RestrictionCheckState' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCuzkEpoRestrictionCheckById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {
                        kind: 'Name',
                        value: 'cuzkEpoRestrictionCheckPatch',
                      },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'boughtAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'boughtAt' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'boughtBy' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'boughtBy' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'checkedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'checkedAt' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'checkedBy' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'checkedBy' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'state' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'state' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateEpoRestrictionCheckByIdMutation() {
  return Urql.useMutation<
    UpdateEpoRestrictionCheckByIdMutation,
    UpdateEpoRestrictionCheckByIdMutationVariables
  >(UpdateEpoRestrictionCheckByIdDocument)
}
export const UpdateEpoRestrictionCheckDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateEpoRestrictionCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'nodeId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boughtAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'boughtBy' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkedAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkedBy' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'state' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'RestrictionCheckState' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCuzkEpoRestrictionCheck' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'nodeId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'nodeId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {
                        kind: 'Name',
                        value: 'cuzkEpoRestrictionCheckPatch',
                      },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'boughtAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'boughtAt' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'boughtBy' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'boughtBy' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'checkedAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'checkedAt' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'checkedBy' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'checkedBy' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'state' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'state' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateEpoRestrictionCheckMutation() {
  return Urql.useMutation<
    UpdateEpoRestrictionCheckMutation,
    UpdateEpoRestrictionCheckMutationVariables
  >(UpdateEpoRestrictionCheckDocument)
}
export const UpdateCuzkLvDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCuzkLv' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stav' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pocetstran' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pocetjednotek' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'datumvytvoreni' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cena' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'BigFloat' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'elznacka' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCuzkLvById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'cuzkLvPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'stav' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'stav' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'pocetstran' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'pocetstran' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'pocetjednotek' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'pocetjednotek' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'datumvytvoreni' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'datumvytvoreni' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'cena' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'cena' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'elznacka' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'elznacka' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cuzkLv' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateCuzkLvMutation() {
  return Urql.useMutation<UpdateCuzkLvMutation, UpdateCuzkLvMutationVariables>(
    UpdateCuzkLvDocument
  )
}
export const UpdateMonitoringCeeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateMonitoringCee' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastCheck' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'checkFrequency' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'found' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'birthDate' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'firstname' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastname' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'executionCount' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'errorState' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateMonitoringCeeById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'monitoringCeePatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'checkFrequency' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'checkFrequency' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lastCheck' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lastCheck' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'found' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'found' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'executionCount' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'executionCount' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'birthDate' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'birthDate' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'firstname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'firstname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'lastname' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'lastname' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'errorState' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'errorState' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'monitoringCee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateMonitoringCeeMutation() {
  return Urql.useMutation<
    UpdateMonitoringCeeMutation,
    UpdateMonitoringCeeMutationVariables
  >(UpdateMonitoringCeeDocument)
}
export const UpdateRecipientListByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateRecipientListById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'letterText' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRecipientListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'recipientListPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'letterText' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'letterText' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipientList' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateRecipientListByIdMutation() {
  return Urql.useMutation<
    UpdateRecipientListByIdMutation,
    UpdateRecipientListByIdMutationVariables
  >(UpdateRecipientListByIdDocument)
}
export const UpdaterecipientListRecipientDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updaterecipientListRecipient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'postserviceId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRecipientListRecipientById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {
                        kind: 'Name',
                        value: 'recipientListRecipientPatch',
                      },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'postserviceId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'postserviceId' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdaterecipientListRecipientMutation() {
  return Urql.useMutation<
    UpdaterecipientListRecipientMutation,
    UpdaterecipientListRecipientMutationVariables
  >(UpdaterecipientListRecipientDocument)
}
export const UpdateRecipientListDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateRecipientList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'dispatchDate' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRecipientListById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'recipientListPatch' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'dispatchDate' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'dispatchDate' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdateRecipientListMutation() {
  return Urql.useMutation<
    UpdateRecipientListMutation,
    UpdateRecipientListMutationVariables
  >(UpdateRecipientListDocument)
}
export const UpdatePostServiceSentLetterDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePostServiceSentLetter' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'letterId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sentAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sentByUserId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'postserviceType' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'PostserviceLetterType' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePostserviceSentLetterById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {
                        kind: 'Name',
                        value: 'postserviceSentLetterPatch',
                      },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'sentAt' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'sentAt' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'sentByUserId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'sentByUserId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'postserviceType' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'postserviceType' },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'letterId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdatePostServiceSentLetterMutation() {
  return Urql.useMutation<
    UpdatePostServiceSentLetterMutation,
    UpdatePostServiceSentLetterMutationVariables
  >(UpdatePostServiceSentLetterDocument)
}
export const UpdatePostserviceSentRecipientByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePostserviceSentRecipientById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'postserviceId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'postserviceTrackingNumber' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePostserviceSentRecipientById' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: {
                        kind: 'Name',
                        value: 'postserviceSentRecipientPatch',
                      },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'postserviceId' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'postserviceId' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: {
                              kind: 'Name',
                              value: 'postserviceTrackingNumber',
                            },
                            value: {
                              kind: 'Variable',
                              name: {
                                kind: 'Name',
                                value: 'postserviceTrackingNumber',
                              },
                            },
                          },
                        ],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode

export function useUpdatePostserviceSentRecipientByIdMutation() {
  return Urql.useMutation<
    UpdatePostserviceSentRecipientByIdMutation,
    UpdatePostserviceSentRecipientByIdMutationVariables
  >(UpdatePostserviceSentRecipientByIdDocument)
}
